export default {
  data: {
    getBook: {
      id: 'pantoneSolidCoated',
      title: 'Formula Guide Coated',
      colors: [
        {
          code: 'White',
          name: null,
          rgb: {
            r: 255,
            g: 255,
            b: 255
          },
          hex: 'FFFFFF',
          positionInBook: 0,
          pageNumberInBook: '1.1'
        },
        {
          code: 'Yellow 012 C',
          name: null,
          rgb: {
            r: 255,
            g: 215,
            b: 0
          },
          hex: 'FFD700',
          positionInBook: 0,
          pageNumberInBook: '1.1'
        },
        {
          code: 'Bright Red C',
          name: null,
          rgb: {
            r: 249,
            g: 56,
            b: 34
          },
          hex: 'F93822',
          positionInBook: 1,
          pageNumberInBook: '1.1'
        },
        {
          code: 'Pink C',
          name: null,
          rgb: {
            r: 214,
            g: 37,
            b: 152
          },
          hex: 'D62598',
          positionInBook: 2,
          pageNumberInBook: '1.1'
        },
        {
          code: 'Medium Purple C',
          name: null,
          rgb: {
            r: 78,
            g: 0,
            b: 142
          },
          hex: '4E008E',
          positionInBook: 3,
          pageNumberInBook: '1.1'
        },
        {
          code: 'Dark Blue C',
          name: null,
          rgb: {
            r: 0,
            g: 36,
            b: 156
          },
          hex: '00249C',
          positionInBook: 4,
          pageNumberInBook: '1.1'
        },
        {
          code: '100 C',
          name: null,
          rgb: {
            r: 246,
            g: 235,
            b: 97
          },
          hex: 'F6EB61',
          positionInBook: 5,
          pageNumberInBook: '2'
        },
        {
          code: '101 C',
          name: null,
          rgb: {
            r: 247,
            g: 234,
            b: 72
          },
          hex: 'F7EA48',
          positionInBook: 6,
          pageNumberInBook: '2'
        },
        {
          code: '102 C',
          name: null,
          rgb: {
            r: 252,
            g: 227,
            b: 0
          },
          hex: 'FCE300',
          positionInBook: 7,
          pageNumberInBook: '2'
        },
        {
          code: 'Yellow C',
          name: null,
          rgb: {
            r: 254,
            g: 221,
            b: 0
          },
          hex: 'FEDD00',
          positionInBook: 8,
          pageNumberInBook: '2'
        },
        {
          code: '103 C',
          name: null,
          rgb: {
            r: 197,
            g: 169,
            b: 0
          },
          hex: 'C5A900',
          positionInBook: 9,
          pageNumberInBook: '2'
        },
        {
          code: '104 C',
          name: null,
          rgb: {
            r: 175,
            g: 152,
            b: 0
          },
          hex: 'AF9800',
          positionInBook: 10,
          pageNumberInBook: '2'
        },
        {
          code: '105 C',
          name: null,
          rgb: {
            r: 137,
            g: 122,
            b: 39
          },
          hex: '897A27',
          positionInBook: 11,
          pageNumberInBook: '2'
        },
        {
          code: '7401 C',
          name: null,
          rgb: {
            r: 245,
            g: 225,
            b: 164
          },
          hex: 'F5E1A4',
          positionInBook: 12,
          pageNumberInBook: '3'
        },
        {
          code: '7402 C',
          name: null,
          rgb: {
            r: 236,
            g: 216,
            b: 152
          },
          hex: 'ECD898',
          positionInBook: 13,
          pageNumberInBook: '3'
        },
        {
          code: '7403 C',
          name: null,
          rgb: {
            r: 238,
            g: 212,
            b: 132
          },
          hex: 'EED484',
          positionInBook: 14,
          pageNumberInBook: '3'
        },
        {
          code: '7404 C',
          name: null,
          rgb: {
            r: 244,
            g: 218,
            b: 64
          },
          hex: 'F4DA40',
          positionInBook: 15,
          pageNumberInBook: '3'
        },
        {
          code: '7405 C',
          name: null,
          rgb: {
            r: 242,
            g: 205,
            b: 0
          },
          hex: 'F2CD00',
          positionInBook: 16,
          pageNumberInBook: '3'
        },
        {
          code: '7406 C',
          name: null,
          rgb: {
            r: 241,
            g: 196,
            b: 0
          },
          hex: 'F1C400',
          positionInBook: 17,
          pageNumberInBook: '3'
        },
        {
          code: '7407 C',
          name: null,
          rgb: {
            r: 203,
            g: 160,
            b: 82
          },
          hex: 'CBA052',
          positionInBook: 18,
          pageNumberInBook: '3'
        },
        {
          code: '2001 C',
          name: null,
          rgb: {
            r: 248,
            g: 229,
            b: 154
          },
          hex: 'F8E59A',
          positionInBook: 19,
          pageNumberInBook: '4'
        },
        {
          code: '2002 C',
          name: null,
          rgb: {
            r: 249,
            g: 226,
            b: 125
          },
          hex: 'F9E27D',
          positionInBook: 20,
          pageNumberInBook: '4'
        },
        {
          code: '2003 C',
          name: null,
          rgb: {
            r: 249,
            g: 226,
            b: 103
          },
          hex: 'F9E267',
          positionInBook: 21,
          pageNumberInBook: '4'
        },
        {
          code: '2004 C',
          name: null,
          rgb: {
            r: 251,
            g: 221,
            b: 122
          },
          hex: 'FBDD7A',
          positionInBook: 22,
          pageNumberInBook: '4'
        },
        {
          code: '2005 C',
          name: null,
          rgb: {
            r: 254,
            g: 216,
            b: 128
          },
          hex: 'FED880',
          positionInBook: 23,
          pageNumberInBook: '4'
        },
        {
          code: '2006 C',
          name: null,
          rgb: {
            r: 235,
            g: 188,
            b: 78
          },
          hex: 'EBBC4E',
          positionInBook: 24,
          pageNumberInBook: '4'
        },
        {
          code: '2007 C',
          name: null,
          rgb: {
            r: 224,
            g: 165,
            b: 38
          },
          hex: 'E0A526',
          positionInBook: 25,
          pageNumberInBook: '4'
        },
        {
          code: '106 C',
          name: null,
          rgb: {
            r: 249,
            g: 229,
            b: 71
          },
          hex: 'F9E547',
          positionInBook: 26,
          pageNumberInBook: '5'
        },
        {
          code: '107 C',
          name: null,
          rgb: {
            r: 251,
            g: 225,
            b: 34
          },
          hex: 'FBE122',
          positionInBook: 27,
          pageNumberInBook: '5'
        },
        {
          code: '108 C',
          name: null,
          rgb: {
            r: 254,
            g: 219,
            b: 0
          },
          hex: 'FEDB00',
          positionInBook: 28,
          pageNumberInBook: '5'
        },
        {
          code: '109 C',
          name: null,
          rgb: {
            r: 255,
            g: 209,
            b: 0
          },
          hex: 'FFD100',
          positionInBook: 29,
          pageNumberInBook: '5'
        },
        {
          code: '110 C',
          name: null,
          rgb: {
            r: 218,
            g: 170,
            b: 0
          },
          hex: 'DAAA00',
          positionInBook: 30,
          pageNumberInBook: '5'
        },
        {
          code: '111 C',
          name: null,
          rgb: {
            r: 170,
            g: 138,
            b: 0
          },
          hex: 'AA8A00',
          positionInBook: 31,
          pageNumberInBook: '5'
        },
        {
          code: '112 C',
          name: null,
          rgb: {
            r: 156,
            g: 132,
            b: 18
          },
          hex: '9C8412',
          positionInBook: 32,
          pageNumberInBook: '5'
        },
        {
          code: '113 C',
          name: null,
          rgb: {
            r: 250,
            g: 224,
            b: 83
          },
          hex: 'FAE053',
          positionInBook: 33,
          pageNumberInBook: '6'
        },
        {
          code: '114 C',
          name: null,
          rgb: {
            r: 251,
            g: 222,
            b: 64
          },
          hex: 'FBDE40',
          positionInBook: 34,
          pageNumberInBook: '6'
        },
        {
          code: '115 C',
          name: null,
          rgb: {
            r: 253,
            g: 218,
            b: 37
          },
          hex: 'FDDA25',
          positionInBook: 35,
          pageNumberInBook: '6'
        },
        {
          code: '116 C',
          name: null,
          rgb: {
            r: 255,
            g: 205,
            b: 0
          },
          hex: 'FFCD00',
          positionInBook: 36,
          pageNumberInBook: '6'
        },
        {
          code: '117 C',
          name: null,
          rgb: {
            r: 201,
            g: 151,
            b: 0
          },
          hex: 'C99700',
          positionInBook: 37,
          pageNumberInBook: '6'
        },
        {
          code: '118 C',
          name: null,
          rgb: {
            r: 172,
            g: 132,
            b: 0
          },
          hex: 'AC8400',
          positionInBook: 38,
          pageNumberInBook: '6'
        },
        {
          code: '119 C',
          name: null,
          rgb: {
            r: 137,
            g: 115,
            b: 34
          },
          hex: '897322',
          positionInBook: 39,
          pageNumberInBook: '6'
        },
        {
          code: '127 C',
          name: null,
          rgb: {
            r: 243,
            g: 221,
            b: 109
          },
          hex: 'F3DD6D',
          positionInBook: 40,
          pageNumberInBook: '7'
        },
        {
          code: '128 C',
          name: null,
          rgb: {
            r: 243,
            g: 213,
            b: 78
          },
          hex: 'F3D54E',
          positionInBook: 41,
          pageNumberInBook: '7'
        },
        {
          code: '129 C',
          name: null,
          rgb: {
            r: 243,
            g: 208,
            b: 62
          },
          hex: 'F3D03E',
          positionInBook: 42,
          pageNumberInBook: '7'
        },
        {
          code: '130 C',
          name: null,
          rgb: {
            r: 242,
            g: 169,
            b: 0
          },
          hex: 'F2A900',
          positionInBook: 43,
          pageNumberInBook: '7'
        },
        {
          code: '131 C',
          name: null,
          rgb: {
            r: 204,
            g: 138,
            b: 0
          },
          hex: 'CC8A00',
          positionInBook: 44,
          pageNumberInBook: '7'
        },
        {
          code: '132 C',
          name: null,
          rgb: {
            r: 160,
            g: 116,
            b: 0
          },
          hex: 'A07400',
          positionInBook: 45,
          pageNumberInBook: '7'
        },
        {
          code: '133 C',
          name: null,
          rgb: {
            r: 108,
            g: 87,
            b: 27
          },
          hex: '6C571B',
          positionInBook: 46,
          pageNumberInBook: '7'
        },
        {
          code: '4001 C',
          name: null,
          rgb: {
            r: 233,
            g: 219,
            b: 156
          },
          hex: 'E9DB9C',
          positionInBook: 47,
          pageNumberInBook: '8'
        },
        {
          code: '4002 C',
          name: null,
          rgb: {
            r: 220,
            g: 198,
            b: 129
          },
          hex: 'DCC681',
          positionInBook: 48,
          pageNumberInBook: '8'
        },
        {
          code: '4003 C',
          name: null,
          rgb: {
            r: 213,
            g: 200,
            b: 151
          },
          hex: 'D5C897',
          positionInBook: 49,
          pageNumberInBook: '8'
        },
        {
          code: '4004 C',
          name: null,
          rgb: {
            r: 201,
            g: 183,
            b: 119
          },
          hex: 'C9B777',
          positionInBook: 50,
          pageNumberInBook: '8'
        },
        {
          code: '4005 C',
          name: null,
          rgb: {
            r: 192,
            g: 173,
            b: 123
          },
          hex: 'C0AD7B',
          positionInBook: 51,
          pageNumberInBook: '8'
        },
        {
          code: '4006 C',
          name: null,
          rgb: {
            r: 187,
            g: 163,
            b: 112
          },
          hex: 'BBA370',
          positionInBook: 52,
          pageNumberInBook: '8'
        },
        {
          code: '4007 C',
          name: null,
          rgb: {
            r: 173,
            g: 150,
            b: 95
          },
          hex: 'AD965F',
          positionInBook: 53,
          pageNumberInBook: '8'
        },
        {
          code: '1205 C',
          name: null,
          rgb: {
            r: 248,
            g: 224,
            b: 142
          },
          hex: 'F8E08E',
          positionInBook: 54,
          pageNumberInBook: '9'
        },
        {
          code: '1215 C',
          name: null,
          rgb: {
            r: 251,
            g: 216,
            b: 114
          },
          hex: 'FBD872',
          positionInBook: 55,
          pageNumberInBook: '9'
        },
        {
          code: '1225 C',
          name: null,
          rgb: {
            r: 255,
            g: 200,
            b: 69
          },
          hex: 'FFC845',
          positionInBook: 56,
          pageNumberInBook: '9'
        },
        {
          code: '1235 C',
          name: null,
          rgb: {
            r: 255,
            g: 184,
            b: 28
          },
          hex: 'FFB81C',
          positionInBook: 57,
          pageNumberInBook: '9'
        },
        {
          code: '1245 C',
          name: null,
          rgb: {
            r: 198,
            g: 146,
            b: 20
          },
          hex: 'C69214',
          positionInBook: 58,
          pageNumberInBook: '9'
        },
        {
          code: '1255 C',
          name: null,
          rgb: {
            r: 173,
            g: 132,
            b: 31
          },
          hex: 'AD841F',
          positionInBook: 59,
          pageNumberInBook: '9'
        },
        {
          code: '1265 C',
          name: null,
          rgb: {
            r: 136,
            g: 107,
            b: 37
          },
          hex: '886B25',
          positionInBook: 60,
          pageNumberInBook: '9'
        },
        {
          code: '120 C',
          name: null,
          rgb: {
            r: 251,
            g: 219,
            b: 101
          },
          hex: 'FBDB65',
          positionInBook: 61,
          pageNumberInBook: '10'
        },
        {
          code: '121 C',
          name: null,
          rgb: {
            r: 252,
            g: 215,
            b: 87
          },
          hex: 'FCD757',
          positionInBook: 62,
          pageNumberInBook: '10'
        },
        {
          code: '122 C',
          name: null,
          rgb: {
            r: 254,
            g: 209,
            b: 65
          },
          hex: 'FED141',
          positionInBook: 63,
          pageNumberInBook: '10'
        },
        {
          code: '123 C',
          name: null,
          rgb: {
            r: 255,
            g: 199,
            b: 44
          },
          hex: 'FFC72C',
          positionInBook: 64,
          pageNumberInBook: '10'
        },
        {
          code: '124 C',
          name: null,
          rgb: {
            r: 234,
            g: 170,
            b: 0
          },
          hex: 'EAAA00',
          positionInBook: 65,
          pageNumberInBook: '10'
        },
        {
          code: '125 C',
          name: null,
          rgb: {
            r: 181,
            g: 133,
            b: 0
          },
          hex: 'B58500',
          positionInBook: 66,
          pageNumberInBook: '10'
        },
        {
          code: '126 C',
          name: null,
          rgb: {
            r: 154,
            g: 118,
            b: 17
          },
          hex: '9A7611',
          positionInBook: 67,
          pageNumberInBook: '10'
        },
        {
          code: '7548 C',
          name: null,
          rgb: {
            r: 255,
            g: 198,
            b: 0
          },
          hex: 'FFC600',
          positionInBook: 68,
          pageNumberInBook: '11'
        },
        {
          code: '7549 C',
          name: null,
          rgb: {
            r: 255,
            g: 182,
            b: 0
          },
          hex: 'FFB600',
          positionInBook: 69,
          pageNumberInBook: '11'
        },
        {
          code: '7550 C',
          name: null,
          rgb: {
            r: 209,
            g: 144,
            b: 0
          },
          hex: 'D19000',
          positionInBook: 70,
          pageNumberInBook: '11'
        },
        {
          code: '7551 C',
          name: null,
          rgb: {
            r: 180,
            g: 126,
            b: 0
          },
          hex: 'B47E00',
          positionInBook: 71,
          pageNumberInBook: '11'
        },
        {
          code: '7552 C',
          name: null,
          rgb: {
            r: 115,
            g: 83,
            b: 29
          },
          hex: '73531D',
          positionInBook: 72,
          pageNumberInBook: '11'
        },
        {
          code: '7553 C',
          name: null,
          rgb: {
            r: 90,
            g: 69,
            b: 34
          },
          hex: '5A4522',
          positionInBook: 73,
          pageNumberInBook: '11'
        },
        {
          code: '7554 C',
          name: null,
          rgb: {
            r: 75,
            g: 61,
            b: 42
          },
          hex: '4B3D2A',
          positionInBook: 74,
          pageNumberInBook: '11'
        },
        {
          code: '7555 C',
          name: null,
          rgb: {
            r: 210,
            g: 159,
            b: 19
          },
          hex: 'D29F13',
          positionInBook: 75,
          pageNumberInBook: '12'
        },
        {
          code: '7556 C',
          name: null,
          rgb: {
            r: 183,
            g: 139,
            b: 32
          },
          hex: 'B78B20',
          positionInBook: 76,
          pageNumberInBook: '12'
        },
        {
          code: '7557 C',
          name: null,
          rgb: {
            r: 159,
            g: 125,
            b: 35
          },
          hex: '9F7D23',
          positionInBook: 77,
          pageNumberInBook: '12'
        },
        {
          code: '7558 C',
          name: null,
          rgb: {
            r: 150,
            g: 113,
            b: 38
          },
          hex: '967126',
          positionInBook: 78,
          pageNumberInBook: '12'
        },
        {
          code: '7559 C',
          name: null,
          rgb: {
            r: 143,
            g: 106,
            b: 42
          },
          hex: '8F6A2A',
          positionInBook: 79,
          pageNumberInBook: '12'
        },
        {
          code: '7560 C',
          name: null,
          rgb: {
            r: 125,
            g: 98,
            b: 46
          },
          hex: '7D622E',
          positionInBook: 80,
          pageNumberInBook: '12'
        },
        {
          code: '7561 C',
          name: null,
          rgb: {
            r: 108,
            g: 93,
            b: 52
          },
          hex: '6C5D34',
          positionInBook: 81,
          pageNumberInBook: '12'
        },
        {
          code: '134 C',
          name: null,
          rgb: {
            r: 253,
            g: 210,
            b: 110
          },
          hex: 'FDD26E',
          positionInBook: 82,
          pageNumberInBook: '13'
        },
        {
          code: '135 C',
          name: null,
          rgb: {
            r: 255,
            g: 198,
            b: 88
          },
          hex: 'FFC658',
          positionInBook: 83,
          pageNumberInBook: '13'
        },
        {
          code: '136 C',
          name: null,
          rgb: {
            r: 255,
            g: 191,
            b: 63
          },
          hex: 'FFBF3F',
          positionInBook: 84,
          pageNumberInBook: '13'
        },
        {
          code: '137 C',
          name: null,
          rgb: {
            r: 255,
            g: 164,
            b: 0
          },
          hex: 'FFA400',
          positionInBook: 85,
          pageNumberInBook: '13'
        },
        {
          code: '138 C',
          name: null,
          rgb: {
            r: 222,
            g: 124,
            b: 0
          },
          hex: 'DE7C00',
          positionInBook: 86,
          pageNumberInBook: '13'
        },
        {
          code: '139 C',
          name: null,
          rgb: {
            r: 175,
            g: 109,
            b: 4
          },
          hex: 'AF6D04',
          positionInBook: 87,
          pageNumberInBook: '13'
        },
        {
          code: '140 C',
          name: null,
          rgb: {
            r: 116,
            g: 83,
            b: 28
          },
          hex: '74531C',
          positionInBook: 88,
          pageNumberInBook: '13'
        },
        {
          code: '2008 C',
          name: null,
          rgb: {
            r: 239,
            g: 192,
            b: 110
          },
          hex: 'EFC06E',
          positionInBook: 89,
          pageNumberInBook: '14'
        },
        {
          code: '2009 C',
          name: null,
          rgb: {
            r: 239,
            g: 182,
            b: 97
          },
          hex: 'EFB661',
          positionInBook: 90,
          pageNumberInBook: '14'
        },
        {
          code: '2010 C',
          name: null,
          rgb: {
            r: 255,
            g: 173,
            b: 0
          },
          hex: 'FFAD00',
          positionInBook: 91,
          pageNumberInBook: '14'
        },
        {
          code: '2011 C',
          name: null,
          rgb: {
            r: 237,
            g: 155,
            b: 51
          },
          hex: 'ED9B33',
          positionInBook: 92,
          pageNumberInBook: '14'
        },
        {
          code: '2012 C',
          name: null,
          rgb: {
            r: 239,
            g: 150,
            b: 0
          },
          hex: 'EF9600',
          positionInBook: 93,
          pageNumberInBook: '14'
        },
        {
          code: '2013 C',
          name: null,
          rgb: {
            r: 255,
            g: 152,
            b: 0
          },
          hex: 'FF9800',
          positionInBook: 94,
          pageNumberInBook: '14'
        },
        {
          code: '2014 C',
          name: null,
          rgb: {
            r: 185,
            g: 112,
            b: 0
          },
          hex: 'B97000',
          positionInBook: 95,
          pageNumberInBook: '14'
        },
        {
          code: '1345 C',
          name: null,
          rgb: {
            r: 253,
            g: 208,
            b: 134
          },
          hex: 'FDD086',
          positionInBook: 96,
          pageNumberInBook: '15'
        },
        {
          code: '1355 C',
          name: null,
          rgb: {
            r: 255,
            g: 197,
            b: 110
          },
          hex: 'FFC56E',
          positionInBook: 97,
          pageNumberInBook: '15'
        },
        {
          code: '1365 C',
          name: null,
          rgb: {
            r: 255,
            g: 181,
            b: 73
          },
          hex: 'FFB549',
          positionInBook: 98,
          pageNumberInBook: '15'
        },
        {
          code: '1375 C',
          name: null,
          rgb: {
            r: 255,
            g: 158,
            b: 27
          },
          hex: 'FF9E1B',
          positionInBook: 99,
          pageNumberInBook: '15'
        },
        {
          code: '1385 C',
          name: null,
          rgb: {
            r: 213,
            g: 120,
            b: 0
          },
          hex: 'D57800',
          positionInBook: 100,
          pageNumberInBook: '15'
        },
        {
          code: '1395 C',
          name: null,
          rgb: {
            r: 153,
            g: 96,
            b: 23
          },
          hex: '996017',
          positionInBook: 101,
          pageNumberInBook: '15'
        },
        {
          code: '1405 C',
          name: null,
          rgb: {
            r: 110,
            g: 76,
            b: 30
          },
          hex: '6E4C1E',
          positionInBook: 102,
          pageNumberInBook: '15'
        },
        {
          code: '141 C',
          name: null,
          rgb: {
            r: 242,
            g: 199,
            b: 92
          },
          hex: 'F2C75C',
          positionInBook: 103,
          pageNumberInBook: '16'
        },
        {
          code: '142 C',
          name: null,
          rgb: {
            r: 241,
            g: 190,
            b: 72
          },
          hex: 'F1BE48',
          positionInBook: 104,
          pageNumberInBook: '16'
        },
        {
          code: '143 C',
          name: null,
          rgb: {
            r: 241,
            g: 180,
            b: 52
          },
          hex: 'F1B434',
          positionInBook: 105,
          pageNumberInBook: '16'
        },
        {
          code: '144 C',
          name: null,
          rgb: {
            r: 237,
            g: 139,
            b: 0
          },
          hex: 'ED8B00',
          positionInBook: 106,
          pageNumberInBook: '16'
        },
        {
          code: '145 C',
          name: null,
          rgb: {
            r: 207,
            g: 127,
            b: 0
          },
          hex: 'CF7F00',
          positionInBook: 107,
          pageNumberInBook: '16'
        },
        {
          code: '146 C',
          name: null,
          rgb: {
            r: 167,
            g: 109,
            b: 17
          },
          hex: 'A76D11',
          positionInBook: 108,
          pageNumberInBook: '16'
        },
        {
          code: '147 C',
          name: null,
          rgb: {
            r: 113,
            g: 92,
            b: 42
          },
          hex: '715C2A',
          positionInBook: 109,
          pageNumberInBook: '16'
        },
        {
          code: '4008 C',
          name: null,
          rgb: {
            r: 244,
            g: 175,
            b: 35
          },
          hex: 'F4AF23',
          positionInBook: 110,
          pageNumberInBook: '17'
        },
        {
          code: '4009 C',
          name: null,
          rgb: {
            r: 241,
            g: 156,
            b: 73
          },
          hex: 'F19C49',
          positionInBook: 111,
          pageNumberInBook: '17'
        },
        {
          code: '4010 C',
          name: null,
          rgb: {
            r: 229,
            g: 105,
            b: 16
          },
          hex: 'E56910',
          positionInBook: 112,
          pageNumberInBook: '17'
        },
        {
          code: '4011 C',
          name: null,
          rgb: {
            r: 222,
            g: 117,
            b: 76
          },
          hex: 'DE754C',
          positionInBook: 113,
          pageNumberInBook: '17'
        },
        {
          code: '4012 C',
          name: null,
          rgb: {
            r: 234,
            g: 115,
            b: 61
          },
          hex: 'EA733D',
          positionInBook: 114,
          pageNumberInBook: '17'
        },
        {
          code: '4013 C',
          name: null,
          rgb: {
            r: 204,
            g: 108,
            b: 39
          },
          hex: 'CC6C27',
          positionInBook: 115,
          pageNumberInBook: '17'
        },
        {
          code: '4014 C',
          name: null,
          rgb: {
            r: 184,
            g: 103,
            b: 72
          },
          hex: 'B86748',
          positionInBook: 116,
          pageNumberInBook: '17'
        },
        {
          code: '3514 C',
          name: null,
          rgb: {
            r: 246,
            g: 183,
            b: 0
          },
          hex: 'F6B700',
          positionInBook: 117,
          pageNumberInBook: '18'
        },
        {
          code: '3596 C',
          name: null,
          rgb: {
            r: 222,
            g: 188,
            b: 139
          },
          hex: 'DEBC8B',
          positionInBook: 118,
          pageNumberInBook: '18'
        },
        {
          code: '3547 C',
          name: null,
          rgb: {
            r: 197,
            g: 144,
            b: 20
          },
          hex: 'C59014',
          positionInBook: 119,
          pageNumberInBook: '18'
        },
        {
          code: '3588 C',
          name: null,
          rgb: {
            r: 255,
            g: 148,
            b: 37
          },
          hex: 'FF9425',
          positionInBook: 120,
          pageNumberInBook: '18'
        },
        {
          code: '3564 C',
          name: null,
          rgb: {
            r: 239,
            g: 106,
            b: 0
          },
          hex: 'EF6A00',
          positionInBook: 121,
          pageNumberInBook: '18'
        },
        {
          code: '2428 C',
          name: null,
          rgb: {
            r: 222,
            g: 136,
            b: 45
          },
          hex: 'DE882D',
          positionInBook: 122,
          pageNumberInBook: '18'
        },
        {
          code: '2429 C',
          name: null,
          rgb: {
            r: 194,
            g: 94,
            b: 28
          },
          hex: 'C25E1C',
          positionInBook: 123,
          pageNumberInBook: '18'
        },
        {
          code: '4015 C',
          name: null,
          rgb: {
            r: 211,
            g: 199,
            b: 99
          },
          hex: 'D3C763',
          positionInBook: 124,
          pageNumberInBook: '19'
        },
        {
          code: '4016 C',
          name: null,
          rgb: {
            r: 213,
            g: 191,
            b: 57
          },
          hex: 'D5BF39',
          positionInBook: 125,
          pageNumberInBook: '19'
        },
        {
          code: '4017 C',
          name: null,
          rgb: {
            r: 222,
            g: 184,
            b: 59
          },
          hex: 'DEB83B',
          positionInBook: 126,
          pageNumberInBook: '19'
        },
        {
          code: '4018 C',
          name: null,
          rgb: {
            r: 209,
            g: 178,
            b: 73
          },
          hex: 'D1B249',
          positionInBook: 127,
          pageNumberInBook: '19'
        },
        {
          code: '4019 C',
          name: null,
          rgb: {
            r: 194,
            g: 168,
            b: 77
          },
          hex: 'C2A84D',
          positionInBook: 128,
          pageNumberInBook: '19'
        },
        {
          code: '4020 C',
          name: null,
          rgb: {
            r: 191,
            g: 159,
            b: 0
          },
          hex: 'BF9F00',
          positionInBook: 129,
          pageNumberInBook: '19'
        },
        {
          code: '4021 C',
          name: null,
          rgb: {
            r: 175,
            g: 147,
            b: 53
          },
          hex: 'AF9335',
          positionInBook: 130,
          pageNumberInBook: '19'
        },
        {
          code: '7408 C',
          name: null,
          rgb: {
            r: 246,
            g: 190,
            b: 0
          },
          hex: 'F6BE00',
          positionInBook: 131,
          pageNumberInBook: '20'
        },
        {
          code: '7409 C',
          name: null,
          rgb: {
            r: 240,
            g: 179,
            b: 35
          },
          hex: 'F0B323',
          positionInBook: 132,
          pageNumberInBook: '20'
        },
        {
          code: '7410 C',
          name: null,
          rgb: {
            r: 254,
            g: 173,
            b: 119
          },
          hex: 'FEAD77',
          positionInBook: 133,
          pageNumberInBook: '20'
        },
        {
          code: '7411 C',
          name: null,
          rgb: {
            r: 230,
            g: 166,
            b: 93
          },
          hex: 'E6A65D',
          positionInBook: 134,
          pageNumberInBook: '20'
        },
        {
          code: '7412 C',
          name: null,
          rgb: {
            r: 211,
            g: 130,
            b: 53
          },
          hex: 'D38235',
          positionInBook: 135,
          pageNumberInBook: '20'
        },
        {
          code: '7413 C',
          name: null,
          rgb: {
            r: 220,
            g: 134,
            b: 51
          },
          hex: 'DC8633',
          positionInBook: 136,
          pageNumberInBook: '20'
        },
        {
          code: '7414 C',
          name: null,
          rgb: {
            r: 193,
            g: 108,
            b: 24
          },
          hex: 'C16C18',
          positionInBook: 137,
          pageNumberInBook: '20'
        },
        {
          code: '7562 C',
          name: null,
          rgb: {
            r: 189,
            g: 155,
            b: 96
          },
          hex: 'BD9B60',
          positionInBook: 138,
          pageNumberInBook: '21'
        },
        {
          code: '7563 C',
          name: null,
          rgb: {
            r: 214,
            g: 154,
            b: 45
          },
          hex: 'D69A2D',
          positionInBook: 139,
          pageNumberInBook: '21'
        },
        {
          code: '7564 C',
          name: null,
          rgb: {
            r: 219,
            g: 138,
            b: 6
          },
          hex: 'DB8A06',
          positionInBook: 140,
          pageNumberInBook: '21'
        },
        {
          code: '7565 C',
          name: null,
          rgb: {
            r: 205,
            g: 121,
            b: 37
          },
          hex: 'CD7925',
          positionInBook: 141,
          pageNumberInBook: '21'
        },
        {
          code: '7566 C',
          name: null,
          rgb: {
            r: 173,
            g: 100,
            b: 51
          },
          hex: 'AD6433',
          positionInBook: 142,
          pageNumberInBook: '21'
        },
        {
          code: '7567 C',
          name: null,
          rgb: {
            r: 137,
            g: 83,
            b: 47
          },
          hex: '89532F',
          positionInBook: 143,
          pageNumberInBook: '21'
        },
        {
          code: '7568 C',
          name: null,
          rgb: {
            r: 120,
            g: 81,
            b: 53
          },
          hex: '785135',
          positionInBook: 144,
          pageNumberInBook: '21'
        },
        {
          code: '7569 C',
          name: null,
          rgb: {
            r: 215,
            g: 136,
            b: 37
          },
          hex: 'D78825',
          positionInBook: 145,
          pageNumberInBook: '22'
        },
        {
          code: '7570 C',
          name: null,
          rgb: {
            r: 211,
            g: 131,
            b: 43
          },
          hex: 'D3832B',
          positionInBook: 146,
          pageNumberInBook: '22'
        },
        {
          code: '7571 C',
          name: null,
          rgb: {
            r: 198,
            g: 125,
            b: 48
          },
          hex: 'C67D30',
          positionInBook: 147,
          pageNumberInBook: '22'
        },
        {
          code: '7572 C',
          name: null,
          rgb: {
            r: 182,
            g: 114,
            b: 51
          },
          hex: 'B67233',
          positionInBook: 148,
          pageNumberInBook: '22'
        },
        {
          code: '7573 C',
          name: null,
          rgb: {
            r: 167,
            g: 102,
            b: 43
          },
          hex: 'A7662B',
          positionInBook: 149,
          pageNumberInBook: '22'
        },
        {
          code: '7574 C',
          name: null,
          rgb: {
            r: 158,
            g: 106,
            b: 55
          },
          hex: '9E6A37',
          positionInBook: 150,
          pageNumberInBook: '22'
        },
        {
          code: '7575 C',
          name: null,
          rgb: {
            r: 131,
            g: 93,
            b: 50
          },
          hex: '835D32',
          positionInBook: 151,
          pageNumberInBook: '22'
        },
        {
          code: '4022 C',
          name: null,
          rgb: {
            r: 206,
            g: 180,
            b: 126
          },
          hex: 'CEB47E',
          positionInBook: 152,
          pageNumberInBook: '23'
        },
        {
          code: '4023 C',
          name: null,
          rgb: {
            r: 210,
            g: 180,
            b: 103
          },
          hex: 'D2B467',
          positionInBook: 153,
          pageNumberInBook: '23'
        },
        {
          code: '4024 C',
          name: null,
          rgb: {
            r: 212,
            g: 173,
            b: 103
          },
          hex: 'D4AD67',
          positionInBook: 154,
          pageNumberInBook: '23'
        },
        {
          code: '4025 C',
          name: null,
          rgb: {
            r: 215,
            g: 160,
            b: 72
          },
          hex: 'D7A048',
          positionInBook: 155,
          pageNumberInBook: '23'
        },
        {
          code: '4026 C',
          name: null,
          rgb: {
            r: 188,
            g: 140,
            b: 61
          },
          hex: 'BC8C3D',
          positionInBook: 156,
          pageNumberInBook: '23'
        },
        {
          code: '4027 C',
          name: null,
          rgb: {
            r: 142,
            g: 99,
            b: 32
          },
          hex: '8E6320',
          positionInBook: 157,
          pageNumberInBook: '23'
        },
        {
          code: '4028 C',
          name: null,
          rgb: {
            r: 131,
            g: 96,
            b: 43
          },
          hex: '83602B',
          positionInBook: 158,
          pageNumberInBook: '23'
        },
        {
          code: '4029 C',
          name: null,
          rgb: {
            r: 233,
            g: 205,
            b: 165
          },
          hex: 'E9CDA5',
          positionInBook: 159,
          pageNumberInBook: '24'
        },
        {
          code: '4030 C',
          name: null,
          rgb: {
            r: 241,
            g: 202,
            b: 173
          },
          hex: 'F1CAAD',
          positionInBook: 160,
          pageNumberInBook: '24'
        },
        {
          code: '4031 C',
          name: null,
          rgb: {
            r: 234,
            g: 203,
            b: 187
          },
          hex: 'EACBBB',
          positionInBook: 161,
          pageNumberInBook: '24'
        },
        {
          code: '4032 C',
          name: null,
          rgb: {
            r: 245,
            g: 202,
            b: 191
          },
          hex: 'F5CABF',
          positionInBook: 162,
          pageNumberInBook: '24'
        },
        {
          code: '4033 C',
          name: null,
          rgb: {
            r: 247,
            g: 188,
            b: 172
          },
          hex: 'F7BCAC',
          positionInBook: 163,
          pageNumberInBook: '24'
        },
        {
          code: '4034 C',
          name: null,
          rgb: {
            r: 203,
            g: 149,
            b: 118
          },
          hex: 'CB9576',
          positionInBook: 164,
          pageNumberInBook: '24'
        },
        {
          code: '4035 C',
          name: null,
          rgb: {
            r: 199,
            g: 150,
            b: 116
          },
          hex: 'C79674',
          positionInBook: 165,
          pageNumberInBook: '24'
        },
        {
          code: '148 C',
          name: null,
          rgb: {
            r: 254,
            g: 203,
            b: 139
          },
          hex: 'FECB8B',
          positionInBook: 166,
          pageNumberInBook: '25'
        },
        {
          code: '149 C',
          name: null,
          rgb: {
            r: 255,
            g: 194,
            b: 123
          },
          hex: 'FFC27B',
          positionInBook: 167,
          pageNumberInBook: '25'
        },
        {
          code: '150 C',
          name: null,
          rgb: {
            r: 255,
            g: 178,
            b: 91
          },
          hex: 'FFB25B',
          positionInBook: 168,
          pageNumberInBook: '25'
        },
        {
          code: '151 C',
          name: null,
          rgb: {
            r: 255,
            g: 130,
            b: 0
          },
          hex: 'FF8200',
          positionInBook: 169,
          pageNumberInBook: '25'
        },
        {
          code: '152 C',
          name: null,
          rgb: {
            r: 229,
            g: 114,
            b: 0
          },
          hex: 'E57200',
          positionInBook: 170,
          pageNumberInBook: '25'
        },
        {
          code: '153 C',
          name: null,
          rgb: {
            r: 190,
            g: 106,
            b: 20
          },
          hex: 'BE6A14',
          positionInBook: 171,
          pageNumberInBook: '25'
        },
        {
          code: '154 C',
          name: null,
          rgb: {
            r: 155,
            g: 90,
            b: 26
          },
          hex: '9B5A1A',
          positionInBook: 172,
          pageNumberInBook: '25'
        },
        {
          code: '155 C',
          name: null,
          rgb: {
            r: 239,
            g: 209,
            b: 159
          },
          hex: 'EFD19F',
          positionInBook: 173,
          pageNumberInBook: '26'
        },
        {
          code: '156 C',
          name: null,
          rgb: {
            r: 239,
            g: 190,
            b: 125
          },
          hex: 'EFBE7D',
          positionInBook: 174,
          pageNumberInBook: '26'
        },
        {
          code: '157 C',
          name: null,
          rgb: {
            r: 236,
            g: 161,
            b: 84
          },
          hex: 'ECA154',
          positionInBook: 175,
          pageNumberInBook: '26'
        },
        {
          code: '158 C',
          name: null,
          rgb: {
            r: 232,
            g: 119,
            b: 34
          },
          hex: 'E87722',
          positionInBook: 176,
          pageNumberInBook: '26'
        },
        {
          code: '159 C',
          name: null,
          rgb: {
            r: 203,
            g: 96,
            b: 21
          },
          hex: 'CB6015',
          positionInBook: 177,
          pageNumberInBook: '26'
        },
        {
          code: '160 C',
          name: null,
          rgb: {
            r: 161,
            g: 86,
            b: 28
          },
          hex: 'A1561C',
          positionInBook: 178,
          pageNumberInBook: '26'
        },
        {
          code: '161 C',
          name: null,
          rgb: {
            r: 96,
            g: 61,
            b: 32
          },
          hex: '603D20',
          positionInBook: 179,
          pageNumberInBook: '26'
        },
        {
          code: '1485 C',
          name: null,
          rgb: {
            r: 255,
            g: 174,
            b: 98
          },
          hex: 'FFAE62',
          positionInBook: 180,
          pageNumberInBook: '27'
        },
        {
          code: '1495 C',
          name: null,
          rgb: {
            r: 255,
            g: 143,
            b: 28
          },
          hex: 'FF8F1C',
          positionInBook: 181,
          pageNumberInBook: '27'
        },
        {
          code: '1505 C',
          name: null,
          rgb: {
            r: 255,
            g: 105,
            b: 0
          },
          hex: 'FF6900',
          positionInBook: 182,
          pageNumberInBook: '27'
        },
        {
          code: 'Orange 021 C',
          name: null,
          rgb: {
            r: 254,
            g: 80,
            b: 0
          },
          hex: 'FE5000',
          positionInBook: 183,
          pageNumberInBook: '27'
        },
        {
          code: '1525 C',
          name: null,
          rgb: {
            r: 185,
            g: 71,
            b: 0
          },
          hex: 'B94700',
          positionInBook: 184,
          pageNumberInBook: '27'
        },
        {
          code: '1535 C',
          name: null,
          rgb: {
            r: 148,
            g: 69,
            b: 11
          },
          hex: '94450B',
          positionInBook: 185,
          pageNumberInBook: '27'
        },
        {
          code: '1545 C',
          name: null,
          rgb: {
            r: 101,
            g: 56,
            b: 24
          },
          hex: '653818',
          positionInBook: 186,
          pageNumberInBook: '27'
        },
        {
          code: '1555 C',
          name: null,
          rgb: {
            r: 255,
            g: 185,
            b: 144
          },
          hex: 'FFB990',
          positionInBook: 187,
          pageNumberInBook: '28'
        },
        {
          code: '1565 C',
          name: null,
          rgb: {
            r: 255,
            g: 160,
            b: 106
          },
          hex: 'FFA06A',
          positionInBook: 188,
          pageNumberInBook: '28'
        },
        {
          code: '1575 C',
          name: null,
          rgb: {
            r: 255,
            g: 127,
            b: 50
          },
          hex: 'FF7F32',
          positionInBook: 189,
          pageNumberInBook: '28'
        },
        {
          code: '1585 C',
          name: null,
          rgb: {
            r: 255,
            g: 106,
            b: 20
          },
          hex: 'FF6A14',
          positionInBook: 190,
          pageNumberInBook: '28'
        },
        {
          code: '1595 C',
          name: null,
          rgb: {
            r: 216,
            g: 96,
            b: 24
          },
          hex: 'D86018',
          positionInBook: 191,
          pageNumberInBook: '28'
        },
        {
          code: '1605 C',
          name: null,
          rgb: {
            r: 166,
            g: 85,
            b: 35
          },
          hex: 'A65523',
          positionInBook: 192,
          pageNumberInBook: '28'
        },
        {
          code: '1615 C',
          name: null,
          rgb: {
            r: 139,
            g: 71,
            b: 32
          },
          hex: '8B4720',
          positionInBook: 193,
          pageNumberInBook: '28'
        },
        {
          code: '712 C',
          name: null,
          rgb: {
            r: 252,
            g: 200,
            b: 155
          },
          hex: 'FCC89B',
          positionInBook: 194,
          pageNumberInBook: '29'
        },
        {
          code: '713 C',
          name: null,
          rgb: {
            r: 253,
            g: 190,
            b: 135
          },
          hex: 'FDBE87',
          positionInBook: 195,
          pageNumberInBook: '29'
        },
        {
          code: '714 C',
          name: null,
          rgb: {
            r: 253,
            g: 170,
            b: 99
          },
          hex: 'FDAA63',
          positionInBook: 196,
          pageNumberInBook: '29'
        },
        {
          code: '715 C',
          name: null,
          rgb: {
            r: 246,
            g: 141,
            b: 46
          },
          hex: 'F68D2E',
          positionInBook: 197,
          pageNumberInBook: '29'
        },
        {
          code: '716 C',
          name: null,
          rgb: {
            r: 234,
            g: 118,
            b: 0
          },
          hex: 'EA7600',
          positionInBook: 198,
          pageNumberInBook: '29'
        },
        {
          code: '717 C',
          name: null,
          rgb: {
            r: 212,
            g: 93,
            b: 0
          },
          hex: 'D45D00',
          positionInBook: 199,
          pageNumberInBook: '29'
        },
        {
          code: '718 C',
          name: null,
          rgb: {
            r: 190,
            g: 77,
            b: 0
          },
          hex: 'BE4D00',
          positionInBook: 200,
          pageNumberInBook: '29'
        },
        {
          code: '2015 C',
          name: null,
          rgb: {
            r: 248,
            g: 207,
            b: 169
          },
          hex: 'F8CFA9',
          positionInBook: 201,
          pageNumberInBook: '30'
        },
        {
          code: '2016 C',
          name: null,
          rgb: {
            r: 255,
            g: 182,
            b: 115
          },
          hex: 'FFB673',
          positionInBook: 202,
          pageNumberInBook: '30'
        },
        {
          code: '2017 C',
          name: null,
          rgb: {
            r: 248,
            g: 173,
            b: 109
          },
          hex: 'F8AD6D',
          positionInBook: 203,
          pageNumberInBook: '30'
        },
        {
          code: '2018 C',
          name: null,
          rgb: {
            r: 255,
            g: 117,
            b: 0
          },
          hex: 'FF7500',
          positionInBook: 204,
          pageNumberInBook: '30'
        },
        {
          code: '2019 C',
          name: null,
          rgb: {
            r: 215,
            g: 107,
            b: 0
          },
          hex: 'D76B00',
          positionInBook: 205,
          pageNumberInBook: '30'
        },
        {
          code: '2020 C',
          name: null,
          rgb: {
            r: 190,
            g: 84,
            b: 0
          },
          hex: 'BE5400',
          positionInBook: 206,
          pageNumberInBook: '30'
        },
        {
          code: '2021 C',
          name: null,
          rgb: {
            r: 157,
            g: 72,
            b: 21
          },
          hex: '9D4815',
          positionInBook: 207,
          pageNumberInBook: '30'
        },
        {
          code: '2022 C',
          name: null,
          rgb: {
            r: 250,
            g: 170,
            b: 141
          },
          hex: 'FAAA8D',
          positionInBook: 208,
          pageNumberInBook: '31'
        },
        {
          code: '2023 C',
          name: null,
          rgb: {
            r: 250,
            g: 147,
            b: 112
          },
          hex: 'FA9370',
          positionInBook: 209,
          pageNumberInBook: '31'
        },
        {
          code: '2024 C',
          name: null,
          rgb: {
            r: 248,
            g: 124,
            b: 86
          },
          hex: 'F87C56',
          positionInBook: 210,
          pageNumberInBook: '31'
        },
        {
          code: '2025 C',
          name: null,
          rgb: {
            r: 255,
            g: 138,
            b: 61
          },
          hex: 'FF8A3D',
          positionInBook: 211,
          pageNumberInBook: '31'
        },
        {
          code: '2026 C',
          name: null,
          rgb: {
            r: 244,
            g: 99,
            b: 58
          },
          hex: 'F4633A',
          positionInBook: 212,
          pageNumberInBook: '31'
        },
        {
          code: '2027 C',
          name: null,
          rgb: {
            r: 238,
            g: 83,
            b: 64
          },
          hex: 'EE5340',
          positionInBook: 213,
          pageNumberInBook: '31'
        },
        {
          code: '2028 C',
          name: null,
          rgb: {
            r: 235,
            g: 51,
            b: 0
          },
          hex: 'EB3300',
          positionInBook: 214,
          pageNumberInBook: '31'
        },
        {
          code: '162 C',
          name: null,
          rgb: {
            r: 255,
            g: 190,
            b: 159
          },
          hex: 'FFBE9F',
          positionInBook: 215,
          pageNumberInBook: '32'
        },
        {
          code: '163 C',
          name: null,
          rgb: {
            r: 255,
            g: 157,
            b: 110
          },
          hex: 'FF9D6E',
          positionInBook: 216,
          pageNumberInBook: '32'
        },
        {
          code: '164 C',
          name: null,
          rgb: {
            r: 255,
            g: 127,
            b: 65
          },
          hex: 'FF7F41',
          positionInBook: 217,
          pageNumberInBook: '32'
        },
        {
          code: '165 C',
          name: null,
          rgb: {
            r: 255,
            g: 103,
            b: 32
          },
          hex: 'FF6720',
          positionInBook: 218,
          pageNumberInBook: '32'
        },
        {
          code: '166 C',
          name: null,
          rgb: {
            r: 227,
            g: 82,
            b: 5
          },
          hex: 'E35205',
          positionInBook: 219,
          pageNumberInBook: '32'
        },
        {
          code: '167 C',
          name: null,
          rgb: {
            r: 190,
            g: 83,
            b: 28
          },
          hex: 'BE531C',
          positionInBook: 220,
          pageNumberInBook: '32'
        },
        {
          code: '168 C',
          name: null,
          rgb: {
            r: 115,
            g: 57,
            b: 29
          },
          hex: '73391D',
          positionInBook: 221,
          pageNumberInBook: '32'
        },
        {
          code: '7576 C',
          name: null,
          rgb: {
            r: 219,
            g: 134,
            b: 78
          },
          hex: 'DB864E',
          positionInBook: 222,
          pageNumberInBook: '33'
        },
        {
          code: '7577 C',
          name: null,
          rgb: {
            r: 224,
            g: 126,
            b: 60
          },
          hex: 'E07E3C',
          positionInBook: 223,
          pageNumberInBook: '33'
        },
        {
          code: '7578 C',
          name: null,
          rgb: {
            r: 219,
            g: 107,
            b: 48
          },
          hex: 'DB6B30',
          positionInBook: 224,
          pageNumberInBook: '33'
        },
        {
          code: '7579 C',
          name: null,
          rgb: {
            r: 220,
            g: 88,
            b: 42
          },
          hex: 'DC582A',
          positionInBook: 225,
          pageNumberInBook: '33'
        },
        {
          code: '7580 C',
          name: null,
          rgb: {
            r: 192,
            g: 81,
            b: 49
          },
          hex: 'C05131',
          positionInBook: 226,
          pageNumberInBook: '33'
        },
        {
          code: '7581 C',
          name: null,
          rgb: {
            r: 134,
            g: 74,
            b: 51
          },
          hex: '864A33',
          positionInBook: 227,
          pageNumberInBook: '33'
        },
        {
          code: '7582 C',
          name: null,
          rgb: {
            r: 103,
            g: 71,
            b: 54
          },
          hex: '674736',
          positionInBook: 228,
          pageNumberInBook: '33'
        },
        {
          code: '2430 C',
          name: null,
          rgb: {
            r: 215,
            g: 161,
            b: 121
          },
          hex: 'D7A179',
          positionInBook: 229,
          pageNumberInBook: '34'
        },
        {
          code: '2431 C',
          name: null,
          rgb: {
            r: 222,
            g: 147,
            b: 83
          },
          hex: 'DE9353',
          positionInBook: 230,
          pageNumberInBook: '34'
        },
        {
          code: '2432 C',
          name: null,
          rgb: {
            r: 222,
            g: 140,
            b: 89
          },
          hex: 'DE8C59',
          positionInBook: 231,
          pageNumberInBook: '34'
        },
        {
          code: '2433 C',
          name: null,
          rgb: {
            r: 219,
            g: 123,
            b: 81
          },
          hex: 'DB7B51',
          positionInBook: 232,
          pageNumberInBook: '34'
        },
        {
          code: '2434 C',
          name: null,
          rgb: {
            r: 227,
            g: 120,
            b: 94
          },
          hex: 'E3785E',
          positionInBook: 233,
          pageNumberInBook: '34'
        },
        {
          code: '2435 C',
          name: null,
          rgb: {
            r: 193,
            g: 112,
            b: 89
          },
          hex: 'C17059',
          positionInBook: 234,
          pageNumberInBook: '34'
        },
        {
          code: '2436 C',
          name: null,
          rgb: {
            r: 182,
            g: 83,
            b: 62
          },
          hex: 'B6533E',
          positionInBook: 235,
          pageNumberInBook: '34'
        },
        {
          code: '1625 C',
          name: null,
          rgb: {
            r: 255,
            g: 163,
            b: 139
          },
          hex: 'FFA38B',
          positionInBook: 236,
          pageNumberInBook: '35'
        },
        {
          code: '1635 C',
          name: null,
          rgb: {
            r: 255,
            g: 141,
            b: 109
          },
          hex: 'FF8D6D',
          positionInBook: 237,
          pageNumberInBook: '35'
        },
        {
          code: '1645 C',
          name: null,
          rgb: {
            r: 255,
            g: 106,
            b: 57
          },
          hex: 'FF6A39',
          positionInBook: 238,
          pageNumberInBook: '35'
        },
        {
          code: '1655 C',
          name: null,
          rgb: {
            r: 252,
            g: 76,
            b: 2
          },
          hex: 'FC4C02',
          positionInBook: 239,
          pageNumberInBook: '35'
        },
        {
          code: '1665 C',
          name: null,
          rgb: {
            r: 220,
            g: 68,
            b: 5
          },
          hex: 'DC4405',
          positionInBook: 240,
          pageNumberInBook: '35'
        },
        {
          code: '1675 C',
          name: null,
          rgb: {
            r: 169,
            g: 67,
            b: 30
          },
          hex: 'A9431E',
          positionInBook: 241,
          pageNumberInBook: '35'
        },
        {
          code: '1685 C',
          name: null,
          rgb: {
            r: 131,
            g: 57,
            b: 33
          },
          hex: '833921',
          positionInBook: 242,
          pageNumberInBook: '35'
        },
        {
          code: '169 C',
          name: null,
          rgb: {
            r: 255,
            g: 179,
            b: 171
          },
          hex: 'FFB3AB',
          positionInBook: 243,
          pageNumberInBook: '36'
        },
        {
          code: '170 C',
          name: null,
          rgb: {
            r: 255,
            g: 134,
            b: 116
          },
          hex: 'FF8674',
          positionInBook: 244,
          pageNumberInBook: '36'
        },
        {
          code: '171 C',
          name: null,
          rgb: {
            r: 255,
            g: 92,
            b: 57
          },
          hex: 'FF5C39',
          positionInBook: 245,
          pageNumberInBook: '36'
        },
        {
          code: '172 C',
          name: null,
          rgb: {
            r: 250,
            g: 70,
            b: 22
          },
          hex: 'FA4616',
          positionInBook: 246,
          pageNumberInBook: '36'
        },
        {
          code: '173 C',
          name: null,
          rgb: {
            r: 207,
            g: 69,
            b: 32
          },
          hex: 'CF4520',
          positionInBook: 247,
          pageNumberInBook: '36'
        },
        {
          code: '174 C',
          name: null,
          rgb: {
            r: 150,
            g: 56,
            b: 33
          },
          hex: '963821',
          positionInBook: 248,
          pageNumberInBook: '36'
        },
        {
          code: '175 C',
          name: null,
          rgb: {
            r: 107,
            g: 53,
            b: 41
          },
          hex: '6B3529',
          positionInBook: 249,
          pageNumberInBook: '36'
        },
        {
          code: '7583 C',
          name: null,
          rgb: {
            r: 196,
            g: 98,
            b: 45
          },
          hex: 'C4622D',
          positionInBook: 250,
          pageNumberInBook: '37'
        },
        {
          code: '7584 C',
          name: null,
          rgb: {
            r: 186,
            g: 88,
            b: 38
          },
          hex: 'BA5826',
          positionInBook: 251,
          pageNumberInBook: '37'
        },
        {
          code: '7585 C',
          name: null,
          rgb: {
            r: 176,
            g: 92,
            b: 55
          },
          hex: 'B05C37',
          positionInBook: 252,
          pageNumberInBook: '37'
        },
        {
          code: '7586 C',
          name: null,
          rgb: {
            r: 158,
            g: 83,
            b: 48
          },
          hex: '9E5330',
          positionInBook: 253,
          pageNumberInBook: '37'
        },
        {
          code: '7587 C',
          name: null,
          rgb: {
            r: 146,
            g: 76,
            b: 46
          },
          hex: '924C2E',
          positionInBook: 254,
          pageNumberInBook: '37'
        },
        {
          code: '7588 C',
          name: null,
          rgb: {
            r: 123,
            g: 77,
            b: 53
          },
          hex: '7B4D35',
          positionInBook: 255,
          pageNumberInBook: '37'
        },
        {
          code: '7589 C',
          name: null,
          rgb: {
            r: 92,
            g: 71,
            b: 56
          },
          hex: '5C4738',
          positionInBook: 256,
          pageNumberInBook: '37'
        },
        {
          code: '7590 C',
          name: null,
          rgb: {
            r: 212,
            g: 181,
            b: 158
          },
          hex: 'D4B59E',
          positionInBook: 257,
          pageNumberInBook: '38'
        },
        {
          code: '7591 C',
          name: null,
          rgb: {
            r: 192,
            g: 125,
            b: 89
          },
          hex: 'C07D59',
          positionInBook: 258,
          pageNumberInBook: '38'
        },
        {
          code: '7592 C',
          name: null,
          rgb: {
            r: 177,
            g: 85,
            b: 51
          },
          hex: 'B15533',
          positionInBook: 259,
          pageNumberInBook: '38'
        },
        {
          code: '7593 C',
          name: null,
          rgb: {
            r: 157,
            g: 67,
            b: 44
          },
          hex: '9D432C',
          positionInBook: 260,
          pageNumberInBook: '38'
        },
        {
          code: '7594 C',
          name: null,
          rgb: {
            r: 124,
            g: 58,
            b: 45
          },
          hex: '7C3A2D',
          positionInBook: 261,
          pageNumberInBook: '38'
        },
        {
          code: '7595 C',
          name: null,
          rgb: {
            r: 107,
            g: 61,
            b: 46
          },
          hex: '6B3D2E',
          positionInBook: 262,
          pageNumberInBook: '38'
        },
        {
          code: '7596 C',
          name: null,
          rgb: {
            r: 92,
            g: 61,
            b: 49
          },
          hex: '5C3D31',
          positionInBook: 263,
          pageNumberInBook: '38'
        },
        {
          code: '7597 C',
          name: null,
          rgb: {
            r: 209,
            g: 65,
            b: 36
          },
          hex: 'D14124',
          positionInBook: 264,
          pageNumberInBook: '39'
        },
        {
          code: '7598 C',
          name: null,
          rgb: {
            r: 189,
            g: 71,
            b: 42
          },
          hex: 'BD472A',
          positionInBook: 265,
          pageNumberInBook: '39'
        },
        {
          code: '7599 C',
          name: null,
          rgb: {
            r: 179,
            g: 61,
            b: 38
          },
          hex: 'B33D26',
          positionInBook: 266,
          pageNumberInBook: '39'
        },
        {
          code: '7600 C',
          name: null,
          rgb: {
            r: 141,
            g: 63,
            b: 43
          },
          hex: '8D3F2B',
          positionInBook: 267,
          pageNumberInBook: '39'
        },
        {
          code: '7601 C',
          name: null,
          rgb: {
            r: 131,
            g: 65,
            b: 44
          },
          hex: '83412C',
          positionInBook: 268,
          pageNumberInBook: '39'
        },
        {
          code: '7602 C',
          name: null,
          rgb: {
            r: 123,
            g: 73,
            b: 49
          },
          hex: '7B4931',
          positionInBook: 269,
          pageNumberInBook: '39'
        },
        {
          code: '7603 C',
          name: null,
          rgb: {
            r: 103,
            g: 66,
            b: 48
          },
          hex: '674230',
          positionInBook: 270,
          pageNumberInBook: '39'
        },
        {
          code: '7604 C',
          name: null,
          rgb: {
            r: 228,
            g: 213,
            b: 211
          },
          hex: 'E4D5D3',
          positionInBook: 271,
          pageNumberInBook: '40'
        },
        {
          code: '7605 C',
          name: null,
          rgb: {
            r: 225,
            g: 187,
            b: 180
          },
          hex: 'E1BBB4',
          positionInBook: 272,
          pageNumberInBook: '40'
        },
        {
          code: '7606 C',
          name: null,
          rgb: {
            r: 214,
            g: 147,
            b: 138
          },
          hex: 'D6938A',
          positionInBook: 273,
          pageNumberInBook: '40'
        },
        {
          code: '7607 C',
          name: null,
          rgb: {
            r: 194,
            g: 110,
            b: 96
          },
          hex: 'C26E60',
          positionInBook: 274,
          pageNumberInBook: '40'
        },
        {
          code: '7608 C',
          name: null,
          rgb: {
            r: 164,
            g: 73,
            b: 61
          },
          hex: 'A4493D',
          positionInBook: 275,
          pageNumberInBook: '40'
        },
        {
          code: '7609 C',
          name: null,
          rgb: {
            r: 130,
            g: 59,
            b: 52
          },
          hex: '823B34',
          positionInBook: 276,
          pageNumberInBook: '40'
        },
        {
          code: '7610 C',
          name: null,
          rgb: {
            r: 104,
            g: 52,
            b: 49
          },
          hex: '683431',
          positionInBook: 277,
          pageNumberInBook: '40'
        },
        {
          code: '3544 C',
          name: null,
          rgb: {
            r: 223,
            g: 184,
            b: 167
          },
          hex: 'DFB8A7',
          positionInBook: 278,
          pageNumberInBook: '41'
        },
        {
          code: '2444 C',
          name: null,
          rgb: {
            r: 221,
            g: 166,
            b: 157
          },
          hex: 'DDA69D',
          positionInBook: 279,
          pageNumberInBook: '41'
        },
        {
          code: '3519 C',
          name: null,
          rgb: {
            r: 225,
            g: 166,
            b: 173
          },
          hex: 'E1A6AD',
          positionInBook: 280,
          pageNumberInBook: '41'
        },
        {
          code: '3572 C',
          name: null,
          rgb: {
            r: 255,
            g: 157,
            b: 162
          },
          hex: 'FF9DA2',
          positionInBook: 281,
          pageNumberInBook: '41'
        },
        {
          code: '2445 C',
          name: null,
          rgb: {
            r: 221,
            g: 135,
            b: 141
          },
          hex: 'DD878D',
          positionInBook: 282,
          pageNumberInBook: '41'
        },
        {
          code: '2446 C',
          name: null,
          rgb: {
            r: 208,
            g: 133,
            b: 139
          },
          hex: 'D0858B',
          positionInBook: 283,
          pageNumberInBook: '41'
        },
        {
          code: '2447 C',
          name: null,
          rgb: {
            r: 176,
            g: 111,
            b: 118
          },
          hex: 'B06F76',
          positionInBook: 284,
          pageNumberInBook: '41'
        },
        {
          code: '2337 C',
          name: null,
          rgb: {
            r: 248,
            g: 193,
            b: 184
          },
          hex: 'F8C1B8',
          positionInBook: 285,
          pageNumberInBook: '42'
        },
        {
          code: '2338 C',
          name: null,
          rgb: {
            r: 222,
            g: 163,
            b: 156
          },
          hex: 'DEA39C',
          positionInBook: 286,
          pageNumberInBook: '42'
        },
        {
          code: '2339 C',
          name: null,
          rgb: {
            r: 240,
            g: 148,
            b: 145
          },
          hex: 'F09491',
          positionInBook: 287,
          pageNumberInBook: '42'
        },
        {
          code: '2340 C',
          name: null,
          rgb: {
            r: 207,
            g: 111,
            b: 119
          },
          hex: 'CF6F77',
          positionInBook: 288,
          pageNumberInBook: '42'
        },
        {
          code: '2341 C',
          name: null,
          rgb: {
            r: 182,
            g: 108,
            b: 109
          },
          hex: 'B66C6D',
          positionInBook: 289,
          pageNumberInBook: '42'
        },
        {
          code: '2342 C',
          name: null,
          rgb: {
            r: 182,
            g: 90,
            b: 101
          },
          hex: 'B65A65',
          positionInBook: 290,
          pageNumberInBook: '42'
        },
        {
          code: '2343 C',
          name: null,
          rgb: {
            r: 168,
            g: 85,
            b: 102
          },
          hex: 'A85566',
          positionInBook: 291,
          pageNumberInBook: '42'
        },
        {
          code: '4036 C',
          name: null,
          rgb: {
            r: 192,
            g: 154,
            b: 151
          },
          hex: 'C09A97',
          positionInBook: 292,
          pageNumberInBook: '43'
        },
        {
          code: '4037 C',
          name: null,
          rgb: {
            r: 180,
            g: 125,
            b: 117
          },
          hex: 'B47D75',
          positionInBook: 293,
          pageNumberInBook: '43'
        },
        {
          code: '4038 C',
          name: null,
          rgb: {
            r: 177,
            g: 115,
            b: 104
          },
          hex: 'B17368',
          positionInBook: 294,
          pageNumberInBook: '43'
        },
        {
          code: '4039 C',
          name: null,
          rgb: {
            r: 173,
            g: 105,
            b: 96
          },
          hex: 'AD6960',
          positionInBook: 295,
          pageNumberInBook: '43'
        },
        {
          code: '4040 C',
          name: null,
          rgb: {
            r: 149,
            g: 106,
            b: 100
          },
          hex: '956A64',
          positionInBook: 296,
          pageNumberInBook: '43'
        },
        {
          code: '4041 C',
          name: null,
          rgb: {
            r: 129,
            g: 94,
            b: 88
          },
          hex: '815E58',
          positionInBook: 297,
          pageNumberInBook: '43'
        },
        {
          code: '4042 C',
          name: null,
          rgb: {
            r: 122,
            g: 93,
            b: 83
          },
          hex: '7A5D53',
          positionInBook: 298,
          pageNumberInBook: '43'
        },
        {
          code: '7611 C',
          name: null,
          rgb: {
            r: 221,
            g: 188,
            b: 176
          },
          hex: 'DDBCB0',
          positionInBook: 299,
          pageNumberInBook: '44'
        },
        {
          code: '7612 C',
          name: null,
          rgb: {
            r: 202,
            g: 154,
            b: 142
          },
          hex: 'CA9A8E',
          positionInBook: 300,
          pageNumberInBook: '44'
        },
        {
          code: '7613 C',
          name: null,
          rgb: {
            r: 188,
            g: 138,
            b: 126
          },
          hex: 'BC8A7E',
          positionInBook: 301,
          pageNumberInBook: '44'
        },
        {
          code: '7614 C',
          name: null,
          rgb: {
            r: 164,
            g: 127,
            b: 116
          },
          hex: 'A47F74',
          positionInBook: 302,
          pageNumberInBook: '44'
        },
        {
          code: '7615 C',
          name: null,
          rgb: {
            r: 134,
            g: 103,
            b: 97
          },
          hex: '866761',
          positionInBook: 303,
          pageNumberInBook: '44'
        },
        {
          code: '7616 C',
          name: null,
          rgb: {
            r: 107,
            g: 76,
            b: 76
          },
          hex: '6B4C4C',
          positionInBook: 304,
          pageNumberInBook: '44'
        },
        {
          code: '7617 C',
          name: null,
          rgb: {
            r: 88,
            g: 61,
            b: 62
          },
          hex: '583D3E',
          positionInBook: 305,
          pageNumberInBook: '44'
        },
        {
          code: '7520 C',
          name: null,
          rgb: {
            r: 234,
            g: 190,
            b: 176
          },
          hex: 'EABEB0',
          positionInBook: 306,
          pageNumberInBook: '45'
        },
        {
          code: '7521 C',
          name: null,
          rgb: {
            r: 192,
            g: 156,
            b: 131
          },
          hex: 'C09C83',
          positionInBook: 307,
          pageNumberInBook: '45'
        },
        {
          code: '7522 C',
          name: null,
          rgb: {
            r: 180,
            g: 106,
            b: 85
          },
          hex: 'B46A55',
          positionInBook: 308,
          pageNumberInBook: '45'
        },
        {
          code: '7523 C',
          name: null,
          rgb: {
            r: 171,
            g: 92,
            b: 87
          },
          hex: 'AB5C57',
          positionInBook: 309,
          pageNumberInBook: '45'
        },
        {
          code: '7524 C',
          name: null,
          rgb: {
            r: 164,
            g: 82,
            b: 72
          },
          hex: 'A45248',
          positionInBook: 310,
          pageNumberInBook: '45'
        },
        {
          code: '7525 C',
          name: null,
          rgb: {
            r: 154,
            g: 106,
            b: 79
          },
          hex: '9A6A4F',
          positionInBook: 311,
          pageNumberInBook: '45'
        },
        {
          code: '7526 C',
          name: null,
          rgb: {
            r: 138,
            g: 57,
            b: 27
          },
          hex: '8A391B',
          positionInBook: 312,
          pageNumberInBook: '45'
        },
        {
          code: '2437 C',
          name: null,
          rgb: {
            r: 242,
            g: 191,
            b: 160
          },
          hex: 'F2BFA0',
          positionInBook: 313,
          pageNumberInBook: '46'
        },
        {
          code: '2438 C',
          name: null,
          rgb: {
            r: 227,
            g: 161,
            b: 132
          },
          hex: 'E3A184',
          positionInBook: 314,
          pageNumberInBook: '46'
        },
        {
          code: '2439 C',
          name: null,
          rgb: {
            r: 196,
            g: 134,
            b: 114
          },
          hex: 'C48672',
          positionInBook: 315,
          pageNumberInBook: '46'
        },
        {
          code: '2440 C',
          name: null,
          rgb: {
            r: 181,
            g: 146,
            b: 137
          },
          hex: 'B59289',
          positionInBook: 316,
          pageNumberInBook: '46'
        },
        {
          code: '2441 C',
          name: null,
          rgb: {
            r: 168,
            g: 111,
            b: 95
          },
          hex: 'A86F5F',
          positionInBook: 317,
          pageNumberInBook: '46'
        },
        {
          code: '2442 C',
          name: null,
          rgb: {
            r: 159,
            g: 95,
            b: 84
          },
          hex: '9F5F54',
          positionInBook: 318,
          pageNumberInBook: '46'
        },
        {
          code: '2443 C',
          name: null,
          rgb: {
            r: 142,
            g: 58,
            b: 34
          },
          hex: '8E3A22',
          positionInBook: 319,
          pageNumberInBook: '46'
        },
        {
          code: '4043 C',
          name: null,
          rgb: {
            r: 225,
            g: 196,
            b: 174
          },
          hex: 'E1C4AE',
          positionInBook: 320,
          pageNumberInBook: '47'
        },
        {
          code: '4044 C',
          name: null,
          rgb: {
            r: 196,
            g: 162,
            b: 138
          },
          hex: 'C4A28A',
          positionInBook: 321,
          pageNumberInBook: '47'
        },
        {
          code: '4045 C',
          name: null,
          rgb: {
            r: 186,
            g: 150,
            b: 130
          },
          hex: 'BA9682',
          positionInBook: 322,
          pageNumberInBook: '47'
        },
        {
          code: '4046 C',
          name: null,
          rgb: {
            r: 178,
            g: 151,
            b: 128
          },
          hex: 'B29780',
          positionInBook: 323,
          pageNumberInBook: '47'
        },
        {
          code: '4047 C',
          name: null,
          rgb: {
            r: 171,
            g: 140,
            b: 117
          },
          hex: 'AB8C75',
          positionInBook: 324,
          pageNumberInBook: '47'
        },
        {
          code: '4048 C',
          name: null,
          rgb: {
            r: 161,
            g: 130,
            b: 105
          },
          hex: 'A18269',
          positionInBook: 325,
          pageNumberInBook: '47'
        },
        {
          code: '4049 C',
          name: null,
          rgb: {
            r: 150,
            g: 130,
            b: 109
          },
          hex: '96826D',
          positionInBook: 326,
          pageNumberInBook: '47'
        },
        {
          code: '489 C',
          name: null,
          rgb: {
            r: 236,
            g: 195,
            b: 178
          },
          hex: 'ECC3B2',
          positionInBook: 327,
          pageNumberInBook: '48'
        },
        {
          code: '488 C',
          name: null,
          rgb: {
            r: 236,
            g: 186,
            b: 168
          },
          hex: 'ECBAA8',
          positionInBook: 328,
          pageNumberInBook: '48'
        },
        {
          code: '487 C',
          name: null,
          rgb: {
            r: 234,
            g: 167,
            b: 148
          },
          hex: 'EAA794',
          positionInBook: 329,
          pageNumberInBook: '48'
        },
        {
          code: '486 C',
          name: null,
          rgb: {
            r: 232,
            g: 146,
            b: 124
          },
          hex: 'E8927C',
          positionInBook: 330,
          pageNumberInBook: '48'
        },
        {
          code: '485 C',
          name: null,
          rgb: {
            r: 218,
            g: 41,
            b: 28
          },
          hex: 'DA291C',
          positionInBook: 331,
          pageNumberInBook: '48'
        },
        {
          code: '484 C',
          name: null,
          rgb: {
            r: 154,
            g: 51,
            b: 36
          },
          hex: '9A3324',
          positionInBook: 332,
          pageNumberInBook: '48'
        },
        {
          code: '483 C',
          name: null,
          rgb: {
            r: 101,
            g: 48,
            b: 36
          },
          hex: '653024',
          positionInBook: 333,
          pageNumberInBook: '48'
        },
        {
          code: '2029 C',
          name: null,
          rgb: {
            r: 242,
            g: 130,
            b: 127
          },
          hex: 'F2827F',
          positionInBook: 334,
          pageNumberInBook: '49'
        },
        {
          code: '2030 C',
          name: null,
          rgb: {
            r: 221,
            g: 121,
            b: 117
          },
          hex: 'DD7975',
          positionInBook: 335,
          pageNumberInBook: '49'
        },
        {
          code: '2031 C',
          name: null,
          rgb: {
            r: 214,
            g: 105,
            b: 101
          },
          hex: 'D66965',
          positionInBook: 336,
          pageNumberInBook: '49'
        },
        {
          code: '2032 C',
          name: null,
          rgb: {
            r: 208,
            g: 90,
            b: 87
          },
          hex: 'D05A57',
          positionInBook: 337,
          pageNumberInBook: '49'
        },
        {
          code: '2033 C',
          name: null,
          rgb: {
            r: 197,
            g: 70,
            b: 68
          },
          hex: 'C54644',
          positionInBook: 338,
          pageNumberInBook: '49'
        },
        {
          code: '2034 C',
          name: null,
          rgb: {
            r: 231,
            g: 60,
            b: 62
          },
          hex: 'E73C3E',
          positionInBook: 339,
          pageNumberInBook: '49'
        },
        {
          code: '2035 C',
          name: null,
          rgb: {
            r: 214,
            g: 0,
            b: 28
          },
          hex: 'D6001C',
          positionInBook: 340,
          pageNumberInBook: '49'
        },
        {
          code: '2344 C',
          name: null,
          rgb: {
            r: 241,
            g: 128,
            b: 112
          },
          hex: 'F18070',
          positionInBook: 341,
          pageNumberInBook: '50'
        },
        {
          code: '2345 C',
          name: null,
          rgb: {
            r: 255,
            g: 109,
            b: 106
          },
          hex: 'FF6D6A',
          positionInBook: 342,
          pageNumberInBook: '50'
        },
        {
          code: '2346 C',
          name: null,
          rgb: {
            r: 255,
            g: 88,
            b: 105
          },
          hex: 'FF5869',
          positionInBook: 343,
          pageNumberInBook: '50'
        },
        {
          code: '2347 C',
          name: null,
          rgb: {
            r: 225,
            g: 6,
            b: 0
          },
          hex: 'E10600',
          positionInBook: 344,
          pageNumberInBook: '50'
        },
        {
          code: '2348 C',
          name: null,
          rgb: {
            r: 229,
            g: 85,
            b: 79
          },
          hex: 'E5554F',
          positionInBook: 345,
          pageNumberInBook: '50'
        },
        {
          code: '2349 C',
          name: null,
          rgb: {
            r: 202,
            g: 54,
            b: 4
          },
          hex: 'CA3604',
          positionInBook: 346,
          pageNumberInBook: '50'
        },
        {
          code: '2350 C',
          name: null,
          rgb: {
            r: 175,
            g: 35,
            b: 28
          },
          hex: 'AF231C',
          positionInBook: 347,
          pageNumberInBook: '50'
        },
        {
          code: '4050 C',
          name: null,
          rgb: {
            r: 217,
            g: 172,
            b: 149
          },
          hex: 'D9AC95',
          positionInBook: 348,
          pageNumberInBook: '51'
        },
        {
          code: '4051 C',
          name: null,
          rgb: {
            r: 223,
            g: 136,
            b: 119
          },
          hex: 'DF8877',
          positionInBook: 349,
          pageNumberInBook: '51'
        },
        {
          code: '4052 C',
          name: null,
          rgb: {
            r: 218,
            g: 136,
            b: 121
          },
          hex: 'DA8879',
          positionInBook: 350,
          pageNumberInBook: '51'
        },
        {
          code: '4053 C',
          name: null,
          rgb: {
            r: 207,
            g: 123,
            b: 105
          },
          hex: 'CF7B69',
          positionInBook: 351,
          pageNumberInBook: '51'
        },
        {
          code: '4054 C',
          name: null,
          rgb: {
            r: 169,
            g: 83,
            b: 63
          },
          hex: 'A9533F',
          positionInBook: 352,
          pageNumberInBook: '51'
        },
        {
          code: '4055 C',
          name: null,
          rgb: {
            r: 165,
            g: 83,
            b: 67
          },
          hex: 'A55343',
          positionInBook: 353,
          pageNumberInBook: '51'
        },
        {
          code: '4056 C',
          name: null,
          rgb: {
            r: 135,
            g: 79,
            b: 71
          },
          hex: '874F47',
          positionInBook: 354,
          pageNumberInBook: '51'
        },
        {
          code: '4057 C',
          name: null,
          rgb: {
            r: 226,
            g: 102,
            b: 92
          },
          hex: 'E2665C',
          positionInBook: 355,
          pageNumberInBook: '52'
        },
        {
          code: '4058 C',
          name: null,
          rgb: {
            r: 228,
            g: 75,
            b: 85
          },
          hex: 'E44B55',
          positionInBook: 356,
          pageNumberInBook: '52'
        },
        {
          code: '4059 C',
          name: null,
          rgb: {
            r: 193,
            g: 47,
            b: 65
          },
          hex: 'C12F41',
          positionInBook: 357,
          pageNumberInBook: '52'
        },
        {
          code: '4060 C',
          name: null,
          rgb: {
            r: 189,
            g: 55,
            b: 66
          },
          hex: 'BD3742',
          positionInBook: 358,
          pageNumberInBook: '52'
        },
        {
          code: '4061 C',
          name: null,
          rgb: {
            r: 189,
            g: 98,
            b: 94
          },
          hex: 'BD625E',
          positionInBook: 359,
          pageNumberInBook: '52'
        },
        {
          code: '4062 C',
          name: null,
          rgb: {
            r: 168,
            g: 69,
            b: 68
          },
          hex: 'A84544',
          positionInBook: 360,
          pageNumberInBook: '52'
        },
        {
          code: '4063 C',
          name: null,
          rgb: {
            r: 155,
            g: 63,
            b: 52
          },
          hex: '9B3F34',
          positionInBook: 361,
          pageNumberInBook: '52'
        },
        {
          code: '176 C',
          name: null,
          rgb: {
            r: 255,
            g: 177,
            b: 187
          },
          hex: 'FFB1BB',
          positionInBook: 362,
          pageNumberInBook: '53'
        },
        {
          code: '177 C',
          name: null,
          rgb: {
            r: 255,
            g: 128,
            b: 139
          },
          hex: 'FF808B',
          positionInBook: 363,
          pageNumberInBook: '53'
        },
        {
          code: '178 C',
          name: null,
          rgb: {
            r: 255,
            g: 88,
            b: 93
          },
          hex: 'FF585D',
          positionInBook: 364,
          pageNumberInBook: '53'
        },
        {
          code: 'Warm Red C',
          name: null,
          rgb: {
            r: 249,
            g: 66,
            b: 58
          },
          hex: 'F9423A',
          positionInBook: 365,
          pageNumberInBook: '53'
        },
        {
          code: '179 C',
          name: null,
          rgb: {
            r: 224,
            g: 60,
            b: 49
          },
          hex: 'E03C31',
          positionInBook: 366,
          pageNumberInBook: '53'
        },
        {
          code: '180 C',
          name: null,
          rgb: {
            r: 190,
            g: 58,
            b: 52
          },
          hex: 'BE3A34',
          positionInBook: 367,
          pageNumberInBook: '53'
        },
        {
          code: '181 C',
          name: null,
          rgb: {
            r: 129,
            g: 49,
            b: 47
          },
          hex: '81312F',
          positionInBook: 368,
          pageNumberInBook: '53'
        },
        {
          code: '1765 C',
          name: null,
          rgb: {
            r: 255,
            g: 163,
            b: 181
          },
          hex: 'FFA3B5',
          positionInBook: 369,
          pageNumberInBook: '54'
        },
        {
          code: '1775 C',
          name: null,
          rgb: {
            r: 255,
            g: 141,
            b: 161
          },
          hex: 'FF8DA1',
          positionInBook: 370,
          pageNumberInBook: '54'
        },
        {
          code: '1785 C',
          name: null,
          rgb: {
            r: 248,
            g: 72,
            b: 94
          },
          hex: 'F8485E',
          positionInBook: 371,
          pageNumberInBook: '54'
        },
        {
          code: '1788 C',
          name: null,
          rgb: {
            r: 238,
            g: 39,
            b: 55
          },
          hex: 'EE2737',
          positionInBook: 372,
          pageNumberInBook: '54'
        },
        {
          code: '1795 C',
          name: null,
          rgb: {
            r: 210,
            g: 39,
            b: 48
          },
          hex: 'D22730',
          positionInBook: 373,
          pageNumberInBook: '54'
        },
        {
          code: '1805 C',
          name: null,
          rgb: {
            r: 175,
            g: 39,
            b: 47
          },
          hex: 'AF272F',
          positionInBook: 374,
          pageNumberInBook: '54'
        },
        {
          code: '1815 C',
          name: null,
          rgb: {
            r: 124,
            g: 38,
            b: 41
          },
          hex: '7C2629',
          positionInBook: 375,
          pageNumberInBook: '54'
        },
        {
          code: '1767 C',
          name: null,
          rgb: {
            r: 252,
            g: 175,
            b: 192
          },
          hex: 'FCAFC0',
          positionInBook: 376,
          pageNumberInBook: '55'
        },
        {
          code: '1777 C',
          name: null,
          rgb: {
            r: 251,
            g: 99,
            b: 126
          },
          hex: 'FB637E',
          positionInBook: 377,
          pageNumberInBook: '55'
        },
        {
          code: '1787 C',
          name: null,
          rgb: {
            r: 244,
            g: 54,
            b: 76
          },
          hex: 'F4364C',
          positionInBook: 378,
          pageNumberInBook: '55'
        },
        {
          code: 'Red 032 C',
          name: null,
          rgb: {
            r: 239,
            g: 51,
            b: 64
          },
          hex: 'EF3340',
          positionInBook: 379,
          pageNumberInBook: '55'
        },
        {
          code: '1797 C',
          name: null,
          rgb: {
            r: 203,
            g: 51,
            b: 59
          },
          hex: 'CB333B',
          positionInBook: 380,
          pageNumberInBook: '55'
        },
        {
          code: '1807 C',
          name: null,
          rgb: {
            r: 164,
            g: 52,
            b: 58
          },
          hex: 'A4343A',
          positionInBook: 381,
          pageNumberInBook: '55'
        },
        {
          code: '1817 C',
          name: null,
          rgb: {
            r: 100,
            g: 51,
            b: 53
          },
          hex: '643335',
          positionInBook: 382,
          pageNumberInBook: '55'
        },
        {
          code: '2448 C',
          name: null,
          rgb: {
            r: 218,
            g: 98,
            b: 84
          },
          hex: 'DA6254',
          positionInBook: 383,
          pageNumberInBook: '56'
        },
        {
          code: '3556 C',
          name: null,
          rgb: {
            r: 238,
            g: 56,
            b: 49
          },
          hex: 'EE3831',
          positionInBook: 384,
          pageNumberInBook: '56'
        },
        {
          code: '3516 C',
          name: null,
          rgb: {
            r: 220,
            g: 53,
            b: 19
          },
          hex: 'DC3513',
          positionInBook: 385,
          pageNumberInBook: '56'
        },
        {
          code: '3546 C',
          name: null,
          rgb: {
            r: 205,
            g: 0,
            b: 26
          },
          hex: 'CD001A',
          positionInBook: 386,
          pageNumberInBook: '56'
        },
        {
          code: '3517 C',
          name: null,
          rgb: {
            r: 193,
            g: 0,
            b: 22
          },
          hex: 'C10016',
          positionInBook: 387,
          pageNumberInBook: '56'
        },
        {
          code: '3523 C',
          name: null,
          rgb: {
            r: 116,
            g: 46,
            b: 52
          },
          hex: '742E34',
          positionInBook: 388,
          pageNumberInBook: '56'
        },
        {
          code: '2449 C',
          name: null,
          rgb: {
            r: 71,
            g: 36,
            b: 38
          },
          hex: '472426',
          positionInBook: 389,
          pageNumberInBook: '56'
        },
        {
          code: '7618 C',
          name: null,
          rgb: {
            r: 198,
            g: 110,
            b: 78
          },
          hex: 'C66E4E',
          positionInBook: 390,
          pageNumberInBook: '57'
        },
        {
          code: '7619 C',
          name: null,
          rgb: {
            r: 192,
            g: 76,
            b: 54
          },
          hex: 'C04C36',
          positionInBook: 391,
          pageNumberInBook: '57'
        },
        {
          code: '7620 C',
          name: null,
          rgb: {
            r: 183,
            g: 49,
            b: 44
          },
          hex: 'B7312C',
          positionInBook: 392,
          pageNumberInBook: '57'
        },
        {
          code: '7621 C',
          name: null,
          rgb: {
            r: 171,
            g: 35,
            b: 40
          },
          hex: 'AB2328',
          positionInBook: 393,
          pageNumberInBook: '57'
        },
        {
          code: '7622 C',
          name: null,
          rgb: {
            r: 147,
            g: 40,
            b: 44
          },
          hex: '93282C',
          positionInBook: 394,
          pageNumberInBook: '57'
        },
        {
          code: '7623 C',
          name: null,
          rgb: {
            r: 138,
            g: 43,
            b: 43
          },
          hex: '8A2B2B',
          positionInBook: 395,
          pageNumberInBook: '57'
        },
        {
          code: '7624 C',
          name: null,
          rgb: {
            r: 128,
            g: 47,
            b: 45
          },
          hex: '802F2D',
          positionInBook: 396,
          pageNumberInBook: '57'
        },
        {
          code: '7625 C',
          name: null,
          rgb: {
            r: 225,
            g: 82,
            b: 62
          },
          hex: 'E1523E',
          positionInBook: 397,
          pageNumberInBook: '58'
        },
        {
          code: '7626 C',
          name: null,
          rgb: {
            r: 198,
            g: 53,
            b: 39
          },
          hex: 'C63527',
          positionInBook: 398,
          pageNumberInBook: '58'
        },
        {
          code: '7627 C',
          name: null,
          rgb: {
            r: 167,
            g: 43,
            b: 42
          },
          hex: 'A72B2A',
          positionInBook: 399,
          pageNumberInBook: '58'
        },
        {
          code: '7628 C',
          name: null,
          rgb: {
            r: 158,
            g: 42,
            b: 43
          },
          hex: '9E2A2B',
          positionInBook: 400,
          pageNumberInBook: '58'
        },
        {
          code: '7629 C',
          name: null,
          rgb: {
            r: 109,
            g: 51,
            b: 50
          },
          hex: '6D3332',
          positionInBook: 401,
          pageNumberInBook: '58'
        },
        {
          code: '7630 C',
          name: null,
          rgb: {
            r: 99,
            g: 50,
            b: 49
          },
          hex: '633231',
          positionInBook: 402,
          pageNumberInBook: '58'
        },
        {
          code: '7631 C',
          name: null,
          rgb: {
            r: 87,
            g: 45,
            b: 45
          },
          hex: '572D2D',
          positionInBook: 403,
          pageNumberInBook: '58'
        },
        {
          code: '7415 C',
          name: null,
          rgb: {
            r: 230,
            g: 186,
            b: 168
          },
          hex: 'E6BAA8',
          positionInBook: 404,
          pageNumberInBook: '59'
        },
        {
          code: '7416 C',
          name: null,
          rgb: {
            r: 229,
            g: 106,
            b: 84
          },
          hex: 'E56A54',
          positionInBook: 405,
          pageNumberInBook: '59'
        },
        {
          code: '7417 C',
          name: null,
          rgb: {
            r: 224,
            g: 79,
            b: 57
          },
          hex: 'E04F39',
          positionInBook: 406,
          pageNumberInBook: '59'
        },
        {
          code: '7418 C',
          name: null,
          rgb: {
            r: 205,
            g: 84,
            b: 91
          },
          hex: 'CD545B',
          positionInBook: 407,
          pageNumberInBook: '59'
        },
        {
          code: '7419 C',
          name: null,
          rgb: {
            r: 176,
            g: 74,
            b: 90
          },
          hex: 'B04A5A',
          positionInBook: 408,
          pageNumberInBook: '59'
        },
        {
          code: '7420 C',
          name: null,
          rgb: {
            r: 155,
            g: 34,
            b: 66
          },
          hex: '9B2242',
          positionInBook: 409,
          pageNumberInBook: '59'
        },
        {
          code: '7421 C',
          name: null,
          rgb: {
            r: 101,
            g: 28,
            b: 50
          },
          hex: '651C32',
          positionInBook: 410,
          pageNumberInBook: '59'
        },
        {
          code: '182 C',
          name: null,
          rgb: {
            r: 250,
            g: 187,
            b: 203
          },
          hex: 'FABBCB',
          positionInBook: 411,
          pageNumberInBook: '60'
        },
        {
          code: '183 C',
          name: null,
          rgb: {
            r: 252,
            g: 155,
            b: 179
          },
          hex: 'FC9BB3',
          positionInBook: 412,
          pageNumberInBook: '60'
        },
        {
          code: '184 C',
          name: null,
          rgb: {
            r: 246,
            g: 82,
            b: 117
          },
          hex: 'F65275',
          positionInBook: 413,
          pageNumberInBook: '60'
        },
        {
          code: '185 C',
          name: null,
          rgb: {
            r: 228,
            g: 0,
            b: 43
          },
          hex: 'E4002B',
          positionInBook: 414,
          pageNumberInBook: '60'
        },
        {
          code: '186 C',
          name: null,
          rgb: {
            r: 200,
            g: 16,
            b: 46
          },
          hex: 'C8102E',
          positionInBook: 415,
          pageNumberInBook: '60'
        },
        {
          code: '187 C',
          name: null,
          rgb: {
            r: 166,
            g: 25,
            b: 46
          },
          hex: 'A6192E',
          positionInBook: 416,
          pageNumberInBook: '60'
        },
        {
          code: '188 C',
          name: null,
          rgb: {
            r: 118,
            g: 35,
            b: 47
          },
          hex: '76232F',
          positionInBook: 417,
          pageNumberInBook: '60'
        },
        {
          code: '4064 C',
          name: null,
          rgb: {
            r: 235,
            g: 180,
            b: 187
          },
          hex: 'EBB4BB',
          positionInBook: 418,
          pageNumberInBook: '61'
        },
        {
          code: '4065 C',
          name: null,
          rgb: {
            r: 228,
            g: 174,
            b: 177
          },
          hex: 'E4AEB1',
          positionInBook: 419,
          pageNumberInBook: '61'
        },
        {
          code: '4066 C',
          name: null,
          rgb: {
            r: 234,
            g: 160,
            b: 156
          },
          hex: 'EAA09C',
          positionInBook: 420,
          pageNumberInBook: '61'
        },
        {
          code: '4067 C',
          name: null,
          rgb: {
            r: 232,
            g: 158,
            b: 157
          },
          hex: 'E89E9D',
          positionInBook: 421,
          pageNumberInBook: '61'
        },
        {
          code: '4068 C',
          name: null,
          rgb: {
            r: 228,
            g: 143,
            b: 147
          },
          hex: 'E48F93',
          positionInBook: 422,
          pageNumberInBook: '61'
        },
        {
          code: '4069 C',
          name: null,
          rgb: {
            r: 199,
            g: 78,
            b: 97
          },
          hex: 'C74E61',
          positionInBook: 423,
          pageNumberInBook: '61'
        },
        {
          code: '4070 C',
          name: null,
          rgb: {
            r: 181,
            g: 59,
            b: 80
          },
          hex: 'B53B50',
          positionInBook: 424,
          pageNumberInBook: '61'
        },
        {
          code: '196 C',
          name: null,
          rgb: {
            r: 236,
            g: 199,
            b: 205
          },
          hex: 'ECC7CD',
          positionInBook: 425,
          pageNumberInBook: '62'
        },
        {
          code: '197 C',
          name: null,
          rgb: {
            r: 232,
            g: 156,
            b: 174
          },
          hex: 'E89CAE',
          positionInBook: 426,
          pageNumberInBook: '62'
        },
        {
          code: '198 C',
          name: null,
          rgb: {
            r: 223,
            g: 70,
            b: 97
          },
          hex: 'DF4661',
          positionInBook: 427,
          pageNumberInBook: '62'
        },
        {
          code: '199 C',
          name: null,
          rgb: {
            r: 213,
            g: 0,
            b: 50
          },
          hex: 'D50032',
          positionInBook: 428,
          pageNumberInBook: '62'
        },
        {
          code: '200 C',
          name: null,
          rgb: {
            r: 186,
            g: 12,
            b: 47
          },
          hex: 'BA0C2F',
          positionInBook: 429,
          pageNumberInBook: '62'
        },
        {
          code: '201 C',
          name: null,
          rgb: {
            r: 157,
            g: 34,
            b: 53
          },
          hex: '9D2235',
          positionInBook: 430,
          pageNumberInBook: '62'
        },
        {
          code: '202 C',
          name: null,
          rgb: {
            r: 134,
            g: 38,
            b: 51
          },
          hex: '862633',
          positionInBook: 431,
          pageNumberInBook: '62'
        },
        {
          code: '189 C',
          name: null,
          rgb: {
            r: 248,
            g: 163,
            b: 188
          },
          hex: 'F8A3BC',
          positionInBook: 432,
          pageNumberInBook: '63'
        },
        {
          code: '190 C',
          name: null,
          rgb: {
            r: 246,
            g: 117,
            b: 153
          },
          hex: 'F67599',
          positionInBook: 433,
          pageNumberInBook: '63'
        },
        {
          code: '191 C',
          name: null,
          rgb: {
            r: 239,
            g: 66,
            b: 111
          },
          hex: 'EF426F',
          positionInBook: 434,
          pageNumberInBook: '63'
        },
        {
          code: '192 C',
          name: null,
          rgb: {
            r: 228,
            g: 0,
            b: 70
          },
          hex: 'E40046',
          positionInBook: 435,
          pageNumberInBook: '63'
        },
        {
          code: '193 C',
          name: null,
          rgb: {
            r: 191,
            g: 13,
            b: 62
          },
          hex: 'BF0D3E',
          positionInBook: 436,
          pageNumberInBook: '63'
        },
        {
          code: '194 C',
          name: null,
          rgb: {
            r: 155,
            g: 39,
            b: 67
          },
          hex: '9B2743',
          positionInBook: 437,
          pageNumberInBook: '63'
        },
        {
          code: '195 C',
          name: null,
          rgb: {
            r: 120,
            g: 47,
            b: 64
          },
          hex: '782F40',
          positionInBook: 438,
          pageNumberInBook: '63'
        },
        {
          code: '1895 C',
          name: null,
          rgb: {
            r: 245,
            g: 182,
            b: 205
          },
          hex: 'F5B6CD',
          positionInBook: 439,
          pageNumberInBook: '64'
        },
        {
          code: '1905 C',
          name: null,
          rgb: {
            r: 245,
            g: 155,
            b: 187
          },
          hex: 'F59BBB',
          positionInBook: 440,
          pageNumberInBook: '64'
        },
        {
          code: '1915 C',
          name: null,
          rgb: {
            r: 239,
            g: 75,
            b: 129
          },
          hex: 'EF4B81',
          positionInBook: 441,
          pageNumberInBook: '64'
        },
        {
          code: '1925 C',
          name: null,
          rgb: {
            r: 224,
            g: 0,
            b: 77
          },
          hex: 'E0004D',
          positionInBook: 442,
          pageNumberInBook: '64'
        },
        {
          code: '1935 C',
          name: null,
          rgb: {
            r: 197,
            g: 0,
            b: 62
          },
          hex: 'C5003E',
          positionInBook: 443,
          pageNumberInBook: '64'
        },
        {
          code: '1945 C',
          name: null,
          rgb: {
            r: 166,
            g: 10,
            b: 61
          },
          hex: 'A60A3D',
          positionInBook: 444,
          pageNumberInBook: '64'
        },
        {
          code: '1955 C',
          name: null,
          rgb: {
            r: 138,
            g: 21,
            b: 56
          },
          hex: '8A1538',
          positionInBook: 445,
          pageNumberInBook: '64'
        },
        {
          code: '705 C',
          name: null,
          rgb: {
            r: 245,
            g: 218,
            b: 223
          },
          hex: 'F5DADF',
          positionInBook: 446,
          pageNumberInBook: '65'
        },
        {
          code: '706 C',
          name: null,
          rgb: {
            r: 247,
            g: 206,
            b: 215
          },
          hex: 'F7CED7',
          positionInBook: 447,
          pageNumberInBook: '65'
        },
        {
          code: '707 C',
          name: null,
          rgb: {
            r: 248,
            g: 181,
            b: 196
          },
          hex: 'F8B5C4',
          positionInBook: 448,
          pageNumberInBook: '65'
        },
        {
          code: '708 C',
          name: null,
          rgb: {
            r: 248,
            g: 145,
            b: 165
          },
          hex: 'F891A5',
          positionInBook: 449,
          pageNumberInBook: '65'
        },
        {
          code: '709 C',
          name: null,
          rgb: {
            r: 239,
            g: 96,
            b: 121
          },
          hex: 'EF6079',
          positionInBook: 450,
          pageNumberInBook: '65'
        },
        {
          code: '710 C',
          name: null,
          rgb: {
            r: 224,
            g: 62,
            b: 82
          },
          hex: 'E03E52',
          positionInBook: 451,
          pageNumberInBook: '65'
        },
        {
          code: '711 C',
          name: null,
          rgb: {
            r: 203,
            g: 44,
            b: 48
          },
          hex: 'CB2C30',
          positionInBook: 452,
          pageNumberInBook: '65'
        },
        {
          code: '698 C',
          name: null,
          rgb: {
            r: 242,
            g: 212,
            b: 215
          },
          hex: 'F2D4D7',
          positionInBook: 453,
          pageNumberInBook: '66'
        },
        {
          code: '699 C',
          name: null,
          rgb: {
            r: 244,
            g: 195,
            b: 204
          },
          hex: 'F4C3CC',
          positionInBook: 454,
          pageNumberInBook: '66'
        },
        {
          code: '700 C',
          name: null,
          rgb: {
            r: 242,
            g: 172,
            b: 185
          },
          hex: 'F2ACB9',
          positionInBook: 455,
          pageNumberInBook: '66'
        },
        {
          code: '701 C',
          name: null,
          rgb: {
            r: 230,
            g: 134,
            b: 153
          },
          hex: 'E68699',
          positionInBook: 456,
          pageNumberInBook: '66'
        },
        {
          code: '702 C',
          name: null,
          rgb: {
            r: 210,
            g: 91,
            b: 115
          },
          hex: 'D25B73',
          positionInBook: 457,
          pageNumberInBook: '66'
        },
        {
          code: '703 C',
          name: null,
          rgb: {
            r: 184,
            g: 58,
            b: 75
          },
          hex: 'B83A4B',
          positionInBook: 458,
          pageNumberInBook: '66'
        },
        {
          code: '704 C',
          name: null,
          rgb: {
            r: 158,
            g: 43,
            b: 47
          },
          hex: '9E2B2F',
          positionInBook: 459,
          pageNumberInBook: '66'
        },
        {
          code: '203 C',
          name: null,
          rgb: {
            r: 236,
            g: 179,
            b: 203
          },
          hex: 'ECB3CB',
          positionInBook: 460,
          pageNumberInBook: '67'
        },
        {
          code: '204 C',
          name: null,
          rgb: {
            r: 231,
            g: 130,
            b: 169
          },
          hex: 'E782A9',
          positionInBook: 461,
          pageNumberInBook: '67'
        },
        {
          code: '205 C',
          name: null,
          rgb: {
            r: 224,
            g: 69,
            b: 123
          },
          hex: 'E0457B',
          positionInBook: 462,
          pageNumberInBook: '67'
        },
        {
          code: '206 C',
          name: null,
          rgb: {
            r: 206,
            g: 0,
            b: 55
          },
          hex: 'CE0037',
          positionInBook: 463,
          pageNumberInBook: '67'
        },
        {
          code: '207 C',
          name: null,
          rgb: {
            r: 165,
            g: 0,
            b: 52
          },
          hex: 'A50034',
          positionInBook: 464,
          pageNumberInBook: '67'
        },
        {
          code: '208 C',
          name: null,
          rgb: {
            r: 134,
            g: 32,
            b: 65
          },
          hex: '862041',
          positionInBook: 465,
          pageNumberInBook: '67'
        },
        {
          code: '209 C',
          name: null,
          rgb: {
            r: 111,
            g: 38,
            b: 61
          },
          hex: '6F263D',
          positionInBook: 466,
          pageNumberInBook: '67'
        },
        {
          code: '210 C',
          name: null,
          rgb: {
            r: 249,
            g: 159,
            b: 201
          },
          hex: 'F99FC9',
          positionInBook: 467,
          pageNumberInBook: '68'
        },
        {
          code: '211 C',
          name: null,
          rgb: {
            r: 245,
            g: 126,
            b: 182
          },
          hex: 'F57EB6',
          positionInBook: 468,
          pageNumberInBook: '68'
        },
        {
          code: '212 C',
          name: null,
          rgb: {
            r: 240,
            g: 78,
            b: 152
          },
          hex: 'F04E98',
          positionInBook: 469,
          pageNumberInBook: '68'
        },
        {
          code: '213 C',
          name: null,
          rgb: {
            r: 227,
            g: 28,
            b: 121
          },
          hex: 'E31C79',
          positionInBook: 470,
          pageNumberInBook: '68'
        },
        {
          code: '214 C',
          name: null,
          rgb: {
            r: 206,
            g: 15,
            b: 105
          },
          hex: 'CE0F69',
          positionInBook: 471,
          pageNumberInBook: '68'
        },
        {
          code: '215 C',
          name: null,
          rgb: {
            r: 172,
            g: 20,
            b: 90
          },
          hex: 'AC145A',
          positionInBook: 472,
          pageNumberInBook: '68'
        },
        {
          code: '216 C',
          name: null,
          rgb: {
            r: 125,
            g: 34,
            b: 72
          },
          hex: '7D2248',
          positionInBook: 473,
          pageNumberInBook: '68'
        },
        {
          code: '2036 C',
          name: null,
          rgb: {
            r: 248,
            g: 190,
            b: 214
          },
          hex: 'F8BED6',
          positionInBook: 474,
          pageNumberInBook: '69'
        },
        {
          code: '2037 C',
          name: null,
          rgb: {
            r: 243,
            g: 149,
            b: 199
          },
          hex: 'F395C7',
          positionInBook: 475,
          pageNumberInBook: '69'
        },
        {
          code: '2038 C',
          name: null,
          rgb: {
            r: 239,
            g: 96,
            b: 163
          },
          hex: 'EF60A3',
          positionInBook: 476,
          pageNumberInBook: '69'
        },
        {
          code: '2039 C',
          name: null,
          rgb: {
            r: 230,
            g: 56,
            b: 136
          },
          hex: 'E63888',
          positionInBook: 477,
          pageNumberInBook: '69'
        },
        {
          code: '2040 C',
          name: null,
          rgb: {
            r: 219,
            g: 11,
            b: 91
          },
          hex: 'DB0B5B',
          positionInBook: 478,
          pageNumberInBook: '69'
        },
        {
          code: '2041 C',
          name: null,
          rgb: {
            r: 161,
            g: 34,
            b: 78
          },
          hex: 'A1224E',
          positionInBook: 479,
          pageNumberInBook: '69'
        },
        {
          code: '2042 C',
          name: null,
          rgb: {
            r: 112,
            g: 39,
            b: 61
          },
          hex: '70273D',
          positionInBook: 480,
          pageNumberInBook: '69'
        },
        {
          code: '7422 C',
          name: null,
          rgb: {
            r: 244,
            g: 205,
            b: 212
          },
          hex: 'F4CDD4',
          positionInBook: 481,
          pageNumberInBook: '70'
        },
        {
          code: '7423 C',
          name: null,
          rgb: {
            r: 224,
            g: 98,
            b: 135
          },
          hex: 'E06287',
          positionInBook: 482,
          pageNumberInBook: '70'
        },
        {
          code: '7424 C',
          name: null,
          rgb: {
            r: 226,
            g: 69,
            b: 133
          },
          hex: 'E24585',
          positionInBook: 483,
          pageNumberInBook: '70'
        },
        {
          code: '7425 C',
          name: null,
          rgb: {
            r: 181,
            g: 37,
            b: 85
          },
          hex: 'B52555',
          positionInBook: 484,
          pageNumberInBook: '70'
        },
        {
          code: '7426 C',
          name: null,
          rgb: {
            r: 164,
            g: 18,
            b: 63
          },
          hex: 'A4123F',
          positionInBook: 485,
          pageNumberInBook: '70'
        },
        {
          code: '7427 C',
          name: null,
          rgb: {
            r: 151,
            g: 27,
            b: 47
          },
          hex: '971B2F',
          positionInBook: 486,
          pageNumberInBook: '70'
        },
        {
          code: '7428 C',
          name: null,
          rgb: {
            r: 106,
            g: 44,
            b: 62
          },
          hex: '6A2C3E',
          positionInBook: 487,
          pageNumberInBook: '70'
        },
        {
          code: '4071 C',
          name: null,
          rgb: {
            r: 207,
            g: 135,
            b: 157
          },
          hex: 'CF879D',
          positionInBook: 488,
          pageNumberInBook: '71'
        },
        {
          code: '4072 C',
          name: null,
          rgb: {
            r: 223,
            g: 122,
            b: 153
          },
          hex: 'DF7A99',
          positionInBook: 489,
          pageNumberInBook: '71'
        },
        {
          code: '4073 C',
          name: null,
          rgb: {
            r: 198,
            g: 71,
            b: 113
          },
          hex: 'C64771',
          positionInBook: 490,
          pageNumberInBook: '71'
        },
        {
          code: '4074 C',
          name: null,
          rgb: {
            r: 125,
            g: 27,
            b: 73
          },
          hex: '7D1B49',
          positionInBook: 491,
          pageNumberInBook: '71'
        },
        {
          code: '4075 C',
          name: null,
          rgb: {
            r: 130,
            g: 53,
            b: 80
          },
          hex: '823550',
          positionInBook: 492,
          pageNumberInBook: '71'
        },
        {
          code: '4076 C',
          name: null,
          rgb: {
            r: 130,
            g: 66,
            b: 89
          },
          hex: '824259',
          positionInBook: 493,
          pageNumberInBook: '71'
        },
        {
          code: '4077 C',
          name: null,
          rgb: {
            r: 131,
            g: 69,
            b: 83
          },
          hex: '834553',
          positionInBook: 494,
          pageNumberInBook: '71'
        },
        {
          code: '7632 C',
          name: null,
          rgb: {
            r: 214,
            g: 201,
            b: 202
          },
          hex: 'D6C9CA',
          positionInBook: 495,
          pageNumberInBook: '72'
        },
        {
          code: '7633 C',
          name: null,
          rgb: {
            r: 196,
            g: 164,
            b: 167
          },
          hex: 'C4A4A7',
          positionInBook: 496,
          pageNumberInBook: '72'
        },
        {
          code: '7634 C',
          name: null,
          rgb: {
            r: 193,
            g: 103,
            b: 132
          },
          hex: 'C16784',
          positionInBook: 497,
          pageNumberInBook: '72'
        },
        {
          code: '7635 C',
          name: null,
          rgb: {
            r: 198,
            g: 54,
            b: 99
          },
          hex: 'C63663',
          positionInBook: 498,
          pageNumberInBook: '72'
        },
        {
          code: '7636 C',
          name: null,
          rgb: {
            r: 188,
            g: 32,
            b: 75
          },
          hex: 'BC204B',
          positionInBook: 499,
          pageNumberInBook: '72'
        },
        {
          code: '7637 C',
          name: null,
          rgb: {
            r: 145,
            g: 47,
            b: 70
          },
          hex: '912F46',
          positionInBook: 500,
          pageNumberInBook: '72'
        },
        {
          code: '7638 C',
          name: null,
          rgb: {
            r: 126,
            g: 45,
            b: 64
          },
          hex: '7E2D40',
          positionInBook: 501,
          pageNumberInBook: '72'
        },
        {
          code: '217 C',
          name: null,
          rgb: {
            r: 234,
            g: 190,
            b: 219
          },
          hex: 'EABEDB',
          positionInBook: 502,
          pageNumberInBook: '73'
        },
        {
          code: '218 C',
          name: null,
          rgb: {
            r: 229,
            g: 109,
            b: 177
          },
          hex: 'E56DB1',
          positionInBook: 503,
          pageNumberInBook: '73'
        },
        {
          code: '219 C',
          name: null,
          rgb: {
            r: 218,
            g: 25,
            b: 132
          },
          hex: 'DA1984',
          positionInBook: 504,
          pageNumberInBook: '73'
        },
        {
          code: 'Rubine Red C',
          name: null,
          rgb: {
            r: 206,
            g: 0,
            b: 88
          },
          hex: 'CE0058',
          positionInBook: 505,
          pageNumberInBook: '73'
        },
        {
          code: '220 C',
          name: null,
          rgb: {
            r: 165,
            g: 0,
            b: 80
          },
          hex: 'A50050',
          positionInBook: 506,
          pageNumberInBook: '73'
        },
        {
          code: '221 C',
          name: null,
          rgb: {
            r: 145,
            g: 0,
            b: 72
          },
          hex: '910048',
          positionInBook: 507,
          pageNumberInBook: '73'
        },
        {
          code: '222 C',
          name: null,
          rgb: {
            r: 108,
            g: 29,
            b: 69
          },
          hex: '6C1D45',
          positionInBook: 508,
          pageNumberInBook: '73'
        },
        {
          code: '7639 C',
          name: null,
          rgb: {
            r: 147,
            g: 109,
            b: 115
          },
          hex: '936D73',
          positionInBook: 509,
          pageNumberInBook: '74'
        },
        {
          code: '7640 C',
          name: null,
          rgb: {
            r: 147,
            g: 64,
            b: 84
          },
          hex: '934054',
          positionInBook: 510,
          pageNumberInBook: '74'
        },
        {
          code: '7641 C',
          name: null,
          rgb: {
            r: 142,
            g: 44,
            b: 72
          },
          hex: '8E2C48',
          positionInBook: 511,
          pageNumberInBook: '74'
        },
        {
          code: '7642 C',
          name: null,
          rgb: {
            r: 115,
            g: 46,
            b: 74
          },
          hex: '732E4A',
          positionInBook: 512,
          pageNumberInBook: '74'
        },
        {
          code: '7643 C',
          name: null,
          rgb: {
            r: 103,
            g: 46,
            b: 69
          },
          hex: '672E45',
          positionInBook: 513,
          pageNumberInBook: '74'
        },
        {
          code: '7644 C',
          name: null,
          rgb: {
            r: 88,
            g: 45,
            b: 64
          },
          hex: '582D40',
          positionInBook: 514,
          pageNumberInBook: '74'
        },
        {
          code: '7645 C',
          name: null,
          rgb: {
            r: 80,
            g: 43,
            b: 58
          },
          hex: '502B3A',
          positionInBook: 515,
          pageNumberInBook: '74'
        },
        {
          code: '3568 C',
          name: null,
          rgb: {
            r: 240,
            g: 200,
            b: 217
          },
          hex: 'F0C8D9',
          positionInBook: 516,
          pageNumberInBook: '75'
        },
        {
          code: '3595 C',
          name: null,
          rgb: {
            r: 241,
            g: 188,
            b: 213
          },
          hex: 'F1BCD5',
          positionInBook: 517,
          pageNumberInBook: '75'
        },
        {
          code: '2450 C',
          name: null,
          rgb: {
            r: 215,
            g: 67,
            b: 136
          },
          hex: 'D74388',
          positionInBook: 518,
          pageNumberInBook: '75'
        },
        {
          code: '3527 C',
          name: null,
          rgb: {
            r: 213,
            g: 65,
            b: 158
          },
          hex: 'D5419E',
          positionInBook: 519,
          pageNumberInBook: '75'
        },
        {
          code: '3582 C',
          name: null,
          rgb: {
            r: 209,
            g: 115,
            b: 166
          },
          hex: 'D173A6',
          positionInBook: 520,
          pageNumberInBook: '75'
        },
        {
          code: '2451 C',
          name: null,
          rgb: {
            r: 183,
            g: 66,
            b: 113
          },
          hex: 'B74271',
          positionInBook: 521,
          pageNumberInBook: '75'
        },
        {
          code: '2452 C',
          name: null,
          rgb: {
            r: 195,
            g: 54,
            b: 111
          },
          hex: 'C3366F',
          positionInBook: 522,
          pageNumberInBook: '75'
        },
        {
          code: '223 C',
          name: null,
          rgb: {
            r: 239,
            g: 149,
            b: 207
          },
          hex: 'EF95CF',
          positionInBook: 523,
          pageNumberInBook: '76'
        },
        {
          code: '224 C',
          name: null,
          rgb: {
            r: 235,
            g: 111,
            b: 189
          },
          hex: 'EB6FBD',
          positionInBook: 524,
          pageNumberInBook: '76'
        },
        {
          code: '225 C',
          name: null,
          rgb: {
            r: 223,
            g: 25,
            b: 149
          },
          hex: 'DF1995',
          positionInBook: 525,
          pageNumberInBook: '76'
        },
        {
          code: '226 C',
          name: null,
          rgb: {
            r: 208,
            g: 0,
            b: 112
          },
          hex: 'D00070',
          positionInBook: 526,
          pageNumberInBook: '76'
        },
        {
          code: '227 C',
          name: null,
          rgb: {
            r: 170,
            g: 0,
            b: 97
          },
          hex: 'AA0061',
          positionInBook: 527,
          pageNumberInBook: '76'
        },
        {
          code: '228 C',
          name: null,
          rgb: {
            r: 137,
            g: 12,
            b: 88
          },
          hex: '890C58',
          positionInBook: 528,
          pageNumberInBook: '76'
        },
        {
          code: '229 C',
          name: null,
          rgb: {
            r: 103,
            g: 33,
            b: 70
          },
          hex: '672146',
          positionInBook: 529,
          pageNumberInBook: '76'
        },
        {
          code: '230 C',
          name: null,
          rgb: {
            r: 244,
            g: 166,
            b: 215
          },
          hex: 'F4A6D7',
          positionInBook: 530,
          pageNumberInBook: '77'
        },
        {
          code: '231 C',
          name: null,
          rgb: {
            r: 242,
            g: 119,
            b: 198
          },
          hex: 'F277C6',
          positionInBook: 531,
          pageNumberInBook: '77'
        },
        {
          code: '232 C',
          name: null,
          rgb: {
            r: 233,
            g: 60,
            b: 172
          },
          hex: 'E93CAC',
          positionInBook: 532,
          pageNumberInBook: '77'
        },
        {
          code: 'Rhodamine Red C',
          name: null,
          rgb: {
            r: 225,
            g: 0,
            b: 152
          },
          hex: 'E10098',
          positionInBook: 533,
          pageNumberInBook: '77'
        },
        {
          code: '233 C',
          name: null,
          rgb: {
            r: 198,
            g: 0,
            b: 126
          },
          hex: 'C6007E',
          positionInBook: 534,
          pageNumberInBook: '77'
        },
        {
          code: '234 C',
          name: null,
          rgb: {
            r: 162,
            g: 0,
            b: 103
          },
          hex: 'A20067',
          positionInBook: 535,
          pageNumberInBook: '77'
        },
        {
          code: '235 C',
          name: null,
          rgb: {
            r: 132,
            g: 11,
            b: 85
          },
          hex: '840B55',
          positionInBook: 536,
          pageNumberInBook: '77'
        },
        {
          code: '670 C',
          name: null,
          rgb: {
            r: 234,
            g: 211,
            b: 226
          },
          hex: 'EAD3E2',
          positionInBook: 537,
          pageNumberInBook: '78'
        },
        {
          code: '671 C',
          name: null,
          rgb: {
            r: 230,
            g: 188,
            b: 215
          },
          hex: 'E6BCD7',
          positionInBook: 538,
          pageNumberInBook: '78'
        },
        {
          code: '672 C',
          name: null,
          rgb: {
            r: 223,
            g: 160,
            b: 201
          },
          hex: 'DFA0C9',
          positionInBook: 539,
          pageNumberInBook: '78'
        },
        {
          code: '673 C',
          name: null,
          rgb: {
            r: 217,
            g: 134,
            b: 186
          },
          hex: 'D986BA',
          positionInBook: 540,
          pageNumberInBook: '78'
        },
        {
          code: '674 C',
          name: null,
          rgb: {
            r: 199,
            g: 87,
            b: 154
          },
          hex: 'C7579A',
          positionInBook: 541,
          pageNumberInBook: '78'
        },
        {
          code: '675 C',
          name: null,
          rgb: {
            r: 174,
            g: 37,
            b: 115
          },
          hex: 'AE2573',
          positionInBook: 542,
          pageNumberInBook: '78'
        },
        {
          code: '676 C',
          name: null,
          rgb: {
            r: 150,
            g: 0,
            b: 81
          },
          hex: '960051',
          positionInBook: 543,
          pageNumberInBook: '78'
        },
        {
          code: '2043 C',
          name: null,
          rgb: {
            r: 234,
            g: 196,
            b: 210
          },
          hex: 'EAC4D2',
          positionInBook: 544,
          pageNumberInBook: '79'
        },
        {
          code: '2044 C',
          name: null,
          rgb: {
            r: 231,
            g: 147,
            b: 183
          },
          hex: 'E793B7',
          positionInBook: 545,
          pageNumberInBook: '79'
        },
        {
          code: '2045 C',
          name: null,
          rgb: {
            r: 221,
            g: 116,
            b: 161
          },
          hex: 'DD74A1',
          positionInBook: 546,
          pageNumberInBook: '79'
        },
        {
          code: '2046 C',
          name: null,
          rgb: {
            r: 207,
            g: 87,
            b: 138
          },
          hex: 'CF578A',
          positionInBook: 547,
          pageNumberInBook: '79'
        },
        {
          code: '2047 C',
          name: null,
          rgb: {
            r: 166,
            g: 69,
            b: 112
          },
          hex: 'A64570',
          positionInBook: 548,
          pageNumberInBook: '79'
        },
        {
          code: '2048 C',
          name: null,
          rgb: {
            r: 151,
            g: 57,
            b: 97
          },
          hex: '973961',
          positionInBook: 549,
          pageNumberInBook: '79'
        },
        {
          code: '2049 C',
          name: null,
          rgb: {
            r: 133,
            g: 44,
            b: 77
          },
          hex: '852C4D',
          positionInBook: 550,
          pageNumberInBook: '79'
        },
        {
          code: '677 C',
          name: null,
          rgb: {
            r: 229,
            g: 206,
            b: 219
          },
          hex: 'E5CEDB',
          positionInBook: 551,
          pageNumberInBook: '80'
        },
        {
          code: '678 C',
          name: null,
          rgb: {
            r: 227,
            g: 200,
            b: 216
          },
          hex: 'E3C8D8',
          positionInBook: 552,
          pageNumberInBook: '80'
        },
        {
          code: '679 C',
          name: null,
          rgb: {
            r: 222,
            g: 190,
            b: 210
          },
          hex: 'DEBED2',
          positionInBook: 553,
          pageNumberInBook: '80'
        },
        {
          code: '680 C',
          name: null,
          rgb: {
            r: 201,
            g: 150,
            b: 182
          },
          hex: 'C996B6',
          positionInBook: 554,
          pageNumberInBook: '80'
        },
        {
          code: '681 C',
          name: null,
          rgb: {
            r: 176,
            g: 108,
            b: 149
          },
          hex: 'B06C95',
          positionInBook: 555,
          pageNumberInBook: '80'
        },
        {
          code: '682 C',
          name: null,
          rgb: {
            r: 153,
            g: 72,
            b: 120
          },
          hex: '994878',
          positionInBook: 556,
          pageNumberInBook: '80'
        },
        {
          code: '683 C',
          name: null,
          rgb: {
            r: 124,
            g: 40,
            b: 85
          },
          hex: '7C2855',
          positionInBook: 557,
          pageNumberInBook: '80'
        },
        {
          code: '2050 C',
          name: null,
          rgb: {
            r: 239,
            g: 215,
            b: 229
          },
          hex: 'EFD7E5',
          positionInBook: 558,
          pageNumberInBook: '81'
        },
        {
          code: '2051 C',
          name: null,
          rgb: {
            r: 221,
            g: 194,
            b: 207
          },
          hex: 'DDC2CF',
          positionInBook: 559,
          pageNumberInBook: '81'
        },
        {
          code: '2052 C',
          name: null,
          rgb: {
            r: 200,
            g: 159,
            b: 182
          },
          hex: 'C89FB6',
          positionInBook: 560,
          pageNumberInBook: '81'
        },
        {
          code: '2053 C',
          name: null,
          rgb: {
            r: 179,
            g: 128,
            b: 157
          },
          hex: 'B3809D',
          positionInBook: 561,
          pageNumberInBook: '81'
        },
        {
          code: '2054 C',
          name: null,
          rgb: {
            r: 158,
            g: 112,
            b: 139
          },
          hex: '9E708B',
          positionInBook: 562,
          pageNumberInBook: '81'
        },
        {
          code: '2055 C',
          name: null,
          rgb: {
            r: 144,
            g: 94,
            b: 123
          },
          hex: '905E7B',
          positionInBook: 563,
          pageNumberInBook: '81'
        },
        {
          code: '2056 C',
          name: null,
          rgb: {
            r: 126,
            g: 73,
            b: 102
          },
          hex: '7E4966',
          positionInBook: 564,
          pageNumberInBook: '81'
        },
        {
          code: '4078 C',
          name: null,
          rgb: {
            r: 231,
            g: 193,
            b: 213
          },
          hex: 'E7C1D5',
          positionInBook: 565,
          pageNumberInBook: '82'
        },
        {
          code: '4079 C',
          name: null,
          rgb: {
            r: 205,
            g: 167,
            b: 193
          },
          hex: 'CDA7C1',
          positionInBook: 566,
          pageNumberInBook: '82'
        },
        {
          code: '4080 C',
          name: null,
          rgb: {
            r: 208,
            g: 176,
            b: 202
          },
          hex: 'D0B0CA',
          positionInBook: 567,
          pageNumberInBook: '82'
        },
        {
          code: '4081 C',
          name: null,
          rgb: {
            r: 175,
            g: 144,
            b: 167
          },
          hex: 'AF90A7',
          positionInBook: 568,
          pageNumberInBook: '82'
        },
        {
          code: '4082 C',
          name: null,
          rgb: {
            r: 168,
            g: 101,
            b: 144
          },
          hex: 'A86590',
          positionInBook: 569,
          pageNumberInBook: '82'
        },
        {
          code: '4083 C',
          name: null,
          rgb: {
            r: 134,
            g: 89,
            b: 145
          },
          hex: '865991',
          positionInBook: 570,
          pageNumberInBook: '82'
        },
        {
          code: '4084 C',
          name: null,
          rgb: {
            r: 113,
            g: 60,
            b: 98
          },
          hex: '713C62',
          positionInBook: 571,
          pageNumberInBook: '82'
        },
        {
          code: '684 C',
          name: null,
          rgb: {
            r: 228,
            g: 198,
            b: 212
          },
          hex: 'E4C6D4',
          positionInBook: 572,
          pageNumberInBook: '83'
        },
        {
          code: '685 C',
          name: null,
          rgb: {
            r: 220,
            g: 182,
            b: 201
          },
          hex: 'DCB6C9',
          positionInBook: 573,
          pageNumberInBook: '83'
        },
        {
          code: '686 C',
          name: null,
          rgb: {
            r: 208,
            g: 161,
            b: 186
          },
          hex: 'D0A1BA',
          positionInBook: 574,
          pageNumberInBook: '83'
        },
        {
          code: '687 C',
          name: null,
          rgb: {
            r: 190,
            g: 132,
            b: 163
          },
          hex: 'BE84A3',
          positionInBook: 575,
          pageNumberInBook: '83'
        },
        {
          code: '688 C',
          name: null,
          rgb: {
            r: 167,
            g: 99,
            b: 137
          },
          hex: 'A76389',
          positionInBook: 576,
          pageNumberInBook: '83'
        },
        {
          code: '689 C',
          name: null,
          rgb: {
            r: 137,
            g: 59,
            b: 103
          },
          hex: '893B67',
          positionInBook: 577,
          pageNumberInBook: '83'
        },
        {
          code: '690 C',
          name: null,
          rgb: {
            r: 97,
            g: 33,
            b: 65
          },
          hex: '612141',
          positionInBook: 578,
          pageNumberInBook: '83'
        },
        {
          code: '510 C',
          name: null,
          rgb: {
            r: 235,
            g: 190,
            b: 203
          },
          hex: 'EBBECB',
          positionInBook: 579,
          pageNumberInBook: '84'
        },
        {
          code: '509 C',
          name: null,
          rgb: {
            r: 232,
            g: 179,
            b: 195
          },
          hex: 'E8B3C3',
          positionInBook: 580,
          pageNumberInBook: '84'
        },
        {
          code: '508 C',
          name: null,
          rgb: {
            r: 228,
            g: 169,
            b: 187
          },
          hex: 'E4A9BB',
          positionInBook: 581,
          pageNumberInBook: '84'
        },
        {
          code: '507 C',
          name: null,
          rgb: {
            r: 213,
            g: 146,
            b: 170
          },
          hex: 'D592AA',
          positionInBook: 582,
          pageNumberInBook: '84'
        },
        {
          code: '506 C',
          name: null,
          rgb: {
            r: 132,
            g: 52,
            b: 78
          },
          hex: '84344E',
          positionInBook: 583,
          pageNumberInBook: '84'
        },
        {
          code: '505 C',
          name: null,
          rgb: {
            r: 111,
            g: 44,
            b: 63
          },
          hex: '6F2C3F',
          positionInBook: 584,
          pageNumberInBook: '84'
        },
        {
          code: '504 C',
          name: null,
          rgb: {
            r: 87,
            g: 41,
            b: 50
          },
          hex: '572932',
          positionInBook: 585,
          pageNumberInBook: '84'
        },
        {
          code: '7429 C',
          name: null,
          rgb: {
            r: 226,
            g: 188,
            b: 203
          },
          hex: 'E2BCCB',
          positionInBook: 586,
          pageNumberInBook: '85'
        },
        {
          code: '7430 C',
          name: null,
          rgb: {
            r: 220,
            g: 169,
            b: 191
          },
          hex: 'DCA9BF',
          positionInBook: 587,
          pageNumberInBook: '85'
        },
        {
          code: '7431 C',
          name: null,
          rgb: {
            r: 201,
            g: 128,
            b: 158
          },
          hex: 'C9809E',
          positionInBook: 588,
          pageNumberInBook: '85'
        },
        {
          code: '7432 C',
          name: null,
          rgb: {
            r: 181,
            g: 92,
            b: 128
          },
          hex: 'B55C80',
          positionInBook: 589,
          pageNumberInBook: '85'
        },
        {
          code: '7433 C',
          name: null,
          rgb: {
            r: 167,
            g: 58,
            b: 100
          },
          hex: 'A73A64',
          positionInBook: 590,
          pageNumberInBook: '85'
        },
        {
          code: '7434 C',
          name: null,
          rgb: {
            r: 155,
            g: 51,
            b: 89
          },
          hex: '9B3359',
          positionInBook: 591,
          pageNumberInBook: '85'
        },
        {
          code: '7435 C',
          name: null,
          rgb: {
            r: 135,
            g: 38,
            b: 81
          },
          hex: '872651',
          positionInBook: 592,
          pageNumberInBook: '85'
        },
        {
          code: '691 C',
          name: null,
          rgb: {
            r: 233,
            g: 205,
            b: 208
          },
          hex: 'E9CDD0',
          positionInBook: 593,
          pageNumberInBook: '86'
        },
        {
          code: '692 C',
          name: null,
          rgb: {
            r: 227,
            g: 190,
            b: 195
          },
          hex: 'E3BEC3',
          positionInBook: 594,
          pageNumberInBook: '86'
        },
        {
          code: '693 C',
          name: null,
          rgb: {
            r: 215,
            g: 163,
            b: 171
          },
          hex: 'D7A3AB',
          positionInBook: 595,
          pageNumberInBook: '86'
        },
        {
          code: '694 C',
          name: null,
          rgb: {
            r: 196,
            g: 132,
            b: 144
          },
          hex: 'C48490',
          positionInBook: 596,
          pageNumberInBook: '86'
        },
        {
          code: '695 C',
          name: null,
          rgb: {
            r: 180,
            g: 107,
            b: 122
          },
          hex: 'B46B7A',
          positionInBook: 597,
          pageNumberInBook: '86'
        },
        {
          code: '696 C',
          name: null,
          rgb: {
            r: 152,
            g: 72,
            b: 87
          },
          hex: '984857',
          positionInBook: 598,
          pageNumberInBook: '86'
        },
        {
          code: '697 C',
          name: null,
          rgb: {
            r: 137,
            g: 60,
            b: 71
          },
          hex: '893C47',
          positionInBook: 599,
          pageNumberInBook: '86'
        },
        {
          code: '496 C',
          name: null,
          rgb: {
            r: 242,
            g: 198,
            b: 207
          },
          hex: 'F2C6CF',
          positionInBook: 600,
          pageNumberInBook: '87'
        },
        {
          code: '495 C',
          name: null,
          rgb: {
            r: 241,
            g: 189,
            b: 200
          },
          hex: 'F1BDC8',
          positionInBook: 601,
          pageNumberInBook: '87'
        },
        {
          code: '494 C',
          name: null,
          rgb: {
            r: 233,
            g: 162,
            b: 178
          },
          hex: 'E9A2B2',
          positionInBook: 602,
          pageNumberInBook: '87'
        },
        {
          code: '493 C',
          name: null,
          rgb: {
            r: 220,
            g: 134,
            b: 153
          },
          hex: 'DC8699',
          positionInBook: 603,
          pageNumberInBook: '87'
        },
        {
          code: '492 C',
          name: null,
          rgb: {
            r: 143,
            g: 50,
            b: 55
          },
          hex: '8F3237',
          positionInBook: 604,
          pageNumberInBook: '87'
        },
        {
          code: '491 C',
          name: null,
          rgb: {
            r: 127,
            g: 48,
            b: 53
          },
          hex: '7F3035',
          positionInBook: 605,
          pageNumberInBook: '87'
        },
        {
          code: '490 C',
          name: null,
          rgb: {
            r: 93,
            g: 42,
            b: 44
          },
          hex: '5D2A2C',
          positionInBook: 606,
          pageNumberInBook: '87'
        },
        {
          code: '503 C',
          name: null,
          rgb: {
            r: 233,
            g: 197,
            b: 199
          },
          hex: 'E9C5C7',
          positionInBook: 607,
          pageNumberInBook: '88'
        },
        {
          code: '502 C',
          name: null,
          rgb: {
            r: 229,
            g: 186,
            b: 193
          },
          hex: 'E5BAC1',
          positionInBook: 608,
          pageNumberInBook: '88'
        },
        {
          code: '501 C',
          name: null,
          rgb: {
            r: 218,
            g: 165,
            b: 173
          },
          hex: 'DAA5AD',
          positionInBook: 609,
          pageNumberInBook: '88'
        },
        {
          code: '500 C',
          name: null,
          rgb: {
            r: 198,
            g: 133,
            b: 143
          },
          hex: 'C6858F',
          positionInBook: 610,
          pageNumberInBook: '88'
        },
        {
          code: '499 C',
          name: null,
          rgb: {
            r: 122,
            g: 62,
            b: 58
          },
          hex: '7A3E3A',
          positionInBook: 611,
          pageNumberInBook: '88'
        },
        {
          code: '498 C',
          name: null,
          rgb: {
            r: 106,
            g: 55,
            b: 53
          },
          hex: '6A3735',
          positionInBook: 612,
          pageNumberInBook: '88'
        },
        {
          code: '497 C',
          name: null,
          rgb: {
            r: 81,
            g: 47,
            b: 46
          },
          hex: '512F2E',
          positionInBook: 613,
          pageNumberInBook: '88'
        },
        {
          code: '4085 C',
          name: null,
          rgb: {
            r: 200,
            g: 183,
            b: 173
          },
          hex: 'C8B7AD',
          positionInBook: 614,
          pageNumberInBook: '89'
        },
        {
          code: '4086 C',
          name: null,
          rgb: {
            r: 188,
            g: 165,
            b: 165
          },
          hex: 'BCA5A5',
          positionInBook: 615,
          pageNumberInBook: '89'
        },
        {
          code: '4087 C',
          name: null,
          rgb: {
            r: 183,
            g: 159,
            b: 151
          },
          hex: 'B79F97',
          positionInBook: 616,
          pageNumberInBook: '89'
        },
        {
          code: '4088 C',
          name: null,
          rgb: {
            r: 168,
            g: 139,
            b: 128
          },
          hex: 'A88B80',
          positionInBook: 617,
          pageNumberInBook: '89'
        },
        {
          code: '4089 C',
          name: null,
          rgb: {
            r: 164,
            g: 140,
            b: 136
          },
          hex: 'A48C88',
          positionInBook: 618,
          pageNumberInBook: '89'
        },
        {
          code: '4090 C',
          name: null,
          rgb: {
            r: 143,
            g: 115,
            b: 104
          },
          hex: '8F7368',
          positionInBook: 619,
          pageNumberInBook: '89'
        },
        {
          code: '4091 C',
          name: null,
          rgb: {
            r: 123,
            g: 96,
            b: 94
          },
          hex: '7B605E',
          positionInBook: 620,
          pageNumberInBook: '89'
        },
        {
          code: '4092 C',
          name: null,
          rgb: {
            r: 202,
            g: 167,
            b: 181
          },
          hex: 'CAA7B5',
          positionInBook: 621,
          pageNumberInBook: '90'
        },
        {
          code: '4093 C',
          name: null,
          rgb: {
            r: 174,
            g: 144,
            b: 147
          },
          hex: 'AE9093',
          positionInBook: 622,
          pageNumberInBook: '90'
        },
        {
          code: '4094 C',
          name: null,
          rgb: {
            r: 145,
            g: 105,
            b: 118
          },
          hex: '916976',
          positionInBook: 623,
          pageNumberInBook: '90'
        },
        {
          code: '4095 C',
          name: null,
          rgb: {
            r: 139,
            g: 90,
            b: 107
          },
          hex: '8B5A6B',
          positionInBook: 624,
          pageNumberInBook: '90'
        },
        {
          code: '4096 C',
          name: null,
          rgb: {
            r: 120,
            g: 73,
            b: 77
          },
          hex: '78494D',
          positionInBook: 625,
          pageNumberInBook: '90'
        },
        {
          code: '4097 C',
          name: null,
          rgb: {
            r: 116,
            g: 77,
            b: 81
          },
          hex: '744D51',
          positionInBook: 626,
          pageNumberInBook: '90'
        },
        {
          code: '4098 C',
          name: null,
          rgb: {
            r: 101,
            g: 68,
            b: 61
          },
          hex: '65443D',
          positionInBook: 627,
          pageNumberInBook: '90'
        },
        {
          code: '5035 C',
          name: null,
          rgb: {
            r: 223,
            g: 194,
            b: 195
          },
          hex: 'DFC2C3',
          positionInBook: 628,
          pageNumberInBook: '91'
        },
        {
          code: '5025 C',
          name: null,
          rgb: {
            r: 219,
            g: 183,
            b: 187
          },
          hex: 'DBB7BB',
          positionInBook: 629,
          pageNumberInBook: '91'
        },
        {
          code: '5015 C',
          name: null,
          rgb: {
            r: 204,
            g: 161,
            b: 166
          },
          hex: 'CCA1A6',
          positionInBook: 630,
          pageNumberInBook: '91'
        },
        {
          code: '5005 C',
          name: null,
          rgb: {
            r: 176,
            g: 124,
            b: 131
          },
          hex: 'B07C83',
          positionInBook: 631,
          pageNumberInBook: '91'
        },
        {
          code: '4995 C',
          name: null,
          rgb: {
            r: 156,
            g: 97,
            b: 105
          },
          hex: '9C6169',
          positionInBook: 632,
          pageNumberInBook: '91'
        },
        {
          code: '4985 C',
          name: null,
          rgb: {
            r: 135,
            g: 75,
            b: 82
          },
          hex: '874B52',
          positionInBook: 633,
          pageNumberInBook: '91'
        },
        {
          code: '4975 C',
          name: null,
          rgb: {
            r: 63,
            g: 32,
            b: 33
          },
          hex: '3F2021',
          positionInBook: 634,
          pageNumberInBook: '91'
        },
        {
          code: '4099 C',
          name: null,
          rgb: {
            r: 172,
            g: 133,
            b: 132
          },
          hex: 'AC8584',
          positionInBook: 635,
          pageNumberInBook: '92'
        },
        {
          code: '4100 C',
          name: null,
          rgb: {
            r: 126,
            g: 77,
            b: 77
          },
          hex: '7E4D4D',
          positionInBook: 636,
          pageNumberInBook: '92'
        },
        {
          code: '4101 C',
          name: null,
          rgb: {
            r: 98,
            g: 33,
            b: 40
          },
          hex: '622128',
          positionInBook: 637,
          pageNumberInBook: '92'
        },
        {
          code: '4102 C',
          name: null,
          rgb: {
            r: 85,
            g: 28,
            b: 37
          },
          hex: '551C25',
          positionInBook: 638,
          pageNumberInBook: '92'
        },
        {
          code: '4103 C',
          name: null,
          rgb: {
            r: 81,
            g: 37,
            b: 47
          },
          hex: '51252F',
          positionInBook: 639,
          pageNumberInBook: '92'
        },
        {
          code: '4104 C',
          name: null,
          rgb: {
            r: 84,
            g: 58,
            b: 59
          },
          hex: '543A3B',
          positionInBook: 640,
          pageNumberInBook: '92'
        },
        {
          code: '4105 C',
          name: null,
          rgb: {
            r: 102,
            g: 63,
            b: 52
          },
          hex: '663F34',
          positionInBook: 641,
          pageNumberInBook: '92'
        },
        {
          code: '236 C',
          name: null,
          rgb: {
            r: 241,
            g: 167,
            b: 220
          },
          hex: 'F1A7DC',
          positionInBook: 642,
          pageNumberInBook: '93'
        },
        {
          code: '237 C',
          name: null,
          rgb: {
            r: 236,
            g: 134,
            b: 208
          },
          hex: 'EC86D0',
          positionInBook: 643,
          pageNumberInBook: '93'
        },
        {
          code: '238 C',
          name: null,
          rgb: {
            r: 228,
            g: 93,
            b: 191
          },
          hex: 'E45DBF',
          positionInBook: 644,
          pageNumberInBook: '93'
        },
        {
          code: '239 C',
          name: null,
          rgb: {
            r: 219,
            g: 62,
            b: 177
          },
          hex: 'DB3EB1',
          positionInBook: 645,
          pageNumberInBook: '93'
        },
        {
          code: '240 C',
          name: null,
          rgb: {
            r: 197,
            g: 41,
            b: 155
          },
          hex: 'C5299B',
          positionInBook: 646,
          pageNumberInBook: '93'
        },
        {
          code: '241 C',
          name: null,
          rgb: {
            r: 175,
            g: 22,
            b: 133
          },
          hex: 'AF1685',
          positionInBook: 647,
          pageNumberInBook: '93'
        },
        {
          code: '242 C',
          name: null,
          rgb: {
            r: 128,
            g: 34,
            b: 95
          },
          hex: '80225F',
          positionInBook: 648,
          pageNumberInBook: '93'
        },
        {
          code: '2057 C',
          name: null,
          rgb: {
            r: 207,
            g: 146,
            b: 183
          },
          hex: 'CF92B7',
          positionInBook: 649,
          pageNumberInBook: '94'
        },
        {
          code: '2058 C',
          name: null,
          rgb: {
            r: 187,
            g: 133,
            b: 171
          },
          hex: 'BB85AB',
          positionInBook: 650,
          pageNumberInBook: '94'
        },
        {
          code: '2059 C',
          name: null,
          rgb: {
            r: 184,
            g: 123,
            b: 161
          },
          hex: 'B87BA1',
          positionInBook: 651,
          pageNumberInBook: '94'
        },
        {
          code: '2060 C',
          name: null,
          rgb: {
            r: 200,
            g: 107,
            b: 168
          },
          hex: 'C86BA8',
          positionInBook: 652,
          pageNumberInBook: '94'
        },
        {
          code: '2061 C',
          name: null,
          rgb: {
            r: 173,
            g: 83,
            b: 137
          },
          hex: 'AD5389',
          positionInBook: 653,
          pageNumberInBook: '94'
        },
        {
          code: '2062 C',
          name: null,
          rgb: {
            r: 180,
            g: 69,
            b: 141
          },
          hex: 'B4458D',
          positionInBook: 654,
          pageNumberInBook: '94'
        },
        {
          code: '2063 C',
          name: null,
          rgb: {
            r: 165,
            g: 48,
            b: 124
          },
          hex: 'A5307C',
          positionInBook: 655,
          pageNumberInBook: '94'
        },
        {
          code: '2365 C',
          name: null,
          rgb: {
            r: 239,
            g: 186,
            b: 225
          },
          hex: 'EFBAE1',
          positionInBook: 656,
          pageNumberInBook: '95'
        },
        {
          code: '2375 C',
          name: null,
          rgb: {
            r: 226,
            g: 119,
            b: 205
          },
          hex: 'E277CD',
          positionInBook: 657,
          pageNumberInBook: '95'
        },
        {
          code: '2385 C',
          name: null,
          rgb: {
            r: 213,
            g: 57,
            b: 181
          },
          hex: 'D539B5',
          positionInBook: 658,
          pageNumberInBook: '95'
        },
        {
          code: '2395 C',
          name: null,
          rgb: {
            r: 200,
            g: 0,
            b: 161
          },
          hex: 'C800A1',
          positionInBook: 659,
          pageNumberInBook: '95'
        },
        {
          code: '2405 C',
          name: null,
          rgb: {
            r: 176,
            g: 0,
            b: 142
          },
          hex: 'B0008E',
          positionInBook: 660,
          pageNumberInBook: '95'
        },
        {
          code: '2415 C',
          name: null,
          rgb: {
            r: 158,
            g: 0,
            b: 126
          },
          hex: '9E007E',
          positionInBook: 661,
          pageNumberInBook: '95'
        },
        {
          code: '2425 C',
          name: null,
          rgb: {
            r: 131,
            g: 0,
            b: 101
          },
          hex: '830065',
          positionInBook: 662,
          pageNumberInBook: '95'
        },
        {
          code: '243 C',
          name: null,
          rgb: {
            r: 234,
            g: 184,
            b: 228
          },
          hex: 'EAB8E4',
          positionInBook: 663,
          pageNumberInBook: '96'
        },
        {
          code: '244 C',
          name: null,
          rgb: {
            r: 229,
            g: 155,
            b: 220
          },
          hex: 'E59BDC',
          positionInBook: 664,
          pageNumberInBook: '96'
        },
        {
          code: '245 C',
          name: null,
          rgb: {
            r: 221,
            g: 127,
            b: 211
          },
          hex: 'DD7FD3',
          positionInBook: 665,
          pageNumberInBook: '96'
        },
        {
          code: '246 C',
          name: null,
          rgb: {
            r: 199,
            g: 36,
            b: 177
          },
          hex: 'C724B1',
          positionInBook: 666,
          pageNumberInBook: '96'
        },
        {
          code: '247 C',
          name: null,
          rgb: {
            r: 187,
            g: 22,
            b: 163
          },
          hex: 'BB16A3',
          positionInBook: 667,
          pageNumberInBook: '96'
        },
        {
          code: '248 C',
          name: null,
          rgb: {
            r: 165,
            g: 24,
            b: 144
          },
          hex: 'A51890',
          positionInBook: 668,
          pageNumberInBook: '96'
        },
        {
          code: '249 C',
          name: null,
          rgb: {
            r: 128,
            g: 40,
            b: 108
          },
          hex: '80286C',
          positionInBook: 669,
          pageNumberInBook: '96'
        },
        {
          code: '7646 C',
          name: null,
          rgb: {
            r: 165,
            g: 110,
            b: 135
          },
          hex: 'A56E87',
          positionInBook: 670,
          pageNumberInBook: '97'
        },
        {
          code: '7647 C',
          name: null,
          rgb: {
            r: 168,
            g: 61,
            b: 114
          },
          hex: 'A83D72',
          positionInBook: 671,
          pageNumberInBook: '97'
        },
        {
          code: '7648 C',
          name: null,
          rgb: {
            r: 153,
            g: 30,
            b: 102
          },
          hex: '991E66',
          positionInBook: 672,
          pageNumberInBook: '97'
        },
        {
          code: '7649 C',
          name: null,
          rgb: {
            r: 138,
            g: 27,
            b: 97
          },
          hex: '8A1B61',
          positionInBook: 673,
          pageNumberInBook: '97'
        },
        {
          code: '7650 C',
          name: null,
          rgb: {
            r: 114,
            g: 34,
            b: 87
          },
          hex: '722257',
          positionInBook: 674,
          pageNumberInBook: '97'
        },
        {
          code: '7651 C',
          name: null,
          rgb: {
            r: 106,
            g: 42,
            b: 91
          },
          hex: '6A2A5B',
          positionInBook: 675,
          pageNumberInBook: '97'
        },
        {
          code: '7652 C',
          name: null,
          rgb: {
            r: 94,
            g: 39,
            b: 81
          },
          hex: '5E2751',
          positionInBook: 676,
          pageNumberInBook: '97'
        },
        {
          code: '250 C',
          name: null,
          rgb: {
            r: 231,
            g: 186,
            b: 228
          },
          hex: 'E7BAE4',
          positionInBook: 677,
          pageNumberInBook: '98'
        },
        {
          code: '251 C',
          name: null,
          rgb: {
            r: 221,
            g: 156,
            b: 223
          },
          hex: 'DD9CDF',
          positionInBook: 678,
          pageNumberInBook: '98'
        },
        {
          code: '252 C',
          name: null,
          rgb: {
            r: 201,
            g: 100,
            b: 207
          },
          hex: 'C964CF',
          positionInBook: 679,
          pageNumberInBook: '98'
        },
        {
          code: 'Purple C',
          name: null,
          rgb: {
            r: 187,
            g: 41,
            b: 187
          },
          hex: 'BB29BB',
          positionInBook: 680,
          pageNumberInBook: '98'
        },
        {
          code: '253 C',
          name: null,
          rgb: {
            r: 173,
            g: 26,
            b: 172
          },
          hex: 'AD1AAC',
          positionInBook: 681,
          pageNumberInBook: '98'
        },
        {
          code: '254 C',
          name: null,
          rgb: {
            r: 152,
            g: 30,
            b: 151
          },
          hex: '981E97',
          positionInBook: 682,
          pageNumberInBook: '98'
        },
        {
          code: '255 C',
          name: null,
          rgb: {
            r: 114,
            g: 36,
            b: 108
          },
          hex: '72246C',
          positionInBook: 683,
          pageNumberInBook: '98'
        },
        {
          code: '2064 C',
          name: null,
          rgb: {
            r: 224,
            g: 162,
            b: 212
          },
          hex: 'E0A2D4',
          positionInBook: 684,
          pageNumberInBook: '99'
        },
        {
          code: '2065 C',
          name: null,
          rgb: {
            r: 222,
            g: 168,
            b: 221
          },
          hex: 'DEA8DD',
          positionInBook: 685,
          pageNumberInBook: '99'
        },
        {
          code: '2066 C',
          name: null,
          rgb: {
            r: 210,
            g: 141,
            b: 211
          },
          hex: 'D28DD3',
          positionInBook: 686,
          pageNumberInBook: '99'
        },
        {
          code: '2067 C',
          name: null,
          rgb: {
            r: 192,
            g: 105,
            b: 194
          },
          hex: 'C069C2',
          positionInBook: 687,
          pageNumberInBook: '99'
        },
        {
          code: '2068 C',
          name: null,
          rgb: {
            r: 177,
            g: 78,
            b: 181
          },
          hex: 'B14EB5',
          positionInBook: 688,
          pageNumberInBook: '99'
        },
        {
          code: '2069 C',
          name: null,
          rgb: {
            r: 164,
            g: 56,
            b: 168
          },
          hex: 'A438A8',
          positionInBook: 689,
          pageNumberInBook: '99'
        },
        {
          code: '2070 C',
          name: null,
          rgb: {
            r: 143,
            g: 26,
            b: 149
          },
          hex: '8F1A95',
          positionInBook: 690,
          pageNumberInBook: '99'
        },
        {
          code: '517 C',
          name: null,
          rgb: {
            r: 235,
            g: 198,
            b: 223
          },
          hex: 'EBC6DF',
          positionInBook: 691,
          pageNumberInBook: '100'
        },
        {
          code: '516 C',
          name: null,
          rgb: {
            r: 230,
            g: 190,
            b: 221
          },
          hex: 'E6BEDD',
          positionInBook: 692,
          pageNumberInBook: '100'
        },
        {
          code: '515 C',
          name: null,
          rgb: {
            r: 226,
            g: 172,
            b: 215
          },
          hex: 'E2ACD7',
          positionInBook: 693,
          pageNumberInBook: '100'
        },
        {
          code: '514 C',
          name: null,
          rgb: {
            r: 212,
            g: 139,
            b: 200
          },
          hex: 'D48BC8',
          positionInBook: 694,
          pageNumberInBook: '100'
        },
        {
          code: '513 C',
          name: null,
          rgb: {
            r: 147,
            g: 50,
            b: 142
          },
          hex: '93328E',
          positionInBook: 695,
          pageNumberInBook: '100'
        },
        {
          code: '512 C',
          name: null,
          rgb: {
            r: 131,
            g: 49,
            b: 119
          },
          hex: '833177',
          positionInBook: 696,
          pageNumberInBook: '100'
        },
        {
          code: '511 C',
          name: null,
          rgb: {
            r: 97,
            g: 44,
            b: 81
          },
          hex: '612C51',
          positionInBook: 697,
          pageNumberInBook: '100'
        },
        {
          code: '2351 C',
          name: null,
          rgb: {
            r: 189,
            g: 122,
            b: 179
          },
          hex: 'BD7AB3',
          positionInBook: 698,
          pageNumberInBook: '101'
        },
        {
          code: '2352 C',
          name: null,
          rgb: {
            r: 181,
            g: 101,
            b: 167
          },
          hex: 'B565A7',
          positionInBook: 699,
          pageNumberInBook: '101'
        },
        {
          code: '2353 C',
          name: null,
          rgb: {
            r: 191,
            g: 77,
            b: 165
          },
          hex: 'BF4DA5',
          positionInBook: 700,
          pageNumberInBook: '101'
        },
        {
          code: '2354 C',
          name: null,
          rgb: {
            r: 146,
            g: 78,
            b: 140
          },
          hex: '924E8C',
          positionInBook: 701,
          pageNumberInBook: '101'
        },
        {
          code: '2355 C',
          name: null,
          rgb: {
            r: 135,
            g: 3,
            b: 123
          },
          hex: '87037B',
          positionInBook: 702,
          pageNumberInBook: '101'
        },
        {
          code: '2356 C',
          name: null,
          rgb: {
            r: 114,
            g: 0,
            b: 98
          },
          hex: '720062',
          positionInBook: 703,
          pageNumberInBook: '101'
        },
        {
          code: '2357 C',
          name: null,
          rgb: {
            r: 98,
            g: 18,
            b: 68
          },
          hex: '621244',
          positionInBook: 704,
          pageNumberInBook: '101'
        },
        {
          code: '7653 C',
          name: null,
          rgb: {
            r: 148,
            g: 135,
            b: 148
          },
          hex: '948794',
          positionInBook: 705,
          pageNumberInBook: '102'
        },
        {
          code: '7654 C',
          name: null,
          rgb: {
            r: 162,
            g: 120,
            b: 156
          },
          hex: 'A2789C',
          positionInBook: 706,
          pageNumberInBook: '102'
        },
        {
          code: '7655 C',
          name: null,
          rgb: {
            r: 161,
            g: 90,
            b: 149
          },
          hex: 'A15A95',
          positionInBook: 707,
          pageNumberInBook: '102'
        },
        {
          code: '7656 C',
          name: null,
          rgb: {
            r: 142,
            g: 58,
            b: 128
          },
          hex: '8E3A80',
          positionInBook: 708,
          pageNumberInBook: '102'
        },
        {
          code: '7657 C',
          name: null,
          rgb: {
            r: 110,
            g: 43,
            b: 98
          },
          hex: '6E2B62',
          positionInBook: 709,
          pageNumberInBook: '102'
        },
        {
          code: '7658 C',
          name: null,
          rgb: {
            r: 106,
            g: 52,
            b: 96
          },
          hex: '6A3460',
          positionInBook: 710,
          pageNumberInBook: '102'
        },
        {
          code: '7659 C',
          name: null,
          rgb: {
            r: 93,
            g: 55,
            b: 84
          },
          hex: '5D3754',
          positionInBook: 711,
          pageNumberInBook: '102'
        },
        {
          code: '5175 C',
          name: null,
          rgb: {
            r: 216,
            g: 200,
            b: 209
          },
          hex: 'D8C8D1',
          positionInBook: 712,
          pageNumberInBook: '103'
        },
        {
          code: '5165 C',
          name: null,
          rgb: {
            r: 211,
            g: 192,
            b: 205
          },
          hex: 'D3C0CD',
          positionInBook: 713,
          pageNumberInBook: '103'
        },
        {
          code: '5155 C',
          name: null,
          rgb: {
            r: 191,
            g: 165,
            b: 184
          },
          hex: 'BFA5B8',
          positionInBook: 714,
          pageNumberInBook: '103'
        },
        {
          code: '5145 C',
          name: null,
          rgb: {
            r: 155,
            g: 119,
            b: 147
          },
          hex: '9B7793',
          positionInBook: 715,
          pageNumberInBook: '103'
        },
        {
          code: '5135 C',
          name: null,
          rgb: {
            r: 126,
            g: 84,
            b: 117
          },
          hex: '7E5475',
          positionInBook: 716,
          pageNumberInBook: '103'
        },
        {
          code: '5125 C',
          name: null,
          rgb: {
            r: 105,
            g: 60,
            b: 94
          },
          hex: '693C5E',
          positionInBook: 717,
          pageNumberInBook: '103'
        },
        {
          code: '5115 C',
          name: null,
          rgb: {
            r: 81,
            g: 42,
            b: 68
          },
          hex: '512A44',
          positionInBook: 718,
          pageNumberInBook: '103'
        },
        {
          code: '4106 C',
          name: null,
          rgb: {
            r: 196,
            g: 170,
            b: 178
          },
          hex: 'C4AAB2',
          positionInBook: 719,
          pageNumberInBook: '104'
        },
        {
          code: '4107 C',
          name: null,
          rgb: {
            r: 173,
            g: 146,
            b: 164
          },
          hex: 'AD92A4',
          positionInBook: 720,
          pageNumberInBook: '104'
        },
        {
          code: '4108 C',
          name: null,
          rgb: {
            r: 165,
            g: 132,
            b: 150
          },
          hex: 'A58496',
          positionInBook: 721,
          pageNumberInBook: '104'
        },
        {
          code: '4109 C',
          name: null,
          rgb: {
            r: 158,
            g: 120,
            b: 137
          },
          hex: '9E7889',
          positionInBook: 722,
          pageNumberInBook: '104'
        },
        {
          code: '4110 C',
          name: null,
          rgb: {
            r: 138,
            g: 109,
            b: 127
          },
          hex: '8A6D7F',
          positionInBook: 723,
          pageNumberInBook: '104'
        },
        {
          code: '4111 C',
          name: null,
          rgb: {
            r: 124,
            g: 87,
            b: 106
          },
          hex: '7C576A',
          positionInBook: 724,
          pageNumberInBook: '104'
        },
        {
          code: '4112 C',
          name: null,
          rgb: {
            r: 140,
            g: 109,
            b: 115
          },
          hex: '8C6D73',
          positionInBook: 725,
          pageNumberInBook: '104'
        },
        {
          code: '5245 C',
          name: null,
          rgb: {
            r: 219,
            g: 205,
            b: 211
          },
          hex: 'DBCDD3',
          positionInBook: 726,
          pageNumberInBook: '105'
        },
        {
          code: '5235 C',
          name: null,
          rgb: {
            r: 208,
            g: 190,
            b: 199
          },
          hex: 'D0BEC7',
          positionInBook: 727,
          pageNumberInBook: '105'
        },
        {
          code: '5225 C',
          name: null,
          rgb: {
            r: 198,
            g: 176,
            b: 188
          },
          hex: 'C6B0BC',
          positionInBook: 728,
          pageNumberInBook: '105'
        },
        {
          code: '5215 C',
          name: null,
          rgb: {
            r: 175,
            g: 149,
            b: 166
          },
          hex: 'AF95A6',
          positionInBook: 729,
          pageNumberInBook: '105'
        },
        {
          code: '5205 C',
          name: null,
          rgb: {
            r: 134,
            g: 100,
            b: 122
          },
          hex: '86647A',
          positionInBook: 730,
          pageNumberInBook: '105'
        },
        {
          code: '5195 C',
          name: null,
          rgb: {
            r: 102,
            g: 67,
            b: 90
          },
          hex: '66435A',
          positionInBook: 731,
          pageNumberInBook: '105'
        },
        {
          code: '5185 C',
          name: null,
          rgb: {
            r: 74,
            g: 48,
            b: 65
          },
          hex: '4A3041',
          positionInBook: 732,
          pageNumberInBook: '105'
        },
        {
          code: '4113 C',
          name: null,
          rgb: {
            r: 163,
            g: 141,
            b: 145
          },
          hex: 'A38D91',
          positionInBook: 733,
          pageNumberInBook: '106'
        },
        {
          code: '4114 C',
          name: null,
          rgb: {
            r: 155,
            g: 140,
            b: 146
          },
          hex: '9B8C92',
          positionInBook: 734,
          pageNumberInBook: '106'
        },
        {
          code: '4115 C',
          name: null,
          rgb: {
            r: 148,
            g: 128,
            b: 130
          },
          hex: '948082',
          positionInBook: 735,
          pageNumberInBook: '106'
        },
        {
          code: '4116 C',
          name: null,
          rgb: {
            r: 152,
            g: 131,
            b: 131
          },
          hex: '988383',
          positionInBook: 736,
          pageNumberInBook: '106'
        },
        {
          code: '4117 C',
          name: null,
          rgb: {
            r: 114,
            g: 100,
            b: 119
          },
          hex: '726477',
          positionInBook: 737,
          pageNumberInBook: '106'
        },
        {
          code: '4118 C',
          name: null,
          rgb: {
            r: 70,
            g: 57,
            b: 78
          },
          hex: '46394E',
          positionInBook: 738,
          pageNumberInBook: '106'
        },
        {
          code: '4119 C',
          name: null,
          rgb: {
            r: 64,
            g: 56,
            b: 69
          },
          hex: '403845',
          positionInBook: 739,
          pageNumberInBook: '106'
        },
        {
          code: '524 C',
          name: null,
          rgb: {
            r: 213,
            g: 194,
            b: 216
          },
          hex: 'D5C2D8',
          positionInBook: 740,
          pageNumberInBook: '107'
        },
        {
          code: '523 C',
          name: null,
          rgb: {
            r: 201,
            g: 177,
            b: 208
          },
          hex: 'C9B1D0',
          positionInBook: 741,
          pageNumberInBook: '107'
        },
        {
          code: '522 C',
          name: null,
          rgb: {
            r: 186,
            g: 156,
            b: 197
          },
          hex: 'BA9CC5',
          positionInBook: 742,
          pageNumberInBook: '107'
        },
        {
          code: '521 C',
          name: null,
          rgb: {
            r: 165,
            g: 127,
            b: 178
          },
          hex: 'A57FB2',
          positionInBook: 743,
          pageNumberInBook: '107'
        },
        {
          code: '520 C',
          name: null,
          rgb: {
            r: 100,
            g: 47,
            b: 108
          },
          hex: '642F6C',
          positionInBook: 744,
          pageNumberInBook: '107'
        },
        {
          code: '519 C',
          name: null,
          rgb: {
            r: 89,
            g: 49,
            b: 95
          },
          hex: '59315F',
          positionInBook: 745,
          pageNumberInBook: '107'
        },
        {
          code: '518 C',
          name: null,
          rgb: {
            r: 75,
            g: 48,
            b: 72
          },
          hex: '4B3048',
          positionInBook: 746,
          pageNumberInBook: '107'
        },
        {
          code: '7436 C',
          name: null,
          rgb: {
            r: 238,
            g: 218,
            b: 234
          },
          hex: 'EEDAEA',
          positionInBook: 747,
          pageNumberInBook: '108'
        },
        {
          code: '7437 C',
          name: null,
          rgb: {
            r: 204,
            g: 174,
            b: 208
          },
          hex: 'CCAED0',
          positionInBook: 748,
          pageNumberInBook: '108'
        },
        {
          code: '7438 C',
          name: null,
          rgb: {
            r: 213,
            g: 158,
            b: 215
          },
          hex: 'D59ED7',
          positionInBook: 749,
          pageNumberInBook: '108'
        },
        {
          code: '7439 C',
          name: null,
          rgb: {
            r: 178,
            g: 136,
            b: 185
          },
          hex: 'B288B9',
          positionInBook: 750,
          pageNumberInBook: '108'
        },
        {
          code: '7440 C',
          name: null,
          rgb: {
            r: 162,
            g: 119,
            b: 166
          },
          hex: 'A277A6',
          positionInBook: 751,
          pageNumberInBook: '108'
        },
        {
          code: '7441 C',
          name: null,
          rgb: {
            r: 159,
            g: 92,
            b: 192
          },
          hex: '9F5CC0',
          positionInBook: 752,
          pageNumberInBook: '108'
        },
        {
          code: '7442 C',
          name: null,
          rgb: {
            r: 150,
            g: 60,
            b: 189
          },
          hex: '963CBD',
          positionInBook: 753,
          pageNumberInBook: '108'
        },
        {
          code: '2562 C',
          name: null,
          rgb: {
            r: 215,
            g: 169,
            b: 227
          },
          hex: 'D7A9E3',
          positionInBook: 754,
          pageNumberInBook: '109'
        },
        {
          code: '2572 C',
          name: null,
          rgb: {
            r: 201,
            g: 139,
            b: 219
          },
          hex: 'C98BDB',
          positionInBook: 755,
          pageNumberInBook: '109'
        },
        {
          code: '2582 C',
          name: null,
          rgb: {
            r: 172,
            g: 79,
            b: 198
          },
          hex: 'AC4FC6',
          positionInBook: 756,
          pageNumberInBook: '109'
        },
        {
          code: '2592 C',
          name: null,
          rgb: {
            r: 155,
            g: 38,
            b: 182
          },
          hex: '9B26B6',
          positionInBook: 757,
          pageNumberInBook: '109'
        },
        {
          code: '2602 C',
          name: null,
          rgb: {
            r: 135,
            g: 24,
            b: 157
          },
          hex: '87189D',
          positionInBook: 758,
          pageNumberInBook: '109'
        },
        {
          code: '2612 C',
          name: null,
          rgb: {
            r: 119,
            g: 37,
            b: 131
          },
          hex: '772583',
          positionInBook: 759,
          pageNumberInBook: '109'
        },
        {
          code: '2622 C',
          name: null,
          rgb: {
            r: 101,
            g: 49,
            b: 101
          },
          hex: '653165',
          positionInBook: 760,
          pageNumberInBook: '109'
        },
        {
          code: '531 C',
          name: null,
          rgb: {
            r: 223,
            g: 200,
            b: 231
          },
          hex: 'DFC8E7',
          positionInBook: 761,
          pageNumberInBook: '110'
        },
        {
          code: '530 C',
          name: null,
          rgb: {
            r: 215,
            g: 185,
            b: 228
          },
          hex: 'D7B9E4',
          positionInBook: 762,
          pageNumberInBook: '110'
        },
        {
          code: '529 C',
          name: null,
          rgb: {
            r: 202,
            g: 162,
            b: 221
          },
          hex: 'CAA2DD',
          positionInBook: 763,
          pageNumberInBook: '110'
        },
        {
          code: '528 C',
          name: null,
          rgb: {
            r: 181,
            g: 128,
            b: 209
          },
          hex: 'B580D1',
          positionInBook: 764,
          pageNumberInBook: '110'
        },
        {
          code: '527 C',
          name: null,
          rgb: {
            r: 128,
            g: 49,
            b: 167
          },
          hex: '8031A7',
          positionInBook: 765,
          pageNumberInBook: '110'
        },
        {
          code: '526 C',
          name: null,
          rgb: {
            r: 112,
            g: 47,
            b: 138
          },
          hex: '702F8A',
          positionInBook: 766,
          pageNumberInBook: '110'
        },
        {
          code: '525 C',
          name: null,
          rgb: {
            r: 87,
            g: 44,
            b: 95
          },
          hex: '572C5F',
          positionInBook: 767,
          pageNumberInBook: '110'
        },
        {
          code: '256 C',
          name: null,
          rgb: {
            r: 214,
            g: 191,
            b: 221
          },
          hex: 'D6BFDD',
          positionInBook: 768,
          pageNumberInBook: '111'
        },
        {
          code: '257 C',
          name: null,
          rgb: {
            r: 198,
            g: 161,
            b: 207
          },
          hex: 'C6A1CF',
          positionInBook: 769,
          pageNumberInBook: '111'
        },
        {
          code: '258 C',
          name: null,
          rgb: {
            r: 140,
            g: 71,
            b: 153
          },
          hex: '8C4799',
          positionInBook: 770,
          pageNumberInBook: '111'
        },
        {
          code: '259 C',
          name: null,
          rgb: {
            r: 109,
            g: 32,
            b: 119
          },
          hex: '6D2077',
          positionInBook: 771,
          pageNumberInBook: '111'
        },
        {
          code: '260 C',
          name: null,
          rgb: {
            r: 100,
            g: 38,
            b: 103
          },
          hex: '642667',
          positionInBook: 772,
          pageNumberInBook: '111'
        },
        {
          code: '261 C',
          name: null,
          rgb: {
            r: 93,
            g: 41,
            b: 95
          },
          hex: '5D295F',
          positionInBook: 773,
          pageNumberInBook: '111'
        },
        {
          code: '262 C',
          name: null,
          rgb: {
            r: 81,
            g: 40,
            b: 79
          },
          hex: '51284F',
          positionInBook: 774,
          pageNumberInBook: '111'
        },
        {
          code: '2563 C',
          name: null,
          rgb: {
            r: 203,
            g: 163,
            b: 216
          },
          hex: 'CBA3D8',
          positionInBook: 775,
          pageNumberInBook: '112'
        },
        {
          code: '2573 C',
          name: null,
          rgb: {
            r: 184,
            g: 132,
            b: 203
          },
          hex: 'B884CB',
          positionInBook: 776,
          pageNumberInBook: '112'
        },
        {
          code: '2583 C',
          name: null,
          rgb: {
            r: 160,
            g: 94,
            b: 181
          },
          hex: 'A05EB5',
          positionInBook: 777,
          pageNumberInBook: '112'
        },
        {
          code: '2593 C',
          name: null,
          rgb: {
            r: 132,
            g: 50,
            b: 155
          },
          hex: '84329B',
          positionInBook: 778,
          pageNumberInBook: '112'
        },
        {
          code: '2603 C',
          name: null,
          rgb: {
            r: 112,
            g: 32,
            b: 130
          },
          hex: '702082',
          positionInBook: 779,
          pageNumberInBook: '112'
        },
        {
          code: '2613 C',
          name: null,
          rgb: {
            r: 103,
            g: 30,
            b: 117
          },
          hex: '671E75',
          positionInBook: 780,
          pageNumberInBook: '112'
        },
        {
          code: '2623 C',
          name: null,
          rgb: {
            r: 95,
            g: 33,
            b: 103
          },
          hex: '5F2167',
          positionInBook: 781,
          pageNumberInBook: '112'
        },
        {
          code: '2078 C',
          name: null,
          rgb: {
            r: 181,
            g: 157,
            b: 187
          },
          hex: 'B59DBB',
          positionInBook: 782,
          pageNumberInBook: '113'
        },
        {
          code: '2079 C',
          name: null,
          rgb: {
            r: 155,
            g: 126,
            b: 164
          },
          hex: '9B7EA4',
          positionInBook: 783,
          pageNumberInBook: '113'
        },
        {
          code: '2080 C',
          name: null,
          rgb: {
            r: 152,
            g: 115,
            b: 172
          },
          hex: '9873AC',
          positionInBook: 784,
          pageNumberInBook: '113'
        },
        {
          code: '2081 C',
          name: null,
          rgb: {
            r: 134,
            g: 94,
            b: 156
          },
          hex: '865E9C',
          positionInBook: 785,
          pageNumberInBook: '113'
        },
        {
          code: '2082 C',
          name: null,
          rgb: {
            r: 120,
            g: 78,
            b: 144
          },
          hex: '784E90',
          positionInBook: 786,
          pageNumberInBook: '113'
        },
        {
          code: '2083 C',
          name: null,
          rgb: {
            r: 150,
            g: 94,
            b: 199
          },
          hex: '965EC7',
          positionInBook: 787,
          pageNumberInBook: '113'
        },
        {
          code: '2084 C',
          name: null,
          rgb: {
            r: 127,
            g: 53,
            b: 178
          },
          hex: '7F35B2',
          positionInBook: 788,
          pageNumberInBook: '113'
        },
        {
          code: '2453 C',
          name: null,
          rgb: {
            r: 185,
            g: 150,
            b: 195
          },
          hex: 'B996C3',
          positionInBook: 789,
          pageNumberInBook: '114'
        },
        {
          code: '3520 C',
          name: null,
          rgb: {
            r: 178,
            g: 123,
            b: 196
          },
          hex: 'B27BC4',
          positionInBook: 790,
          pageNumberInBook: '114'
        },
        {
          code: '3559 C',
          name: null,
          rgb: {
            r: 142,
            g: 81,
            b: 168
          },
          hex: '8E51A8',
          positionInBook: 791,
          pageNumberInBook: '114'
        },
        {
          code: '3593 C',
          name: null,
          rgb: {
            r: 155,
            g: 110,
            b: 182
          },
          hex: '9B6EB6',
          positionInBook: 792,
          pageNumberInBook: '114'
        },
        {
          code: '3575 C',
          name: null,
          rgb: {
            r: 150,
            g: 114,
            b: 196
          },
          hex: '9672C4',
          positionInBook: 793,
          pageNumberInBook: '114'
        },
        {
          code: '3543 C',
          name: null,
          rgb: {
            r: 164,
            g: 141,
            b: 209
          },
          hex: 'A48DD1',
          positionInBook: 794,
          pageNumberInBook: '114'
        },
        {
          code: '3515 C',
          name: null,
          rgb: {
            r: 97,
            g: 0,
            b: 125
          },
          hex: '61007D',
          positionInBook: 795,
          pageNumberInBook: '114'
        },
        {
          code: '2071 C',
          name: null,
          rgb: {
            r: 199,
            g: 178,
            b: 222
          },
          hex: 'C7B2DE',
          positionInBook: 796,
          pageNumberInBook: '115'
        },
        {
          code: '2072 C',
          name: null,
          rgb: {
            r: 184,
            g: 150,
            b: 212
          },
          hex: 'B896D4',
          positionInBook: 797,
          pageNumberInBook: '115'
        },
        {
          code: '2073 C',
          name: null,
          rgb: {
            r: 175,
            g: 149,
            b: 211
          },
          hex: 'AF95D3',
          positionInBook: 798,
          pageNumberInBook: '115'
        },
        {
          code: '2074 C',
          name: null,
          rgb: {
            r: 149,
            g: 105,
            b: 190
          },
          hex: '9569BE',
          positionInBook: 799,
          pageNumberInBook: '115'
        },
        {
          code: '2075 C',
          name: null,
          rgb: {
            r: 136,
            g: 102,
            b: 188
          },
          hex: '8866BC',
          positionInBook: 800,
          pageNumberInBook: '115'
        },
        {
          code: '2076 C',
          name: null,
          rgb: {
            r: 134,
            g: 89,
            b: 181
          },
          hex: '8659B5',
          positionInBook: 801,
          pageNumberInBook: '115'
        },
        {
          code: '2077 C',
          name: null,
          rgb: {
            r: 110,
            g: 63,
            b: 163
          },
          hex: '6E3FA3',
          positionInBook: 802,
          pageNumberInBook: '115'
        },
        {
          code: '7660 C',
          name: null,
          rgb: {
            r: 153,
            g: 145,
            b: 164
          },
          hex: '9991A4',
          positionInBook: 803,
          pageNumberInBook: '116'
        },
        {
          code: '7661 C',
          name: null,
          rgb: {
            r: 141,
            g: 110,
            b: 151
          },
          hex: '8D6E97',
          positionInBook: 804,
          pageNumberInBook: '116'
        },
        {
          code: '7662 C',
          name: null,
          rgb: {
            r: 122,
            g: 66,
            b: 130
          },
          hex: '7A4282',
          positionInBook: 805,
          pageNumberInBook: '116'
        },
        {
          code: '7663 C',
          name: null,
          rgb: {
            r: 107,
            g: 48,
            b: 119
          },
          hex: '6B3077',
          positionInBook: 806,
          pageNumberInBook: '116'
        },
        {
          code: '7664 C',
          name: null,
          rgb: {
            r: 101,
            g: 51,
            b: 121
          },
          hex: '653379',
          positionInBook: 807,
          pageNumberInBook: '116'
        },
        {
          code: '7665 C',
          name: null,
          rgb: {
            r: 94,
            g: 54,
            b: 110
          },
          hex: '5E366E',
          positionInBook: 808,
          pageNumberInBook: '116'
        },
        {
          code: '7666 C',
          name: null,
          rgb: {
            r: 92,
            g: 78,
            b: 99
          },
          hex: '5C4E63',
          positionInBook: 809,
          pageNumberInBook: '116'
        },
        {
          code: '2567 C',
          name: null,
          rgb: {
            r: 193,
            g: 160,
            b: 218
          },
          hex: 'C1A0DA',
          positionInBook: 810,
          pageNumberInBook: '117'
        },
        {
          code: '2577 C',
          name: null,
          rgb: {
            r: 167,
            g: 123,
            b: 202
          },
          hex: 'A77BCA',
          positionInBook: 811,
          pageNumberInBook: '117'
        },
        {
          code: '2587 C',
          name: null,
          rgb: {
            r: 130,
            g: 70,
            b: 175
          },
          hex: '8246AF',
          positionInBook: 812,
          pageNumberInBook: '117'
        },
        {
          code: '2597 C',
          name: null,
          rgb: {
            r: 92,
            g: 6,
            b: 140
          },
          hex: '5C068C',
          positionInBook: 813,
          pageNumberInBook: '117'
        },
        {
          code: '2607 C',
          name: null,
          rgb: {
            r: 80,
            g: 8,
            b: 120
          },
          hex: '500878',
          positionInBook: 814,
          pageNumberInBook: '117'
        },
        {
          code: '2617 C',
          name: null,
          rgb: {
            r: 71,
            g: 10,
            b: 104
          },
          hex: '470A68',
          positionInBook: 815,
          pageNumberInBook: '117'
        },
        {
          code: '2627 C',
          name: null,
          rgb: {
            r: 60,
            g: 16,
            b: 83
          },
          hex: '3C1053',
          positionInBook: 816,
          pageNumberInBook: '117'
        },
        {
          code: '263 C',
          name: null,
          rgb: {
            r: 215,
            g: 198,
            b: 230
          },
          hex: 'D7C6E6',
          positionInBook: 817,
          pageNumberInBook: '118'
        },
        {
          code: '264 C',
          name: null,
          rgb: {
            r: 193,
            g: 167,
            b: 226
          },
          hex: 'C1A7E2',
          positionInBook: 818,
          pageNumberInBook: '118'
        },
        {
          code: '265 C',
          name: null,
          rgb: {
            r: 144,
            g: 99,
            b: 205
          },
          hex: '9063CD',
          positionInBook: 819,
          pageNumberInBook: '118'
        },
        {
          code: '266 C',
          name: null,
          rgb: {
            r: 117,
            g: 59,
            b: 189
          },
          hex: '753BBD',
          positionInBook: 820,
          pageNumberInBook: '118'
        },
        {
          code: '267 C',
          name: null,
          rgb: {
            r: 95,
            g: 36,
            b: 159
          },
          hex: '5F249F',
          positionInBook: 821,
          pageNumberInBook: '118'
        },
        {
          code: '268 C',
          name: null,
          rgb: {
            r: 88,
            g: 44,
            b: 131
          },
          hex: '582C83',
          positionInBook: 822,
          pageNumberInBook: '118'
        },
        {
          code: '269 C',
          name: null,
          rgb: {
            r: 81,
            g: 45,
            b: 109
          },
          hex: '512D6D',
          positionInBook: 823,
          pageNumberInBook: '118'
        },
        {
          code: '2085 C',
          name: null,
          rgb: {
            r: 222,
            g: 205,
            b: 231
          },
          hex: 'DECDE7',
          positionInBook: 824,
          pageNumberInBook: '119'
        },
        {
          code: '2086 C',
          name: null,
          rgb: {
            r: 160,
            g: 139,
            b: 203
          },
          hex: 'A08BCB',
          positionInBook: 825,
          pageNumberInBook: '119'
        },
        {
          code: '2087 C',
          name: null,
          rgb: {
            r: 155,
            g: 125,
            b: 212
          },
          hex: '9B7DD4',
          positionInBook: 826,
          pageNumberInBook: '119'
        },
        {
          code: '2088 C',
          name: null,
          rgb: {
            r: 130,
            g: 93,
            b: 199
          },
          hex: '825DC7',
          positionInBook: 827,
          pageNumberInBook: '119'
        },
        {
          code: '2089 C',
          name: null,
          rgb: {
            r: 114,
            g: 72,
            b: 189
          },
          hex: '7248BD',
          positionInBook: 828,
          pageNumberInBook: '119'
        },
        {
          code: '2090 C',
          name: null,
          rgb: {
            r: 102,
            g: 56,
            b: 182
          },
          hex: '6638B6',
          positionInBook: 829,
          pageNumberInBook: '119'
        },
        {
          code: '2091 C',
          name: null,
          rgb: {
            r: 76,
            g: 18,
            b: 161
          },
          hex: '4C12A1',
          positionInBook: 830,
          pageNumberInBook: '119'
        },
        {
          code: '2635 C',
          name: null,
          rgb: {
            r: 197,
            g: 180,
            b: 227
          },
          hex: 'C5B4E3',
          positionInBook: 831,
          pageNumberInBook: '120'
        },
        {
          code: '2645 C',
          name: null,
          rgb: {
            r: 173,
            g: 150,
            b: 220
          },
          hex: 'AD96DC',
          positionInBook: 832,
          pageNumberInBook: '120'
        },
        {
          code: '2655 C',
          name: null,
          rgb: {
            r: 150,
            g: 120,
            b: 211
          },
          hex: '9678D3',
          positionInBook: 833,
          pageNumberInBook: '120'
        },
        {
          code: '2665 C',
          name: null,
          rgb: {
            r: 125,
            g: 85,
            b: 199
          },
          hex: '7D55C7',
          positionInBook: 834,
          pageNumberInBook: '120'
        },
        {
          code: 'Violet C',
          name: null,
          rgb: {
            r: 68,
            g: 0,
            b: 153
          },
          hex: '440099',
          positionInBook: 835,
          pageNumberInBook: '120'
        },
        {
          code: '2685 C',
          name: null,
          rgb: {
            r: 51,
            g: 0,
            b: 114
          },
          hex: '330072',
          positionInBook: 836,
          pageNumberInBook: '120'
        },
        {
          code: '2695 C',
          name: null,
          rgb: {
            r: 46,
            g: 26,
            b: 71
          },
          hex: '2E1A47',
          positionInBook: 837,
          pageNumberInBook: '120'
        },
        {
          code: '2092 C',
          name: null,
          rgb: {
            r: 184,
            g: 172,
            b: 214
          },
          hex: 'B8ACD6',
          positionInBook: 838,
          pageNumberInBook: '121'
        },
        {
          code: '2093 C',
          name: null,
          rgb: {
            r: 166,
            g: 153,
            b: 193
          },
          hex: 'A699C1',
          positionInBook: 839,
          pageNumberInBook: '121'
        },
        {
          code: '2094 C',
          name: null,
          rgb: {
            r: 142,
            g: 127,
            b: 174
          },
          hex: '8E7FAE',
          positionInBook: 840,
          pageNumberInBook: '121'
        },
        {
          code: '2095 C',
          name: null,
          rgb: {
            r: 121,
            g: 101,
            b: 178
          },
          hex: '7965B2',
          positionInBook: 841,
          pageNumberInBook: '121'
        },
        {
          code: '2096 C',
          name: null,
          rgb: {
            r: 101,
            g: 78,
            b: 163
          },
          hex: '654EA3',
          positionInBook: 842,
          pageNumberInBook: '121'
        },
        {
          code: '2097 C',
          name: null,
          rgb: {
            r: 98,
            g: 68,
            b: 187
          },
          hex: '6244BB',
          positionInBook: 843,
          pageNumberInBook: '121'
        },
        {
          code: '2098 C',
          name: null,
          rgb: {
            r: 74,
            g: 37,
            b: 170
          },
          hex: '4A25AA',
          positionInBook: 844,
          pageNumberInBook: '121'
        },
        {
          code: '2099 C',
          name: null,
          rgb: {
            r: 177,
            g: 162,
            b: 202
          },
          hex: 'B1A2CA',
          positionInBook: 845,
          pageNumberInBook: '122'
        },
        {
          code: '2100 C',
          name: null,
          rgb: {
            r: 159,
            g: 143,
            b: 202
          },
          hex: '9F8FCA',
          positionInBook: 846,
          pageNumberInBook: '122'
        },
        {
          code: '2101 C',
          name: null,
          rgb: {
            r: 138,
            g: 117,
            b: 209
          },
          hex: '8A75D1',
          positionInBook: 847,
          pageNumberInBook: '122'
        },
        {
          code: '2102 C',
          name: null,
          rgb: {
            r: 101,
            g: 88,
            b: 177
          },
          hex: '6558B1',
          positionInBook: 848,
          pageNumberInBook: '122'
        },
        {
          code: '2103 C',
          name: null,
          rgb: {
            r: 89,
            g: 73,
            b: 167
          },
          hex: '5949A7',
          positionInBook: 849,
          pageNumberInBook: '122'
        },
        {
          code: '2104 C',
          name: null,
          rgb: {
            r: 72,
            g: 54,
            b: 152
          },
          hex: '483698',
          positionInBook: 850,
          pageNumberInBook: '122'
        },
        {
          code: '2105 C',
          name: null,
          rgb: {
            r: 57,
            g: 32,
            b: 124
          },
          hex: '39207C',
          positionInBook: 851,
          pageNumberInBook: '122'
        },
        {
          code: '4120 C',
          name: null,
          rgb: {
            r: 184,
            g: 172,
            b: 208
          },
          hex: 'B8ACD0',
          positionInBook: 852,
          pageNumberInBook: '123'
        },
        {
          code: '4121 C',
          name: null,
          rgb: {
            r: 155,
            g: 139,
            b: 181
          },
          hex: '9B8BB5',
          positionInBook: 853,
          pageNumberInBook: '123'
        },
        {
          code: '4122 C',
          name: null,
          rgb: {
            r: 119,
            g: 108,
            b: 177
          },
          hex: '776CB1',
          positionInBook: 854,
          pageNumberInBook: '123'
        },
        {
          code: '4123 C',
          name: null,
          rgb: {
            r: 165,
            g: 167,
            b: 188
          },
          hex: 'A5A7BC',
          positionInBook: 855,
          pageNumberInBook: '123'
        },
        {
          code: '4124 C',
          name: null,
          rgb: {
            r: 143,
            g: 145,
            b: 176
          },
          hex: '8F91B0',
          positionInBook: 856,
          pageNumberInBook: '123'
        },
        {
          code: '4125 C',
          name: null,
          rgb: {
            r: 95,
            g: 94,
            b: 119
          },
          hex: '5F5E77',
          positionInBook: 857,
          pageNumberInBook: '123'
        },
        {
          code: '4126 C',
          name: null,
          rgb: {
            r: 81,
            g: 65,
            b: 99
          },
          hex: '514163',
          positionInBook: 858,
          pageNumberInBook: '123'
        },
        {
          code: '270 C',
          name: null,
          rgb: {
            r: 180,
            g: 181,
            b: 223
          },
          hex: 'B4B5DF',
          positionInBook: 859,
          pageNumberInBook: '124'
        },
        {
          code: '271 C',
          name: null,
          rgb: {
            r: 149,
            g: 149,
            b: 210
          },
          hex: '9595D2',
          positionInBook: 860,
          pageNumberInBook: '124'
        },
        {
          code: '272 C',
          name: null,
          rgb: {
            r: 116,
            g: 116,
            b: 193
          },
          hex: '7474C1',
          positionInBook: 861,
          pageNumberInBook: '124'
        },
        {
          code: '273 C',
          name: null,
          rgb: {
            r: 36,
            g: 18,
            b: 95
          },
          hex: '24125F',
          positionInBook: 862,
          pageNumberInBook: '124'
        },
        {
          code: '274 C',
          name: null,
          rgb: {
            r: 34,
            g: 21,
            b: 81
          },
          hex: '221551',
          positionInBook: 863,
          pageNumberInBook: '124'
        },
        {
          code: '275 C',
          name: null,
          rgb: {
            r: 33,
            g: 23,
            b: 71
          },
          hex: '211747',
          positionInBook: 864,
          pageNumberInBook: '124'
        },
        {
          code: '276 C',
          name: null,
          rgb: {
            r: 34,
            g: 28,
            b: 53
          },
          hex: '221C35',
          positionInBook: 865,
          pageNumberInBook: '124'
        },
        {
          code: '3558 C',
          name: null,
          rgb: {
            r: 145,
            g: 156,
            b: 212
          },
          hex: '919CD4',
          positionInBook: 866,
          pageNumberInBook: '125'
        },
        {
          code: '3555 C',
          name: null,
          rgb: {
            r: 81,
            g: 33,
            b: 121
          },
          hex: '512179',
          positionInBook: 867,
          pageNumberInBook: '125'
        },
        {
          code: '3583 C',
          name: null,
          rgb: {
            r: 81,
            g: 30,
            b: 132
          },
          hex: '511E84',
          positionInBook: 868,
          pageNumberInBook: '125'
        },
        {
          code: '3574 C',
          name: null,
          rgb: {
            r: 92,
            g: 69,
            b: 128
          },
          hex: '5C4580',
          positionInBook: 869,
          pageNumberInBook: '125'
        },
        {
          code: '3566 C',
          name: null,
          rgb: {
            r: 71,
            g: 43,
            b: 116
          },
          hex: '472B74',
          positionInBook: 870,
          pageNumberInBook: '125'
        },
        {
          code: '3535 C',
          name: null,
          rgb: {
            r: 64,
            g: 1,
            b: 134
          },
          hex: '400186',
          positionInBook: 871,
          pageNumberInBook: '125'
        },
        {
          code: '3542 C',
          name: null,
          rgb: {
            r: 49,
            g: 19,
            b: 124
          },
          hex: '31137C',
          positionInBook: 872,
          pageNumberInBook: '125'
        },
        {
          code: '2705 C',
          name: null,
          rgb: {
            r: 167,
            g: 164,
            b: 224
          },
          hex: 'A7A4E0',
          positionInBook: 873,
          pageNumberInBook: '126'
        },
        {
          code: '2715 C',
          name: null,
          rgb: {
            r: 139,
            g: 132,
            b: 215
          },
          hex: '8B84D7',
          positionInBook: 874,
          pageNumberInBook: '126'
        },
        {
          code: '2725 C',
          name: null,
          rgb: {
            r: 104,
            g: 91,
            b: 199
          },
          hex: '685BC7',
          positionInBook: 875,
          pageNumberInBook: '126'
        },
        {
          code: '2735 C',
          name: null,
          rgb: {
            r: 46,
            g: 0,
            b: 139
          },
          hex: '2E008B',
          positionInBook: 876,
          pageNumberInBook: '126'
        },
        {
          code: '2745 C',
          name: null,
          rgb: {
            r: 40,
            g: 0,
            b: 113
          },
          hex: '280071',
          positionInBook: 877,
          pageNumberInBook: '126'
        },
        {
          code: '2755 C',
          name: null,
          rgb: {
            r: 37,
            g: 14,
            b: 98
          },
          hex: '250E62',
          positionInBook: 878,
          pageNumberInBook: '126'
        },
        {
          code: '2765 C',
          name: null,
          rgb: {
            r: 32,
            g: 21,
            b: 71
          },
          hex: '201547',
          positionInBook: 879,
          pageNumberInBook: '126'
        },
        {
          code: '7667 C',
          name: null,
          rgb: {
            r: 110,
            g: 124,
            b: 160
          },
          hex: '6E7CA0',
          positionInBook: 880,
          pageNumberInBook: '127'
        },
        {
          code: '7668 C',
          name: null,
          rgb: {
            r: 103,
            g: 110,
            b: 159
          },
          hex: '676E9F',
          positionInBook: 881,
          pageNumberInBook: '127'
        },
        {
          code: '7669 C',
          name: null,
          rgb: {
            r: 97,
            g: 94,
            b: 155
          },
          hex: '615E9B',
          positionInBook: 882,
          pageNumberInBook: '127'
        },
        {
          code: '7670 C',
          name: null,
          rgb: {
            r: 86,
            g: 82,
            b: 148
          },
          hex: '565294',
          positionInBook: 883,
          pageNumberInBook: '127'
        },
        {
          code: '7671 C',
          name: null,
          rgb: {
            r: 81,
            g: 70,
            b: 137
          },
          hex: '514689',
          positionInBook: 884,
          pageNumberInBook: '127'
        },
        {
          code: '7672 C',
          name: null,
          rgb: {
            r: 76,
            g: 64,
            b: 132
          },
          hex: '4C4084',
          positionInBook: 885,
          pageNumberInBook: '127'
        },
        {
          code: '7673 C',
          name: null,
          rgb: {
            r: 83,
            g: 84,
            b: 134
          },
          hex: '535486',
          positionInBook: 886,
          pageNumberInBook: '127'
        },
        {
          code: '7443 C',
          name: null,
          rgb: {
            r: 221,
            g: 218,
            b: 232
          },
          hex: 'DDDAE8',
          positionInBook: 887,
          pageNumberInBook: '128'
        },
        {
          code: '7444 C',
          name: null,
          rgb: {
            r: 182,
            g: 184,
            b: 220
          },
          hex: 'B6B8DC',
          positionInBook: 888,
          pageNumberInBook: '128'
        },
        {
          code: '7445 C',
          name: null,
          rgb: {
            r: 167,
            g: 162,
            b: 195
          },
          hex: 'A7A2C3',
          positionInBook: 889,
          pageNumberInBook: '128'
        },
        {
          code: '7446 C',
          name: null,
          rgb: {
            r: 137,
            g: 134,
            b: 202
          },
          hex: '8986CA',
          positionInBook: 890,
          pageNumberInBook: '128'
        },
        {
          code: '7447 C',
          name: null,
          rgb: {
            r: 93,
            g: 71,
            b: 119
          },
          hex: '5D4777',
          positionInBook: 891,
          pageNumberInBook: '128'
        },
        {
          code: '7448 C',
          name: null,
          rgb: {
            r: 75,
            g: 56,
            b: 76
          },
          hex: '4B384C',
          positionInBook: 892,
          pageNumberInBook: '128'
        },
        {
          code: '7449 C',
          name: null,
          rgb: {
            r: 65,
            g: 39,
            b: 59
          },
          hex: '41273B',
          positionInBook: 893,
          pageNumberInBook: '128'
        },
        {
          code: '7674 C',
          name: null,
          rgb: {
            r: 135,
            g: 140,
            b: 180
          },
          hex: '878CB4',
          positionInBook: 894,
          pageNumberInBook: '129'
        },
        {
          code: '7675 C',
          name: null,
          rgb: {
            r: 124,
            g: 127,
            b: 171
          },
          hex: '7C7FAB',
          positionInBook: 895,
          pageNumberInBook: '129'
        },
        {
          code: '7676 C',
          name: null,
          rgb: {
            r: 117,
            g: 102,
            b: 160
          },
          hex: '7566A0',
          positionInBook: 896,
          pageNumberInBook: '129'
        },
        {
          code: '7677 C',
          name: null,
          rgb: {
            r: 111,
            g: 80,
            b: 145
          },
          hex: '6F5091',
          positionInBook: 897,
          pageNumberInBook: '129'
        },
        {
          code: '7678 C',
          name: null,
          rgb: {
            r: 104,
            g: 71,
            b: 141
          },
          hex: '68478D',
          positionInBook: 898,
          pageNumberInBook: '129'
        },
        {
          code: '7679 C',
          name: null,
          rgb: {
            r: 86,
            g: 61,
            b: 130
          },
          hex: '563D82',
          positionInBook: 899,
          pageNumberInBook: '129'
        },
        {
          code: '7680 C',
          name: null,
          rgb: {
            r: 82,
            g: 49,
            b: 120
          },
          hex: '523178',
          positionInBook: 900,
          pageNumberInBook: '129'
        },
        {
          code: '663 C',
          name: null,
          rgb: {
            r: 229,
            g: 225,
            b: 230
          },
          hex: 'E5E1E6',
          positionInBook: 901,
          pageNumberInBook: '130'
        },
        {
          code: '664 C',
          name: null,
          rgb: {
            r: 224,
            g: 219,
            b: 227
          },
          hex: 'E0DBE3',
          positionInBook: 902,
          pageNumberInBook: '130'
        },
        {
          code: '665 C',
          name: null,
          rgb: {
            r: 198,
            g: 188,
            b: 208
          },
          hex: 'C6BCD0',
          positionInBook: 903,
          pageNumberInBook: '130'
        },
        {
          code: '666 C',
          name: null,
          rgb: {
            r: 161,
            g: 146,
            b: 178
          },
          hex: 'A192B2',
          positionInBook: 904,
          pageNumberInBook: '130'
        },
        {
          code: '667 C',
          name: null,
          rgb: {
            r: 124,
            g: 105,
            b: 146
          },
          hex: '7C6992',
          positionInBook: 905,
          pageNumberInBook: '130'
        },
        {
          code: '668 C',
          name: null,
          rgb: {
            r: 97,
            g: 75,
            b: 121
          },
          hex: '614B79',
          positionInBook: 906,
          pageNumberInBook: '130'
        },
        {
          code: '669 C',
          name: null,
          rgb: {
            r: 63,
            g: 42,
            b: 86
          },
          hex: '3F2A56',
          positionInBook: 907,
          pageNumberInBook: '130'
        },
        {
          code: '5315 C',
          name: null,
          rgb: {
            r: 216,
            g: 215,
            b: 223
          },
          hex: 'D8D7DF',
          positionInBook: 908,
          pageNumberInBook: '131'
        },
        {
          code: '5305 C',
          name: null,
          rgb: {
            r: 198,
            g: 196,
            b: 210
          },
          hex: 'C6C4D2',
          positionInBook: 909,
          pageNumberInBook: '131'
        },
        {
          code: '5295 C',
          name: null,
          rgb: {
            r: 179,
            g: 176,
            b: 196
          },
          hex: 'B3B0C4',
          positionInBook: 910,
          pageNumberInBook: '131'
        },
        {
          code: '5285 C',
          name: null,
          rgb: {
            r: 141,
            g: 137,
            b: 165
          },
          hex: '8D89A5',
          positionInBook: 911,
          pageNumberInBook: '131'
        },
        {
          code: '5275 C',
          name: null,
          rgb: {
            r: 89,
            g: 84,
            b: 120
          },
          hex: '595478',
          positionInBook: 912,
          pageNumberInBook: '131'
        },
        {
          code: '5265 C',
          name: null,
          rgb: {
            r: 64,
            g: 58,
            b: 96
          },
          hex: '403A60',
          positionInBook: 913,
          pageNumberInBook: '131'
        },
        {
          code: '5255 C',
          name: null,
          rgb: {
            r: 30,
            g: 26,
            b: 52
          },
          hex: '1E1A34',
          positionInBook: 914,
          pageNumberInBook: '131'
        },
        {
          code: '2358 C',
          name: null,
          rgb: {
            r: 173,
            g: 164,
            b: 174
          },
          hex: 'ADA4AE',
          positionInBook: 915,
          pageNumberInBook: '132'
        },
        {
          code: '2359 C',
          name: null,
          rgb: {
            r: 127,
            g: 115,
            b: 132
          },
          hex: '7F7384',
          positionInBook: 916,
          pageNumberInBook: '132'
        },
        {
          code: '2360 C',
          name: null,
          rgb: {
            r: 123,
            g: 121,
            b: 142
          },
          hex: '7B798E',
          positionInBook: 917,
          pageNumberInBook: '132'
        },
        {
          code: '2361 C',
          name: null,
          rgb: {
            r: 112,
            g: 112,
            b: 141
          },
          hex: '70708D',
          positionInBook: 918,
          pageNumberInBook: '132'
        },
        {
          code: '2362 C',
          name: null,
          rgb: {
            r: 108,
            g: 106,
            b: 129
          },
          hex: '6C6A81',
          positionInBook: 919,
          pageNumberInBook: '132'
        },
        {
          code: '2363 C',
          name: null,
          rgb: {
            r: 96,
            g: 93,
            b: 117
          },
          hex: '605D75',
          positionInBook: 920,
          pageNumberInBook: '132'
        },
        {
          code: '2364 C',
          name: null,
          rgb: {
            r: 102,
            g: 89,
            b: 108
          },
          hex: '66596C',
          positionInBook: 921,
          pageNumberInBook: '132'
        },
        {
          code: '4127 C',
          name: null,
          rgb: {
            r: 128,
            g: 129,
            b: 148
          },
          hex: '808194',
          positionInBook: 922,
          pageNumberInBook: '133'
        },
        {
          code: '4128 C',
          name: null,
          rgb: {
            r: 110,
            g: 113,
            b: 133
          },
          hex: '6E7185',
          positionInBook: 923,
          pageNumberInBook: '133'
        },
        {
          code: '4129 C',
          name: null,
          rgb: {
            r: 103,
            g: 111,
            b: 127
          },
          hex: '676F7F',
          positionInBook: 924,
          pageNumberInBook: '133'
        },
        {
          code: '4130 C',
          name: null,
          rgb: {
            r: 81,
            g: 90,
            b: 108
          },
          hex: '515A6C',
          positionInBook: 925,
          pageNumberInBook: '133'
        },
        {
          code: '4131 C',
          name: null,
          rgb: {
            r: 72,
            g: 75,
            b: 93
          },
          hex: '484B5D',
          positionInBook: 926,
          pageNumberInBook: '133'
        },
        {
          code: '4132 C',
          name: null,
          rgb: {
            r: 59,
            g: 58,
            b: 74
          },
          hex: '3B3A4A',
          positionInBook: 927,
          pageNumberInBook: '133'
        },
        {
          code: '4133 C',
          name: null,
          rgb: {
            r: 59,
            g: 59,
            b: 70
          },
          hex: '3B3B46',
          positionInBook: 928,
          pageNumberInBook: '133'
        },
        {
          code: '2106 C',
          name: null,
          rgb: {
            r: 177,
            g: 181,
            b: 206
          },
          hex: 'B1B5CE',
          positionInBook: 929,
          pageNumberInBook: '134'
        },
        {
          code: '2107 C',
          name: null,
          rgb: {
            r: 144,
            g: 153,
            b: 186
          },
          hex: '9099BA',
          positionInBook: 930,
          pageNumberInBook: '134'
        },
        {
          code: '2108 C',
          name: null,
          rgb: {
            r: 119,
            g: 127,
            b: 168
          },
          hex: '777FA8',
          positionInBook: 931,
          pageNumberInBook: '134'
        },
        {
          code: '2109 C',
          name: null,
          rgb: {
            r: 103,
            g: 109,
            b: 153
          },
          hex: '676D99',
          positionInBook: 932,
          pageNumberInBook: '134'
        },
        {
          code: '2110 C',
          name: null,
          rgb: {
            r: 91,
            g: 97,
            b: 143
          },
          hex: '5B618F',
          positionInBook: 933,
          pageNumberInBook: '134'
        },
        {
          code: '2111 C',
          name: null,
          rgb: {
            r: 70,
            g: 78,
            b: 126
          },
          hex: '464E7E',
          positionInBook: 934,
          pageNumberInBook: '134'
        },
        {
          code: '2112 C',
          name: null,
          rgb: {
            r: 53,
            g: 31,
            b: 101
          },
          hex: '351F65',
          positionInBook: 935,
          pageNumberInBook: '134'
        },
        {
          code: '2113 C',
          name: null,
          rgb: {
            r: 165,
            g: 176,
            b: 227
          },
          hex: 'A5B0E3',
          positionInBook: 936,
          pageNumberInBook: '135'
        },
        {
          code: '2114 C',
          name: null,
          rgb: {
            r: 131,
            g: 141,
            b: 200
          },
          hex: '838DC8',
          positionInBook: 937,
          pageNumberInBook: '135'
        },
        {
          code: '2115 C',
          name: null,
          rgb: {
            r: 111,
            g: 121,
            b: 189
          },
          hex: '6F79BD',
          positionInBook: 938,
          pageNumberInBook: '135'
        },
        {
          code: '2116 C',
          name: null,
          rgb: {
            r: 96,
            g: 104,
            b: 178
          },
          hex: '6068B2',
          positionInBook: 939,
          pageNumberInBook: '135'
        },
        {
          code: '2117 C',
          name: null,
          rgb: {
            r: 68,
            g: 73,
            b: 156
          },
          hex: '44499C',
          positionInBook: 940,
          pageNumberInBook: '135'
        },
        {
          code: '2118 C',
          name: null,
          rgb: {
            r: 52,
            g: 53,
            b: 121
          },
          hex: '343579',
          positionInBook: 941,
          pageNumberInBook: '135'
        },
        {
          code: '2119 C',
          name: null,
          rgb: {
            r: 44,
            g: 46,
            b: 101
          },
          hex: '2C2E65',
          positionInBook: 942,
          pageNumberInBook: '135'
        },
        {
          code: '2366 C',
          name: null,
          rgb: {
            r: 106,
            g: 109,
            b: 205
          },
          hex: '6A6DCD',
          positionInBook: 943,
          pageNumberInBook: '136'
        },
        {
          code: '2367 C',
          name: null,
          rgb: {
            r: 79,
            g: 76,
            b: 177
          },
          hex: '4F4CB1',
          positionInBook: 944,
          pageNumberInBook: '136'
        },
        {
          code: '2368 C',
          name: null,
          rgb: {
            r: 77,
            g: 73,
            b: 190
          },
          hex: '4D49BE',
          positionInBook: 945,
          pageNumberInBook: '136'
        },
        {
          code: '2369 C',
          name: null,
          rgb: {
            r: 59,
            g: 63,
            b: 182
          },
          hex: '3B3FB6',
          positionInBook: 946,
          pageNumberInBook: '136'
        },
        {
          code: '2370 C',
          name: null,
          rgb: {
            r: 47,
            g: 42,
            b: 149
          },
          hex: '2F2A95',
          positionInBook: 947,
          pageNumberInBook: '136'
        },
        {
          code: '2371 C',
          name: null,
          rgb: {
            r: 51,
            g: 5,
            b: 141
          },
          hex: '33058D',
          positionInBook: 948,
          pageNumberInBook: '136'
        },
        {
          code: '2372 C',
          name: null,
          rgb: {
            r: 40,
            g: 30,
            b: 120
          },
          hex: '281E78',
          positionInBook: 949,
          pageNumberInBook: '136'
        },
        {
          code: '538 C',
          name: null,
          rgb: {
            r: 197,
            g: 207,
            b: 218
          },
          hex: 'C5CFDA',
          positionInBook: 950,
          pageNumberInBook: '137'
        },
        {
          code: '537 C',
          name: null,
          rgb: {
            r: 187,
            g: 199,
            b: 214
          },
          hex: 'BBC7D6',
          positionInBook: 951,
          pageNumberInBook: '137'
        },
        {
          code: '536 C',
          name: null,
          rgb: {
            r: 162,
            g: 178,
            b: 200
          },
          hex: 'A2B2C8',
          positionInBook: 952,
          pageNumberInBook: '137'
        },
        {
          code: '535 C',
          name: null,
          rgb: {
            r: 142,
            g: 159,
            b: 188
          },
          hex: '8E9FBC',
          positionInBook: 953,
          pageNumberInBook: '137'
        },
        {
          code: '534 C',
          name: null,
          rgb: {
            r: 27,
            g: 54,
            b: 93
          },
          hex: '1B365D',
          positionInBook: 954,
          pageNumberInBook: '137'
        },
        {
          code: '533 C',
          name: null,
          rgb: {
            r: 32,
            g: 42,
            b: 68
          },
          hex: '202A44',
          positionInBook: 955,
          pageNumberInBook: '137'
        },
        {
          code: '532 C',
          name: null,
          rgb: {
            r: 29,
            g: 31,
            b: 42
          },
          hex: '1D1F2A',
          positionInBook: 956,
          pageNumberInBook: '137'
        },
        {
          code: '7541 C',
          name: null,
          rgb: {
            r: 217,
            g: 225,
            b: 226
          },
          hex: 'D9E1E2',
          positionInBook: 957,
          pageNumberInBook: '138'
        },
        {
          code: '7542 C',
          name: null,
          rgb: {
            r: 164,
            g: 188,
            b: 194
          },
          hex: 'A4BCC2',
          positionInBook: 958,
          pageNumberInBook: '138'
        },
        {
          code: '7543 C',
          name: null,
          rgb: {
            r: 152,
            g: 164,
            b: 174
          },
          hex: '98A4AE',
          positionInBook: 959,
          pageNumberInBook: '138'
        },
        {
          code: '7544 C',
          name: null,
          rgb: {
            r: 118,
            g: 134,
            b: 146
          },
          hex: '768692',
          positionInBook: 960,
          pageNumberInBook: '138'
        },
        {
          code: '7545 C',
          name: null,
          rgb: {
            r: 66,
            g: 85,
            b: 99
          },
          hex: '425563',
          positionInBook: 961,
          pageNumberInBook: '138'
        },
        {
          code: '7546 C',
          name: null,
          rgb: {
            r: 37,
            g: 55,
            b: 70
          },
          hex: '253746',
          positionInBook: 962,
          pageNumberInBook: '138'
        },
        {
          code: '7547 C',
          name: null,
          rgb: {
            r: 19,
            g: 30,
            b: 41
          },
          hex: '131E29',
          positionInBook: 963,
          pageNumberInBook: '138'
        },
        {
          code: '2162 C',
          name: null,
          rgb: {
            r: 158,
            g: 166,
            b: 180
          },
          hex: '9EA6B4',
          positionInBook: 964,
          pageNumberInBook: '139'
        },
        {
          code: '2163 C',
          name: null,
          rgb: {
            r: 134,
            g: 156,
            b: 174
          },
          hex: '869CAE',
          positionInBook: 965,
          pageNumberInBook: '139'
        },
        {
          code: '2164 C',
          name: null,
          rgb: {
            r: 126,
            g: 147,
            b: 167
          },
          hex: '7E93A7',
          positionInBook: 966,
          pageNumberInBook: '139'
        },
        {
          code: '2165 C',
          name: null,
          rgb: {
            r: 104,
            g: 129,
            b: 151
          },
          hex: '688197',
          positionInBook: 967,
          pageNumberInBook: '139'
        },
        {
          code: '2166 C',
          name: null,
          rgb: {
            r: 87,
            g: 114,
            b: 139
          },
          hex: '57728B',
          positionInBook: 968,
          pageNumberInBook: '139'
        },
        {
          code: '2167 C',
          name: null,
          rgb: {
            r: 80,
            g: 109,
            b: 133
          },
          hex: '506D85',
          positionInBook: 969,
          pageNumberInBook: '139'
        },
        {
          code: '2168 C',
          name: null,
          rgb: {
            r: 37,
            g: 74,
            b: 93
          },
          hex: '254A5D',
          positionInBook: 970,
          pageNumberInBook: '139'
        },
        {
          code: '4134 C',
          name: null,
          rgb: {
            r: 160,
            g: 162,
            b: 176
          },
          hex: 'A0A2B0',
          positionInBook: 971,
          pageNumberInBook: '140'
        },
        {
          code: '4135 C',
          name: null,
          rgb: {
            r: 123,
            g: 133,
            b: 155
          },
          hex: '7B859B',
          positionInBook: 972,
          pageNumberInBook: '140'
        },
        {
          code: '4136 C',
          name: null,
          rgb: {
            r: 96,
            g: 110,
            b: 129
          },
          hex: '606E81',
          positionInBook: 973,
          pageNumberInBook: '140'
        },
        {
          code: '4137 C',
          name: null,
          rgb: {
            r: 71,
            g: 93,
            b: 118
          },
          hex: '475D76',
          positionInBook: 974,
          pageNumberInBook: '140'
        },
        {
          code: '4138 C',
          name: null,
          rgb: {
            r: 76,
            g: 95,
            b: 113
          },
          hex: '4C5F71',
          positionInBook: 975,
          pageNumberInBook: '140'
        },
        {
          code: '4139 C',
          name: null,
          rgb: {
            r: 79,
            g: 90,
            b: 107
          },
          hex: '4F5A6B',
          positionInBook: 976,
          pageNumberInBook: '140'
        },
        {
          code: '4140 C',
          name: null,
          rgb: {
            r: 57,
            g: 61,
            b: 71
          },
          hex: '393D47',
          positionInBook: 977,
          pageNumberInBook: '140'
        },
        {
          code: '2373 C',
          name: null,
          rgb: {
            r: 115,
            g: 130,
            b: 159
          },
          hex: '73829F',
          positionInBook: 978,
          pageNumberInBook: '141'
        },
        {
          code: '2374 C',
          name: null,
          rgb: {
            r: 77,
            g: 95,
            b: 128
          },
          hex: '4D5F80',
          positionInBook: 979,
          pageNumberInBook: '141'
        },
        {
          code: '2376 C',
          name: null,
          rgb: {
            r: 78,
            g: 91,
            b: 115
          },
          hex: '4E5B73',
          positionInBook: 980,
          pageNumberInBook: '141'
        },
        {
          code: '2377 C',
          name: null,
          rgb: {
            r: 49,
            g: 84,
            b: 112
          },
          hex: '315470',
          positionInBook: 981,
          pageNumberInBook: '141'
        },
        {
          code: '2378 C',
          name: null,
          rgb: {
            r: 56,
            g: 73,
            b: 103
          },
          hex: '384967',
          positionInBook: 982,
          pageNumberInBook: '141'
        },
        {
          code: '2379 C',
          name: null,
          rgb: {
            r: 59,
            g: 69,
            b: 89
          },
          hex: '3B4559',
          positionInBook: 983,
          pageNumberInBook: '141'
        },
        {
          code: '2380 C',
          name: null,
          rgb: {
            r: 40,
            g: 51,
            b: 74
          },
          hex: '28334A',
          positionInBook: 984,
          pageNumberInBook: '141'
        },
        {
          code: '552 C',
          name: null,
          rgb: {
            r: 185,
            g: 211,
            b: 220
          },
          hex: 'B9D3DC',
          positionInBook: 985,
          pageNumberInBook: '142'
        },
        {
          code: '551 C',
          name: null,
          rgb: {
            r: 163,
            g: 199,
            b: 210
          },
          hex: 'A3C7D2',
          positionInBook: 986,
          pageNumberInBook: '142'
        },
        {
          code: '550 C',
          name: null,
          rgb: {
            r: 141,
            g: 185,
            b: 202
          },
          hex: '8DB9CA',
          positionInBook: 987,
          pageNumberInBook: '142'
        },
        {
          code: '549 C',
          name: null,
          rgb: {
            r: 107,
            g: 164,
            b: 184
          },
          hex: '6BA4B8',
          positionInBook: 988,
          pageNumberInBook: '142'
        },
        {
          code: '548 C',
          name: null,
          rgb: {
            r: 0,
            g: 61,
            b: 76
          },
          hex: '003D4C',
          positionInBook: 989,
          pageNumberInBook: '142'
        },
        {
          code: '547 C',
          name: null,
          rgb: {
            r: 0,
            g: 49,
            b: 60
          },
          hex: '00313C',
          positionInBook: 990,
          pageNumberInBook: '142'
        },
        {
          code: '546 C',
          name: null,
          rgb: {
            r: 7,
            g: 43,
            b: 49
          },
          hex: '072B31',
          positionInBook: 991,
          pageNumberInBook: '142'
        },
        {
          code: '5455 C',
          name: null,
          rgb: {
            r: 191,
            g: 206,
            b: 214
          },
          hex: 'BFCED6',
          positionInBook: 992,
          pageNumberInBook: '143'
        },
        {
          code: '5445 C',
          name: null,
          rgb: {
            r: 183,
            g: 201,
            b: 211
          },
          hex: 'B7C9D3',
          positionInBook: 993,
          pageNumberInBook: '143'
        },
        {
          code: '5435 C',
          name: null,
          rgb: {
            r: 166,
            g: 187,
            b: 200
          },
          hex: 'A6BBC8',
          positionInBook: 994,
          pageNumberInBook: '143'
        },
        {
          code: '5425 C',
          name: null,
          rgb: {
            r: 122,
            g: 153,
            b: 172
          },
          hex: '7A99AC',
          positionInBook: 995,
          pageNumberInBook: '143'
        },
        {
          code: '5415 C',
          name: null,
          rgb: {
            r: 91,
            g: 127,
            b: 149
          },
          hex: '5B7F95',
          positionInBook: 996,
          pageNumberInBook: '143'
        },
        {
          code: '5405 C',
          name: null,
          rgb: {
            r: 79,
            g: 117,
            b: 139
          },
          hex: '4F758B',
          positionInBook: 997,
          pageNumberInBook: '143'
        },
        {
          code: '5395 C',
          name: null,
          rgb: {
            r: 9,
            g: 31,
            b: 44
          },
          hex: '091F2C',
          positionInBook: 998,
          pageNumberInBook: '143'
        },
        {
          code: '2155 C',
          name: null,
          rgb: {
            r: 158,
            g: 181,
            b: 203
          },
          hex: '9EB5CB',
          positionInBook: 999,
          pageNumberInBook: '144'
        },
        {
          code: '2156 C',
          name: null,
          rgb: {
            r: 139,
            g: 166,
            b: 193
          },
          hex: '8BA6C1',
          positionInBook: 1000,
          pageNumberInBook: '144'
        },
        {
          code: '2157 C',
          name: null,
          rgb: {
            r: 117,
            g: 148,
            b: 179
          },
          hex: '7594B3',
          positionInBook: 1001,
          pageNumberInBook: '144'
        },
        {
          code: '2158 C',
          name: null,
          rgb: {
            r: 92,
            g: 130,
            b: 165
          },
          hex: '5C82A5',
          positionInBook: 1002,
          pageNumberInBook: '144'
        },
        {
          code: '2159 C',
          name: null,
          rgb: {
            r: 78,
            g: 118,
            b: 155
          },
          hex: '4E769B',
          positionInBook: 1003,
          pageNumberInBook: '144'
        },
        {
          code: '2160 C',
          name: null,
          rgb: {
            r: 62,
            g: 105,
            b: 145
          },
          hex: '3E6991',
          positionInBook: 1004,
          pageNumberInBook: '144'
        },
        {
          code: '2161 C',
          name: null,
          rgb: {
            r: 40,
            g: 87,
            b: 128
          },
          hex: '285780',
          positionInBook: 1005,
          pageNumberInBook: '144'
        },
        {
          code: '2134 C',
          name: null,
          rgb: {
            r: 147,
            g: 165,
            b: 207
          },
          hex: '93A5CF',
          positionInBook: 1006,
          pageNumberInBook: '145'
        },
        {
          code: '2135 C',
          name: null,
          rgb: {
            r: 117,
            g: 140,
            b: 192
          },
          hex: '758CC0',
          positionInBook: 1007,
          pageNumberInBook: '145'
        },
        {
          code: '2136 C',
          name: null,
          rgb: {
            r: 131,
            g: 148,
            b: 184
          },
          hex: '8394B8',
          positionInBook: 1008,
          pageNumberInBook: '145'
        },
        {
          code: '2137 C',
          name: null,
          rgb: {
            r: 110,
            g: 128,
            b: 169
          },
          hex: '6E80A9',
          positionInBook: 1009,
          pageNumberInBook: '145'
        },
        {
          code: '2138 C',
          name: null,
          rgb: {
            r: 100,
            g: 118,
            b: 146
          },
          hex: '647692',
          positionInBook: 1010,
          pageNumberInBook: '145'
        },
        {
          code: '2139 C',
          name: null,
          rgb: {
            r: 77,
            g: 105,
            b: 149
          },
          hex: '4D6995',
          positionInBook: 1011,
          pageNumberInBook: '145'
        },
        {
          code: '2140 C',
          name: null,
          rgb: {
            r: 57,
            g: 83,
            b: 130
          },
          hex: '395382',
          positionInBook: 1012,
          pageNumberInBook: '145'
        },
        {
          code: '642 C',
          name: null,
          rgb: {
            r: 209,
            g: 221,
            b: 230
          },
          hex: 'D1DDE6',
          positionInBook: 1013,
          pageNumberInBook: '146'
        },
        {
          code: '643 C',
          name: null,
          rgb: {
            r: 198,
            g: 214,
            b: 227
          },
          hex: 'C6D6E3',
          positionInBook: 1014,
          pageNumberInBook: '146'
        },
        {
          code: '644 C',
          name: null,
          rgb: {
            r: 155,
            g: 184,
            b: 211
          },
          hex: '9BB8D3',
          positionInBook: 1015,
          pageNumberInBook: '146'
        },
        {
          code: '645 C',
          name: null,
          rgb: {
            r: 125,
            g: 161,
            b: 196
          },
          hex: '7DA1C4',
          positionInBook: 1016,
          pageNumberInBook: '146'
        },
        {
          code: '646 C',
          name: null,
          rgb: {
            r: 94,
            g: 138,
            b: 180
          },
          hex: '5E8AB4',
          positionInBook: 1017,
          pageNumberInBook: '146'
        },
        {
          code: '647 C',
          name: null,
          rgb: {
            r: 35,
            g: 97,
            b: 146
          },
          hex: '236192',
          positionInBook: 1018,
          pageNumberInBook: '146'
        },
        {
          code: '648 C',
          name: null,
          rgb: {
            r: 0,
            g: 46,
            b: 93
          },
          hex: '002E5D',
          positionInBook: 1019,
          pageNumberInBook: '146'
        },
        {
          code: '649 C',
          name: null,
          rgb: {
            r: 219,
            g: 226,
            b: 233
          },
          hex: 'DBE2E9',
          positionInBook: 1020,
          pageNumberInBook: '147'
        },
        {
          code: '650 C',
          name: null,
          rgb: {
            r: 206,
            g: 217,
            b: 229
          },
          hex: 'CED9E5',
          positionInBook: 1021,
          pageNumberInBook: '147'
        },
        {
          code: '651 C',
          name: null,
          rgb: {
            r: 167,
            g: 188,
            b: 214
          },
          hex: 'A7BCD6',
          positionInBook: 1022,
          pageNumberInBook: '147'
        },
        {
          code: '652 C',
          name: null,
          rgb: {
            r: 125,
            g: 156,
            b: 192
          },
          hex: '7D9CC0',
          positionInBook: 1023,
          pageNumberInBook: '147'
        },
        {
          code: '653 C',
          name: null,
          rgb: {
            r: 50,
            g: 98,
            b: 149
          },
          hex: '326295',
          positionInBook: 1024,
          pageNumberInBook: '147'
        },
        {
          code: '654 C',
          name: null,
          rgb: {
            r: 0,
            g: 58,
            b: 112
          },
          hex: '003A70',
          positionInBook: 1025,
          pageNumberInBook: '147'
        },
        {
          code: '655 C',
          name: null,
          rgb: {
            r: 0,
            g: 37,
            b: 84
          },
          hex: '002554',
          positionInBook: 1026,
          pageNumberInBook: '147'
        },
        {
          code: '656 C',
          name: null,
          rgb: {
            r: 221,
            g: 229,
            b: 237
          },
          hex: 'DDE5ED',
          positionInBook: 1027,
          pageNumberInBook: '148'
        },
        {
          code: '657 C',
          name: null,
          rgb: {
            r: 200,
            g: 216,
            b: 235
          },
          hex: 'C8D8EB',
          positionInBook: 1028,
          pageNumberInBook: '148'
        },
        {
          code: '658 C',
          name: null,
          rgb: {
            r: 177,
            g: 201,
            b: 232
          },
          hex: 'B1C9E8',
          positionInBook: 1029,
          pageNumberInBook: '148'
        },
        {
          code: '659 C',
          name: null,
          rgb: {
            r: 123,
            g: 164,
            b: 219
          },
          hex: '7BA4DB',
          positionInBook: 1030,
          pageNumberInBook: '148'
        },
        {
          code: '660 C',
          name: null,
          rgb: {
            r: 64,
            g: 126,
            b: 201
          },
          hex: '407EC9',
          positionInBook: 1031,
          pageNumberInBook: '148'
        },
        {
          code: '661 C',
          name: null,
          rgb: {
            r: 0,
            g: 53,
            b: 148
          },
          hex: '003594',
          positionInBook: 1032,
          pageNumberInBook: '148'
        },
        {
          code: '662 C',
          name: null,
          rgb: {
            r: 0,
            g: 26,
            b: 112
          },
          hex: '001A70',
          positionInBook: 1033,
          pageNumberInBook: '148'
        },
        {
          code: '2127 C',
          name: null,
          rgb: {
            r: 184,
            g: 201,
            b: 225
          },
          hex: 'B8C9E1',
          positionInBook: 1034,
          pageNumberInBook: '149'
        },
        {
          code: '2128 C',
          name: null,
          rgb: {
            r: 152,
            g: 182,
            b: 228
          },
          hex: '98B6E4',
          positionInBook: 1035,
          pageNumberInBook: '149'
        },
        {
          code: '2129 C',
          name: null,
          rgb: {
            r: 95,
            g: 141,
            b: 218
          },
          hex: '5F8DDA',
          positionInBook: 1036,
          pageNumberInBook: '149'
        },
        {
          code: '2130 C',
          name: null,
          rgb: {
            r: 85,
            g: 118,
            b: 209
          },
          hex: '5576D1',
          positionInBook: 1037,
          pageNumberInBook: '149'
        },
        {
          code: '2131 C',
          name: null,
          rgb: {
            r: 54,
            g: 90,
            b: 189
          },
          hex: '365ABD',
          positionInBook: 1038,
          pageNumberInBook: '149'
        },
        {
          code: '2132 C',
          name: null,
          rgb: {
            r: 8,
            g: 87,
            b: 195
          },
          hex: '0857C3',
          positionInBook: 1039,
          pageNumberInBook: '149'
        },
        {
          code: '2133 C',
          name: null,
          rgb: {
            r: 29,
            g: 87,
            b: 165
          },
          hex: '1D57A5',
          positionInBook: 1040,
          pageNumberInBook: '149'
        },
        {
          code: '7450 C',
          name: null,
          rgb: {
            r: 189,
            g: 197,
            b: 219
          },
          hex: 'BDC5DB',
          positionInBook: 1041,
          pageNumberInBook: '150'
        },
        {
          code: '7451 C',
          name: null,
          rgb: {
            r: 137,
            g: 171,
            b: 227
          },
          hex: '89ABE3',
          positionInBook: 1042,
          pageNumberInBook: '150'
        },
        {
          code: '7452 C',
          name: null,
          rgb: {
            r: 129,
            g: 148,
            b: 221
          },
          hex: '8194DD',
          positionInBook: 1043,
          pageNumberInBook: '150'
        },
        {
          code: '7453 C',
          name: null,
          rgb: {
            r: 124,
            g: 166,
            b: 222
          },
          hex: '7CA6DE',
          positionInBook: 1044,
          pageNumberInBook: '150'
        },
        {
          code: '7454 C',
          name: null,
          rgb: {
            r: 95,
            g: 143,
            b: 180
          },
          hex: '5F8FB4',
          positionInBook: 1045,
          pageNumberInBook: '150'
        },
        {
          code: '7455 C',
          name: null,
          rgb: {
            r: 58,
            g: 93,
            b: 174
          },
          hex: '3A5DAE',
          positionInBook: 1046,
          pageNumberInBook: '150'
        },
        {
          code: '7456 C',
          name: null,
          rgb: {
            r: 96,
            g: 110,
            b: 178
          },
          hex: '606EB2',
          positionInBook: 1047,
          pageNumberInBook: '150'
        },
        {
          code: '2120 C',
          name: null,
          rgb: {
            r: 190,
            g: 202,
            b: 233
          },
          hex: 'BECAE9',
          positionInBook: 1048,
          pageNumberInBook: '151'
        },
        {
          code: '2121 C',
          name: null,
          rgb: {
            r: 143,
            g: 172,
            b: 216
          },
          hex: '8FACD8',
          positionInBook: 1049,
          pageNumberInBook: '151'
        },
        {
          code: '2122 C',
          name: null,
          rgb: {
            r: 155,
            g: 174,
            b: 228
          },
          hex: '9BAEE4',
          positionInBook: 1050,
          pageNumberInBook: '151'
        },
        {
          code: '2123 C',
          name: null,
          rgb: {
            r: 122,
            g: 147,
            b: 220
          },
          hex: '7A93DC',
          positionInBook: 1051,
          pageNumberInBook: '151'
        },
        {
          code: '2124 C',
          name: null,
          rgb: {
            r: 111,
            g: 123,
            b: 212
          },
          hex: '6F7BD4',
          positionInBook: 1052,
          pageNumberInBook: '151'
        },
        {
          code: '2125 C',
          name: null,
          rgb: {
            r: 84,
            g: 97,
            b: 200
          },
          hex: '5461C8',
          positionInBook: 1053,
          pageNumberInBook: '151'
        },
        {
          code: '2126 C',
          name: null,
          rgb: {
            r: 48,
            g: 58,
            b: 178
          },
          hex: '303AB2',
          positionInBook: 1054,
          pageNumberInBook: '151'
        },
        {
          code: '2706 C',
          name: null,
          rgb: {
            r: 203,
            g: 211,
            b: 234
          },
          hex: 'CBD3EA',
          positionInBook: 1055,
          pageNumberInBook: '152'
        },
        {
          code: '2716 C',
          name: null,
          rgb: {
            r: 159,
            g: 174,
            b: 229
          },
          hex: '9FAEE5',
          positionInBook: 1056,
          pageNumberInBook: '152'
        },
        {
          code: '2726 C',
          name: null,
          rgb: {
            r: 72,
            g: 92,
            b: 199
          },
          hex: '485CC7',
          positionInBook: 1057,
          pageNumberInBook: '152'
        },
        {
          code: '2736 C',
          name: null,
          rgb: {
            r: 30,
            g: 34,
            b: 170
          },
          hex: '1E22AA',
          positionInBook: 1058,
          pageNumberInBook: '152'
        },
        {
          code: '2746 C',
          name: null,
          rgb: {
            r: 23,
            g: 28,
            b: 143
          },
          hex: '171C8F',
          positionInBook: 1059,
          pageNumberInBook: '152'
        },
        {
          code: '2756 C',
          name: null,
          rgb: {
            r: 21,
            g: 31,
            b: 109
          },
          hex: '151F6D',
          positionInBook: 1060,
          pageNumberInBook: '152'
        },
        {
          code: '2766 C',
          name: null,
          rgb: {
            r: 20,
            g: 27,
            b: 77
          },
          hex: '141B4D',
          positionInBook: 1061,
          pageNumberInBook: '152'
        },
        {
          code: '2708 C',
          name: null,
          rgb: {
            r: 184,
            g: 204,
            b: 234
          },
          hex: 'B8CCEA',
          positionInBook: 1062,
          pageNumberInBook: '153'
        },
        {
          code: '2718 C',
          name: null,
          rgb: {
            r: 92,
            g: 136,
            b: 218
          },
          hex: '5C88DA',
          positionInBook: 1063,
          pageNumberInBook: '153'
        },
        {
          code: '2728 C',
          name: null,
          rgb: {
            r: 0,
            g: 71,
            b: 187
          },
          hex: '0047BB',
          positionInBook: 1064,
          pageNumberInBook: '153'
        },
        {
          code: '2738 C',
          name: null,
          rgb: {
            r: 6,
            g: 3,
            b: 141
          },
          hex: '06038D',
          positionInBook: 1065,
          pageNumberInBook: '153'
        },
        {
          code: '2748 C',
          name: null,
          rgb: {
            r: 0,
            g: 24,
            b: 113
          },
          hex: '001871',
          positionInBook: 1066,
          pageNumberInBook: '153'
        },
        {
          code: '2758 C',
          name: null,
          rgb: {
            r: 0,
            g: 30,
            b: 98
          },
          hex: '001E62',
          positionInBook: 1067,
          pageNumberInBook: '153'
        },
        {
          code: '2768 C',
          name: null,
          rgb: {
            r: 7,
            g: 29,
            b: 73
          },
          hex: '071D49',
          positionInBook: 1068,
          pageNumberInBook: '153'
        },
        {
          code: '2707 C',
          name: null,
          rgb: {
            r: 195,
            g: 215,
            b: 238
          },
          hex: 'C3D7EE',
          positionInBook: 1069,
          pageNumberInBook: '154'
        },
        {
          code: '2717 C',
          name: null,
          rgb: {
            r: 167,
            g: 198,
            b: 237
          },
          hex: 'A7C6ED',
          positionInBook: 1070,
          pageNumberInBook: '154'
        },
        {
          code: '2727 C',
          name: null,
          rgb: {
            r: 48,
            g: 127,
            b: 226
          },
          hex: '307FE2',
          positionInBook: 1071,
          pageNumberInBook: '154'
        },
        {
          code: 'Blue 072 C',
          name: null,
          rgb: {
            r: 16,
            g: 6,
            b: 159
          },
          hex: '10069F',
          positionInBook: 1072,
          pageNumberInBook: '154'
        },
        {
          code: '2747 C',
          name: null,
          rgb: {
            r: 0,
            g: 26,
            b: 114
          },
          hex: '001A72',
          positionInBook: 1073,
          pageNumberInBook: '154'
        },
        {
          code: '2757 C',
          name: null,
          rgb: {
            r: 0,
            g: 30,
            b: 96
          },
          hex: '001E60',
          positionInBook: 1074,
          pageNumberInBook: '154'
        },
        {
          code: '2767 C',
          name: null,
          rgb: {
            r: 19,
            g: 41,
            b: 75
          },
          hex: '13294B',
          positionInBook: 1075,
          pageNumberInBook: '154'
        },
        {
          code: '277 C',
          name: null,
          rgb: {
            r: 171,
            g: 202,
            b: 233
          },
          hex: 'ABCAE9',
          positionInBook: 1076,
          pageNumberInBook: '155'
        },
        {
          code: '278 C',
          name: null,
          rgb: {
            r: 139,
            g: 184,
            b: 232
          },
          hex: '8BB8E8',
          positionInBook: 1077,
          pageNumberInBook: '155'
        },
        {
          code: '279 C',
          name: null,
          rgb: {
            r: 65,
            g: 143,
            b: 222
          },
          hex: '418FDE',
          positionInBook: 1078,
          pageNumberInBook: '155'
        },
        {
          code: 'Reflex Blue C',
          name: null,
          rgb: {
            r: 0,
            g: 20,
            b: 137
          },
          hex: '001489',
          positionInBook: 1079,
          pageNumberInBook: '155'
        },
        {
          code: '280 C',
          name: null,
          rgb: {
            r: 1,
            g: 33,
            b: 105
          },
          hex: '012169',
          positionInBook: 1080,
          pageNumberInBook: '155'
        },
        {
          code: '281 C',
          name: null,
          rgb: {
            r: 0,
            g: 32,
            b: 91
          },
          hex: '00205B',
          positionInBook: 1081,
          pageNumberInBook: '155'
        },
        {
          code: '282 C',
          name: null,
          rgb: {
            r: 4,
            g: 30,
            b: 66
          },
          hex: '041E42',
          positionInBook: 1082,
          pageNumberInBook: '155'
        },
        {
          code: '283 C',
          name: null,
          rgb: {
            r: 146,
            g: 193,
            b: 233
          },
          hex: '92C1E9',
          positionInBook: 1083,
          pageNumberInBook: '156'
        },
        {
          code: '284 C',
          name: null,
          rgb: {
            r: 108,
            g: 172,
            b: 228
          },
          hex: '6CACE4',
          positionInBook: 1084,
          pageNumberInBook: '156'
        },
        {
          code: '285 C',
          name: null,
          rgb: {
            r: 0,
            g: 114,
            b: 206
          },
          hex: '0072CE',
          positionInBook: 1085,
          pageNumberInBook: '156'
        },
        {
          code: '286 C',
          name: null,
          rgb: {
            r: 0,
            g: 50,
            b: 160
          },
          hex: '0032A0',
          positionInBook: 1086,
          pageNumberInBook: '156'
        },
        {
          code: '287 C',
          name: null,
          rgb: {
            r: 0,
            g: 48,
            b: 135
          },
          hex: '003087',
          positionInBook: 1087,
          pageNumberInBook: '156'
        },
        {
          code: '288 C',
          name: null,
          rgb: {
            r: 0,
            g: 45,
            b: 114
          },
          hex: '002D72',
          positionInBook: 1088,
          pageNumberInBook: '156'
        },
        {
          code: '289 C',
          name: null,
          rgb: {
            r: 12,
            g: 35,
            b: 64
          },
          hex: '0C2340',
          positionInBook: 1089,
          pageNumberInBook: '156'
        },
        {
          code: '3506 C',
          name: null,
          rgb: {
            r: 25,
            g: 97,
            b: 174
          },
          hex: '1961AE',
          positionInBook: 1090,
          pageNumberInBook: '157'
        },
        {
          code: '3590 C',
          name: null,
          rgb: {
            r: 60,
            g: 87,
            b: 161
          },
          hex: '3C57A1',
          positionInBook: 1091,
          pageNumberInBook: '157'
        },
        {
          code: '3584 C',
          name: null,
          rgb: {
            r: 46,
            g: 62,
            b: 128
          },
          hex: '2E3E80',
          positionInBook: 1092,
          pageNumberInBook: '157'
        },
        {
          code: '3591 C',
          name: null,
          rgb: {
            r: 3,
            g: 37,
            b: 126
          },
          hex: '03257E',
          positionInBook: 1093,
          pageNumberInBook: '157'
        },
        {
          code: '3597 C',
          name: null,
          rgb: {
            r: 28,
            g: 55,
            b: 117
          },
          hex: '1C3775',
          positionInBook: 1094,
          pageNumberInBook: '157'
        },
        {
          code: '3581 C',
          name: null,
          rgb: {
            r: 34,
            g: 50,
            b: 110
          },
          hex: '22326E',
          positionInBook: 1095,
          pageNumberInBook: '157'
        },
        {
          code: '3524 C',
          name: null,
          rgb: {
            r: 47,
            g: 41,
            b: 81
          },
          hex: '2F2951',
          positionInBook: 1096,
          pageNumberInBook: '157'
        },
        {
          code: '4141 C',
          name: null,
          rgb: {
            r: 73,
            g: 100,
            b: 162
          },
          hex: '4964A2',
          positionInBook: 1097,
          pageNumberInBook: '158'
        },
        {
          code: '4142 C',
          name: null,
          rgb: {
            r: 61,
            g: 78,
            b: 128
          },
          hex: '3D4E80',
          positionInBook: 1098,
          pageNumberInBook: '158'
        },
        {
          code: '4143 C',
          name: null,
          rgb: {
            r: 67,
            g: 85,
            b: 112
          },
          hex: '435570',
          positionInBook: 1099,
          pageNumberInBook: '158'
        },
        {
          code: '4144 C',
          name: null,
          rgb: {
            r: 58,
            g: 58,
            b: 89
          },
          hex: '3A3A59',
          positionInBook: 1100,
          pageNumberInBook: '158'
        },
        {
          code: '4145 C',
          name: null,
          rgb: {
            r: 46,
            g: 51,
            b: 78
          },
          hex: '2E334E',
          positionInBook: 1101,
          pageNumberInBook: '158'
        },
        {
          code: '4146 C',
          name: null,
          rgb: {
            r: 27,
            g: 29,
            b: 54
          },
          hex: '1B1D36',
          positionInBook: 1102,
          pageNumberInBook: '158'
        },
        {
          code: '4147 C',
          name: null,
          rgb: {
            r: 38,
            g: 33,
            b: 63
          },
          hex: '26213F',
          positionInBook: 1103,
          pageNumberInBook: '158'
        },
        {
          code: '7681 C',
          name: null,
          rgb: {
            r: 148,
            g: 169,
            b: 203
          },
          hex: '94A9CB',
          positionInBook: 1104,
          pageNumberInBook: '159'
        },
        {
          code: '7682 C',
          name: null,
          rgb: {
            r: 103,
            g: 135,
            b: 183
          },
          hex: '6787B7',
          positionInBook: 1105,
          pageNumberInBook: '159'
        },
        {
          code: '7683 C',
          name: null,
          rgb: {
            r: 66,
            g: 109,
            b: 169
          },
          hex: '426DA9',
          positionInBook: 1106,
          pageNumberInBook: '159'
        },
        {
          code: '7684 C',
          name: null,
          rgb: {
            r: 56,
            g: 94,
            b: 157
          },
          hex: '385E9D',
          positionInBook: 1107,
          pageNumberInBook: '159'
        },
        {
          code: '7685 C',
          name: null,
          rgb: {
            r: 44,
            g: 86,
            b: 151
          },
          hex: '2C5697',
          positionInBook: 1108,
          pageNumberInBook: '159'
        },
        {
          code: '7686 C',
          name: null,
          rgb: {
            r: 29,
            g: 79,
            b: 145
          },
          hex: '1D4F91',
          positionInBook: 1109,
          pageNumberInBook: '159'
        },
        {
          code: '7687 C',
          name: null,
          rgb: {
            r: 29,
            g: 66,
            b: 137
          },
          hex: '1D4289',
          positionInBook: 1110,
          pageNumberInBook: '159'
        },
        {
          code: '2141 C',
          name: null,
          rgb: {
            r: 139,
            g: 190,
            b: 232
          },
          hex: '8BBEE8',
          positionInBook: 1111,
          pageNumberInBook: '160'
        },
        {
          code: '2142 C',
          name: null,
          rgb: {
            r: 127,
            g: 173,
            b: 227
          },
          hex: '7FADE3',
          positionInBook: 1112,
          pageNumberInBook: '160'
        },
        {
          code: '2143 C',
          name: null,
          rgb: {
            r: 61,
            g: 135,
            b: 203
          },
          hex: '3D87CB',
          positionInBook: 1113,
          pageNumberInBook: '160'
        },
        {
          code: '2144 C',
          name: null,
          rgb: {
            r: 0,
            g: 103,
            b: 185
          },
          hex: '0067B9',
          positionInBook: 1114,
          pageNumberInBook: '160'
        },
        {
          code: '2145 C',
          name: null,
          rgb: {
            r: 0,
            g: 78,
            b: 168
          },
          hex: '004EA8',
          positionInBook: 1115,
          pageNumberInBook: '160'
        },
        {
          code: '2146 C',
          name: null,
          rgb: {
            r: 0,
            g: 53,
            b: 142
          },
          hex: '00358E',
          positionInBook: 1116,
          pageNumberInBook: '160'
        },
        {
          code: '2147 C',
          name: null,
          rgb: {
            r: 0,
            g: 38,
            b: 119
          },
          hex: '002677',
          positionInBook: 1117,
          pageNumberInBook: '160'
        },
        {
          code: '545 C',
          name: null,
          rgb: {
            r: 198,
            g: 218,
            b: 231
          },
          hex: 'C6DAE7',
          positionInBook: 1118,
          pageNumberInBook: '161'
        },
        {
          code: '544 C',
          name: null,
          rgb: {
            r: 189,
            g: 214,
            b: 230
          },
          hex: 'BDD6E6',
          positionInBook: 1119,
          pageNumberInBook: '161'
        },
        {
          code: '543 C',
          name: null,
          rgb: {
            r: 164,
            g: 200,
            b: 225
          },
          hex: 'A4C8E1',
          positionInBook: 1120,
          pageNumberInBook: '161'
        },
        {
          code: '542 C',
          name: null,
          rgb: {
            r: 123,
            g: 175,
            b: 212
          },
          hex: '7BAFD4',
          positionInBook: 1121,
          pageNumberInBook: '161'
        },
        {
          code: '541 C',
          name: null,
          rgb: {
            r: 0,
            g: 60,
            b: 113
          },
          hex: '003C71',
          positionInBook: 1122,
          pageNumberInBook: '161'
        },
        {
          code: '540 C',
          name: null,
          rgb: {
            r: 0,
            g: 48,
            b: 87
          },
          hex: '003057',
          positionInBook: 1123,
          pageNumberInBook: '161'
        },
        {
          code: '539 C',
          name: null,
          rgb: {
            r: 0,
            g: 38,
            b: 58
          },
          hex: '00263A',
          positionInBook: 1124,
          pageNumberInBook: '161'
        },
        {
          code: '290 C',
          name: null,
          rgb: {
            r: 185,
            g: 217,
            b: 235
          },
          hex: 'B9D9EB',
          positionInBook: 1125,
          pageNumberInBook: '162'
        },
        {
          code: '291 C',
          name: null,
          rgb: {
            r: 155,
            g: 203,
            b: 235
          },
          hex: '9BCBEB',
          positionInBook: 1126,
          pageNumberInBook: '162'
        },
        {
          code: '292 C',
          name: null,
          rgb: {
            r: 105,
            g: 179,
            b: 231
          },
          hex: '69B3E7',
          positionInBook: 1127,
          pageNumberInBook: '162'
        },
        {
          code: '293 C',
          name: null,
          rgb: {
            r: 0,
            g: 61,
            b: 165
          },
          hex: '003DA5',
          positionInBook: 1128,
          pageNumberInBook: '162'
        },
        {
          code: '294 C',
          name: null,
          rgb: {
            r: 0,
            g: 47,
            b: 108
          },
          hex: '002F6C',
          positionInBook: 1129,
          pageNumberInBook: '162'
        },
        {
          code: '295 C',
          name: null,
          rgb: {
            r: 0,
            g: 40,
            b: 85
          },
          hex: '002855',
          positionInBook: 1130,
          pageNumberInBook: '162'
        },
        {
          code: '296 C',
          name: null,
          rgb: {
            r: 5,
            g: 28,
            b: 44
          },
          hex: '051C2C',
          positionInBook: 1131,
          pageNumberInBook: '162'
        },
        {
          code: '2905 C',
          name: null,
          rgb: {
            r: 141,
            g: 200,
            b: 232
          },
          hex: '8DC8E8',
          positionInBook: 1132,
          pageNumberInBook: '163'
        },
        {
          code: '2915 C',
          name: null,
          rgb: {
            r: 98,
            g: 181,
            b: 229
          },
          hex: '62B5E5',
          positionInBook: 1133,
          pageNumberInBook: '163'
        },
        {
          code: '2925 C',
          name: null,
          rgb: {
            r: 0,
            g: 156,
            b: 222
          },
          hex: '009CDE',
          positionInBook: 1134,
          pageNumberInBook: '163'
        },
        {
          code: '2935 C',
          name: null,
          rgb: {
            r: 0,
            g: 87,
            b: 183
          },
          hex: '0057B7',
          positionInBook: 1135,
          pageNumberInBook: '163'
        },
        {
          code: '2945 C',
          name: null,
          rgb: {
            r: 0,
            g: 76,
            b: 151
          },
          hex: '004C97',
          positionInBook: 1136,
          pageNumberInBook: '163'
        },
        {
          code: '2955 C',
          name: null,
          rgb: {
            r: 0,
            g: 56,
            b: 101
          },
          hex: '003865',
          positionInBook: 1137,
          pageNumberInBook: '163'
        },
        {
          code: '2965 C',
          name: null,
          rgb: {
            r: 0,
            g: 38,
            b: 62
          },
          hex: '00263E',
          positionInBook: 1138,
          pageNumberInBook: '163'
        },
        {
          code: '2169 C',
          name: null,
          rgb: {
            r: 129,
            g: 176,
            b: 210
          },
          hex: '81B0D2',
          positionInBook: 1139,
          pageNumberInBook: '164'
        },
        {
          code: '2170 C',
          name: null,
          rgb: {
            r: 95,
            g: 155,
            b: 198
          },
          hex: '5F9BC6',
          positionInBook: 1140,
          pageNumberInBook: '164'
        },
        {
          code: '2171 C',
          name: null,
          rgb: {
            r: 72,
            g: 159,
            b: 223
          },
          hex: '489FDF',
          positionInBook: 1141,
          pageNumberInBook: '164'
        },
        {
          code: '2172 C',
          name: null,
          rgb: {
            r: 20,
            g: 123,
            b: 209
          },
          hex: '147BD1',
          positionInBook: 1142,
          pageNumberInBook: '164'
        },
        {
          code: '2173 C',
          name: null,
          rgb: {
            r: 0,
            g: 132,
            b: 213
          },
          hex: '0084D5',
          positionInBook: 1143,
          pageNumberInBook: '164'
        },
        {
          code: '2174 C',
          name: null,
          rgb: {
            r: 0,
            g: 118,
            b: 206
          },
          hex: '0076CE',
          positionInBook: 1144,
          pageNumberInBook: '164'
        },
        {
          code: '2175 C',
          name: null,
          rgb: {
            r: 0,
            g: 106,
            b: 198
          },
          hex: '006AC6',
          positionInBook: 1145,
          pageNumberInBook: '164'
        },
        {
          code: '2381 C',
          name: null,
          rgb: {
            r: 94,
            g: 147,
            b: 219
          },
          hex: '5E93DB',
          positionInBook: 1146,
          pageNumberInBook: '165'
        },
        {
          code: '2382 C',
          name: null,
          rgb: {
            r: 0,
            g: 138,
            b: 216
          },
          hex: '008AD8',
          positionInBook: 1147,
          pageNumberInBook: '165'
        },
        {
          code: '2383 C',
          name: null,
          rgb: {
            r: 39,
            g: 116,
            b: 174
          },
          hex: '2774AE',
          positionInBook: 1148,
          pageNumberInBook: '165'
        },
        {
          code: '2384 C',
          name: null,
          rgb: {
            r: 0,
            g: 97,
            b: 160
          },
          hex: '0061A0',
          positionInBook: 1149,
          pageNumberInBook: '165'
        },
        {
          code: '2386 C',
          name: null,
          rgb: {
            r: 45,
            g: 104,
            b: 196
          },
          hex: '2D68C4',
          positionInBook: 1150,
          pageNumberInBook: '165'
        },
        {
          code: '2387 C',
          name: null,
          rgb: {
            r: 7,
            g: 98,
            b: 200
          },
          hex: '0762C8',
          positionInBook: 1151,
          pageNumberInBook: '165'
        },
        {
          code: '2388 C',
          name: null,
          rgb: {
            r: 0,
            g: 80,
            b: 181
          },
          hex: '0050B5',
          positionInBook: 1152,
          pageNumberInBook: '165'
        },
        {
          code: '4148 C',
          name: null,
          rgb: {
            r: 97,
            g: 151,
            b: 176
          },
          hex: '6197B0',
          positionInBook: 1153,
          pageNumberInBook: '166'
        },
        {
          code: '4149 C',
          name: null,
          rgb: {
            r: 138,
            g: 170,
            b: 197
          },
          hex: '8AAAC5',
          positionInBook: 1154,
          pageNumberInBook: '166'
        },
        {
          code: '4150 C',
          name: null,
          rgb: {
            r: 81,
            g: 125,
            b: 185
          },
          hex: '517DB9',
          positionInBook: 1155,
          pageNumberInBook: '166'
        },
        {
          code: '4151 C',
          name: null,
          rgb: {
            r: 0,
            g: 103,
            b: 172
          },
          hex: '0067AC',
          positionInBook: 1156,
          pageNumberInBook: '166'
        },
        {
          code: '4152 C',
          name: null,
          rgb: {
            r: 19,
            g: 81,
            b: 147
          },
          hex: '135193',
          positionInBook: 1157,
          pageNumberInBook: '166'
        },
        {
          code: '4153 C',
          name: null,
          rgb: {
            r: 26,
            g: 78,
            b: 138
          },
          hex: '1A4E8A',
          positionInBook: 1158,
          pageNumberInBook: '166'
        },
        {
          code: '4154 C',
          name: null,
          rgb: {
            r: 14,
            g: 65,
            b: 116
          },
          hex: '0E4174',
          positionInBook: 1159,
          pageNumberInBook: '166'
        },
        {
          code: '297 C',
          name: null,
          rgb: {
            r: 113,
            g: 197,
            b: 232
          },
          hex: '71C5E8',
          positionInBook: 1160,
          pageNumberInBook: '167'
        },
        {
          code: '298 C',
          name: null,
          rgb: {
            r: 65,
            g: 182,
            b: 230
          },
          hex: '41B6E6',
          positionInBook: 1161,
          pageNumberInBook: '167'
        },
        {
          code: '299 C',
          name: null,
          rgb: {
            r: 0,
            g: 163,
            b: 224
          },
          hex: '00A3E0',
          positionInBook: 1162,
          pageNumberInBook: '167'
        },
        {
          code: '300 C',
          name: null,
          rgb: {
            r: 0,
            g: 94,
            b: 184
          },
          hex: '005EB8',
          positionInBook: 1163,
          pageNumberInBook: '167'
        },
        {
          code: '301 C',
          name: null,
          rgb: {
            r: 0,
            g: 75,
            b: 135
          },
          hex: '004B87',
          positionInBook: 1164,
          pageNumberInBook: '167'
        },
        {
          code: '302 C',
          name: null,
          rgb: {
            r: 0,
            g: 59,
            b: 92
          },
          hex: '003B5C',
          positionInBook: 1165,
          pageNumberInBook: '167'
        },
        {
          code: '303 C',
          name: null,
          rgb: {
            r: 0,
            g: 42,
            b: 58
          },
          hex: '002A3A',
          positionInBook: 1166,
          pageNumberInBook: '167'
        },
        {
          code: '7688 C',
          name: null,
          rgb: {
            r: 70,
            g: 152,
            b: 202
          },
          hex: '4698CA',
          positionInBook: 1167,
          pageNumberInBook: '168'
        },
        {
          code: '7689 C',
          name: null,
          rgb: {
            r: 41,
            g: 143,
            b: 194
          },
          hex: '298FC2',
          positionInBook: 1168,
          pageNumberInBook: '168'
        },
        {
          code: '7690 C',
          name: null,
          rgb: {
            r: 0,
            g: 118,
            b: 168
          },
          hex: '0076A8',
          positionInBook: 1169,
          pageNumberInBook: '168'
        },
        {
          code: '7691 C',
          name: null,
          rgb: {
            r: 0,
            g: 98,
            b: 152
          },
          hex: '006298',
          positionInBook: 1170,
          pageNumberInBook: '168'
        },
        {
          code: '7692 C',
          name: null,
          rgb: {
            r: 0,
            g: 86,
            b: 135
          },
          hex: '005687',
          positionInBook: 1171,
          pageNumberInBook: '168'
        },
        {
          code: '7693 C',
          name: null,
          rgb: {
            r: 0,
            g: 73,
            b: 118
          },
          hex: '004976',
          positionInBook: 1172,
          pageNumberInBook: '168'
        },
        {
          code: '7694 C',
          name: null,
          rgb: {
            r: 1,
            g: 66,
            b: 106
          },
          hex: '01426A',
          positionInBook: 1173,
          pageNumberInBook: '168'
        },
        {
          code: '2148 C',
          name: null,
          rgb: {
            r: 97,
            g: 145,
            b: 180
          },
          hex: '6191B4',
          positionInBook: 1174,
          pageNumberInBook: '169'
        },
        {
          code: '2149 C',
          name: null,
          rgb: {
            r: 76,
            g: 130,
            b: 168
          },
          hex: '4C82A8',
          positionInBook: 1175,
          pageNumberInBook: '169'
        },
        {
          code: '2150 C',
          name: null,
          rgb: {
            r: 54,
            g: 116,
            b: 157
          },
          hex: '36749D',
          positionInBook: 1176,
          pageNumberInBook: '169'
        },
        {
          code: '2151 C',
          name: null,
          rgb: {
            r: 37,
            g: 107,
            b: 162
          },
          hex: '256BA2',
          positionInBook: 1177,
          pageNumberInBook: '169'
        },
        {
          code: '2152 C',
          name: null,
          rgb: {
            r: 26,
            g: 101,
            b: 143
          },
          hex: '1A658F',
          positionInBook: 1178,
          pageNumberInBook: '169'
        },
        {
          code: '2153 C',
          name: null,
          rgb: {
            r: 0,
            g: 86,
            b: 126
          },
          hex: '00567E',
          positionInBook: 1179,
          pageNumberInBook: '169'
        },
        {
          code: '2154 C',
          name: null,
          rgb: {
            r: 0,
            g: 70,
            b: 128
          },
          hex: '004680',
          positionInBook: 1180,
          pageNumberInBook: '169'
        },
        {
          code: '2183 C',
          name: null,
          rgb: {
            r: 0,
            g: 146,
            b: 189
          },
          hex: '0092BD',
          positionInBook: 1181,
          pageNumberInBook: '170'
        },
        {
          code: '2184 C',
          name: null,
          rgb: {
            r: 0,
            g: 132,
            b: 212
          },
          hex: '0084D4',
          positionInBook: 1182,
          pageNumberInBook: '170'
        },
        {
          code: '2185 C',
          name: null,
          rgb: {
            r: 0,
            g: 118,
            b: 165
          },
          hex: '0076A5',
          positionInBook: 1183,
          pageNumberInBook: '170'
        },
        {
          code: '2186 C',
          name: null,
          rgb: {
            r: 0,
            g: 73,
            b: 134
          },
          hex: '004986',
          positionInBook: 1184,
          pageNumberInBook: '170'
        },
        {
          code: '2187 C',
          name: null,
          rgb: {
            r: 0,
            g: 70,
            b: 119
          },
          hex: '004677',
          positionInBook: 1185,
          pageNumberInBook: '170'
        },
        {
          code: '2188 C',
          name: null,
          rgb: {
            r: 0,
            g: 66,
            b: 106
          },
          hex: '00426A',
          positionInBook: 1186,
          pageNumberInBook: '170'
        },
        {
          code: '2189 C',
          name: null,
          rgb: {
            r: 0,
            g: 51,
            b: 73
          },
          hex: '003349',
          positionInBook: 1187,
          pageNumberInBook: '170'
        },
        {
          code: '2975 C',
          name: null,
          rgb: {
            r: 153,
            g: 214,
            b: 234
          },
          hex: '99D6EA',
          positionInBook: 1188,
          pageNumberInBook: '171'
        },
        {
          code: '2985 C',
          name: null,
          rgb: {
            r: 91,
            g: 194,
            b: 231
          },
          hex: '5BC2E7',
          positionInBook: 1189,
          pageNumberInBook: '171'
        },
        {
          code: '2995 C',
          name: null,
          rgb: {
            r: 0,
            g: 169,
            b: 224
          },
          hex: '00A9E0',
          positionInBook: 1190,
          pageNumberInBook: '171'
        },
        {
          code: '3005 C',
          name: null,
          rgb: {
            r: 0,
            g: 119,
            b: 200
          },
          hex: '0077C8',
          positionInBook: 1191,
          pageNumberInBook: '171'
        },
        {
          code: '3015 C',
          name: null,
          rgb: {
            r: 0,
            g: 98,
            b: 155
          },
          hex: '00629B',
          positionInBook: 1192,
          pageNumberInBook: '171'
        },
        {
          code: '3025 C',
          name: null,
          rgb: {
            r: 0,
            g: 79,
            b: 113
          },
          hex: '004F71',
          positionInBook: 1193,
          pageNumberInBook: '171'
        },
        {
          code: '3035 C',
          name: null,
          rgb: {
            r: 0,
            g: 62,
            b: 81
          },
          hex: '003E51',
          positionInBook: 1194,
          pageNumberInBook: '171'
        },
        {
          code: '2190 C',
          name: null,
          rgb: {
            r: 86,
            g: 183,
            b: 230
          },
          hex: '56B7E6',
          positionInBook: 1195,
          pageNumberInBook: '172'
        },
        {
          code: '2191 C',
          name: null,
          rgb: {
            r: 0,
            g: 163,
            b: 225
          },
          hex: '00A3E1',
          positionInBook: 1196,
          pageNumberInBook: '172'
        },
        {
          code: '2192 C',
          name: null,
          rgb: {
            r: 0,
            g: 145,
            b: 218
          },
          hex: '0091DA',
          positionInBook: 1197,
          pageNumberInBook: '172'
        },
        {
          code: '2193 C',
          name: null,
          rgb: {
            r: 0,
            g: 144,
            b: 218
          },
          hex: '0090DA',
          positionInBook: 1198,
          pageNumberInBook: '172'
        },
        {
          code: '2194 C',
          name: null,
          rgb: {
            r: 0,
            g: 134,
            b: 214
          },
          hex: '0086D6',
          positionInBook: 1199,
          pageNumberInBook: '172'
        },
        {
          code: '2195 C',
          name: null,
          rgb: {
            r: 0,
            g: 119,
            b: 207
          },
          hex: '0077CF',
          positionInBook: 1200,
          pageNumberInBook: '172'
        },
        {
          code: '2196 C',
          name: null,
          rgb: {
            r: 0,
            g: 105,
            b: 177
          },
          hex: '0069B1',
          positionInBook: 1201,
          pageNumberInBook: '172'
        },
        {
          code: '7695 C',
          name: null,
          rgb: {
            r: 123,
            g: 167,
            b: 188
          },
          hex: '7BA7BC',
          positionInBook: 1202,
          pageNumberInBook: '173'
        },
        {
          code: '7696 C',
          name: null,
          rgb: {
            r: 99,
            g: 153,
            b: 174
          },
          hex: '6399AE',
          positionInBook: 1203,
          pageNumberInBook: '173'
        },
        {
          code: '7697 C',
          name: null,
          rgb: {
            r: 78,
            g: 135,
            b: 160
          },
          hex: '4E87A0',
          positionInBook: 1204,
          pageNumberInBook: '173'
        },
        {
          code: '7698 C',
          name: null,
          rgb: {
            r: 65,
            g: 116,
            b: 141
          },
          hex: '41748D',
          positionInBook: 1205,
          pageNumberInBook: '173'
        },
        {
          code: '7699 C',
          name: null,
          rgb: {
            r: 52,
            g: 101,
            b: 127
          },
          hex: '34657F',
          positionInBook: 1206,
          pageNumberInBook: '173'
        },
        {
          code: '7700 C',
          name: null,
          rgb: {
            r: 22,
            g: 92,
            b: 125
          },
          hex: '165C7D',
          positionInBook: 1207,
          pageNumberInBook: '173'
        },
        {
          code: '7701 C',
          name: null,
          rgb: {
            r: 0,
            g: 87,
            b: 118
          },
          hex: '005776',
          positionInBook: 1208,
          pageNumberInBook: '173'
        },
        {
          code: '2176 C',
          name: null,
          rgb: {
            r: 166,
            g: 184,
            b: 193
          },
          hex: 'A6B8C1',
          positionInBook: 1209,
          pageNumberInBook: '174'
        },
        {
          code: '2177 C',
          name: null,
          rgb: {
            r: 127,
            g: 160,
            b: 172
          },
          hex: '7FA0AC',
          positionInBook: 1210,
          pageNumberInBook: '174'
        },
        {
          code: '2178 C',
          name: null,
          rgb: {
            r: 107,
            g: 143,
            b: 156
          },
          hex: '6B8F9C',
          positionInBook: 1211,
          pageNumberInBook: '174'
        },
        {
          code: '2179 C',
          name: null,
          rgb: {
            r: 82,
            g: 122,
            b: 138
          },
          hex: '527A8A',
          positionInBook: 1212,
          pageNumberInBook: '174'
        },
        {
          code: '2180 C',
          name: null,
          rgb: {
            r: 63,
            g: 108,
            b: 125
          },
          hex: '3F6C7D',
          positionInBook: 1213,
          pageNumberInBook: '174'
        },
        {
          code: '2181 C',
          name: null,
          rgb: {
            r: 43,
            g: 91,
            b: 108
          },
          hex: '2B5B6C',
          positionInBook: 1214,
          pageNumberInBook: '174'
        },
        {
          code: '2182 C',
          name: null,
          rgb: {
            r: 23,
            g: 74,
            b: 91
          },
          hex: '174A5B',
          positionInBook: 1215,
          pageNumberInBook: '174'
        },
        {
          code: '2204 C',
          name: null,
          rgb: {
            r: 175,
            g: 205,
            b: 215
          },
          hex: 'AFCDD7',
          positionInBook: 1216,
          pageNumberInBook: '175'
        },
        {
          code: '2205 C',
          name: null,
          rgb: {
            r: 137,
            g: 178,
            b: 196
          },
          hex: '89B2C4',
          positionInBook: 1217,
          pageNumberInBook: '175'
        },
        {
          code: '2206 C',
          name: null,
          rgb: {
            r: 119,
            g: 159,
            b: 181
          },
          hex: '779FB5',
          positionInBook: 1218,
          pageNumberInBook: '175'
        },
        {
          code: '2207 C',
          name: null,
          rgb: {
            r: 101,
            g: 154,
            b: 177
          },
          hex: '659AB1',
          positionInBook: 1219,
          pageNumberInBook: '175'
        },
        {
          code: '2208 C',
          name: null,
          rgb: {
            r: 84,
            g: 137,
            b: 163
          },
          hex: '5489A3',
          positionInBook: 1220,
          pageNumberInBook: '175'
        },
        {
          code: '2209 C',
          name: null,
          rgb: {
            r: 74,
            g: 134,
            b: 160
          },
          hex: '4A86A0',
          positionInBook: 1221,
          pageNumberInBook: '175'
        },
        {
          code: '2210 C',
          name: null,
          rgb: {
            r: 7,
            g: 79,
            b: 113
          },
          hex: '074F71',
          positionInBook: 1222,
          pageNumberInBook: '175'
        },
        {
          code: '4155 C',
          name: null,
          rgb: {
            r: 185,
            g: 201,
            b: 204
          },
          hex: 'B9C9CC',
          positionInBook: 1223,
          pageNumberInBook: '176'
        },
        {
          code: '4156 C',
          name: null,
          rgb: {
            r: 151,
            g: 191,
            b: 203
          },
          hex: '97BFCB',
          positionInBook: 1224,
          pageNumberInBook: '176'
        },
        {
          code: '4157 C',
          name: null,
          rgb: {
            r: 101,
            g: 174,
            b: 193
          },
          hex: '65AEC1',
          positionInBook: 1225,
          pageNumberInBook: '176'
        },
        {
          code: '4158 C',
          name: null,
          rgb: {
            r: 56,
            g: 127,
            b: 151
          },
          hex: '387F97',
          positionInBook: 1226,
          pageNumberInBook: '176'
        },
        {
          code: '4159 C',
          name: null,
          rgb: {
            r: 0,
            g: 86,
            b: 131
          },
          hex: '005683',
          positionInBook: 1227,
          pageNumberInBook: '176'
        },
        {
          code: '4160 C',
          name: null,
          rgb: {
            r: 0,
            g: 72,
            b: 96
          },
          hex: '004860',
          positionInBook: 1228,
          pageNumberInBook: '176'
        },
        {
          code: '4161 C',
          name: null,
          rgb: {
            r: 48,
            g: 76,
            b: 90
          },
          hex: '304C5A',
          positionInBook: 1229,
          pageNumberInBook: '176'
        },
        {
          code: '7457 C',
          name: null,
          rgb: {
            r: 187,
            g: 221,
            b: 230
          },
          hex: 'BBDDE6',
          positionInBook: 1230,
          pageNumberInBook: '177'
        },
        {
          code: '7458 C',
          name: null,
          rgb: {
            r: 113,
            g: 178,
            b: 201
          },
          hex: '71B2C9',
          positionInBook: 1231,
          pageNumberInBook: '177'
        },
        {
          code: '7459 C',
          name: null,
          rgb: {
            r: 66,
            g: 152,
            b: 181
          },
          hex: '4298B5',
          positionInBook: 1232,
          pageNumberInBook: '177'
        },
        {
          code: '7460 C',
          name: null,
          rgb: {
            r: 0,
            g: 134,
            b: 191
          },
          hex: '0086BF',
          positionInBook: 1233,
          pageNumberInBook: '177'
        },
        {
          code: '7461 C',
          name: null,
          rgb: {
            r: 0,
            g: 125,
            b: 186
          },
          hex: '007DBA',
          positionInBook: 1234,
          pageNumberInBook: '177'
        },
        {
          code: '7462 C',
          name: null,
          rgb: {
            r: 0,
            g: 85,
            b: 140
          },
          hex: '00558C',
          positionInBook: 1235,
          pageNumberInBook: '177'
        },
        {
          code: '7463 C',
          name: null,
          rgb: {
            r: 0,
            g: 43,
            b: 73
          },
          hex: '002B49',
          positionInBook: 1236,
          pageNumberInBook: '177'
        },
        {
          code: '304 C',
          name: null,
          rgb: {
            r: 154,
            g: 219,
            b: 232
          },
          hex: '9ADBE8',
          positionInBook: 1237,
          pageNumberInBook: '178'
        },
        {
          code: '305 C',
          name: null,
          rgb: {
            r: 89,
            g: 203,
            b: 232
          },
          hex: '59CBE8',
          positionInBook: 1238,
          pageNumberInBook: '178'
        },
        {
          code: '306 C',
          name: null,
          rgb: {
            r: 0,
            g: 181,
            b: 226
          },
          hex: '00B5E2',
          positionInBook: 1239,
          pageNumberInBook: '178'
        },
        {
          code: 'Process Blue C',
          name: null,
          rgb: {
            r: 0,
            g: 133,
            b: 202
          },
          hex: '0085CA',
          positionInBook: 1240,
          pageNumberInBook: '178'
        },
        {
          code: '307 C',
          name: null,
          rgb: {
            r: 0,
            g: 107,
            b: 166
          },
          hex: '006BA6',
          positionInBook: 1241,
          pageNumberInBook: '178'
        },
        {
          code: '308 C',
          name: null,
          rgb: {
            r: 0,
            g: 88,
            b: 124
          },
          hex: '00587C',
          positionInBook: 1242,
          pageNumberInBook: '178'
        },
        {
          code: '309 C',
          name: null,
          rgb: {
            r: 0,
            g: 59,
            b: 73
          },
          hex: '003B49',
          positionInBook: 1243,
          pageNumberInBook: '178'
        },
        {
          code: '635 C',
          name: null,
          rgb: {
            r: 164,
            g: 219,
            b: 232
          },
          hex: 'A4DBE8',
          positionInBook: 1244,
          pageNumberInBook: '179'
        },
        {
          code: '636 C',
          name: null,
          rgb: {
            r: 139,
            g: 211,
            b: 230
          },
          hex: '8BD3E6',
          positionInBook: 1245,
          pageNumberInBook: '179'
        },
        {
          code: '637 C',
          name: null,
          rgb: {
            r: 78,
            g: 195,
            b: 224
          },
          hex: '4EC3E0',
          positionInBook: 1246,
          pageNumberInBook: '179'
        },
        {
          code: '638 C',
          name: null,
          rgb: {
            r: 0,
            g: 175,
            b: 215
          },
          hex: '00AFD7',
          positionInBook: 1247,
          pageNumberInBook: '179'
        },
        {
          code: '639 C',
          name: null,
          rgb: {
            r: 0,
            g: 149,
            b: 200
          },
          hex: '0095C8',
          positionInBook: 1248,
          pageNumberInBook: '179'
        },
        {
          code: '640 C',
          name: null,
          rgb: {
            r: 0,
            g: 130,
            b: 186
          },
          hex: '0082BA',
          positionInBook: 1249,
          pageNumberInBook: '179'
        },
        {
          code: '641 C',
          name: null,
          rgb: {
            r: 0,
            g: 103,
            b: 160
          },
          hex: '0067A0',
          positionInBook: 1250,
          pageNumberInBook: '179'
        },
        {
          code: '3577 C',
          name: null,
          rgb: {
            r: 138,
            g: 186,
            b: 221
          },
          hex: '8ABADD',
          positionInBook: 1251,
          pageNumberInBook: '180'
        },
        {
          code: '3545 C',
          name: null,
          rgb: {
            r: 0,
            g: 188,
            b: 225
          },
          hex: '00BCE1',
          positionInBook: 1252,
          pageNumberInBook: '180'
        },
        {
          code: '3551 C',
          name: null,
          rgb: {
            r: 0,
            g: 166,
            b: 200
          },
          hex: '00A6C8',
          positionInBook: 1253,
          pageNumberInBook: '180'
        },
        {
          code: '3538 C',
          name: null,
          rgb: {
            r: 0,
            g: 148,
            b: 213
          },
          hex: '0094D5',
          positionInBook: 1254,
          pageNumberInBook: '180'
        },
        {
          code: '3553 C',
          name: null,
          rgb: {
            r: 0,
            g: 110,
            b: 179
          },
          hex: '006EB3',
          positionInBook: 1255,
          pageNumberInBook: '180'
        },
        {
          code: '2454 C',
          name: null,
          rgb: {
            r: 40,
            g: 125,
            b: 161
          },
          hex: '287DA1',
          positionInBook: 1256,
          pageNumberInBook: '180'
        },
        {
          code: '3526 C',
          name: null,
          rgb: {
            r: 122,
            g: 147,
            b: 156
          },
          hex: '7A939C',
          positionInBook: 1257,
          pageNumberInBook: '180'
        },
        {
          code: '2389 C',
          name: null,
          rgb: {
            r: 76,
            g: 159,
            b: 200
          },
          hex: '4C9FC8',
          positionInBook: 1258,
          pageNumberInBook: '181'
        },
        {
          code: '2390 C',
          name: null,
          rgb: {
            r: 7,
            g: 124,
            b: 171
          },
          hex: '077CAB',
          positionInBook: 1259,
          pageNumberInBook: '181'
        },
        {
          code: '2391 C',
          name: null,
          rgb: {
            r: 0,
            g: 129,
            b: 166
          },
          hex: '0081A6',
          positionInBook: 1260,
          pageNumberInBook: '181'
        },
        {
          code: '2392 C',
          name: null,
          rgb: {
            r: 22,
            g: 104,
            b: 134
          },
          hex: '166886',
          positionInBook: 1261,
          pageNumberInBook: '181'
        },
        {
          code: '2393 C',
          name: null,
          rgb: {
            r: 0,
            g: 146,
            b: 203
          },
          hex: '0092CB',
          positionInBook: 1262,
          pageNumberInBook: '181'
        },
        {
          code: '2394 C',
          name: null,
          rgb: {
            r: 0,
            g: 139,
            b: 206
          },
          hex: '008BCE',
          positionInBook: 1263,
          pageNumberInBook: '181'
        },
        {
          code: '2396 C',
          name: null,
          rgb: {
            r: 0,
            g: 153,
            b: 178
          },
          hex: '0099B2',
          positionInBook: 1264,
          pageNumberInBook: '181'
        },
        {
          code: '7702 C',
          name: null,
          rgb: {
            r: 72,
            g: 169,
            b: 197
          },
          hex: '48A9C5',
          positionInBook: 1265,
          pageNumberInBook: '182'
        },
        {
          code: '7703 C',
          name: null,
          rgb: {
            r: 0,
            g: 156,
            b: 189
          },
          hex: '009CBD',
          positionInBook: 1266,
          pageNumberInBook: '182'
        },
        {
          code: '7704 C',
          name: null,
          rgb: {
            r: 0,
            g: 133,
            b: 173
          },
          hex: '0085AD',
          positionInBook: 1267,
          pageNumberInBook: '182'
        },
        {
          code: '7705 C',
          name: null,
          rgb: {
            r: 0,
            g: 112,
            b: 150
          },
          hex: '007096',
          positionInBook: 1268,
          pageNumberInBook: '182'
        },
        {
          code: '7706 C',
          name: null,
          rgb: {
            r: 0,
            g: 106,
            b: 142
          },
          hex: '006A8E',
          positionInBook: 1269,
          pageNumberInBook: '182'
        },
        {
          code: '7707 C',
          name: null,
          rgb: {
            r: 0,
            g: 97,
            b: 127
          },
          hex: '00617F',
          positionInBook: 1270,
          pageNumberInBook: '182'
        },
        {
          code: '7708 C',
          name: null,
          rgb: {
            r: 0,
            g: 86,
            b: 112
          },
          hex: '005670',
          positionInBook: 1271,
          pageNumberInBook: '182'
        },
        {
          code: '2197 C',
          name: null,
          rgb: {
            r: 116,
            g: 210,
            b: 231
          },
          hex: '74D2E7',
          positionInBook: 1272,
          pageNumberInBook: '183'
        },
        {
          code: '2198 C',
          name: null,
          rgb: {
            r: 74,
            g: 201,
            b: 227
          },
          hex: '4AC9E3',
          positionInBook: 1273,
          pageNumberInBook: '183'
        },
        {
          code: '2199 C',
          name: null,
          rgb: {
            r: 0,
            g: 187,
            b: 220
          },
          hex: '00BBDC',
          positionInBook: 1274,
          pageNumberInBook: '183'
        },
        {
          code: '2200 C',
          name: null,
          rgb: {
            r: 5,
            g: 169,
            b: 199
          },
          hex: '05A9C7',
          positionInBook: 1275,
          pageNumberInBook: '183'
        },
        {
          code: '2201 C',
          name: null,
          rgb: {
            r: 0,
            g: 174,
            b: 214
          },
          hex: '00AED6',
          positionInBook: 1276,
          pageNumberInBook: '183'
        },
        {
          code: '2202 C',
          name: null,
          rgb: {
            r: 0,
            g: 165,
            b: 223
          },
          hex: '00A5DF',
          positionInBook: 1277,
          pageNumberInBook: '183'
        },
        {
          code: '2203 C',
          name: null,
          rgb: {
            r: 0,
            g: 135,
            b: 174
          },
          hex: '0087AE',
          positionInBook: 1278,
          pageNumberInBook: '183'
        },
        {
          code: '628 C',
          name: null,
          rgb: {
            r: 183,
            g: 221,
            b: 225
          },
          hex: 'B7DDE1',
          positionInBook: 1279,
          pageNumberInBook: '184'
        },
        {
          code: '629 C',
          name: null,
          rgb: {
            r: 155,
            g: 211,
            b: 221
          },
          hex: '9BD3DD',
          positionInBook: 1280,
          pageNumberInBook: '184'
        },
        {
          code: '630 C',
          name: null,
          rgb: {
            r: 119,
            g: 197,
            b: 213
          },
          hex: '77C5D5',
          positionInBook: 1281,
          pageNumberInBook: '184'
        },
        {
          code: '631 C',
          name: null,
          rgb: {
            r: 62,
            g: 177,
            b: 200
          },
          hex: '3EB1C8',
          positionInBook: 1282,
          pageNumberInBook: '184'
        },
        {
          code: '632 C',
          name: null,
          rgb: {
            r: 0,
            g: 147,
            b: 178
          },
          hex: '0093B2',
          positionInBook: 1283,
          pageNumberInBook: '184'
        },
        {
          code: '633 C',
          name: null,
          rgb: {
            r: 0,
            g: 115,
            b: 150
          },
          hex: '007396',
          positionInBook: 1284,
          pageNumberInBook: '184'
        },
        {
          code: '634 C',
          name: null,
          rgb: {
            r: 0,
            g: 95,
            b: 131
          },
          hex: '005F83',
          positionInBook: 1285,
          pageNumberInBook: '184'
        },
        {
          code: '310 C',
          name: null,
          rgb: {
            r: 106,
            g: 209,
            b: 227
          },
          hex: '6AD1E3',
          positionInBook: 1286,
          pageNumberInBook: '185'
        },
        {
          code: '311 C',
          name: null,
          rgb: {
            r: 5,
            g: 195,
            b: 221
          },
          hex: '05C3DD',
          positionInBook: 1287,
          pageNumberInBook: '185'
        },
        {
          code: '312 C',
          name: null,
          rgb: {
            r: 0,
            g: 169,
            b: 206
          },
          hex: '00A9CE',
          positionInBook: 1288,
          pageNumberInBook: '185'
        },
        {
          code: '313 C',
          name: null,
          rgb: {
            r: 0,
            g: 146,
            b: 188
          },
          hex: '0092BC',
          positionInBook: 1289,
          pageNumberInBook: '185'
        },
        {
          code: '314 C',
          name: null,
          rgb: {
            r: 0,
            g: 127,
            b: 163
          },
          hex: '007FA3',
          positionInBook: 1290,
          pageNumberInBook: '185'
        },
        {
          code: '315 C',
          name: null,
          rgb: {
            r: 0,
            g: 103,
            b: 127
          },
          hex: '00677F',
          positionInBook: 1291,
          pageNumberInBook: '185'
        },
        {
          code: '316 C',
          name: null,
          rgb: {
            r: 0,
            g: 72,
            b: 81
          },
          hex: '004851',
          positionInBook: 1292,
          pageNumberInBook: '185'
        },
        {
          code: '3105 C',
          name: null,
          rgb: {
            r: 103,
            g: 210,
            b: 223
          },
          hex: '67D2DF',
          positionInBook: 1293,
          pageNumberInBook: '186'
        },
        {
          code: '3115 C',
          name: null,
          rgb: {
            r: 0,
            g: 193,
            b: 212
          },
          hex: '00C1D4',
          positionInBook: 1294,
          pageNumberInBook: '186'
        },
        {
          code: '3125 C',
          name: null,
          rgb: {
            r: 0,
            g: 174,
            b: 199
          },
          hex: '00AEC7',
          positionInBook: 1295,
          pageNumberInBook: '186'
        },
        {
          code: '3135 C',
          name: null,
          rgb: {
            r: 0,
            g: 142,
            b: 170
          },
          hex: '008EAA',
          positionInBook: 1296,
          pageNumberInBook: '186'
        },
        {
          code: '3145 C',
          name: null,
          rgb: {
            r: 0,
            g: 119,
            b: 139
          },
          hex: '00778B',
          positionInBook: 1297,
          pageNumberInBook: '186'
        },
        {
          code: '3155 C',
          name: null,
          rgb: {
            r: 0,
            g: 98,
            b: 113
          },
          hex: '006271',
          positionInBook: 1298,
          pageNumberInBook: '186'
        },
        {
          code: '3165 C',
          name: null,
          rgb: {
            r: 0,
            g: 79,
            b: 89
          },
          hex: '004F59',
          positionInBook: 1299,
          pageNumberInBook: '186'
        },
        {
          code: '7709 C',
          name: null,
          rgb: {
            r: 99,
            g: 177,
            b: 188
          },
          hex: '63B1BC',
          positionInBook: 1300,
          pageNumberInBook: '187'
        },
        {
          code: '7710 C',
          name: null,
          rgb: {
            r: 0,
            g: 167,
            b: 181
          },
          hex: '00A7B5',
          positionInBook: 1301,
          pageNumberInBook: '187'
        },
        {
          code: '7711 C',
          name: null,
          rgb: {
            r: 0,
            g: 151,
            b: 169
          },
          hex: '0097A9',
          positionInBook: 1302,
          pageNumberInBook: '187'
        },
        {
          code: '7712 C',
          name: null,
          rgb: {
            r: 0,
            g: 133,
            b: 155
          },
          hex: '00859B',
          positionInBook: 1303,
          pageNumberInBook: '187'
        },
        {
          code: '7713 C',
          name: null,
          rgb: {
            r: 0,
            g: 125,
            b: 138
          },
          hex: '007D8A',
          positionInBook: 1304,
          pageNumberInBook: '187'
        },
        {
          code: '7714 C',
          name: null,
          rgb: {
            r: 0,
            g: 118,
            b: 128
          },
          hex: '007680',
          positionInBook: 1305,
          pageNumberInBook: '187'
        },
        {
          code: '7715 C',
          name: null,
          rgb: {
            r: 0,
            g: 98,
            b: 105
          },
          hex: '006269',
          positionInBook: 1306,
          pageNumberInBook: '187'
        },
        {
          code: '2218 C',
          name: null,
          rgb: {
            r: 114,
            g: 176,
            b: 189
          },
          hex: '72B0BD',
          positionInBook: 1307,
          pageNumberInBook: '188'
        },
        {
          code: '2219 C',
          name: null,
          rgb: {
            r: 93,
            g: 163,
            b: 178
          },
          hex: '5DA3B2',
          positionInBook: 1308,
          pageNumberInBook: '188'
        },
        {
          code: '2220 C',
          name: null,
          rgb: {
            r: 71,
            g: 151,
            b: 168
          },
          hex: '4797A8',
          positionInBook: 1309,
          pageNumberInBook: '188'
        },
        {
          code: '2221 C',
          name: null,
          rgb: {
            r: 45,
            g: 140,
            b: 158
          },
          hex: '2D8C9E',
          positionInBook: 1310,
          pageNumberInBook: '188'
        },
        {
          code: '2222 C',
          name: null,
          rgb: {
            r: 29,
            g: 130,
            b: 150
          },
          hex: '1D8296',
          positionInBook: 1311,
          pageNumberInBook: '188'
        },
        {
          code: '2223 C',
          name: null,
          rgb: {
            r: 0,
            g: 120,
            b: 141
          },
          hex: '00788D',
          positionInBook: 1312,
          pageNumberInBook: '188'
        },
        {
          code: '2224 C',
          name: null,
          rgb: {
            r: 0,
            g: 105,
            b: 128
          },
          hex: '006980',
          positionInBook: 1313,
          pageNumberInBook: '188'
        },
        {
          code: '317 C',
          name: null,
          rgb: {
            r: 177,
            g: 228,
            b: 227
          },
          hex: 'B1E4E3',
          positionInBook: 1314,
          pageNumberInBook: '189'
        },
        {
          code: '318 C',
          name: null,
          rgb: {
            r: 136,
            g: 219,
            b: 223
          },
          hex: '88DBDF',
          positionInBook: 1315,
          pageNumberInBook: '189'
        },
        {
          code: '319 C',
          name: null,
          rgb: {
            r: 44,
            g: 204,
            b: 211
          },
          hex: '2CCCD3',
          positionInBook: 1316,
          pageNumberInBook: '189'
        },
        {
          code: '320 C',
          name: null,
          rgb: {
            r: 0,
            g: 156,
            b: 166
          },
          hex: '009CA6',
          positionInBook: 1317,
          pageNumberInBook: '189'
        },
        {
          code: '321 C',
          name: null,
          rgb: {
            r: 0,
            g: 140,
            b: 149
          },
          hex: '008C95',
          positionInBook: 1318,
          pageNumberInBook: '189'
        },
        {
          code: '322 C',
          name: null,
          rgb: {
            r: 0,
            g: 115,
            b: 119
          },
          hex: '007377',
          positionInBook: 1319,
          pageNumberInBook: '189'
        },
        {
          code: '323 C',
          name: null,
          rgb: {
            r: 0,
            g: 95,
            b: 97
          },
          hex: '005F61',
          positionInBook: 1320,
          pageNumberInBook: '189'
        },
        {
          code: '2225 C',
          name: null,
          rgb: {
            r: 120,
            g: 213,
            b: 225
          },
          hex: '78D5E1',
          positionInBook: 1321,
          pageNumberInBook: '190'
        },
        {
          code: '2226 C',
          name: null,
          rgb: {
            r: 60,
            g: 203,
            b: 218
          },
          hex: '3CCBDA',
          positionInBook: 1322,
          pageNumberInBook: '190'
        },
        {
          code: '2227 C',
          name: null,
          rgb: {
            r: 89,
            g: 190,
            b: 201
          },
          hex: '59BEC9',
          positionInBook: 1323,
          pageNumberInBook: '190'
        },
        {
          code: '2228 C',
          name: null,
          rgb: {
            r: 0,
            g: 165,
            b: 189
          },
          hex: '00A5BD',
          positionInBook: 1324,
          pageNumberInBook: '190'
        },
        {
          code: '2229 C',
          name: null,
          rgb: {
            r: 0,
            g: 156,
            b: 182
          },
          hex: '009CB6',
          positionInBook: 1325,
          pageNumberInBook: '190'
        },
        {
          code: '2230 C',
          name: null,
          rgb: {
            r: 0,
            g: 140,
            b: 160
          },
          hex: '008CA0',
          positionInBook: 1326,
          pageNumberInBook: '190'
        },
        {
          code: '2231 C',
          name: null,
          rgb: {
            r: 0,
            g: 124,
            b: 145
          },
          hex: '007C91',
          positionInBook: 1327,
          pageNumberInBook: '190'
        },
        {
          code: '4162 C',
          name: null,
          rgb: {
            r: 168,
            g: 211,
            b: 196
          },
          hex: 'A8D3C4',
          positionInBook: 1328,
          pageNumberInBook: '191'
        },
        {
          code: '4163 C',
          name: null,
          rgb: {
            r: 143,
            g: 202,
            b: 185
          },
          hex: '8FCAB9',
          positionInBook: 1329,
          pageNumberInBook: '191'
        },
        {
          code: '4164 C',
          name: null,
          rgb: {
            r: 28,
            g: 129,
            b: 114
          },
          hex: '1C8172',
          positionInBook: 1330,
          pageNumberInBook: '191'
        },
        {
          code: '4165 C',
          name: null,
          rgb: {
            r: 29,
            g: 105,
            b: 96
          },
          hex: '1D6960',
          positionInBook: 1331,
          pageNumberInBook: '191'
        },
        {
          code: '4166 C',
          name: null,
          rgb: {
            r: 65,
            g: 117,
            b: 113
          },
          hex: '417571',
          positionInBook: 1332,
          pageNumberInBook: '191'
        },
        {
          code: '4167 C',
          name: null,
          rgb: {
            r: 50,
            g: 100,
            b: 92
          },
          hex: '32645C',
          positionInBook: 1333,
          pageNumberInBook: '191'
        },
        {
          code: '4168 C',
          name: null,
          rgb: {
            r: 36,
            g: 69,
            b: 69
          },
          hex: '244545',
          positionInBook: 1334,
          pageNumberInBook: '191'
        },
        {
          code: '7464 C',
          name: null,
          rgb: {
            r: 160,
            g: 209,
            b: 202
          },
          hex: 'A0D1CA',
          positionInBook: 1335,
          pageNumberInBook: '192'
        },
        {
          code: '7465 C',
          name: null,
          rgb: {
            r: 64,
            g: 193,
            b: 172
          },
          hex: '40C1AC',
          positionInBook: 1336,
          pageNumberInBook: '192'
        },
        {
          code: '7466 C',
          name: null,
          rgb: {
            r: 0,
            g: 176,
            b: 185
          },
          hex: '00B0B9',
          positionInBook: 1337,
          pageNumberInBook: '192'
        },
        {
          code: '7467 C',
          name: null,
          rgb: {
            r: 0,
            g: 163,
            b: 173
          },
          hex: '00A3AD',
          positionInBook: 1338,
          pageNumberInBook: '192'
        },
        {
          code: '7468 C',
          name: null,
          rgb: {
            r: 0,
            g: 115,
            b: 152
          },
          hex: '007398',
          positionInBook: 1339,
          pageNumberInBook: '192'
        },
        {
          code: '7469 C',
          name: null,
          rgb: {
            r: 0,
            g: 95,
            b: 134
          },
          hex: '005F86',
          positionInBook: 1340,
          pageNumberInBook: '192'
        },
        {
          code: '7470 C',
          name: null,
          rgb: {
            r: 0,
            g: 90,
            b: 111
          },
          hex: '005A6F',
          positionInBook: 1341,
          pageNumberInBook: '192'
        },
        {
          code: '7471 C',
          name: null,
          rgb: {
            r: 126,
            g: 221,
            b: 211
          },
          hex: '7EDDD3',
          positionInBook: 1342,
          pageNumberInBook: '193'
        },
        {
          code: '7472 C',
          name: null,
          rgb: {
            r: 92,
            g: 184,
            b: 178
          },
          hex: '5CB8B2',
          positionInBook: 1343,
          pageNumberInBook: '193'
        },
        {
          code: '7473 C',
          name: null,
          rgb: {
            r: 39,
            g: 153,
            b: 137
          },
          hex: '279989',
          positionInBook: 1344,
          pageNumberInBook: '193'
        },
        {
          code: '7474 C',
          name: null,
          rgb: {
            r: 0,
            g: 118,
            b: 129
          },
          hex: '007681',
          positionInBook: 1345,
          pageNumberInBook: '193'
        },
        {
          code: '7475 C',
          name: null,
          rgb: {
            r: 71,
            g: 122,
            b: 123
          },
          hex: '477A7B',
          positionInBook: 1346,
          pageNumberInBook: '193'
        },
        {
          code: '7476 C',
          name: null,
          rgb: {
            r: 13,
            g: 82,
            b: 87
          },
          hex: '0D5257',
          positionInBook: 1347,
          pageNumberInBook: '193'
        },
        {
          code: '7477 C',
          name: null,
          rgb: {
            r: 36,
            g: 76,
            b: 90
          },
          hex: '244C5A',
          positionInBook: 1348,
          pageNumberInBook: '193'
        },
        {
          code: '2211 C',
          name: null,
          rgb: {
            r: 111,
            g: 155,
            b: 164
          },
          hex: '6F9BA4',
          positionInBook: 1349,
          pageNumberInBook: '194'
        },
        {
          code: '2212 C',
          name: null,
          rgb: {
            r: 80,
            g: 133,
            b: 144
          },
          hex: '508590',
          positionInBook: 1350,
          pageNumberInBook: '194'
        },
        {
          code: '2213 C',
          name: null,
          rgb: {
            r: 51,
            g: 113,
            b: 121
          },
          hex: '337179',
          positionInBook: 1351,
          pageNumberInBook: '194'
        },
        {
          code: '2214 C',
          name: null,
          rgb: {
            r: 47,
            g: 111,
            b: 122
          },
          hex: '2F6F7A',
          positionInBook: 1352,
          pageNumberInBook: '194'
        },
        {
          code: '2215 C',
          name: null,
          rgb: {
            r: 46,
            g: 86,
            b: 101
          },
          hex: '2E5665',
          positionInBook: 1353,
          pageNumberInBook: '194'
        },
        {
          code: '2216 C',
          name: null,
          rgb: {
            r: 45,
            g: 77,
            b: 88
          },
          hex: '2D4D58',
          positionInBook: 1354,
          pageNumberInBook: '194'
        },
        {
          code: '2217 C',
          name: null,
          rgb: {
            r: 0,
            g: 58,
            b: 64
          },
          hex: '003A40',
          positionInBook: 1355,
          pageNumberInBook: '194'
        },
        {
          code: '5523 C',
          name: null,
          rgb: {
            r: 182,
            g: 207,
            b: 208
          },
          hex: 'B6CFD0',
          positionInBook: 1356,
          pageNumberInBook: '195'
        },
        {
          code: '5513 C',
          name: null,
          rgb: {
            r: 171,
            g: 199,
            b: 201
          },
          hex: 'ABC7C9',
          positionInBook: 1357,
          pageNumberInBook: '195'
        },
        {
          code: '5503 C',
          name: null,
          rgb: {
            r: 148,
            g: 183,
            b: 187
          },
          hex: '94B7BB',
          positionInBook: 1358,
          pageNumberInBook: '195'
        },
        {
          code: '5493 C',
          name: null,
          rgb: {
            r: 127,
            g: 169,
            b: 174
          },
          hex: '7FA9AE',
          positionInBook: 1359,
          pageNumberInBook: '195'
        },
        {
          code: '5483 C',
          name: null,
          rgb: {
            r: 79,
            g: 134,
            b: 142
          },
          hex: '4F868E',
          positionInBook: 1360,
          pageNumberInBook: '195'
        },
        {
          code: '5473 C',
          name: null,
          rgb: {
            r: 17,
            g: 94,
            b: 103
          },
          hex: '115E67',
          positionInBook: 1361,
          pageNumberInBook: '195'
        },
        {
          code: '5463 C',
          name: null,
          rgb: {
            r: 7,
            g: 39,
            b: 45
          },
          hex: '07272D',
          positionInBook: 1362,
          pageNumberInBook: '195'
        },
        {
          code: '2232 C',
          name: null,
          rgb: {
            r: 113,
            g: 176,
            b: 180
          },
          hex: '71B0B4',
          positionInBook: 1363,
          pageNumberInBook: '196'
        },
        {
          code: '2233 C',
          name: null,
          rgb: {
            r: 88,
            g: 167,
            b: 175
          },
          hex: '58A7AF',
          positionInBook: 1364,
          pageNumberInBook: '196'
        },
        {
          code: '2234 C',
          name: null,
          rgb: {
            r: 79,
            g: 159,
            b: 166
          },
          hex: '4F9FA6',
          positionInBook: 1365,
          pageNumberInBook: '196'
        },
        {
          code: '2235 C',
          name: null,
          rgb: {
            r: 40,
            g: 147,
            b: 156
          },
          hex: '28939C',
          positionInBook: 1366,
          pageNumberInBook: '196'
        },
        {
          code: '2236 C',
          name: null,
          rgb: {
            r: 44,
            g: 145,
            b: 153
          },
          hex: '2C9199',
          positionInBook: 1367,
          pageNumberInBook: '196'
        },
        {
          code: '2237 C',
          name: null,
          rgb: {
            r: 5,
            g: 134,
            b: 142
          },
          hex: '05868E',
          positionInBook: 1368,
          pageNumberInBook: '196'
        },
        {
          code: '2238 C',
          name: null,
          rgb: {
            r: 0,
            g: 105,
            b: 117
          },
          hex: '006975',
          positionInBook: 1369,
          pageNumberInBook: '196'
        },
        {
          code: '7716 C',
          name: null,
          rgb: {
            r: 0,
            g: 150,
            b: 143
          },
          hex: '00968F',
          positionInBook: 1370,
          pageNumberInBook: '197'
        },
        {
          code: '7717 C',
          name: null,
          rgb: {
            r: 0,
            g: 133,
            b: 125
          },
          hex: '00857D',
          positionInBook: 1371,
          pageNumberInBook: '197'
        },
        {
          code: '7718 C',
          name: null,
          rgb: {
            r: 0,
            g: 118,
            b: 114
          },
          hex: '007672',
          positionInBook: 1372,
          pageNumberInBook: '197'
        },
        {
          code: '7719 C',
          name: null,
          rgb: {
            r: 0,
            g: 109,
            b: 104
          },
          hex: '006D68',
          positionInBook: 1373,
          pageNumberInBook: '197'
        },
        {
          code: '7720 C',
          name: null,
          rgb: {
            r: 0,
            g: 99,
            b: 91
          },
          hex: '00635B',
          positionInBook: 1374,
          pageNumberInBook: '197'
        },
        {
          code: '7721 C',
          name: null,
          rgb: {
            r: 0,
            g: 94,
            b: 93
          },
          hex: '005E5D',
          positionInBook: 1375,
          pageNumberInBook: '197'
        },
        {
          code: '7722 C',
          name: null,
          rgb: {
            r: 0,
            g: 81,
            b: 81
          },
          hex: '005151',
          positionInBook: 1376,
          pageNumberInBook: '197'
        },
        {
          code: '324 C',
          name: null,
          rgb: {
            r: 156,
            g: 219,
            b: 217
          },
          hex: '9CDBD9',
          positionInBook: 1377,
          pageNumberInBook: '198'
        },
        {
          code: '325 C',
          name: null,
          rgb: {
            r: 100,
            g: 204,
            b: 201
          },
          hex: '64CCC9',
          positionInBook: 1378,
          pageNumberInBook: '198'
        },
        {
          code: '326 C',
          name: null,
          rgb: {
            r: 0,
            g: 178,
            b: 169
          },
          hex: '00B2A9',
          positionInBook: 1379,
          pageNumberInBook: '198'
        },
        {
          code: '327 C',
          name: null,
          rgb: {
            r: 0,
            g: 134,
            b: 117
          },
          hex: '008675',
          positionInBook: 1380,
          pageNumberInBook: '198'
        },
        {
          code: '328 C',
          name: null,
          rgb: {
            r: 0,
            g: 115,
            b: 103
          },
          hex: '007367',
          positionInBook: 1381,
          pageNumberInBook: '198'
        },
        {
          code: '329 C',
          name: null,
          rgb: {
            r: 0,
            g: 104,
            b: 94
          },
          hex: '00685E',
          positionInBook: 1382,
          pageNumberInBook: '198'
        },
        {
          code: '330 C',
          name: null,
          rgb: {
            r: 0,
            g: 83,
            b: 76
          },
          hex: '00534C',
          positionInBook: 1383,
          pageNumberInBook: '198'
        },
        {
          code: '2455 C',
          name: null,
          rgb: {
            r: 147,
            g: 189,
            b: 180
          },
          hex: '93BDB4',
          positionInBook: 1384,
          pageNumberInBook: '199'
        },
        {
          code: '3533 C',
          name: null,
          rgb: {
            r: 105,
            g: 219,
            b: 200
          },
          hex: '69DBC8',
          positionInBook: 1385,
          pageNumberInBook: '199'
        },
        {
          code: '3534 C',
          name: null,
          rgb: {
            r: 0,
            g: 178,
            b: 162
          },
          hex: '00B2A2',
          positionInBook: 1386,
          pageNumberInBook: '199'
        },
        {
          code: '2456 C',
          name: null,
          rgb: {
            r: 49,
            g: 156,
            b: 138
          },
          hex: '319C8A',
          positionInBook: 1387,
          pageNumberInBook: '199'
        },
        {
          code: '3560 C',
          name: null,
          rgb: {
            r: 0,
            g: 164,
            b: 151
          },
          hex: '00A497',
          positionInBook: 1388,
          pageNumberInBook: '199'
        },
        {
          code: '3557 C',
          name: null,
          rgb: {
            r: 0,
            g: 124,
            b: 128
          },
          hex: '007C80',
          positionInBook: 1389,
          pageNumberInBook: '199'
        },
        {
          code: '3541 C',
          name: null,
          rgb: {
            r: 0,
            g: 147,
            b: 157
          },
          hex: '00939D',
          positionInBook: 1390,
          pageNumberInBook: '199'
        },
        {
          code: '3242 C',
          name: null,
          rgb: {
            r: 113,
            g: 219,
            b: 212
          },
          hex: '71DBD4',
          positionInBook: 1391,
          pageNumberInBook: '200'
        },
        {
          code: '3252 C',
          name: null,
          rgb: {
            r: 42,
            g: 210,
            b: 201
          },
          hex: '2AD2C9',
          positionInBook: 1392,
          pageNumberInBook: '200'
        },
        {
          code: '3262 C',
          name: null,
          rgb: {
            r: 0,
            g: 191,
            b: 178
          },
          hex: '00BFB2',
          positionInBook: 1393,
          pageNumberInBook: '200'
        },
        {
          code: '3272 C',
          name: null,
          rgb: {
            r: 0,
            g: 164,
            b: 153
          },
          hex: '00A499',
          positionInBook: 1394,
          pageNumberInBook: '200'
        },
        {
          code: '3282 C',
          name: null,
          rgb: {
            r: 0,
            g: 133,
            b: 120
          },
          hex: '008578',
          positionInBook: 1395,
          pageNumberInBook: '200'
        },
        {
          code: '3292 C',
          name: null,
          rgb: {
            r: 0,
            g: 89,
            b: 79
          },
          hex: '00594F',
          positionInBook: 1396,
          pageNumberInBook: '200'
        },
        {
          code: '3302 C',
          name: null,
          rgb: {
            r: 0,
            g: 76,
            b: 69
          },
          hex: '004C45',
          positionInBook: 1397,
          pageNumberInBook: '200'
        },
        {
          code: '2397 C',
          name: null,
          rgb: {
            r: 0,
            g: 183,
            b: 189
          },
          hex: '00B7BD',
          positionInBook: 1398,
          pageNumberInBook: '201'
        },
        {
          code: '2398 C',
          name: null,
          rgb: {
            r: 0,
            g: 186,
            b: 179
          },
          hex: '00BAB3',
          positionInBook: 1399,
          pageNumberInBook: '201'
        },
        {
          code: '2399 C',
          name: null,
          rgb: {
            r: 0,
            g: 172,
            b: 160
          },
          hex: '00ACA0',
          positionInBook: 1400,
          pageNumberInBook: '201'
        },
        {
          code: '2400 C',
          name: null,
          rgb: {
            r: 0,
            g: 176,
            b: 151
          },
          hex: '00B097',
          positionInBook: 1401,
          pageNumberInBook: '201'
        },
        {
          code: '2401 C',
          name: null,
          rgb: {
            r: 52,
            g: 167,
            b: 152
          },
          hex: '34A798',
          positionInBook: 1402,
          pageNumberInBook: '201'
        },
        {
          code: '2402 C',
          name: null,
          rgb: {
            r: 0,
            g: 157,
            b: 133
          },
          hex: '009D85',
          positionInBook: 1403,
          pageNumberInBook: '201'
        },
        {
          code: '2403 C',
          name: null,
          rgb: {
            r: 0,
            g: 137,
            b: 123
          },
          hex: '00897B',
          positionInBook: 1404,
          pageNumberInBook: '201'
        },
        {
          code: '2457 C',
          name: null,
          rgb: {
            r: 139,
            g: 170,
            b: 153
          },
          hex: '8BAA99',
          positionInBook: 1405,
          pageNumberInBook: '202'
        },
        {
          code: '2458 C',
          name: null,
          rgb: {
            r: 104,
            g: 152,
            b: 129
          },
          hex: '689881',
          positionInBook: 1406,
          pageNumberInBook: '202'
        },
        {
          code: '2459 C',
          name: null,
          rgb: {
            r: 86,
            g: 176,
            b: 147
          },
          hex: '56B093',
          positionInBook: 1407,
          pageNumberInBook: '202'
        },
        {
          code: '2460 C',
          name: null,
          rgb: {
            r: 106,
            g: 175,
            b: 170
          },
          hex: '6AAFAA',
          positionInBook: 1408,
          pageNumberInBook: '202'
        },
        {
          code: '2461 C',
          name: null,
          rgb: {
            r: 37,
            g: 149,
            b: 145
          },
          hex: '259591',
          positionInBook: 1409,
          pageNumberInBook: '202'
        },
        {
          code: '2462 C',
          name: null,
          rgb: {
            r: 90,
            g: 141,
            b: 132
          },
          hex: '5A8D84',
          positionInBook: 1410,
          pageNumberInBook: '202'
        },
        {
          code: '2463 C',
          name: null,
          rgb: {
            r: 91,
            g: 118,
            b: 113
          },
          hex: '5B7671',
          positionInBook: 1411,
          pageNumberInBook: '202'
        },
        {
          code: '4169 C',
          name: null,
          rgb: {
            r: 182,
            g: 200,
            b: 194
          },
          hex: 'B6C8C2',
          positionInBook: 1412,
          pageNumberInBook: '203'
        },
        {
          code: '4170 C',
          name: null,
          rgb: {
            r: 164,
            g: 189,
            b: 186
          },
          hex: 'A4BDBA',
          positionInBook: 1413,
          pageNumberInBook: '203'
        },
        {
          code: '4171 C',
          name: null,
          rgb: {
            r: 155,
            g: 185,
            b: 181
          },
          hex: '9BB9B5',
          positionInBook: 1414,
          pageNumberInBook: '203'
        },
        {
          code: '4172 C',
          name: null,
          rgb: {
            r: 129,
            g: 176,
            b: 170
          },
          hex: '81B0AA',
          positionInBook: 1415,
          pageNumberInBook: '203'
        },
        {
          code: '4173 C',
          name: null,
          rgb: {
            r: 132,
            g: 196,
            b: 192
          },
          hex: '84C4C0',
          positionInBook: 1416,
          pageNumberInBook: '203'
        },
        {
          code: '4174 C',
          name: null,
          rgb: {
            r: 131,
            g: 193,
            b: 192
          },
          hex: '83C1C0',
          positionInBook: 1417,
          pageNumberInBook: '203'
        },
        {
          code: '4175 C',
          name: null,
          rgb: {
            r: 147,
            g: 187,
            b: 194
          },
          hex: '93BBC2',
          positionInBook: 1418,
          pageNumberInBook: '203'
        },
        {
          code: '3245 C',
          name: null,
          rgb: {
            r: 124,
            g: 224,
            b: 211
          },
          hex: '7CE0D3',
          positionInBook: 1419,
          pageNumberInBook: '204'
        },
        {
          code: '3255 C',
          name: null,
          rgb: {
            r: 44,
            g: 213,
            b: 196
          },
          hex: '2CD5C4',
          positionInBook: 1420,
          pageNumberInBook: '204'
        },
        {
          code: '3265 C',
          name: null,
          rgb: {
            r: 0,
            g: 199,
            b: 177
          },
          hex: '00C7B1',
          positionInBook: 1421,
          pageNumberInBook: '204'
        },
        {
          code: '3275 C',
          name: null,
          rgb: {
            r: 0,
            g: 179,
            b: 152
          },
          hex: '00B398',
          positionInBook: 1422,
          pageNumberInBook: '204'
        },
        {
          code: '3285 C',
          name: null,
          rgb: {
            r: 0,
            g: 150,
            b: 129
          },
          hex: '009681',
          positionInBook: 1423,
          pageNumberInBook: '204'
        },
        {
          code: '3295 C',
          name: null,
          rgb: {
            r: 0,
            g: 120,
            b: 100
          },
          hex: '007864',
          positionInBook: 1424,
          pageNumberInBook: '204'
        },
        {
          code: '3305 C',
          name: null,
          rgb: {
            r: 0,
            g: 78,
            b: 66
          },
          hex: '004E42',
          positionInBook: 1425,
          pageNumberInBook: '204'
        },
        {
          code: '3248 C',
          name: null,
          rgb: {
            r: 109,
            g: 205,
            b: 184
          },
          hex: '6DCDB8',
          positionInBook: 1426,
          pageNumberInBook: '205'
        },
        {
          code: '3258 C',
          name: null,
          rgb: {
            r: 73,
            g: 197,
            b: 177
          },
          hex: '49C5B1',
          positionInBook: 1427,
          pageNumberInBook: '205'
        },
        {
          code: '3268 C',
          name: null,
          rgb: {
            r: 0,
            g: 171,
            b: 142
          },
          hex: '00AB8E',
          positionInBook: 1428,
          pageNumberInBook: '205'
        },
        {
          code: '3278 C',
          name: null,
          rgb: {
            r: 0,
            g: 155,
            b: 119
          },
          hex: '009B77',
          positionInBook: 1429,
          pageNumberInBook: '205'
        },
        {
          code: '3288 C',
          name: null,
          rgb: {
            r: 0,
            g: 130,
            b: 100
          },
          hex: '008264',
          positionInBook: 1430,
          pageNumberInBook: '205'
        },
        {
          code: '3298 C',
          name: null,
          rgb: {
            r: 0,
            g: 106,
            b: 82
          },
          hex: '006A52',
          positionInBook: 1431,
          pageNumberInBook: '205'
        },
        {
          code: '3308 C',
          name: null,
          rgb: {
            r: 2,
            g: 70,
            b: 56
          },
          hex: '024638',
          positionInBook: 1432,
          pageNumberInBook: '205'
        },
        {
          code: '566 C',
          name: null,
          rgb: {
            r: 185,
            g: 220,
            b: 210
          },
          hex: 'B9DCD2',
          positionInBook: 1433,
          pageNumberInBook: '206'
        },
        {
          code: '565 C',
          name: null,
          rgb: {
            r: 161,
            g: 214,
            b: 202
          },
          hex: 'A1D6CA',
          positionInBook: 1434,
          pageNumberInBook: '206'
        },
        {
          code: '564 C',
          name: null,
          rgb: {
            r: 134,
            g: 200,
            b: 188
          },
          hex: '86C8BC',
          positionInBook: 1435,
          pageNumberInBook: '206'
        },
        {
          code: '563 C',
          name: null,
          rgb: {
            r: 107,
            g: 187,
            b: 174
          },
          hex: '6BBBAE',
          positionInBook: 1436,
          pageNumberInBook: '206'
        },
        {
          code: '562 C',
          name: null,
          rgb: {
            r: 0,
            g: 111,
            b: 98
          },
          hex: '006F62',
          positionInBook: 1437,
          pageNumberInBook: '206'
        },
        {
          code: '561 C',
          name: null,
          rgb: {
            r: 0,
            g: 89,
            b: 76
          },
          hex: '00594C',
          positionInBook: 1438,
          pageNumberInBook: '206'
        },
        {
          code: '560 C',
          name: null,
          rgb: {
            r: 29,
            g: 60,
            b: 52
          },
          hex: '1D3C34',
          positionInBook: 1439,
          pageNumberInBook: '206'
        },
        {
          code: '573 C',
          name: null,
          rgb: {
            r: 181,
            g: 227,
            b: 216
          },
          hex: 'B5E3D8',
          positionInBook: 1440,
          pageNumberInBook: '207'
        },
        {
          code: '572 C',
          name: null,
          rgb: {
            r: 165,
            g: 223,
            b: 211
          },
          hex: 'A5DFD3',
          positionInBook: 1441,
          pageNumberInBook: '207'
        },
        {
          code: '571 C',
          name: null,
          rgb: {
            r: 152,
            g: 219,
            b: 206
          },
          hex: '98DBCE',
          positionInBook: 1442,
          pageNumberInBook: '207'
        },
        {
          code: '570 C',
          name: null,
          rgb: {
            r: 107,
            g: 202,
            b: 186
          },
          hex: '6BCABA',
          positionInBook: 1443,
          pageNumberInBook: '207'
        },
        {
          code: '569 C',
          name: null,
          rgb: {
            r: 0,
            g: 129,
            b: 109
          },
          hex: '00816D',
          positionInBook: 1444,
          pageNumberInBook: '207'
        },
        {
          code: '568 C',
          name: null,
          rgb: {
            r: 0,
            g: 108,
            b: 91
          },
          hex: '006C5B',
          positionInBook: 1445,
          pageNumberInBook: '207'
        },
        {
          code: '567 C',
          name: null,
          rgb: {
            r: 23,
            g: 63,
            b: 53
          },
          hex: '173F35',
          positionInBook: 1446,
          pageNumberInBook: '207'
        },
        {
          code: '559 C',
          name: null,
          rgb: {
            r: 173,
            g: 202,
            b: 184
          },
          hex: 'ADCAB8',
          positionInBook: 1447,
          pageNumberInBook: '208'
        },
        {
          code: '558 C',
          name: null,
          rgb: {
            r: 154,
            g: 190,
            b: 170
          },
          hex: '9ABEAA',
          positionInBook: 1448,
          pageNumberInBook: '208'
        },
        {
          code: '557 C',
          name: null,
          rgb: {
            r: 133,
            g: 176,
            b: 154
          },
          hex: '85B09A',
          positionInBook: 1449,
          pageNumberInBook: '208'
        },
        {
          code: '556 C',
          name: null,
          rgb: {
            r: 111,
            g: 162,
            b: 135
          },
          hex: '6FA287',
          positionInBook: 1450,
          pageNumberInBook: '208'
        },
        {
          code: '555 C',
          name: null,
          rgb: {
            r: 40,
            g: 114,
            b: 79
          },
          hex: '28724F',
          positionInBook: 1451,
          pageNumberInBook: '208'
        },
        {
          code: '554 C',
          name: null,
          rgb: {
            r: 32,
            g: 92,
            b: 64
          },
          hex: '205C40',
          positionInBook: 1452,
          pageNumberInBook: '208'
        },
        {
          code: '553 C',
          name: null,
          rgb: {
            r: 40,
            g: 71,
            b: 52
          },
          hex: '284734',
          positionInBook: 1453,
          pageNumberInBook: '208'
        },
        {
          code: '2404 C',
          name: null,
          rgb: {
            r: 165,
            g: 185,
            b: 156
          },
          hex: 'A5B99C',
          positionInBook: 1454,
          pageNumberInBook: '209'
        },
        {
          code: '2406 C',
          name: null,
          rgb: {
            r: 129,
            g: 158,
            b: 135
          },
          hex: '819E87',
          positionInBook: 1455,
          pageNumberInBook: '209'
        },
        {
          code: '2407 C',
          name: null,
          rgb: {
            r: 107,
            g: 141,
            b: 115
          },
          hex: '6B8D73',
          positionInBook: 1456,
          pageNumberInBook: '209'
        },
        {
          code: '2408 C',
          name: null,
          rgb: {
            r: 73,
            g: 123,
            b: 85
          },
          hex: '497B55',
          positionInBook: 1457,
          pageNumberInBook: '209'
        },
        {
          code: '2409 C',
          name: null,
          rgb: {
            r: 78,
            g: 101,
            b: 72
          },
          hex: '4E6548',
          positionInBook: 1458,
          pageNumberInBook: '209'
        },
        {
          code: '2410 C',
          name: null,
          rgb: {
            r: 68,
            g: 90,
            b: 62
          },
          hex: '445A3E',
          positionInBook: 1459,
          pageNumberInBook: '209'
        },
        {
          code: '2411 C',
          name: null,
          rgb: {
            r: 28,
            g: 66,
            b: 32
          },
          hex: '1C4220',
          positionInBook: 1460,
          pageNumberInBook: '209'
        },
        {
          code: '5595 C',
          name: null,
          rgb: {
            r: 191,
            g: 206,
            b: 194
          },
          hex: 'BFCEC2',
          positionInBook: 1461,
          pageNumberInBook: '210'
        },
        {
          code: '5585 C',
          name: null,
          rgb: {
            r: 167,
            g: 189,
            b: 177
          },
          hex: 'A7BDB1',
          positionInBook: 1462,
          pageNumberInBook: '210'
        },
        {
          code: '5575 C',
          name: null,
          rgb: {
            r: 146,
            g: 172,
            b: 160
          },
          hex: '92ACA0',
          positionInBook: 1463,
          pageNumberInBook: '210'
        },
        {
          code: '5565 C',
          name: null,
          rgb: {
            r: 127,
            g: 156,
            b: 144
          },
          hex: '7F9C90',
          positionInBook: 1464,
          pageNumberInBook: '210'
        },
        {
          code: '5555 C',
          name: null,
          rgb: {
            r: 92,
            g: 127,
            b: 113
          },
          hex: '5C7F71',
          positionInBook: 1465,
          pageNumberInBook: '210'
        },
        {
          code: '5545 C',
          name: null,
          rgb: {
            r: 67,
            g: 105,
            b: 91
          },
          hex: '43695B',
          positionInBook: 1466,
          pageNumberInBook: '210'
        },
        {
          code: '5535 C',
          name: null,
          rgb: {
            r: 24,
            g: 48,
            b: 41
          },
          hex: '183029',
          positionInBook: 1467,
          pageNumberInBook: '210'
        },
        {
          code: '5665 C',
          name: null,
          rgb: {
            r: 186,
            g: 197,
            b: 185
          },
          hex: 'BAC5B9',
          positionInBook: 1468,
          pageNumberInBook: '211'
        },
        {
          code: '5655 C',
          name: null,
          rgb: {
            r: 176,
            g: 189,
            b: 176
          },
          hex: 'B0BDB0',
          positionInBook: 1469,
          pageNumberInBook: '211'
        },
        {
          code: '5645 C',
          name: null,
          rgb: {
            r: 163,
            g: 178,
            b: 164
          },
          hex: 'A3B2A4',
          positionInBook: 1470,
          pageNumberInBook: '211'
        },
        {
          code: '5635 C',
          name: null,
          rgb: {
            r: 148,
            g: 165,
            b: 150
          },
          hex: '94A596',
          positionInBook: 1471,
          pageNumberInBook: '211'
        },
        {
          code: '5625 C',
          name: null,
          rgb: {
            r: 112,
            g: 133,
            b: 115
          },
          hex: '708573',
          positionInBook: 1472,
          pageNumberInBook: '211'
        },
        {
          code: '5615 C',
          name: null,
          rgb: {
            r: 94,
            g: 116,
            b: 97
          },
          hex: '5E7461',
          positionInBook: 1473,
          pageNumberInBook: '211'
        },
        {
          code: '5605 C',
          name: null,
          rgb: {
            r: 34,
            g: 55,
            b: 43
          },
          hex: '22372B',
          positionInBook: 1474,
          pageNumberInBook: '211'
        },
        {
          code: '4176 C',
          name: null,
          rgb: {
            r: 196,
            g: 206,
            b: 194
          },
          hex: 'C4CEC2',
          positionInBook: 1475,
          pageNumberInBook: '212'
        },
        {
          code: '4177 C',
          name: null,
          rgb: {
            r: 187,
            g: 190,
            b: 174
          },
          hex: 'BBBEAE',
          positionInBook: 1476,
          pageNumberInBook: '212'
        },
        {
          code: '4178 C',
          name: null,
          rgb: {
            r: 168,
            g: 175,
            b: 153
          },
          hex: 'A8AF99',
          positionInBook: 1477,
          pageNumberInBook: '212'
        },
        {
          code: '4179 C',
          name: null,
          rgb: {
            r: 150,
            g: 164,
            b: 128
          },
          hex: '96A480',
          positionInBook: 1478,
          pageNumberInBook: '212'
        },
        {
          code: '4180 C',
          name: null,
          rgb: {
            r: 143,
            g: 153,
            b: 128
          },
          hex: '8F9980',
          positionInBook: 1479,
          pageNumberInBook: '212'
        },
        {
          code: '4181 C',
          name: null,
          rgb: {
            r: 115,
            g: 134,
            b: 112
          },
          hex: '738670',
          positionInBook: 1480,
          pageNumberInBook: '212'
        },
        {
          code: '4182 C',
          name: null,
          rgb: {
            r: 106,
            g: 120,
            b: 102
          },
          hex: '6A7866',
          positionInBook: 1481,
          pageNumberInBook: '212'
        },
        {
          code: '4183 C',
          name: null,
          rgb: {
            r: 185,
            g: 193,
            b: 180
          },
          hex: 'B9C1B4',
          positionInBook: 1482,
          pageNumberInBook: '213'
        },
        {
          code: '4184 C',
          name: null,
          rgb: {
            r: 154,
            g: 171,
            b: 158
          },
          hex: '9AAB9E',
          positionInBook: 1483,
          pageNumberInBook: '213'
        },
        {
          code: '4185 C',
          name: null,
          rgb: {
            r: 136,
            g: 162,
            b: 154
          },
          hex: '88A29A',
          positionInBook: 1484,
          pageNumberInBook: '213'
        },
        {
          code: '4186 C',
          name: null,
          rgb: {
            r: 106,
            g: 142,
            b: 137
          },
          hex: '6A8E89',
          positionInBook: 1485,
          pageNumberInBook: '213'
        },
        {
          code: '4187 C',
          name: null,
          rgb: {
            r: 104,
            g: 124,
            b: 123
          },
          hex: '687C7B',
          positionInBook: 1486,
          pageNumberInBook: '213'
        },
        {
          code: '4188 C',
          name: null,
          rgb: {
            r: 68,
            g: 93,
            b: 92
          },
          hex: '445D5C',
          positionInBook: 1487,
          pageNumberInBook: '213'
        },
        {
          code: '4189 C',
          name: null,
          rgb: {
            r: 28,
            g: 74,
            b: 80
          },
          hex: '1C4A50',
          positionInBook: 1488,
          pageNumberInBook: '213'
        },
        {
          code: '5527 C',
          name: null,
          rgb: {
            r: 188,
            g: 201,
            b: 197
          },
          hex: 'BCC9C5',
          positionInBook: 1489,
          pageNumberInBook: '214'
        },
        {
          code: '5517 C',
          name: null,
          rgb: {
            r: 177,
            g: 192,
            b: 188
          },
          hex: 'B1C0BC',
          positionInBook: 1490,
          pageNumberInBook: '214'
        },
        {
          code: '5507 C',
          name: null,
          rgb: {
            r: 157,
            g: 176,
            b: 172
          },
          hex: '9DB0AC',
          positionInBook: 1491,
          pageNumberInBook: '214'
        },
        {
          code: '5497 C',
          name: null,
          rgb: {
            r: 130,
            g: 153,
            b: 149
          },
          hex: '829995',
          positionInBook: 1492,
          pageNumberInBook: '214'
        },
        {
          code: '5487 C',
          name: null,
          rgb: {
            r: 94,
            g: 121,
            b: 117
          },
          hex: '5E7975',
          positionInBook: 1493,
          pageNumberInBook: '214'
        },
        {
          code: '5477 C',
          name: null,
          rgb: {
            r: 62,
            g: 93,
            b: 88
          },
          hex: '3E5D58',
          positionInBook: 1494,
          pageNumberInBook: '214'
        },
        {
          code: '5467 C',
          name: null,
          rgb: {
            r: 24,
            g: 51,
            b: 47
          },
          hex: '18332F',
          positionInBook: 1495,
          pageNumberInBook: '214'
        },
        {
          code: '4190 C',
          name: null,
          rgb: {
            r: 167,
            g: 178,
            b: 163
          },
          hex: 'A7B2A3',
          positionInBook: 1496,
          pageNumberInBook: '215'
        },
        {
          code: '4191 C',
          name: null,
          rgb: {
            r: 148,
            g: 165,
            b: 158
          },
          hex: '94A59E',
          positionInBook: 1497,
          pageNumberInBook: '215'
        },
        {
          code: '4192 C',
          name: null,
          rgb: {
            r: 133,
            g: 149,
            b: 135
          },
          hex: '859587',
          positionInBook: 1498,
          pageNumberInBook: '215'
        },
        {
          code: '4193 C',
          name: null,
          rgb: {
            r: 98,
            g: 104,
            b: 90
          },
          hex: '62685A',
          positionInBook: 1499,
          pageNumberInBook: '215'
        },
        {
          code: '4194 C',
          name: null,
          rgb: {
            r: 86,
            g: 99,
            b: 97
          },
          hex: '566361',
          positionInBook: 1500,
          pageNumberInBook: '215'
        },
        {
          code: '4195 C',
          name: null,
          rgb: {
            r: 100,
            g: 101,
            b: 102
          },
          hex: '646566',
          positionInBook: 1501,
          pageNumberInBook: '215'
        },
        {
          code: '4196 C',
          name: null,
          rgb: {
            r: 71,
            g: 86,
            b: 90
          },
          hex: '47565A',
          positionInBook: 1502,
          pageNumberInBook: '215'
        },
        {
          code: '4197 C',
          name: null,
          rgb: {
            r: 138,
            g: 155,
            b: 142
          },
          hex: '8A9B8E',
          positionInBook: 1503,
          pageNumberInBook: '216'
        },
        {
          code: '4198 C',
          name: null,
          rgb: {
            r: 105,
            g: 126,
            b: 112
          },
          hex: '697E70',
          positionInBook: 1504,
          pageNumberInBook: '216'
        },
        {
          code: '4199 C',
          name: null,
          rgb: {
            r: 89,
            g: 105,
            b: 92
          },
          hex: '59695C',
          positionInBook: 1505,
          pageNumberInBook: '216'
        },
        {
          code: '4200 C',
          name: null,
          rgb: {
            r: 89,
            g: 108,
            b: 98
          },
          hex: '596C62',
          positionInBook: 1506,
          pageNumberInBook: '216'
        },
        {
          code: '4201 C',
          name: null,
          rgb: {
            r: 79,
            g: 104,
            b: 93
          },
          hex: '4F685D',
          positionInBook: 1507,
          pageNumberInBook: '216'
        },
        {
          code: '4202 C',
          name: null,
          rgb: {
            r: 56,
            g: 78,
            b: 70
          },
          hex: '384E46',
          positionInBook: 1508,
          pageNumberInBook: '216'
        },
        {
          code: '4203 C',
          name: null,
          rgb: {
            r: 46,
            g: 72,
            b: 62
          },
          hex: '2E483E',
          positionInBook: 1509,
          pageNumberInBook: '216'
        },
        {
          code: '621 C',
          name: null,
          rgb: {
            r: 209,
            g: 224,
            b: 215
          },
          hex: 'D1E0D7',
          positionInBook: 1510,
          pageNumberInBook: '217'
        },
        {
          code: '622 C',
          name: null,
          rgb: {
            r: 183,
            g: 205,
            b: 194
          },
          hex: 'B7CDC2',
          positionInBook: 1511,
          pageNumberInBook: '217'
        },
        {
          code: '623 C',
          name: null,
          rgb: {
            r: 154,
            g: 185,
            b: 173
          },
          hex: '9AB9AD',
          positionInBook: 1512,
          pageNumberInBook: '217'
        },
        {
          code: '624 C',
          name: null,
          rgb: {
            r: 120,
            g: 159,
            b: 144
          },
          hex: '789F90',
          positionInBook: 1513,
          pageNumberInBook: '217'
        },
        {
          code: '625 C',
          name: null,
          rgb: {
            r: 80,
            g: 127,
            b: 112
          },
          hex: '507F70',
          positionInBook: 1514,
          pageNumberInBook: '217'
        },
        {
          code: '626 C',
          name: null,
          rgb: {
            r: 40,
            g: 92,
            b: 77
          },
          hex: '285C4D',
          positionInBook: 1515,
          pageNumberInBook: '217'
        },
        {
          code: '627 C',
          name: null,
          rgb: {
            r: 19,
            g: 50,
            b: 43
          },
          hex: '13322B',
          positionInBook: 1516,
          pageNumberInBook: '217'
        },
        {
          code: '331 C',
          name: null,
          rgb: {
            r: 167,
            g: 230,
            b: 215
          },
          hex: 'A7E6D7',
          positionInBook: 1517,
          pageNumberInBook: '218'
        },
        {
          code: '332 C',
          name: null,
          rgb: {
            r: 140,
            g: 226,
            b: 208
          },
          hex: '8CE2D0',
          positionInBook: 1518,
          pageNumberInBook: '218'
        },
        {
          code: '333 C',
          name: null,
          rgb: {
            r: 60,
            g: 219,
            b: 192
          },
          hex: '3CDBC0',
          positionInBook: 1519,
          pageNumberInBook: '218'
        },
        {
          code: 'Green C',
          name: null,
          rgb: {
            r: 0,
            g: 171,
            b: 132
          },
          hex: '00AB84',
          positionInBook: 1520,
          pageNumberInBook: '218'
        },
        {
          code: '334 C',
          name: null,
          rgb: {
            r: 0,
            g: 151,
            b: 117
          },
          hex: '009775',
          positionInBook: 1521,
          pageNumberInBook: '218'
        },
        {
          code: '335 C',
          name: null,
          rgb: {
            r: 0,
            g: 123,
            b: 95
          },
          hex: '007B5F',
          positionInBook: 1522,
          pageNumberInBook: '218'
        },
        {
          code: '336 C',
          name: null,
          rgb: {
            r: 0,
            g: 102,
            b: 79
          },
          hex: '00664F',
          positionInBook: 1523,
          pageNumberInBook: '218'
        },
        {
          code: '2239 C',
          name: null,
          rgb: {
            r: 0,
            g: 207,
            b: 180
          },
          hex: '00CFB4',
          positionInBook: 1524,
          pageNumberInBook: '219'
        },
        {
          code: '2240 C',
          name: null,
          rgb: {
            r: 0,
            g: 193,
            b: 159
          },
          hex: '00C19F',
          positionInBook: 1525,
          pageNumberInBook: '219'
        },
        {
          code: '2241 C',
          name: null,
          rgb: {
            r: 88,
            g: 162,
            b: 145
          },
          hex: '58A291',
          positionInBook: 1526,
          pageNumberInBook: '219'
        },
        {
          code: '2242 C',
          name: null,
          rgb: {
            r: 0,
            g: 163,
            b: 118
          },
          hex: '00A376',
          positionInBook: 1527,
          pageNumberInBook: '219'
        },
        {
          code: '2243 C',
          name: null,
          rgb: {
            r: 0,
            g: 149,
            b: 122
          },
          hex: '00957A',
          positionInBook: 1528,
          pageNumberInBook: '219'
        },
        {
          code: '2244 C',
          name: null,
          rgb: {
            r: 27,
            g: 128,
            b: 109
          },
          hex: '1B806D',
          positionInBook: 1529,
          pageNumberInBook: '219'
        },
        {
          code: '2245 C',
          name: null,
          rgb: {
            r: 0,
            g: 134,
            b: 85
          },
          hex: '008655',
          positionInBook: 1530,
          pageNumberInBook: '219'
        },
        {
          code: '337 C',
          name: null,
          rgb: {
            r: 143,
            g: 214,
            b: 189
          },
          hex: '8FD6BD',
          positionInBook: 1531,
          pageNumberInBook: '220'
        },
        {
          code: '338 C',
          name: null,
          rgb: {
            r: 110,
            g: 206,
            b: 178
          },
          hex: '6ECEB2',
          positionInBook: 1532,
          pageNumberInBook: '220'
        },
        {
          code: '339 C',
          name: null,
          rgb: {
            r: 0,
            g: 179,
            b: 136
          },
          hex: '00B388',
          positionInBook: 1533,
          pageNumberInBook: '220'
        },
        {
          code: '340 C',
          name: null,
          rgb: {
            r: 0,
            g: 150,
            b: 94
          },
          hex: '00965E',
          positionInBook: 1534,
          pageNumberInBook: '220'
        },
        {
          code: '341 C',
          name: null,
          rgb: {
            r: 0,
            g: 122,
            b: 83
          },
          hex: '007A53',
          positionInBook: 1535,
          pageNumberInBook: '220'
        },
        {
          code: '342 C',
          name: null,
          rgb: {
            r: 0,
            g: 103,
            b: 71
          },
          hex: '006747',
          positionInBook: 1536,
          pageNumberInBook: '220'
        },
        {
          code: '343 C',
          name: null,
          rgb: {
            r: 17,
            g: 87,
            b: 64
          },
          hex: '115740',
          positionInBook: 1537,
          pageNumberInBook: '220'
        },
        {
          code: '7723 C',
          name: null,
          rgb: {
            r: 80,
            g: 166,
            b: 132
          },
          hex: '50A684',
          positionInBook: 1538,
          pageNumberInBook: '221'
        },
        {
          code: '7724 C',
          name: null,
          rgb: {
            r: 0,
            g: 150,
            b: 108
          },
          hex: '00966C',
          positionInBook: 1539,
          pageNumberInBook: '221'
        },
        {
          code: '7725 C',
          name: null,
          rgb: {
            r: 0,
            g: 135,
            b: 85
          },
          hex: '008755',
          positionInBook: 1540,
          pageNumberInBook: '221'
        },
        {
          code: '7726 C',
          name: null,
          rgb: {
            r: 0,
            g: 123,
            b: 75
          },
          hex: '007B4B',
          positionInBook: 1541,
          pageNumberInBook: '221'
        },
        {
          code: '7727 C',
          name: null,
          rgb: {
            r: 0,
            g: 111,
            b: 68
          },
          hex: '006F44',
          positionInBook: 1542,
          pageNumberInBook: '221'
        },
        {
          code: '7728 C',
          name: null,
          rgb: {
            r: 0,
            g: 104,
            b: 69
          },
          hex: '006845',
          positionInBook: 1543,
          pageNumberInBook: '221'
        },
        {
          code: '7729 C',
          name: null,
          rgb: {
            r: 0,
            g: 88,
            b: 68
          },
          hex: '005844',
          positionInBook: 1544,
          pageNumberInBook: '221'
        },
        {
          code: '3375 C',
          name: null,
          rgb: {
            r: 122,
            g: 225,
            b: 191
          },
          hex: '7AE1BF',
          positionInBook: 1545,
          pageNumberInBook: '222'
        },
        {
          code: '3385 C',
          name: null,
          rgb: {
            r: 71,
            g: 215,
            b: 172
          },
          hex: '47D7AC',
          positionInBook: 1546,
          pageNumberInBook: '222'
        },
        {
          code: '3395 C',
          name: null,
          rgb: {
            r: 0,
            g: 195,
            b: 137
          },
          hex: '00C389',
          positionInBook: 1547,
          pageNumberInBook: '222'
        },
        {
          code: '3405 C',
          name: null,
          rgb: {
            r: 0,
            g: 175,
            b: 102
          },
          hex: '00AF66',
          positionInBook: 1548,
          pageNumberInBook: '222'
        },
        {
          code: '3415 C',
          name: null,
          rgb: {
            r: 0,
            g: 119,
            b: 73
          },
          hex: '007749',
          positionInBook: 1549,
          pageNumberInBook: '222'
        },
        {
          code: '3425 C',
          name: null,
          rgb: {
            r: 0,
            g: 99,
            b: 65
          },
          hex: '006341',
          positionInBook: 1550,
          pageNumberInBook: '222'
        },
        {
          code: '3435 C',
          name: null,
          rgb: {
            r: 21,
            g: 71,
            b: 52
          },
          hex: '154734',
          positionInBook: 1551,
          pageNumberInBook: '222'
        },
        {
          code: '2246 C',
          name: null,
          rgb: {
            r: 168,
            g: 213,
            b: 186
          },
          hex: 'A8D5BA',
          positionInBook: 1552,
          pageNumberInBook: '223'
        },
        {
          code: '2247 C',
          name: null,
          rgb: {
            r: 119,
            g: 193,
            b: 154
          },
          hex: '77C19A',
          positionInBook: 1553,
          pageNumberInBook: '223'
        },
        {
          code: '2248 C',
          name: null,
          rgb: {
            r: 113,
            g: 183,
            b: 144
          },
          hex: '71B790',
          positionInBook: 1554,
          pageNumberInBook: '223'
        },
        {
          code: '2249 C',
          name: null,
          rgb: {
            r: 92,
            g: 170,
            b: 127
          },
          hex: '5CAA7F',
          positionInBook: 1555,
          pageNumberInBook: '223'
        },
        {
          code: '2250 C',
          name: null,
          rgb: {
            r: 0,
            g: 179,
            b: 115
          },
          hex: '00B373',
          positionInBook: 1556,
          pageNumberInBook: '223'
        },
        {
          code: '2251 C',
          name: null,
          rgb: {
            r: 0,
            g: 173,
            b: 111
          },
          hex: '00AD6F',
          positionInBook: 1557,
          pageNumberInBook: '223'
        },
        {
          code: '2252 C',
          name: null,
          rgb: {
            r: 0,
            g: 167,
            b: 74
          },
          hex: '00A74A',
          positionInBook: 1558,
          pageNumberInBook: '223'
        },
        {
          code: '2412 C',
          name: null,
          rgb: {
            r: 72,
            g: 213,
            b: 151
          },
          hex: '48D597',
          positionInBook: 1559,
          pageNumberInBook: '224'
        },
        {
          code: '2413 C',
          name: null,
          rgb: {
            r: 52,
            g: 183,
            b: 143
          },
          hex: '34B78F',
          positionInBook: 1560,
          pageNumberInBook: '224'
        },
        {
          code: '2414 C',
          name: null,
          rgb: {
            r: 0,
            g: 187,
            b: 126
          },
          hex: '00BB7E',
          positionInBook: 1561,
          pageNumberInBook: '224'
        },
        {
          code: '2416 C',
          name: null,
          rgb: {
            r: 0,
            g: 177,
            b: 118
          },
          hex: '00B176',
          positionInBook: 1562,
          pageNumberInBook: '224'
        },
        {
          code: '2417 C',
          name: null,
          rgb: {
            r: 36,
            g: 158,
            b: 107
          },
          hex: '249E6B',
          positionInBook: 1563,
          pageNumberInBook: '224'
        },
        {
          code: '2418 C',
          name: null,
          rgb: {
            r: 0,
            g: 135,
            b: 62
          },
          hex: '00873E',
          positionInBook: 1564,
          pageNumberInBook: '224'
        },
        {
          code: '2419 C',
          name: null,
          rgb: {
            r: 0,
            g: 124,
            b: 88
          },
          hex: '007C58',
          positionInBook: 1565,
          pageNumberInBook: '224'
        },
        {
          code: '344 C',
          name: null,
          rgb: {
            r: 160,
            g: 218,
            b: 179
          },
          hex: 'A0DAB3',
          positionInBook: 1566,
          pageNumberInBook: '225'
        },
        {
          code: '345 C',
          name: null,
          rgb: {
            r: 145,
            g: 214,
            b: 172
          },
          hex: '91D6AC',
          positionInBook: 1567,
          pageNumberInBook: '225'
        },
        {
          code: '346 C',
          name: null,
          rgb: {
            r: 113,
            g: 204,
            b: 152
          },
          hex: '71CC98',
          positionInBook: 1568,
          pageNumberInBook: '225'
        },
        {
          code: '347 C',
          name: null,
          rgb: {
            r: 0,
            g: 154,
            b: 68
          },
          hex: '009A44',
          positionInBook: 1569,
          pageNumberInBook: '225'
        },
        {
          code: '348 C',
          name: null,
          rgb: {
            r: 0,
            g: 132,
            b: 61
          },
          hex: '00843D',
          positionInBook: 1570,
          pageNumberInBook: '225'
        },
        {
          code: '349 C',
          name: null,
          rgb: {
            r: 4,
            g: 106,
            b: 56
          },
          hex: '046A38',
          positionInBook: 1571,
          pageNumberInBook: '225'
        },
        {
          code: '350 C',
          name: null,
          rgb: {
            r: 44,
            g: 82,
            b: 52
          },
          hex: '2C5234',
          positionInBook: 1572,
          pageNumberInBook: '225'
        },
        {
          code: '351 C',
          name: null,
          rgb: {
            r: 162,
            g: 228,
            b: 184
          },
          hex: 'A2E4B8',
          positionInBook: 1573,
          pageNumberInBook: '226'
        },
        {
          code: '352 C',
          name: null,
          rgb: {
            r: 143,
            g: 226,
            b: 176
          },
          hex: '8FE2B0',
          positionInBook: 1574,
          pageNumberInBook: '226'
        },
        {
          code: '353 C',
          name: null,
          rgb: {
            r: 128,
            g: 224,
            b: 167
          },
          hex: '80E0A7',
          positionInBook: 1575,
          pageNumberInBook: '226'
        },
        {
          code: '354 C',
          name: null,
          rgb: {
            r: 0,
            g: 177,
            b: 64
          },
          hex: '00B140',
          positionInBook: 1576,
          pageNumberInBook: '226'
        },
        {
          code: '355 C',
          name: null,
          rgb: {
            r: 0,
            g: 151,
            b: 57
          },
          hex: '009739',
          positionInBook: 1577,
          pageNumberInBook: '226'
        },
        {
          code: '356 C',
          name: null,
          rgb: {
            r: 0,
            g: 122,
            b: 51
          },
          hex: '007A33',
          positionInBook: 1578,
          pageNumberInBook: '226'
        },
        {
          code: '357 C',
          name: null,
          rgb: {
            r: 33,
            g: 87,
            b: 50
          },
          hex: '215732',
          positionInBook: 1579,
          pageNumberInBook: '226'
        },
        {
          code: '7478 C',
          name: null,
          rgb: {
            r: 155,
            g: 227,
            b: 191
          },
          hex: '9BE3BF',
          positionInBook: 1580,
          pageNumberInBook: '227'
        },
        {
          code: '7479 C',
          name: null,
          rgb: {
            r: 38,
            g: 208,
            b: 124
          },
          hex: '26D07C',
          positionInBook: 1581,
          pageNumberInBook: '227'
        },
        {
          code: '7480 C',
          name: null,
          rgb: {
            r: 0,
            g: 191,
            b: 111
          },
          hex: '00BF6F',
          positionInBook: 1582,
          pageNumberInBook: '227'
        },
        {
          code: '7481 C',
          name: null,
          rgb: {
            r: 0,
            g: 183,
            b: 79
          },
          hex: '00B74F',
          positionInBook: 1583,
          pageNumberInBook: '227'
        },
        {
          code: '7482 C',
          name: null,
          rgb: {
            r: 0,
            g: 159,
            b: 77
          },
          hex: '009F4D',
          positionInBook: 1584,
          pageNumberInBook: '227'
        },
        {
          code: '7483 C',
          name: null,
          rgb: {
            r: 39,
            g: 93,
            b: 56
          },
          hex: '275D38',
          positionInBook: 1585,
          pageNumberInBook: '227'
        },
        {
          code: '7484 C',
          name: null,
          rgb: {
            r: 0,
            g: 87,
            b: 63
          },
          hex: '00573F',
          positionInBook: 1586,
          pageNumberInBook: '227'
        },
        {
          code: '2253 C',
          name: null,
          rgb: {
            r: 189,
            g: 233,
            b: 201
          },
          hex: 'BDE9C9',
          positionInBook: 1587,
          pageNumberInBook: '228'
        },
        {
          code: '2254 C',
          name: null,
          rgb: {
            r: 173,
            g: 223,
            b: 179
          },
          hex: 'ADDFB3',
          positionInBook: 1588,
          pageNumberInBook: '228'
        },
        {
          code: '2255 C',
          name: null,
          rgb: {
            r: 134,
            g: 210,
            b: 149
          },
          hex: '86D295',
          positionInBook: 1589,
          pageNumberInBook: '228'
        },
        {
          code: '2256 C',
          name: null,
          rgb: {
            r: 86,
            g: 194,
            b: 113
          },
          hex: '56C271',
          positionInBook: 1590,
          pageNumberInBook: '228'
        },
        {
          code: '2257 C',
          name: null,
          rgb: {
            r: 0,
            g: 173,
            b: 80
          },
          hex: '00AD50',
          positionInBook: 1591,
          pageNumberInBook: '228'
        },
        {
          code: '2258 C',
          name: null,
          rgb: {
            r: 0,
            g: 133,
            b: 34
          },
          hex: '008522',
          positionInBook: 1592,
          pageNumberInBook: '228'
        },
        {
          code: '2259 C',
          name: null,
          rgb: {
            r: 2,
            g: 114,
            b: 35
          },
          hex: '027223',
          positionInBook: 1593,
          pageNumberInBook: '228'
        },
        {
          code: '2464 C',
          name: null,
          rgb: {
            r: 121,
            g: 190,
            b: 112
          },
          hex: '79BE70',
          positionInBook: 1594,
          pageNumberInBook: '229'
        },
        {
          code: '2465 C',
          name: null,
          rgb: {
            r: 30,
            g: 111,
            b: 48
          },
          hex: '1E6F30',
          positionInBook: 1595,
          pageNumberInBook: '229'
        },
        {
          code: '3522 C',
          name: null,
          rgb: {
            r: 0,
            g: 137,
            b: 47
          },
          hex: '00892F',
          positionInBook: 1596,
          pageNumberInBook: '229'
        },
        {
          code: '3536 C',
          name: null,
          rgb: {
            r: 0,
            g: 119,
            b: 55
          },
          hex: '007737',
          positionInBook: 1597,
          pageNumberInBook: '229'
        },
        {
          code: '3500 C',
          name: null,
          rgb: {
            r: 0,
            g: 110,
            b: 51
          },
          hex: '006E33',
          positionInBook: 1598,
          pageNumberInBook: '229'
        },
        {
          code: '3537 C',
          name: null,
          rgb: {
            r: 0,
            g: 73,
            b: 30
          },
          hex: '00491E',
          positionInBook: 1599,
          pageNumberInBook: '229'
        },
        {
          code: '2466 C',
          name: null,
          rgb: {
            r: 42,
            g: 81,
            b: 77
          },
          hex: '2A514D',
          positionInBook: 1600,
          pageNumberInBook: '229'
        },
        {
          code: '7730 C',
          name: null,
          rgb: {
            r: 75,
            g: 149,
            b: 96
          },
          hex: '4B9560',
          positionInBook: 1601,
          pageNumberInBook: '230'
        },
        {
          code: '7731 C',
          name: null,
          rgb: {
            r: 34,
            g: 136,
            b: 72
          },
          hex: '228848',
          positionInBook: 1602,
          pageNumberInBook: '230'
        },
        {
          code: '7732 C',
          name: null,
          rgb: {
            r: 0,
            g: 122,
            b: 62
          },
          hex: '007A3E',
          positionInBook: 1603,
          pageNumberInBook: '230'
        },
        {
          code: '7733 C',
          name: null,
          rgb: {
            r: 0,
            g: 112,
            b: 65
          },
          hex: '007041',
          positionInBook: 1604,
          pageNumberInBook: '230'
        },
        {
          code: '7734 C',
          name: null,
          rgb: {
            r: 40,
            g: 97,
            b: 64
          },
          hex: '286140',
          positionInBook: 1605,
          pageNumberInBook: '230'
        },
        {
          code: '7735 C',
          name: null,
          rgb: {
            r: 54,
            g: 87,
            b: 59
          },
          hex: '36573B',
          positionInBook: 1606,
          pageNumberInBook: '230'
        },
        {
          code: '7736 C',
          name: null,
          rgb: {
            r: 56,
            g: 85,
            b: 66
          },
          hex: '385542',
          positionInBook: 1607,
          pageNumberInBook: '230'
        },
        {
          code: '7737 C',
          name: null,
          rgb: {
            r: 107,
            g: 165,
            b: 57
          },
          hex: '6BA539',
          positionInBook: 1608,
          pageNumberInBook: '231'
        },
        {
          code: '7738 C',
          name: null,
          rgb: {
            r: 71,
            g: 162,
            b: 63
          },
          hex: '47A23F',
          positionInBook: 1609,
          pageNumberInBook: '231'
        },
        {
          code: '7739 C',
          name: null,
          rgb: {
            r: 48,
            g: 155,
            b: 66
          },
          hex: '309B42',
          positionInBook: 1610,
          pageNumberInBook: '231'
        },
        {
          code: '7740 C',
          name: null,
          rgb: {
            r: 58,
            g: 145,
            b: 63
          },
          hex: '3A913F',
          positionInBook: 1611,
          pageNumberInBook: '231'
        },
        {
          code: '7741 C',
          name: null,
          rgb: {
            r: 68,
            g: 136,
            b: 62
          },
          hex: '44883E',
          positionInBook: 1612,
          pageNumberInBook: '231'
        },
        {
          code: '7742 C',
          name: null,
          rgb: {
            r: 74,
            g: 120,
            b: 60
          },
          hex: '4A783C',
          positionInBook: 1613,
          pageNumberInBook: '231'
        },
        {
          code: '7743 C',
          name: null,
          rgb: {
            r: 68,
            g: 105,
            b: 61
          },
          hex: '44693D',
          positionInBook: 1614,
          pageNumberInBook: '231'
        },
        {
          code: '4204 C',
          name: null,
          rgb: {
            r: 193,
            g: 209,
            b: 166
          },
          hex: 'C1D1A6',
          positionInBook: 1615,
          pageNumberInBook: '232'
        },
        {
          code: '4205 C',
          name: null,
          rgb: {
            r: 167,
            g: 193,
            b: 134
          },
          hex: 'A7C186',
          positionInBook: 1616,
          pageNumberInBook: '232'
        },
        {
          code: '4206 C',
          name: null,
          rgb: {
            r: 141,
            g: 174,
            b: 129
          },
          hex: '8DAE81',
          positionInBook: 1617,
          pageNumberInBook: '232'
        },
        {
          code: '4207 C',
          name: null,
          rgb: {
            r: 125,
            g: 161,
            b: 119
          },
          hex: '7DA177',
          positionInBook: 1618,
          pageNumberInBook: '232'
        },
        {
          code: '4208 C',
          name: null,
          rgb: {
            r: 62,
            g: 112,
            b: 84
          },
          hex: '3E7054',
          positionInBook: 1619,
          pageNumberInBook: '232'
        },
        {
          code: '4209 C',
          name: null,
          rgb: {
            r: 56,
            g: 88,
            b: 75
          },
          hex: '38584B',
          positionInBook: 1620,
          pageNumberInBook: '232'
        },
        {
          code: '4210 C',
          name: null,
          rgb: {
            r: 48,
            g: 79,
            b: 66
          },
          hex: '304F42',
          positionInBook: 1621,
          pageNumberInBook: '232'
        },
        {
          code: '2260 C',
          name: null,
          rgb: {
            r: 182,
            g: 207,
            b: 174
          },
          hex: 'B6CFAE',
          positionInBook: 1622,
          pageNumberInBook: '233'
        },
        {
          code: '2261 C',
          name: null,
          rgb: {
            r: 154,
            g: 187,
            b: 145
          },
          hex: '9ABB91',
          positionInBook: 1623,
          pageNumberInBook: '233'
        },
        {
          code: '2262 C',
          name: null,
          rgb: {
            r: 140,
            g: 172,
            b: 137
          },
          hex: '8CAC89',
          positionInBook: 1624,
          pageNumberInBook: '233'
        },
        {
          code: '2263 C',
          name: null,
          rgb: {
            r: 116,
            g: 149,
            b: 108
          },
          hex: '74956C',
          positionInBook: 1625,
          pageNumberInBook: '233'
        },
        {
          code: '2264 C',
          name: null,
          rgb: {
            r: 107,
            g: 149,
            b: 96
          },
          hex: '6B9560',
          positionInBook: 1626,
          pageNumberInBook: '233'
        },
        {
          code: '2265 C',
          name: null,
          rgb: {
            r: 92,
            g: 126,
            b: 81
          },
          hex: '5C7E51',
          positionInBook: 1627,
          pageNumberInBook: '233'
        },
        {
          code: '2266 C',
          name: null,
          rgb: {
            r: 51,
            g: 85,
            b: 37
          },
          hex: '335525',
          positionInBook: 1628,
          pageNumberInBook: '233'
        },
        {
          code: '358 C',
          name: null,
          rgb: {
            r: 173,
            g: 220,
            b: 145
          },
          hex: 'ADDC91',
          positionInBook: 1629,
          pageNumberInBook: '234'
        },
        {
          code: '359 C',
          name: null,
          rgb: {
            r: 161,
            g: 216,
            b: 132
          },
          hex: 'A1D884',
          positionInBook: 1630,
          pageNumberInBook: '234'
        },
        {
          code: '360 C',
          name: null,
          rgb: {
            r: 108,
            g: 194,
            b: 74
          },
          hex: '6CC24A',
          positionInBook: 1631,
          pageNumberInBook: '234'
        },
        {
          code: '361 C',
          name: null,
          rgb: {
            r: 67,
            g: 176,
            b: 42
          },
          hex: '43B02A',
          positionInBook: 1632,
          pageNumberInBook: '234'
        },
        {
          code: '362 C',
          name: null,
          rgb: {
            r: 80,
            g: 158,
            b: 47
          },
          hex: '509E2F',
          positionInBook: 1633,
          pageNumberInBook: '234'
        },
        {
          code: '363 C',
          name: null,
          rgb: {
            r: 76,
            g: 141,
            b: 43
          },
          hex: '4C8D2B',
          positionInBook: 1634,
          pageNumberInBook: '234'
        },
        {
          code: '364 C',
          name: null,
          rgb: {
            r: 74,
            g: 119,
            b: 41
          },
          hex: '4A7729',
          positionInBook: 1635,
          pageNumberInBook: '234'
        },
        {
          code: '2267 C',
          name: null,
          rgb: {
            r: 155,
            g: 225,
            b: 152
          },
          hex: '9BE198',
          positionInBook: 1636,
          pageNumberInBook: '235'
        },
        {
          code: '2268 C',
          name: null,
          rgb: {
            r: 121,
            g: 217,
            b: 124
          },
          hex: '79D97C',
          positionInBook: 1637,
          pageNumberInBook: '235'
        },
        {
          code: '2269 C',
          name: null,
          rgb: {
            r: 124,
            g: 204,
            b: 108
          },
          hex: '7CCC6C',
          positionInBook: 1638,
          pageNumberInBook: '235'
        },
        {
          code: '2270 C',
          name: null,
          rgb: {
            r: 44,
            g: 200,
            b: 77
          },
          hex: '2CC84D',
          positionInBook: 1639,
          pageNumberInBook: '235'
        },
        {
          code: '2271 C',
          name: null,
          rgb: {
            r: 0,
            g: 187,
            b: 49
          },
          hex: '00BB31',
          positionInBook: 1640,
          pageNumberInBook: '235'
        },
        {
          code: '2272 C',
          name: null,
          rgb: {
            r: 0,
            g: 154,
            b: 23
          },
          hex: '009A17',
          positionInBook: 1641,
          pageNumberInBook: '235'
        },
        {
          code: '2273 C',
          name: null,
          rgb: {
            r: 37,
            g: 114,
            b: 38
          },
          hex: '257226',
          positionInBook: 1642,
          pageNumberInBook: '235'
        },
        {
          code: '2420 C',
          name: null,
          rgb: {
            r: 0,
            g: 198,
            b: 94
          },
          hex: '00C65E',
          positionInBook: 1643,
          pageNumberInBook: '236'
        },
        {
          code: '2421 C',
          name: null,
          rgb: {
            r: 48,
            g: 183,
            b: 0
          },
          hex: '30B700',
          positionInBook: 1644,
          pageNumberInBook: '236'
        },
        {
          code: '2422 C',
          name: null,
          rgb: {
            r: 0,
            g: 168,
            b: 45
          },
          hex: '00A82D',
          positionInBook: 1645,
          pageNumberInBook: '236'
        },
        {
          code: '2423 C',
          name: null,
          rgb: {
            r: 0,
            g: 170,
            b: 19
          },
          hex: '00AA13',
          positionInBook: 1646,
          pageNumberInBook: '236'
        },
        {
          code: '2424 C',
          name: null,
          rgb: {
            r: 39,
            g: 159,
            b: 0
          },
          hex: '279F00',
          positionInBook: 1647,
          pageNumberInBook: '236'
        },
        {
          code: '2426 C',
          name: null,
          rgb: {
            r: 0,
            g: 140,
            b: 21
          },
          hex: '008C15',
          positionInBook: 1648,
          pageNumberInBook: '236'
        },
        {
          code: '2427 C',
          name: null,
          rgb: {
            r: 2,
            g: 95,
            b: 29
          },
          hex: '025F1D',
          positionInBook: 1649,
          pageNumberInBook: '236'
        },
        {
          code: '7485 C',
          name: null,
          rgb: {
            r: 208,
            g: 222,
            b: 187
          },
          hex: 'D0DEBB',
          positionInBook: 1650,
          pageNumberInBook: '237'
        },
        {
          code: '7486 C',
          name: null,
          rgb: {
            r: 188,
            g: 225,
            b: 148
          },
          hex: 'BCE194',
          positionInBook: 1651,
          pageNumberInBook: '237'
        },
        {
          code: '7487 C',
          name: null,
          rgb: {
            r: 142,
            g: 221,
            b: 101
          },
          hex: '8EDD65',
          positionInBook: 1652,
          pageNumberInBook: '237'
        },
        {
          code: '7488 C',
          name: null,
          rgb: {
            r: 120,
            g: 214,
            b: 75
          },
          hex: '78D64B',
          positionInBook: 1653,
          pageNumberInBook: '237'
        },
        {
          code: '7489 C',
          name: null,
          rgb: {
            r: 116,
            g: 170,
            b: 80
          },
          hex: '74AA50',
          positionInBook: 1654,
          pageNumberInBook: '237'
        },
        {
          code: '7490 C',
          name: null,
          rgb: {
            r: 113,
            g: 153,
            b: 73
          },
          hex: '719949',
          positionInBook: 1655,
          pageNumberInBook: '237'
        },
        {
          code: '7491 C',
          name: null,
          rgb: {
            r: 121,
            g: 134,
            b: 60
          },
          hex: '79863C',
          positionInBook: 1656,
          pageNumberInBook: '237'
        },
        {
          code: '2274 C',
          name: null,
          rgb: {
            r: 207,
            g: 220,
            b: 177
          },
          hex: 'CFDCB1',
          positionInBook: 1657,
          pageNumberInBook: '238'
        },
        {
          code: '2275 C',
          name: null,
          rgb: {
            r: 195,
            g: 220,
            b: 147
          },
          hex: 'C3DC93',
          positionInBook: 1658,
          pageNumberInBook: '238'
        },
        {
          code: '2276 C',
          name: null,
          rgb: {
            r: 137,
            g: 168,
            b: 79
          },
          hex: '89A84F',
          positionInBook: 1659,
          pageNumberInBook: '238'
        },
        {
          code: '2277 C',
          name: null,
          rgb: {
            r: 85,
            g: 149,
            b: 27
          },
          hex: '55951B',
          positionInBook: 1660,
          pageNumberInBook: '238'
        },
        {
          code: '2278 C',
          name: null,
          rgb: {
            r: 78,
            g: 128,
            b: 31
          },
          hex: '4E801F',
          positionInBook: 1661,
          pageNumberInBook: '238'
        },
        {
          code: '2279 C',
          name: null,
          rgb: {
            r: 94,
            g: 126,
            b: 41
          },
          hex: '5E7E29',
          positionInBook: 1662,
          pageNumberInBook: '238'
        },
        {
          code: '2280 C',
          name: null,
          rgb: {
            r: 74,
            g: 106,
            b: 29
          },
          hex: '4A6A1D',
          positionInBook: 1663,
          pageNumberInBook: '238'
        },
        {
          code: '365 C',
          name: null,
          rgb: {
            r: 194,
            g: 225,
            b: 137
          },
          hex: 'C2E189',
          positionInBook: 1664,
          pageNumberInBook: '239'
        },
        {
          code: '366 C',
          name: null,
          rgb: {
            r: 183,
            g: 221,
            b: 121
          },
          hex: 'B7DD79',
          positionInBook: 1665,
          pageNumberInBook: '239'
        },
        {
          code: '367 C',
          name: null,
          rgb: {
            r: 164,
            g: 214,
            b: 94
          },
          hex: 'A4D65E',
          positionInBook: 1666,
          pageNumberInBook: '239'
        },
        {
          code: '368 C',
          name: null,
          rgb: {
            r: 120,
            g: 190,
            b: 33
          },
          hex: '78BE21',
          positionInBook: 1667,
          pageNumberInBook: '239'
        },
        {
          code: '369 C',
          name: null,
          rgb: {
            r: 100,
            g: 167,
            b: 11
          },
          hex: '64A70B',
          positionInBook: 1668,
          pageNumberInBook: '239'
        },
        {
          code: '370 C',
          name: null,
          rgb: {
            r: 101,
            g: 141,
            b: 27
          },
          hex: '658D1B',
          positionInBook: 1669,
          pageNumberInBook: '239'
        },
        {
          code: '371 C',
          name: null,
          rgb: {
            r: 84,
            g: 98,
            b: 35
          },
          hex: '546223',
          positionInBook: 1670,
          pageNumberInBook: '239'
        },
        {
          code: '3570 C',
          name: null,
          rgb: {
            r: 177,
            g: 214,
            b: 0
          },
          hex: 'B1D600',
          positionInBook: 1671,
          pageNumberInBook: '240'
        },
        {
          code: '3507 C',
          name: null,
          rgb: {
            r: 174,
            g: 208,
            b: 0
          },
          hex: 'AED000',
          positionInBook: 1672,
          pageNumberInBook: '240'
        },
        {
          code: '3561 C',
          name: null,
          rgb: {
            r: 121,
            g: 195,
            b: 0
          },
          hex: '79C300',
          positionInBook: 1673,
          pageNumberInBook: '240'
        },
        {
          code: '3501 C',
          name: null,
          rgb: {
            r: 76,
            g: 174,
            b: 4
          },
          hex: '4CAE04',
          positionInBook: 1674,
          pageNumberInBook: '240'
        },
        {
          code: '3529 C',
          name: null,
          rgb: {
            r: 31,
            g: 168,
            b: 36
          },
          hex: '1FA824',
          positionInBook: 1675,
          pageNumberInBook: '240'
        },
        {
          code: '3539 C',
          name: null,
          rgb: {
            r: 62,
            g: 154,
            b: 44
          },
          hex: '3E9A2C',
          positionInBook: 1676,
          pageNumberInBook: '240'
        },
        {
          code: '3508 C',
          name: null,
          rgb: {
            r: 94,
            g: 121,
            b: 48
          },
          hex: '5E7930',
          positionInBook: 1677,
          pageNumberInBook: '240'
        },
        {
          code: '2281 C',
          name: null,
          rgb: {
            r: 217,
            g: 234,
            b: 154
          },
          hex: 'D9EA9A',
          positionInBook: 1678,
          pageNumberInBook: '241'
        },
        {
          code: '2282 C',
          name: null,
          rgb: {
            r: 199,
            g: 233,
            b: 149
          },
          hex: 'C7E995',
          positionInBook: 1679,
          pageNumberInBook: '241'
        },
        {
          code: '2283 C',
          name: null,
          rgb: {
            r: 167,
            g: 225,
            b: 99
          },
          hex: 'A7E163',
          positionInBook: 1680,
          pageNumberInBook: '241'
        },
        {
          code: '2284 C',
          name: null,
          rgb: {
            r: 179,
            g: 213,
            b: 124
          },
          hex: 'B3D57C',
          positionInBook: 1681,
          pageNumberInBook: '241'
        },
        {
          code: '2285 C',
          name: null,
          rgb: {
            r: 147,
            g: 218,
            b: 73
          },
          hex: '93DA49',
          positionInBook: 1682,
          pageNumberInBook: '241'
        },
        {
          code: '2286 C',
          name: null,
          rgb: {
            r: 122,
            g: 204,
            b: 0
          },
          hex: '7ACC00',
          positionInBook: 1683,
          pageNumberInBook: '241'
        },
        {
          code: '2287 C',
          name: null,
          rgb: {
            r: 91,
            g: 197,
            b: 0
          },
          hex: '5BC500',
          positionInBook: 1684,
          pageNumberInBook: '241'
        },
        {
          code: '372 C',
          name: null,
          rgb: {
            r: 212,
            g: 236,
            b: 142
          },
          hex: 'D4EC8E',
          positionInBook: 1685,
          pageNumberInBook: '242'
        },
        {
          code: '373 C',
          name: null,
          rgb: {
            r: 205,
            g: 234,
            b: 128
          },
          hex: 'CDEA80',
          positionInBook: 1686,
          pageNumberInBook: '242'
        },
        {
          code: '374 C',
          name: null,
          rgb: {
            r: 197,
            g: 232,
            b: 108
          },
          hex: 'C5E86C',
          positionInBook: 1687,
          pageNumberInBook: '242'
        },
        {
          code: '375 C',
          name: null,
          rgb: {
            r: 151,
            g: 215,
            b: 0
          },
          hex: '97D700',
          positionInBook: 1688,
          pageNumberInBook: '242'
        },
        {
          code: '376 C',
          name: null,
          rgb: {
            r: 132,
            g: 189,
            b: 0
          },
          hex: '84BD00',
          positionInBook: 1689,
          pageNumberInBook: '242'
        },
        {
          code: '377 C',
          name: null,
          rgb: {
            r: 122,
            g: 154,
            b: 1
          },
          hex: '7A9A01',
          positionInBook: 1690,
          pageNumberInBook: '242'
        },
        {
          code: '378 C',
          name: null,
          rgb: {
            r: 89,
            g: 98,
            b: 29
          },
          hex: '59621D',
          positionInBook: 1691,
          pageNumberInBook: '242'
        },
        {
          code: '2288 C',
          name: null,
          rgb: {
            r: 200,
            g: 227,
            b: 121
          },
          hex: 'C8E379',
          positionInBook: 1692,
          pageNumberInBook: '243'
        },
        {
          code: '2289 C',
          name: null,
          rgb: {
            r: 197,
            g: 217,
            b: 122
          },
          hex: 'C5D97A',
          positionInBook: 1693,
          pageNumberInBook: '243'
        },
        {
          code: '2290 C',
          name: null,
          rgb: {
            r: 170,
            g: 219,
            b: 30
          },
          hex: 'AADB1E',
          positionInBook: 1694,
          pageNumberInBook: '243'
        },
        {
          code: '2291 C',
          name: null,
          rgb: {
            r: 167,
            g: 213,
            b: 0
          },
          hex: 'A7D500',
          positionInBook: 1695,
          pageNumberInBook: '243'
        },
        {
          code: '2292 C',
          name: null,
          rgb: {
            r: 147,
            g: 201,
            b: 15
          },
          hex: '93C90F',
          positionInBook: 1696,
          pageNumberInBook: '243'
        },
        {
          code: '2293 C',
          name: null,
          rgb: {
            r: 139,
            g: 196,
            b: 0
          },
          hex: '8BC400',
          positionInBook: 1697,
          pageNumberInBook: '243'
        },
        {
          code: '2294 C',
          name: null,
          rgb: {
            r: 120,
            g: 170,
            b: 0
          },
          hex: '78AA00',
          positionInBook: 1698,
          pageNumberInBook: '243'
        },
        {
          code: '2295 C',
          name: null,
          rgb: {
            r: 224,
            g: 236,
            b: 137
          },
          hex: 'E0EC89',
          positionInBook: 1699,
          pageNumberInBook: '244'
        },
        {
          code: '2296 C',
          name: null,
          rgb: {
            r: 214,
            g: 232,
            b: 101
          },
          hex: 'D6E865',
          positionInBook: 1700,
          pageNumberInBook: '244'
        },
        {
          code: '2297 C',
          name: null,
          rgb: {
            r: 192,
            g: 223,
            b: 22
          },
          hex: 'C0DF16',
          positionInBook: 1701,
          pageNumberInBook: '244'
        },
        {
          code: '2298 C',
          name: null,
          rgb: {
            r: 183,
            g: 219,
            b: 87
          },
          hex: 'B7DB57',
          positionInBook: 1702,
          pageNumberInBook: '244'
        },
        {
          code: '2299 C',
          name: null,
          rgb: {
            r: 164,
            g: 210,
            b: 51
          },
          hex: 'A4D233',
          positionInBook: 1703,
          pageNumberInBook: '244'
        },
        {
          code: '2300 C',
          name: null,
          rgb: {
            r: 169,
            g: 194,
            b: 63
          },
          hex: 'A9C23F',
          positionInBook: 1704,
          pageNumberInBook: '244'
        },
        {
          code: '2301 C',
          name: null,
          rgb: {
            r: 143,
            g: 173,
            b: 21
          },
          hex: '8FAD15',
          positionInBook: 1705,
          pageNumberInBook: '244'
        },
        {
          code: '580 C',
          name: null,
          rgb: {
            r: 196,
            g: 214,
            b: 164
          },
          hex: 'C4D6A4',
          positionInBook: 1706,
          pageNumberInBook: '245'
        },
        {
          code: '579 C',
          name: null,
          rgb: {
            r: 188,
            g: 209,
            b: 155
          },
          hex: 'BCD19B',
          positionInBook: 1707,
          pageNumberInBook: '245'
        },
        {
          code: '578 C',
          name: null,
          rgb: {
            r: 183,
            g: 206,
            b: 149
          },
          hex: 'B7CE95',
          positionInBook: 1708,
          pageNumberInBook: '245'
        },
        {
          code: '577 C',
          name: null,
          rgb: {
            r: 169,
            g: 196,
            b: 127
          },
          hex: 'A9C47F',
          positionInBook: 1709,
          pageNumberInBook: '245'
        },
        {
          code: '576 C',
          name: null,
          rgb: {
            r: 120,
            g: 157,
            b: 74
          },
          hex: '789D4A',
          positionInBook: 1710,
          pageNumberInBook: '245'
        },
        {
          code: '575 C',
          name: null,
          rgb: {
            r: 103,
            g: 130,
            b: 58
          },
          hex: '67823A',
          positionInBook: 1711,
          pageNumberInBook: '245'
        },
        {
          code: '574 C',
          name: null,
          rgb: {
            r: 78,
            g: 91,
            b: 49
          },
          hex: '4E5B31',
          positionInBook: 1712,
          pageNumberInBook: '245'
        },
        {
          code: '4211 C',
          name: null,
          rgb: {
            r: 207,
            g: 217,
            b: 147
          },
          hex: 'CFD993',
          positionInBook: 1713,
          pageNumberInBook: '246'
        },
        {
          code: '4212 C',
          name: null,
          rgb: {
            r: 134,
            g: 173,
            b: 63
          },
          hex: '86AD3F',
          positionInBook: 1714,
          pageNumberInBook: '246'
        },
        {
          code: '4213 C',
          name: null,
          rgb: {
            r: 106,
            g: 144,
            b: 51
          },
          hex: '6A9033',
          positionInBook: 1715,
          pageNumberInBook: '246'
        },
        {
          code: '4214 C',
          name: null,
          rgb: {
            r: 91,
            g: 121,
            b: 84
          },
          hex: '5B7954',
          positionInBook: 1716,
          pageNumberInBook: '246'
        },
        {
          code: '4215 C',
          name: null,
          rgb: {
            r: 82,
            g: 110,
            b: 62
          },
          hex: '526E3E',
          positionInBook: 1717,
          pageNumberInBook: '246'
        },
        {
          code: '4216 C',
          name: null,
          rgb: {
            r: 62,
            g: 88,
            b: 36
          },
          hex: '3E5824',
          positionInBook: 1718,
          pageNumberInBook: '246'
        },
        {
          code: '4217 C',
          name: null,
          rgb: {
            r: 75,
            g: 94,
            b: 35
          },
          hex: '4B5E23',
          positionInBook: 1719,
          pageNumberInBook: '246'
        },
        {
          code: '5807 C',
          name: null,
          rgb: {
            r: 208,
            g: 209,
            b: 171
          },
          hex: 'D0D1AB',
          positionInBook: 1720,
          pageNumberInBook: '247'
        },
        {
          code: '5797 C',
          name: null,
          rgb: {
            r: 198,
            g: 200,
            b: 155
          },
          hex: 'C6C89B',
          positionInBook: 1721,
          pageNumberInBook: '247'
        },
        {
          code: '5787 C',
          name: null,
          rgb: {
            r: 186,
            g: 189,
            b: 139
          },
          hex: 'BABD8B',
          positionInBook: 1722,
          pageNumberInBook: '247'
        },
        {
          code: '5777 C',
          name: null,
          rgb: {
            r: 162,
            g: 165,
            b: 104
          },
          hex: 'A2A568',
          positionInBook: 1723,
          pageNumberInBook: '247'
        },
        {
          code: '5767 C',
          name: null,
          rgb: {
            r: 138,
            g: 141,
            b: 74
          },
          hex: '8A8D4A',
          positionInBook: 1724,
          pageNumberInBook: '247'
        },
        {
          code: '5757 C',
          name: null,
          rgb: {
            r: 109,
            g: 113,
            b: 46
          },
          hex: '6D712E',
          positionInBook: 1725,
          pageNumberInBook: '247'
        },
        {
          code: '5747 C',
          name: null,
          rgb: {
            r: 61,
            g: 68,
            b: 30
          },
          hex: '3D441E',
          positionInBook: 1726,
          pageNumberInBook: '247'
        },
        {
          code: '5875 C',
          name: null,
          rgb: {
            r: 210,
            g: 206,
            b: 158
          },
          hex: 'D2CE9E',
          positionInBook: 1727,
          pageNumberInBook: '248'
        },
        {
          code: '5865 C',
          name: null,
          rgb: {
            r: 203,
            g: 199,
            b: 147
          },
          hex: 'CBC793',
          positionInBook: 1728,
          pageNumberInBook: '248'
        },
        {
          code: '5855 C',
          name: null,
          rgb: {
            r: 192,
            g: 187,
            b: 135
          },
          hex: 'C0BB87',
          positionInBook: 1729,
          pageNumberInBook: '248'
        },
        {
          code: '5845 C',
          name: null,
          rgb: {
            r: 175,
            g: 169,
            b: 110
          },
          hex: 'AFA96E',
          positionInBook: 1730,
          pageNumberInBook: '248'
        },
        {
          code: '5835 C',
          name: null,
          rgb: {
            r: 160,
            g: 153,
            b: 88
          },
          hex: 'A09958',
          positionInBook: 1731,
          pageNumberInBook: '248'
        },
        {
          code: '5825 C',
          name: null,
          rgb: {
            r: 137,
            g: 129,
            b: 61
          },
          hex: '89813D',
          positionInBook: 1732,
          pageNumberInBook: '248'
        },
        {
          code: '5815 C',
          name: null,
          rgb: {
            r: 85,
            g: 80,
            b: 37
          },
          hex: '555025',
          positionInBook: 1733,
          pageNumberInBook: '248'
        },
        {
          code: '4218 C',
          name: null,
          rgb: {
            r: 175,
            g: 181,
            b: 157
          },
          hex: 'AFB59D',
          positionInBook: 1734,
          pageNumberInBook: '249'
        },
        {
          code: '4219 C',
          name: null,
          rgb: {
            r: 164,
            g: 170,
            b: 150
          },
          hex: 'A4AA96',
          positionInBook: 1735,
          pageNumberInBook: '249'
        },
        {
          code: '4220 C',
          name: null,
          rgb: {
            r: 136,
            g: 138,
            b: 119
          },
          hex: '888A77',
          positionInBook: 1736,
          pageNumberInBook: '249'
        },
        {
          code: '4221 C',
          name: null,
          rgb: {
            r: 123,
            g: 125,
            b: 96
          },
          hex: '7B7D60',
          positionInBook: 1737,
          pageNumberInBook: '249'
        },
        {
          code: '4222 C',
          name: null,
          rgb: {
            r: 114,
            g: 117,
            b: 99
          },
          hex: '727563',
          positionInBook: 1738,
          pageNumberInBook: '249'
        },
        {
          code: '4223 C',
          name: null,
          rgb: {
            r: 98,
            g: 105,
            b: 81
          },
          hex: '626951',
          positionInBook: 1739,
          pageNumberInBook: '249'
        },
        {
          code: '4224 C',
          name: null,
          rgb: {
            r: 62,
            g: 73,
            b: 56
          },
          hex: '3E4938',
          positionInBook: 1740,
          pageNumberInBook: '249'
        },
        {
          code: '5803 C',
          name: null,
          rgb: {
            r: 195,
            g: 198,
            b: 168
          },
          hex: 'C3C6A8',
          positionInBook: 1741,
          pageNumberInBook: '250'
        },
        {
          code: '5793 C',
          name: null,
          rgb: {
            r: 179,
            g: 185,
            b: 149
          },
          hex: 'B3B995',
          positionInBook: 1742,
          pageNumberInBook: '250'
        },
        {
          code: '5783 C',
          name: null,
          rgb: {
            r: 163,
            g: 170,
            b: 131
          },
          hex: 'A3AA83',
          positionInBook: 1743,
          pageNumberInBook: '250'
        },
        {
          code: '5773 C',
          name: null,
          rgb: {
            r: 137,
            g: 144,
            b: 100
          },
          hex: '899064',
          positionInBook: 1744,
          pageNumberInBook: '250'
        },
        {
          code: '5763 C',
          name: null,
          rgb: {
            r: 115,
            g: 123,
            b: 76
          },
          hex: '737B4C',
          positionInBook: 1745,
          pageNumberInBook: '250'
        },
        {
          code: '5753 C',
          name: null,
          rgb: {
            r: 94,
            g: 103,
            b: 56
          },
          hex: '5E6738',
          positionInBook: 1746,
          pageNumberInBook: '250'
        },
        {
          code: '5743 C',
          name: null,
          rgb: {
            r: 62,
            g: 72,
            b: 39
          },
          hex: '3E4827',
          positionInBook: 1747,
          pageNumberInBook: '250'
        },
        {
          code: '4225 C',
          name: null,
          rgb: {
            r: 139,
            g: 131,
            b: 114
          },
          hex: '8B8372',
          positionInBook: 1748,
          pageNumberInBook: '251'
        },
        {
          code: '4226 C',
          name: null,
          rgb: {
            r: 134,
            g: 129,
            b: 101
          },
          hex: '868165',
          positionInBook: 1749,
          pageNumberInBook: '251'
        },
        {
          code: '4227 C',
          name: null,
          rgb: {
            r: 106,
            g: 104,
            b: 81
          },
          hex: '6A6851',
          positionInBook: 1750,
          pageNumberInBook: '251'
        },
        {
          code: '4228 C',
          name: null,
          rgb: {
            r: 89,
            g: 86,
            b: 62
          },
          hex: '59563E',
          positionInBook: 1751,
          pageNumberInBook: '251'
        },
        {
          code: '4229 C',
          name: null,
          rgb: {
            r: 91,
            g: 92,
            b: 74
          },
          hex: '5B5C4A',
          positionInBook: 1752,
          pageNumberInBook: '251'
        },
        {
          code: '4230 C',
          name: null,
          rgb: {
            r: 88,
            g: 83,
            b: 75
          },
          hex: '58534B',
          positionInBook: 1753,
          pageNumberInBook: '251'
        },
        {
          code: '4231 C',
          name: null,
          rgb: {
            r: 99,
            g: 92,
            b: 79
          },
          hex: '635C4F',
          positionInBook: 1754,
          pageNumberInBook: '251'
        },
        {
          code: '7492 C',
          name: null,
          rgb: {
            r: 191,
            g: 204,
            b: 128
          },
          hex: 'BFCC80',
          positionInBook: 1755,
          pageNumberInBook: '252'
        },
        {
          code: '7493 C',
          name: null,
          rgb: {
            r: 187,
            g: 197,
            b: 146
          },
          hex: 'BBC592',
          positionInBook: 1756,
          pageNumberInBook: '252'
        },
        {
          code: '7494 C',
          name: null,
          rgb: {
            r: 156,
            g: 175,
            b: 136
          },
          hex: '9CAF88',
          positionInBook: 1757,
          pageNumberInBook: '252'
        },
        {
          code: '7495 C',
          name: null,
          rgb: {
            r: 143,
            g: 153,
            b: 62
          },
          hex: '8F993E',
          positionInBook: 1758,
          pageNumberInBook: '252'
        },
        {
          code: '7496 C',
          name: null,
          rgb: {
            r: 118,
            g: 136,
            b: 29
          },
          hex: '76881D',
          positionInBook: 1759,
          pageNumberInBook: '252'
        },
        {
          code: '7497 C',
          name: null,
          rgb: {
            r: 122,
            g: 114,
            b: 86
          },
          hex: '7A7256',
          positionInBook: 1760,
          pageNumberInBook: '252'
        },
        {
          code: '7498 C',
          name: null,
          rgb: {
            r: 91,
            g: 98,
            b: 54
          },
          hex: '5B6236',
          positionInBook: 1761,
          pageNumberInBook: '252'
        },
        {
          code: '2302 C',
          name: null,
          rgb: {
            r: 174,
            g: 184,
            b: 98
          },
          hex: 'AEB862',
          positionInBook: 1762,
          pageNumberInBook: '253'
        },
        {
          code: '2303 C',
          name: null,
          rgb: {
            r: 158,
            g: 179,
            b: 86
          },
          hex: '9EB356',
          positionInBook: 1763,
          pageNumberInBook: '253'
        },
        {
          code: '2304 C',
          name: null,
          rgb: {
            r: 160,
            g: 171,
            b: 77
          },
          hex: 'A0AB4D',
          positionInBook: 1764,
          pageNumberInBook: '253'
        },
        {
          code: '2305 C',
          name: null,
          rgb: {
            r: 158,
            g: 167,
            b: 0
          },
          hex: '9EA700',
          positionInBook: 1765,
          pageNumberInBook: '253'
        },
        {
          code: '2306 C',
          name: null,
          rgb: {
            r: 128,
            g: 140,
            b: 36
          },
          hex: '808C24',
          positionInBook: 1766,
          pageNumberInBook: '253'
        },
        {
          code: '2307 C',
          name: null,
          rgb: {
            r: 104,
            g: 111,
            b: 18
          },
          hex: '686F12',
          positionInBook: 1767,
          pageNumberInBook: '253'
        },
        {
          code: '2308 C',
          name: null,
          rgb: {
            r: 93,
            g: 85,
            b: 29
          },
          hex: '5D551D',
          positionInBook: 1768,
          pageNumberInBook: '253'
        },
        {
          code: '7744 C',
          name: null,
          rgb: {
            r: 186,
            g: 188,
            b: 22
          },
          hex: 'BABC16',
          positionInBook: 1769,
          pageNumberInBook: '254'
        },
        {
          code: '7745 C',
          name: null,
          rgb: {
            r: 171,
            g: 173,
            b: 35
          },
          hex: 'ABAD23',
          positionInBook: 1770,
          pageNumberInBook: '254'
        },
        {
          code: '7746 C',
          name: null,
          rgb: {
            r: 153,
            g: 155,
            b: 48
          },
          hex: '999B30',
          positionInBook: 1771,
          pageNumberInBook: '254'
        },
        {
          code: '7747 C',
          name: null,
          rgb: {
            r: 136,
            g: 141,
            b: 48
          },
          hex: '888D30',
          positionInBook: 1772,
          pageNumberInBook: '254'
        },
        {
          code: '7748 C',
          name: null,
          rgb: {
            r: 124,
            g: 128,
            b: 52
          },
          hex: '7C8034',
          positionInBook: 1773,
          pageNumberInBook: '254'
        },
        {
          code: '7749 C',
          name: null,
          rgb: {
            r: 114,
            g: 115,
            b: 55
          },
          hex: '727337',
          positionInBook: 1774,
          pageNumberInBook: '254'
        },
        {
          code: '7750 C',
          name: null,
          rgb: {
            r: 101,
            g: 102,
            b: 53
          },
          hex: '656635',
          positionInBook: 1775,
          pageNumberInBook: '254'
        },
        {
          code: '379 C',
          name: null,
          rgb: {
            r: 226,
            g: 232,
            b: 104
          },
          hex: 'E2E868',
          positionInBook: 1776,
          pageNumberInBook: '255'
        },
        {
          code: '380 C',
          name: null,
          rgb: {
            r: 219,
            g: 228,
            b: 66
          },
          hex: 'DBE442',
          positionInBook: 1777,
          pageNumberInBook: '255'
        },
        {
          code: '381 C',
          name: null,
          rgb: {
            r: 206,
            g: 220,
            b: 0
          },
          hex: 'CEDC00',
          positionInBook: 1778,
          pageNumberInBook: '255'
        },
        {
          code: '382 C',
          name: null,
          rgb: {
            r: 196,
            g: 214,
            b: 0
          },
          hex: 'C4D600',
          positionInBook: 1779,
          pageNumberInBook: '255'
        },
        {
          code: '383 C',
          name: null,
          rgb: {
            r: 168,
            g: 173,
            b: 0
          },
          hex: 'A8AD00',
          positionInBook: 1780,
          pageNumberInBook: '255'
        },
        {
          code: '384 C',
          name: null,
          rgb: {
            r: 148,
            g: 147,
            b: 0
          },
          hex: '949300',
          positionInBook: 1781,
          pageNumberInBook: '255'
        },
        {
          code: '385 C',
          name: null,
          rgb: {
            r: 120,
            g: 113,
            b: 33
          },
          hex: '787121',
          positionInBook: 1782,
          pageNumberInBook: '255'
        },
        {
          code: '386 C',
          name: null,
          rgb: {
            r: 233,
            g: 236,
            b: 107
          },
          hex: 'E9EC6B',
          positionInBook: 1783,
          pageNumberInBook: '256'
        },
        {
          code: '387 C',
          name: null,
          rgb: {
            r: 227,
            g: 233,
            b: 53
          },
          hex: 'E3E935',
          positionInBook: 1784,
          pageNumberInBook: '256'
        },
        {
          code: '388 C',
          name: null,
          rgb: {
            r: 224,
            g: 231,
            b: 34
          },
          hex: 'E0E722',
          positionInBook: 1785,
          pageNumberInBook: '256'
        },
        {
          code: '389 C',
          name: null,
          rgb: {
            r: 208,
            g: 223,
            b: 0
          },
          hex: 'D0DF00',
          positionInBook: 1786,
          pageNumberInBook: '256'
        },
        {
          code: '390 C',
          name: null,
          rgb: {
            r: 181,
            g: 189,
            b: 0
          },
          hex: 'B5BD00',
          positionInBook: 1787,
          pageNumberInBook: '256'
        },
        {
          code: '391 C',
          name: null,
          rgb: {
            r: 154,
            g: 149,
            b: 0
          },
          hex: '9A9500',
          positionInBook: 1788,
          pageNumberInBook: '256'
        },
        {
          code: '392 C',
          name: null,
          rgb: {
            r: 130,
            g: 122,
            b: 4
          },
          hex: '827A04',
          positionInBook: 1789,
          pageNumberInBook: '256'
        },
        {
          code: '587 C',
          name: null,
          rgb: {
            r: 227,
            g: 228,
            b: 141
          },
          hex: 'E3E48D',
          positionInBook: 1790,
          pageNumberInBook: '257'
        },
        {
          code: '586 C',
          name: null,
          rgb: {
            r: 224,
            g: 226,
            b: 124
          },
          hex: 'E0E27C',
          positionInBook: 1791,
          pageNumberInBook: '257'
        },
        {
          code: '585 C',
          name: null,
          rgb: {
            r: 219,
            g: 222,
            b: 112
          },
          hex: 'DBDE70',
          positionInBook: 1792,
          pageNumberInBook: '257'
        },
        {
          code: '584 C',
          name: null,
          rgb: {
            r: 210,
            g: 215,
            b: 85
          },
          hex: 'D2D755',
          positionInBook: 1793,
          pageNumberInBook: '257'
        },
        {
          code: '583 C',
          name: null,
          rgb: {
            r: 183,
            g: 191,
            b: 16
          },
          hex: 'B7BF10',
          positionInBook: 1794,
          pageNumberInBook: '257'
        },
        {
          code: '582 C',
          name: null,
          rgb: {
            r: 142,
            g: 140,
            b: 19
          },
          hex: '8E8C13',
          positionInBook: 1795,
          pageNumberInBook: '257'
        },
        {
          code: '581 C',
          name: null,
          rgb: {
            r: 98,
            g: 93,
            b: 32
          },
          hex: '625D20',
          positionInBook: 1796,
          pageNumberInBook: '257'
        },
        {
          code: '4232 C',
          name: null,
          rgb: {
            r: 210,
            g: 207,
            b: 5
          },
          hex: 'D2CF05',
          positionInBook: 1797,
          pageNumberInBook: '258'
        },
        {
          code: '4233 C',
          name: null,
          rgb: {
            r: 192,
            g: 190,
            b: 0
          },
          hex: 'C0BE00',
          positionInBook: 1798,
          pageNumberInBook: '258'
        },
        {
          code: '4234 C',
          name: null,
          rgb: {
            r: 187,
            g: 194,
            b: 92
          },
          hex: 'BBC25C',
          positionInBook: 1799,
          pageNumberInBook: '258'
        },
        {
          code: '4235 C',
          name: null,
          rgb: {
            r: 176,
            g: 176,
            b: 124
          },
          hex: 'B0B07C',
          positionInBook: 1800,
          pageNumberInBook: '258'
        },
        {
          code: '4236 C',
          name: null,
          rgb: {
            r: 191,
            g: 190,
            b: 105
          },
          hex: 'BFBE69',
          positionInBook: 1801,
          pageNumberInBook: '258'
        },
        {
          code: '4237 C',
          name: null,
          rgb: {
            r: 171,
            g: 163,
            b: 96
          },
          hex: 'ABA360',
          positionInBook: 1802,
          pageNumberInBook: '258'
        },
        {
          code: '4238 C',
          name: null,
          rgb: {
            r: 141,
            g: 139,
            b: 83
          },
          hex: '8D8B53',
          positionInBook: 1803,
          pageNumberInBook: '258'
        },
        {
          code: '393 C',
          name: null,
          rgb: {
            r: 240,
            g: 236,
            b: 116
          },
          hex: 'F0EC74',
          positionInBook: 1804,
          pageNumberInBook: '259'
        },
        {
          code: '394 C',
          name: null,
          rgb: {
            r: 237,
            g: 233,
            b: 57
          },
          hex: 'EDE939',
          positionInBook: 1805,
          pageNumberInBook: '259'
        },
        {
          code: '395 C',
          name: null,
          rgb: {
            r: 236,
            g: 232,
            b: 26
          },
          hex: 'ECE81A',
          positionInBook: 1806,
          pageNumberInBook: '259'
        },
        {
          code: '396 C',
          name: null,
          rgb: {
            r: 225,
            g: 224,
            b: 0
          },
          hex: 'E1E000',
          positionInBook: 1807,
          pageNumberInBook: '259'
        },
        {
          code: '397 C',
          name: null,
          rgb: {
            r: 191,
            g: 184,
            b: 0
          },
          hex: 'BFB800',
          positionInBook: 1808,
          pageNumberInBook: '259'
        },
        {
          code: '398 C',
          name: null,
          rgb: {
            r: 173,
            g: 164,
            b: 0
          },
          hex: 'ADA400',
          positionInBook: 1809,
          pageNumberInBook: '259'
        },
        {
          code: '399 C',
          name: null,
          rgb: {
            r: 160,
            g: 146,
            b: 0
          },
          hex: 'A09200',
          positionInBook: 1810,
          pageNumberInBook: '259'
        },
        {
          code: '3935 C',
          name: null,
          rgb: {
            r: 243,
            g: 234,
            b: 93
          },
          hex: 'F3EA5D',
          positionInBook: 1811,
          pageNumberInBook: '260'
        },
        {
          code: '3945 C',
          name: null,
          rgb: {
            r: 243,
            g: 230,
            b: 0
          },
          hex: 'F3E600',
          positionInBook: 1812,
          pageNumberInBook: '260'
        },
        {
          code: '3955 C',
          name: null,
          rgb: {
            r: 239,
            g: 223,
            b: 0
          },
          hex: 'EFDF00',
          positionInBook: 1813,
          pageNumberInBook: '260'
        },
        {
          code: '3965 C',
          name: null,
          rgb: {
            r: 238,
            g: 220,
            b: 0
          },
          hex: 'EEDC00',
          positionInBook: 1814,
          pageNumberInBook: '260'
        },
        {
          code: '3975 C',
          name: null,
          rgb: {
            r: 187,
            g: 166,
            b: 0
          },
          hex: 'BBA600',
          positionInBook: 1815,
          pageNumberInBook: '260'
        },
        {
          code: '3985 C',
          name: null,
          rgb: {
            r: 154,
            g: 135,
            b: 0
          },
          hex: '9A8700',
          positionInBook: 1816,
          pageNumberInBook: '260'
        },
        {
          code: '3995 C',
          name: null,
          rgb: {
            r: 104,
            g: 92,
            b: 32
          },
          hex: '685C20',
          positionInBook: 1817,
          pageNumberInBook: '260'
        },
        {
          code: '600 C',
          name: null,
          rgb: {
            r: 241,
            g: 235,
            b: 156
          },
          hex: 'F1EB9C',
          positionInBook: 1818,
          pageNumberInBook: '261'
        },
        {
          code: '601 C',
          name: null,
          rgb: {
            r: 240,
            g: 233,
            b: 145
          },
          hex: 'F0E991',
          positionInBook: 1819,
          pageNumberInBook: '261'
        },
        {
          code: '602 C',
          name: null,
          rgb: {
            r: 240,
            g: 232,
            b: 123
          },
          hex: 'F0E87B',
          positionInBook: 1820,
          pageNumberInBook: '261'
        },
        {
          code: '603 C',
          name: null,
          rgb: {
            r: 237,
            g: 224,
            b: 75
          },
          hex: 'EDE04B',
          positionInBook: 1821,
          pageNumberInBook: '261'
        },
        {
          code: '604 C',
          name: null,
          rgb: {
            r: 234,
            g: 218,
            b: 36
          },
          hex: 'EADA24',
          positionInBook: 1822,
          pageNumberInBook: '261'
        },
        {
          code: '605 C',
          name: null,
          rgb: {
            r: 225,
            g: 205,
            b: 0
          },
          hex: 'E1CD00',
          positionInBook: 1823,
          pageNumberInBook: '261'
        },
        {
          code: '606 C',
          name: null,
          rgb: {
            r: 207,
            g: 181,
            b: 0
          },
          hex: 'CFB500',
          positionInBook: 1824,
          pageNumberInBook: '261'
        },
        {
          code: '607 C',
          name: null,
          rgb: {
            r: 235,
            g: 228,
            b: 154
          },
          hex: 'EBE49A',
          positionInBook: 1825,
          pageNumberInBook: '262'
        },
        {
          code: '608 C',
          name: null,
          rgb: {
            r: 233,
            g: 225,
            b: 134
          },
          hex: 'E9E186',
          positionInBook: 1826,
          pageNumberInBook: '262'
        },
        {
          code: '609 C',
          name: null,
          rgb: {
            r: 230,
            g: 222,
            b: 119
          },
          hex: 'E6DE77',
          positionInBook: 1827,
          pageNumberInBook: '262'
        },
        {
          code: '610 C',
          name: null,
          rgb: {
            r: 225,
            g: 213,
            b: 85
          },
          hex: 'E1D555',
          positionInBook: 1828,
          pageNumberInBook: '262'
        },
        {
          code: '611 C',
          name: null,
          rgb: {
            r: 215,
            g: 200,
            b: 38
          },
          hex: 'D7C826',
          positionInBook: 1829,
          pageNumberInBook: '262'
        },
        {
          code: '612 C',
          name: null,
          rgb: {
            r: 196,
            g: 176,
            b: 0
          },
          hex: 'C4B000',
          positionInBook: 1830,
          pageNumberInBook: '262'
        },
        {
          code: '613 C',
          name: null,
          rgb: {
            r: 179,
            g: 155,
            b: 0
          },
          hex: 'B39B00',
          positionInBook: 1831,
          pageNumberInBook: '262'
        },
        {
          code: '461 C',
          name: null,
          rgb: {
            r: 233,
            g: 223,
            b: 151
          },
          hex: 'E9DF97',
          positionInBook: 1832,
          pageNumberInBook: '263'
        },
        {
          code: '460 C',
          name: null,
          rgb: {
            r: 228,
            g: 215,
            b: 126
          },
          hex: 'E4D77E',
          positionInBook: 1833,
          pageNumberInBook: '263'
        },
        {
          code: '459 C',
          name: null,
          rgb: {
            r: 222,
            g: 205,
            b: 99
          },
          hex: 'DECD63',
          positionInBook: 1834,
          pageNumberInBook: '263'
        },
        {
          code: '458 C',
          name: null,
          rgb: {
            r: 217,
            g: 199,
            b: 86
          },
          hex: 'D9C756',
          positionInBook: 1835,
          pageNumberInBook: '263'
        },
        {
          code: '457 C',
          name: null,
          rgb: {
            r: 184,
            g: 157,
            b: 24
          },
          hex: 'B89D18',
          positionInBook: 1836,
          pageNumberInBook: '263'
        },
        {
          code: '456 C',
          name: null,
          rgb: {
            r: 162,
            g: 142,
            b: 42
          },
          hex: 'A28E2A',
          positionInBook: 1837,
          pageNumberInBook: '263'
        },
        {
          code: '455 C',
          name: null,
          rgb: {
            r: 105,
            g: 91,
            b: 36
          },
          hex: '695B24',
          positionInBook: 1838,
          pageNumberInBook: '263'
        },
        {
          code: '614 C',
          name: null,
          rgb: {
            r: 220,
            g: 213,
            b: 154
          },
          hex: 'DCD59A',
          positionInBook: 1839,
          pageNumberInBook: '264'
        },
        {
          code: '615 C',
          name: null,
          rgb: {
            r: 214,
            g: 207,
            b: 141
          },
          hex: 'D6CF8D',
          positionInBook: 1840,
          pageNumberInBook: '264'
        },
        {
          code: '616 C',
          name: null,
          rgb: {
            r: 208,
            g: 200,
            b: 131
          },
          hex: 'D0C883',
          positionInBook: 1841,
          pageNumberInBook: '264'
        },
        {
          code: '617 C',
          name: null,
          rgb: {
            r: 192,
            g: 182,
            b: 97
          },
          hex: 'C0B661',
          positionInBook: 1842,
          pageNumberInBook: '264'
        },
        {
          code: '618 C',
          name: null,
          rgb: {
            r: 172,
            g: 159,
            b: 60
          },
          hex: 'AC9F3C',
          positionInBook: 1843,
          pageNumberInBook: '264'
        },
        {
          code: '619 C',
          name: null,
          rgb: {
            r: 159,
            g: 145,
            b: 42
          },
          hex: '9F912A',
          positionInBook: 1844,
          pageNumberInBook: '264'
        },
        {
          code: '620 C',
          name: null,
          rgb: {
            r: 138,
            g: 123,
            b: 25
          },
          hex: '8A7B19',
          positionInBook: 1845,
          pageNumberInBook: '264'
        },
        {
          code: '7751 C',
          name: null,
          rgb: {
            r: 202,
            g: 182,
            b: 75
          },
          hex: 'CAB64B',
          positionInBook: 1846,
          pageNumberInBook: '265'
        },
        {
          code: '7752 C',
          name: null,
          rgb: {
            r: 207,
            g: 176,
            b: 35
          },
          hex: 'CFB023',
          positionInBook: 1847,
          pageNumberInBook: '265'
        },
        {
          code: '7753 C',
          name: null,
          rgb: {
            r: 193,
            g: 160,
            b: 31
          },
          hex: 'C1A01F',
          positionInBook: 1848,
          pageNumberInBook: '265'
        },
        {
          code: '7754 C',
          name: null,
          rgb: {
            r: 160,
            g: 134,
            b: 41
          },
          hex: 'A08629',
          positionInBook: 1849,
          pageNumberInBook: '265'
        },
        {
          code: '7755 C',
          name: null,
          rgb: {
            r: 137,
            g: 118,
            b: 48
          },
          hex: '897630',
          positionInBook: 1850,
          pageNumberInBook: '265'
        },
        {
          code: '7756 C',
          name: null,
          rgb: {
            r: 115,
            g: 102,
            b: 53
          },
          hex: '736635',
          positionInBook: 1851,
          pageNumberInBook: '265'
        },
        {
          code: '7757 C',
          name: null,
          rgb: {
            r: 103,
            g: 94,
            b: 51
          },
          hex: '675E33',
          positionInBook: 1852,
          pageNumberInBook: '265'
        },
        {
          code: '7758 C',
          name: null,
          rgb: {
            r: 212,
            g: 195,
            b: 4
          },
          hex: 'D4C304',
          positionInBook: 1853,
          pageNumberInBook: '266'
        },
        {
          code: '7759 C',
          name: null,
          rgb: {
            r: 196,
            g: 178,
            b: 0
          },
          hex: 'C4B200',
          positionInBook: 1854,
          pageNumberInBook: '266'
        },
        {
          code: '7760 C',
          name: null,
          rgb: {
            r: 145,
            g: 133,
            b: 44
          },
          hex: '91852C',
          positionInBook: 1855,
          pageNumberInBook: '266'
        },
        {
          code: '7761 C',
          name: null,
          rgb: {
            r: 116,
            g: 113,
            b: 54
          },
          hex: '747136',
          positionInBook: 1856,
          pageNumberInBook: '266'
        },
        {
          code: '7762 C',
          name: null,
          rgb: {
            r: 93,
            g: 100,
            b: 57
          },
          hex: '5D6439',
          positionInBook: 1857,
          pageNumberInBook: '266'
        },
        {
          code: '7763 C',
          name: null,
          rgb: {
            r: 88,
            g: 92,
            b: 59
          },
          hex: '585C3B',
          positionInBook: 1858,
          pageNumberInBook: '266'
        },
        {
          code: '7764 C',
          name: null,
          rgb: {
            r: 83,
            g: 84,
            b: 53
          },
          hex: '535435',
          positionInBook: 1859,
          pageNumberInBook: '266'
        },
        {
          code: '7765 C',
          name: null,
          rgb: {
            r: 187,
            g: 179,
            b: 35
          },
          hex: 'BBB323',
          positionInBook: 1860,
          pageNumberInBook: '267'
        },
        {
          code: '7766 C',
          name: null,
          rgb: {
            r: 180,
            g: 169,
            b: 31
          },
          hex: 'B4A91F',
          positionInBook: 1861,
          pageNumberInBook: '267'
        },
        {
          code: '7767 C',
          name: null,
          rgb: {
            r: 170,
            g: 157,
            b: 46
          },
          hex: 'AA9D2E',
          positionInBook: 1862,
          pageNumberInBook: '267'
        },
        {
          code: '7768 C',
          name: null,
          rgb: {
            r: 143,
            g: 126,
            b: 53
          },
          hex: '8F7E35',
          positionInBook: 1863,
          pageNumberInBook: '267'
        },
        {
          code: '7769 C',
          name: null,
          rgb: {
            r: 113,
            g: 97,
            b: 53
          },
          hex: '716135',
          positionInBook: 1864,
          pageNumberInBook: '267'
        },
        {
          code: '7770 C',
          name: null,
          rgb: {
            r: 99,
            g: 89,
            b: 57
          },
          hex: '635939',
          positionInBook: 1865,
          pageNumberInBook: '267'
        },
        {
          code: '7771 C',
          name: null,
          rgb: {
            r: 78,
            g: 73,
            b: 52
          },
          hex: '4E4934',
          positionInBook: 1866,
          pageNumberInBook: '267'
        },
        {
          code: '4545 C',
          name: null,
          rgb: {
            r: 213,
            g: 203,
            b: 159
          },
          hex: 'D5CB9F',
          positionInBook: 1867,
          pageNumberInBook: '268'
        },
        {
          code: '4535 C',
          name: null,
          rgb: {
            r: 207,
            g: 196,
            b: 147
          },
          hex: 'CFC493',
          positionInBook: 1868,
          pageNumberInBook: '268'
        },
        {
          code: '4525 C',
          name: null,
          rgb: {
            r: 197,
            g: 183,
            b: 131
          },
          hex: 'C5B783',
          positionInBook: 1869,
          pageNumberInBook: '268'
        },
        {
          code: '4515 C',
          name: null,
          rgb: {
            r: 179,
            g: 163,
            b: 105
          },
          hex: 'B3A369',
          positionInBook: 1870,
          pageNumberInBook: '268'
        },
        {
          code: '4505 C',
          name: null,
          rgb: {
            r: 153,
            g: 133,
            b: 66
          },
          hex: '998542',
          positionInBook: 1871,
          pageNumberInBook: '268'
        },
        {
          code: '4495 C',
          name: null,
          rgb: {
            r: 140,
            g: 119,
            b: 50
          },
          hex: '8C7732',
          positionInBook: 1872,
          pageNumberInBook: '268'
        },
        {
          code: '4485 C',
          name: null,
          rgb: {
            r: 97,
            g: 79,
            b: 37
          },
          hex: '614F25',
          positionInBook: 1873,
          pageNumberInBook: '268'
        },
        {
          code: '2323 C',
          name: null,
          rgb: {
            r: 184,
            g: 178,
            b: 152
          },
          hex: 'B8B298',
          positionInBook: 1874,
          pageNumberInBook: '269'
        },
        {
          code: '2324 C',
          name: null,
          rgb: {
            r: 178,
            g: 163,
            b: 132
          },
          hex: 'B2A384',
          positionInBook: 1875,
          pageNumberInBook: '269'
        },
        {
          code: '2325 C',
          name: null,
          rgb: {
            r: 160,
            g: 144,
            b: 116
          },
          hex: 'A09074',
          positionInBook: 1876,
          pageNumberInBook: '269'
        },
        {
          code: '2326 C',
          name: null,
          rgb: {
            r: 139,
            g: 124,
            b: 94
          },
          hex: '8B7C5E',
          positionInBook: 1877,
          pageNumberInBook: '269'
        },
        {
          code: '2327 C',
          name: null,
          rgb: {
            r: 131,
            g: 122,
            b: 88
          },
          hex: '837A58',
          positionInBook: 1878,
          pageNumberInBook: '269'
        },
        {
          code: '2328 C',
          name: null,
          rgb: {
            r: 120,
            g: 103,
            b: 72
          },
          hex: '786748',
          positionInBook: 1879,
          pageNumberInBook: '269'
        },
        {
          code: '2329 C',
          name: null,
          rgb: {
            r: 104,
            g: 89,
            b: 60
          },
          hex: '68593C',
          positionInBook: 1880,
          pageNumberInBook: '269'
        },
        {
          code: '4239 C',
          name: null,
          rgb: {
            r: 200,
            g: 195,
            b: 179
          },
          hex: 'C8C3B3',
          positionInBook: 1881,
          pageNumberInBook: '270'
        },
        {
          code: '4240 C',
          name: null,
          rgb: {
            r: 202,
            g: 191,
            b: 165
          },
          hex: 'CABFA5',
          positionInBook: 1882,
          pageNumberInBook: '270'
        },
        {
          code: '4241 C',
          name: null,
          rgb: {
            r: 186,
            g: 172,
            b: 136
          },
          hex: 'BAAC88',
          positionInBook: 1883,
          pageNumberInBook: '270'
        },
        {
          code: '4242 C',
          name: null,
          rgb: {
            r: 136,
            g: 118,
            b: 79
          },
          hex: '88764F',
          positionInBook: 1884,
          pageNumberInBook: '270'
        },
        {
          code: '4243 C',
          name: null,
          rgb: {
            r: 131,
            g: 106,
            b: 77
          },
          hex: '836A4D',
          positionInBook: 1885,
          pageNumberInBook: '270'
        },
        {
          code: '4244 C',
          name: null,
          rgb: {
            r: 126,
            g: 105,
            b: 79
          },
          hex: '7E694F',
          positionInBook: 1886,
          pageNumberInBook: '270'
        },
        {
          code: '4245 C',
          name: null,
          rgb: {
            r: 90,
            g: 80,
            b: 64
          },
          hex: '5A5040',
          positionInBook: 1887,
          pageNumberInBook: '270'
        },
        {
          code: '454 C',
          name: null,
          rgb: {
            r: 202,
            g: 199,
            b: 167
          },
          hex: 'CAC7A7',
          positionInBook: 1888,
          pageNumberInBook: '271'
        },
        {
          code: '453 C',
          name: null,
          rgb: {
            r: 191,
            g: 187,
            b: 152
          },
          hex: 'BFBB98',
          positionInBook: 1889,
          pageNumberInBook: '271'
        },
        {
          code: '452 C',
          name: null,
          rgb: {
            r: 176,
            g: 170,
            b: 126
          },
          hex: 'B0AA7E',
          positionInBook: 1890,
          pageNumberInBook: '271'
        },
        {
          code: '451 C',
          name: null,
          rgb: {
            r: 155,
            g: 148,
            b: 95
          },
          hex: '9B945F',
          positionInBook: 1891,
          pageNumberInBook: '271'
        },
        {
          code: '450 C',
          name: null,
          rgb: {
            r: 89,
            g: 74,
            b: 37
          },
          hex: '594A25',
          positionInBook: 1892,
          pageNumberInBook: '271'
        },
        {
          code: '449 C',
          name: null,
          rgb: {
            r: 82,
            g: 70,
            b: 39
          },
          hex: '524627',
          positionInBook: 1893,
          pageNumberInBook: '271'
        },
        {
          code: '448 C',
          name: null,
          rgb: {
            r: 74,
            g: 65,
            b: 42
          },
          hex: '4A412A',
          positionInBook: 1894,
          pageNumberInBook: '271'
        },
        {
          code: '7499 C',
          name: null,
          rgb: {
            r: 241,
            g: 230,
            b: 178
          },
          hex: 'F1E6B2',
          positionInBook: 1895,
          pageNumberInBook: '272'
        },
        {
          code: '7500 C',
          name: null,
          rgb: {
            r: 223,
            g: 209,
            b: 167
          },
          hex: 'DFD1A7',
          positionInBook: 1896,
          pageNumberInBook: '272'
        },
        {
          code: '7501 C',
          name: null,
          rgb: {
            r: 217,
            g: 200,
            b: 157
          },
          hex: 'D9C89D',
          positionInBook: 1897,
          pageNumberInBook: '272'
        },
        {
          code: '7502 C',
          name: null,
          rgb: {
            r: 206,
            g: 184,
            b: 136
          },
          hex: 'CEB888',
          positionInBook: 1898,
          pageNumberInBook: '272'
        },
        {
          code: '7503 C',
          name: null,
          rgb: {
            r: 168,
            g: 153,
            b: 104
          },
          hex: 'A89968',
          positionInBook: 1899,
          pageNumberInBook: '272'
        },
        {
          code: '7504 C',
          name: null,
          rgb: {
            r: 148,
            g: 121,
            b: 93
          },
          hex: '94795D',
          positionInBook: 1900,
          pageNumberInBook: '272'
        },
        {
          code: '7505 C',
          name: null,
          rgb: {
            r: 129,
            g: 96,
            b: 64
          },
          hex: '816040',
          positionInBook: 1901,
          pageNumberInBook: '272'
        },
        {
          code: '4246 C',
          name: null,
          rgb: {
            r: 205,
            g: 196,
            b: 170
          },
          hex: 'CDC4AA',
          positionInBook: 1902,
          pageNumberInBook: '273'
        },
        {
          code: '4247 C',
          name: null,
          rgb: {
            r: 209,
            g: 193,
            b: 168
          },
          hex: 'D1C1A8',
          positionInBook: 1903,
          pageNumberInBook: '273'
        },
        {
          code: '4248 C',
          name: null,
          rgb: {
            r: 213,
            g: 194,
            b: 165
          },
          hex: 'D5C2A5',
          positionInBook: 1904,
          pageNumberInBook: '273'
        },
        {
          code: '4249 C',
          name: null,
          rgb: {
            r: 195,
            g: 173,
            b: 139
          },
          hex: 'C3AD8B',
          positionInBook: 1905,
          pageNumberInBook: '273'
        },
        {
          code: '4250 C',
          name: null,
          rgb: {
            r: 187,
            g: 168,
            b: 135
          },
          hex: 'BBA887',
          positionInBook: 1906,
          pageNumberInBook: '273'
        },
        {
          code: '4251 C',
          name: null,
          rgb: {
            r: 184,
            g: 162,
            b: 121
          },
          hex: 'B8A279',
          positionInBook: 1907,
          pageNumberInBook: '273'
        },
        {
          code: '4252 C',
          name: null,
          rgb: {
            r: 182,
            g: 162,
            b: 132
          },
          hex: 'B6A284',
          positionInBook: 1908,
          pageNumberInBook: '273'
        },
        {
          code: '468 C',
          name: null,
          rgb: {
            r: 221,
            g: 203,
            b: 164
          },
          hex: 'DDCBA4',
          positionInBook: 1909,
          pageNumberInBook: '274'
        },
        {
          code: '467 C',
          name: null,
          rgb: {
            r: 211,
            g: 188,
            b: 141
          },
          hex: 'D3BC8D',
          positionInBook: 1910,
          pageNumberInBook: '274'
        },
        {
          code: '466 C',
          name: null,
          rgb: {
            r: 198,
            g: 170,
            b: 118
          },
          hex: 'C6AA76',
          positionInBook: 1911,
          pageNumberInBook: '274'
        },
        {
          code: '465 C',
          name: null,
          rgb: {
            r: 185,
            g: 151,
            b: 91
          },
          hex: 'B9975B',
          positionInBook: 1912,
          pageNumberInBook: '274'
        },
        {
          code: '464 C',
          name: null,
          rgb: {
            r: 139,
            g: 91,
            b: 41
          },
          hex: '8B5B29',
          positionInBook: 1913,
          pageNumberInBook: '274'
        },
        {
          code: '463 C',
          name: null,
          rgb: {
            r: 116,
            g: 79,
            b: 40
          },
          hex: '744F28',
          positionInBook: 1914,
          pageNumberInBook: '274'
        },
        {
          code: '462 C',
          name: null,
          rgb: {
            r: 92,
            g: 70,
            b: 43
          },
          hex: '5C462B',
          positionInBook: 1915,
          pageNumberInBook: '274'
        },
        {
          code: '4253 C',
          name: null,
          rgb: {
            r: 186,
            g: 165,
            b: 141
          },
          hex: 'BAA58D',
          positionInBook: 1916,
          pageNumberInBook: '275'
        },
        {
          code: '4254 C',
          name: null,
          rgb: {
            r: 191,
            g: 153,
            b: 114
          },
          hex: 'BF9972',
          positionInBook: 1917,
          pageNumberInBook: '275'
        },
        {
          code: '4255 C',
          name: null,
          rgb: {
            r: 173,
            g: 150,
            b: 119
          },
          hex: 'AD9677',
          positionInBook: 1918,
          pageNumberInBook: '275'
        },
        {
          code: '4256 C',
          name: null,
          rgb: {
            r: 170,
            g: 144,
            b: 113
          },
          hex: 'AA9071',
          positionInBook: 1919,
          pageNumberInBook: '275'
        },
        {
          code: '4257 C',
          name: null,
          rgb: {
            r: 148,
            g: 125,
            b: 111
          },
          hex: '947D6F',
          positionInBook: 1920,
          pageNumberInBook: '275'
        },
        {
          code: '4258 C',
          name: null,
          rgb: {
            r: 111,
            g: 93,
            b: 88
          },
          hex: '6F5D58',
          positionInBook: 1921,
          pageNumberInBook: '275'
        },
        {
          code: '4259 C',
          name: null,
          rgb: {
            r: 50,
            g: 41,
            b: 35
          },
          hex: '322923',
          positionInBook: 1922,
          pageNumberInBook: '275'
        },
        {
          code: '3599 C',
          name: null,
          rgb: {
            r: 218,
            g: 194,
            b: 135
          },
          hex: 'DAC287',
          positionInBook: 1923,
          pageNumberInBook: '276'
        },
        {
          code: '2467 C',
          name: null,
          rgb: {
            r: 183,
            g: 146,
            b: 108
          },
          hex: 'B7926C',
          positionInBook: 1924,
          pageNumberInBook: '276'
        },
        {
          code: '2468 C',
          name: null,
          rgb: {
            r: 152,
            g: 106,
            b: 76
          },
          hex: '986A4C',
          positionInBook: 1925,
          pageNumberInBook: '276'
        },
        {
          code: '2469 C',
          name: null,
          rgb: {
            r: 143,
            g: 88,
            b: 59
          },
          hex: '8F583B',
          positionInBook: 1926,
          pageNumberInBook: '276'
        },
        {
          code: '2470 C',
          name: null,
          rgb: {
            r: 154,
            g: 127,
            b: 98
          },
          hex: '9A7F62',
          positionInBook: 1927,
          pageNumberInBook: '276'
        },
        {
          code: '2471 C',
          name: null,
          rgb: {
            r: 165,
            g: 136,
            b: 119
          },
          hex: 'A58877',
          positionInBook: 1928,
          pageNumberInBook: '276'
        },
        {
          code: '2472 C',
          name: null,
          rgb: {
            r: 95,
            g: 64,
            b: 41
          },
          hex: '5F4029',
          positionInBook: 1929,
          pageNumberInBook: '276'
        },
        {
          code: '7506 C',
          name: null,
          rgb: {
            r: 239,
            g: 219,
            b: 178
          },
          hex: 'EFDBB2',
          positionInBook: 1930,
          pageNumberInBook: '277'
        },
        {
          code: '7507 C',
          name: null,
          rgb: {
            r: 252,
            g: 210,
            b: 153
          },
          hex: 'FCD299',
          positionInBook: 1931,
          pageNumberInBook: '277'
        },
        {
          code: '7508 C',
          name: null,
          rgb: {
            r: 225,
            g: 184,
            b: 127
          },
          hex: 'E1B87F',
          positionInBook: 1932,
          pageNumberInBook: '277'
        },
        {
          code: '7509 C',
          name: null,
          rgb: {
            r: 214,
            g: 164,
            b: 97
          },
          hex: 'D6A461',
          positionInBook: 1933,
          pageNumberInBook: '277'
        },
        {
          code: '7510 C',
          name: null,
          rgb: {
            r: 198,
            g: 137,
            b: 63
          },
          hex: 'C6893F',
          positionInBook: 1934,
          pageNumberInBook: '277'
        },
        {
          code: '7511 C',
          name: null,
          rgb: {
            r: 183,
            g: 119,
            b: 41
          },
          hex: 'B77729',
          positionInBook: 1935,
          pageNumberInBook: '277'
        },
        {
          code: '7512 C',
          name: null,
          rgb: {
            r: 166,
            g: 99,
            b: 27
          },
          hex: 'A6631B',
          positionInBook: 1936,
          pageNumberInBook: '277'
        },
        {
          code: '719 C',
          name: null,
          rgb: {
            r: 237,
            g: 200,
            b: 163
          },
          hex: 'EDC8A3',
          positionInBook: 1937,
          pageNumberInBook: '278'
        },
        {
          code: '720 C',
          name: null,
          rgb: {
            r: 231,
            g: 183,
            b: 138
          },
          hex: 'E7B78A',
          positionInBook: 1938,
          pageNumberInBook: '278'
        },
        {
          code: '721 C',
          name: null,
          rgb: {
            r: 221,
            g: 164,
            b: 111
          },
          hex: 'DDA46F',
          positionInBook: 1939,
          pageNumberInBook: '278'
        },
        {
          code: '722 C',
          name: null,
          rgb: {
            r: 200,
            g: 130,
            b: 66
          },
          hex: 'C88242',
          positionInBook: 1940,
          pageNumberInBook: '278'
        },
        {
          code: '723 C',
          name: null,
          rgb: {
            r: 179,
            g: 105,
            b: 36
          },
          hex: 'B36924',
          positionInBook: 1941,
          pageNumberInBook: '278'
        },
        {
          code: '724 C',
          name: null,
          rgb: {
            r: 147,
            g: 77,
            b: 17
          },
          hex: '934D11',
          positionInBook: 1942,
          pageNumberInBook: '278'
        },
        {
          code: '725 C',
          name: null,
          rgb: {
            r: 125,
            g: 64,
            b: 22
          },
          hex: '7D4016',
          positionInBook: 1943,
          pageNumberInBook: '278'
        },
        {
          code: '475 C',
          name: null,
          rgb: {
            r: 243,
            g: 207,
            b: 179
          },
          hex: 'F3CFB3',
          positionInBook: 1944,
          pageNumberInBook: '279'
        },
        {
          code: '474 C',
          name: null,
          rgb: {
            r: 241,
            g: 198,
            b: 166
          },
          hex: 'F1C6A6',
          positionInBook: 1945,
          pageNumberInBook: '279'
        },
        {
          code: '473 C',
          name: null,
          rgb: {
            r: 240,
            g: 191,
            b: 155
          },
          hex: 'F0BF9B',
          positionInBook: 1946,
          pageNumberInBook: '279'
        },
        {
          code: '472 C',
          name: null,
          rgb: {
            r: 229,
            g: 158,
            b: 109
          },
          hex: 'E59E6D',
          positionInBook: 1947,
          pageNumberInBook: '279'
        },
        {
          code: '471 C',
          name: null,
          rgb: {
            r: 184,
            g: 97,
            b: 37
          },
          hex: 'B86125',
          positionInBook: 1948,
          pageNumberInBook: '279'
        },
        {
          code: '470 C',
          name: null,
          rgb: {
            r: 164,
            g: 90,
            b: 42
          },
          hex: 'A45A2A',
          positionInBook: 1949,
          pageNumberInBook: '279'
        },
        {
          code: '469 C',
          name: null,
          rgb: {
            r: 105,
            g: 63,
            b: 35
          },
          hex: '693F23',
          positionInBook: 1950,
          pageNumberInBook: '279'
        },
        {
          code: '726 C',
          name: null,
          rgb: {
            r: 224,
            g: 192,
            b: 159
          },
          hex: 'E0C09F',
          positionInBook: 1951,
          pageNumberInBook: '280'
        },
        {
          code: '727 C',
          name: null,
          rgb: {
            r: 217,
            g: 180,
            b: 143
          },
          hex: 'D9B48F',
          positionInBook: 1952,
          pageNumberInBook: '280'
        },
        {
          code: '728 C',
          name: null,
          rgb: {
            r: 205,
            g: 161,
            b: 119
          },
          hex: 'CDA177',
          positionInBook: 1953,
          pageNumberInBook: '280'
        },
        {
          code: '729 C',
          name: null,
          rgb: {
            r: 181,
            g: 129,
            b: 80
          },
          hex: 'B58150',
          positionInBook: 1954,
          pageNumberInBook: '280'
        },
        {
          code: '730 C',
          name: null,
          rgb: {
            r: 158,
            g: 101,
            b: 46
          },
          hex: '9E652E',
          positionInBook: 1955,
          pageNumberInBook: '280'
        },
        {
          code: '731 C',
          name: null,
          rgb: {
            r: 119,
            g: 66,
            b: 18
          },
          hex: '774212',
          positionInBook: 1956,
          pageNumberInBook: '280'
        },
        {
          code: '732 C',
          name: null,
          rgb: {
            r: 98,
            g: 52,
            b: 18
          },
          hex: '623412',
          positionInBook: 1957,
          pageNumberInBook: '280'
        },
        {
          code: '2316 C',
          name: null,
          rgb: {
            r: 189,
            g: 154,
            b: 122
          },
          hex: 'BD9A7A',
          positionInBook: 1958,
          pageNumberInBook: '281'
        },
        {
          code: '2317 C',
          name: null,
          rgb: {
            r: 180,
            g: 135,
            b: 94
          },
          hex: 'B4875E',
          positionInBook: 1959,
          pageNumberInBook: '281'
        },
        {
          code: '2318 C',
          name: null,
          rgb: {
            r: 164,
            g: 116,
            b: 73
          },
          hex: 'A47449',
          positionInBook: 1960,
          pageNumberInBook: '281'
        },
        {
          code: '2319 C',
          name: null,
          rgb: {
            r: 140,
            g: 92,
            b: 48
          },
          hex: '8C5C30',
          positionInBook: 1961,
          pageNumberInBook: '281'
        },
        {
          code: '2320 C',
          name: null,
          rgb: {
            r: 113,
            g: 70,
            b: 35
          },
          hex: '714623',
          positionInBook: 1962,
          pageNumberInBook: '281'
        },
        {
          code: '2321 C',
          name: null,
          rgb: {
            r: 111,
            g: 81,
            b: 56
          },
          hex: '6F5138',
          positionInBook: 1963,
          pageNumberInBook: '281'
        },
        {
          code: '2322 C',
          name: null,
          rgb: {
            r: 78,
            g: 53,
            b: 36
          },
          hex: '4E3524',
          positionInBook: 1964,
          pageNumberInBook: '281'
        },
        {
          code: '2309 C',
          name: null,
          rgb: {
            r: 231,
            g: 206,
            b: 181
          },
          hex: 'E7CEB5',
          positionInBook: 1965,
          pageNumberInBook: '282'
        },
        {
          code: '2310 C',
          name: null,
          rgb: {
            r: 217,
            g: 192,
            b: 169
          },
          hex: 'D9C0A9',
          positionInBook: 1966,
          pageNumberInBook: '282'
        },
        {
          code: '2311 C',
          name: null,
          rgb: {
            r: 205,
            g: 167,
            b: 134
          },
          hex: 'CDA786',
          positionInBook: 1967,
          pageNumberInBook: '282'
        },
        {
          code: '2312 C',
          name: null,
          rgb: {
            r: 183,
            g: 154,
            b: 129
          },
          hex: 'B79A81',
          positionInBook: 1968,
          pageNumberInBook: '282'
        },
        {
          code: '2313 C',
          name: null,
          rgb: {
            r: 195,
            g: 147,
            b: 103
          },
          hex: 'C39367',
          positionInBook: 1969,
          pageNumberInBook: '282'
        },
        {
          code: '2314 C',
          name: null,
          rgb: {
            r: 172,
            g: 118,
            b: 68
          },
          hex: 'AC7644',
          positionInBook: 1970,
          pageNumberInBook: '282'
        },
        {
          code: '2315 C',
          name: null,
          rgb: {
            r: 145,
            g: 73,
            b: 16
          },
          hex: '914910',
          positionInBook: 1971,
          pageNumberInBook: '282'
        },
        {
          code: '4685 C',
          name: null,
          rgb: {
            r: 224,
            g: 198,
            b: 173
          },
          hex: 'E0C6AD',
          positionInBook: 1972,
          pageNumberInBook: '283'
        },
        {
          code: '4675 C',
          name: null,
          rgb: {
            r: 220,
            g: 191,
            b: 166
          },
          hex: 'DCBFA6',
          positionInBook: 1973,
          pageNumberInBook: '283'
        },
        {
          code: '4665 C',
          name: null,
          rgb: {
            r: 205,
            g: 167,
            b: 136
          },
          hex: 'CDA788',
          positionInBook: 1974,
          pageNumberInBook: '283'
        },
        {
          code: '4655 C',
          name: null,
          rgb: {
            r: 191,
            g: 148,
            b: 116
          },
          hex: 'BF9474',
          positionInBook: 1975,
          pageNumberInBook: '283'
        },
        {
          code: '4645 C',
          name: null,
          rgb: {
            r: 173,
            g: 124,
            b: 89
          },
          hex: 'AD7C59',
          positionInBook: 1976,
          pageNumberInBook: '283'
        },
        {
          code: '4635 C',
          name: null,
          rgb: {
            r: 148,
            g: 96,
            b: 55
          },
          hex: '946037',
          positionInBook: 1977,
          pageNumberInBook: '283'
        },
        {
          code: '4625 C',
          name: null,
          rgb: {
            r: 79,
            g: 44,
            b: 29
          },
          hex: '4F2C1D',
          positionInBook: 1978,
          pageNumberInBook: '283'
        },
        {
          code: '4260 C',
          name: null,
          rgb: {
            r: 205,
            g: 168,
            b: 144
          },
          hex: 'CDA890',
          positionInBook: 1979,
          pageNumberInBook: '284'
        },
        {
          code: '4261 C',
          name: null,
          rgb: {
            r: 157,
            g: 110,
            b: 70
          },
          hex: '9D6E46',
          positionInBook: 1980,
          pageNumberInBook: '284'
        },
        {
          code: '4262 C',
          name: null,
          rgb: {
            r: 168,
            g: 113,
            b: 78
          },
          hex: 'A8714E',
          positionInBook: 1981,
          pageNumberInBook: '284'
        },
        {
          code: '4263 C',
          name: null,
          rgb: {
            r: 171,
            g: 110,
            b: 73
          },
          hex: 'AB6E49',
          positionInBook: 1982,
          pageNumberInBook: '284'
        },
        {
          code: '4264 C',
          name: null,
          rgb: {
            r: 172,
            g: 112,
            b: 82
          },
          hex: 'AC7052',
          positionInBook: 1983,
          pageNumberInBook: '284'
        },
        {
          code: '4265 C',
          name: null,
          rgb: {
            r: 155,
            g: 100,
            b: 72
          },
          hex: '9B6448',
          positionInBook: 1984,
          pageNumberInBook: '284'
        },
        {
          code: '4266 C',
          name: null,
          rgb: {
            r: 154,
            g: 95,
            b: 58
          },
          hex: '9A5F3A',
          positionInBook: 1985,
          pageNumberInBook: '284'
        },
        {
          code: '7513 C',
          name: null,
          rgb: {
            r: 225,
            g: 183,
            b: 167
          },
          hex: 'E1B7A7',
          positionInBook: 1986,
          pageNumberInBook: '285'
        },
        {
          code: '7514 C',
          name: null,
          rgb: {
            r: 213,
            g: 162,
            b: 134
          },
          hex: 'D5A286',
          positionInBook: 1987,
          pageNumberInBook: '285'
        },
        {
          code: '7515 C',
          name: null,
          rgb: {
            r: 197,
            g: 139,
            b: 104
          },
          hex: 'C58B68',
          positionInBook: 1988,
          pageNumberInBook: '285'
        },
        {
          code: '7516 C',
          name: null,
          rgb: {
            r: 153,
            g: 85,
            b: 43
          },
          hex: '99552B',
          positionInBook: 1989,
          pageNumberInBook: '285'
        },
        {
          code: '7517 C',
          name: null,
          rgb: {
            r: 133,
            g: 67,
            b: 30
          },
          hex: '85431E',
          positionInBook: 1990,
          pageNumberInBook: '285'
        },
        {
          code: '7518 C',
          name: null,
          rgb: {
            r: 109,
            g: 79,
            b: 71
          },
          hex: '6D4F47',
          positionInBook: 1991,
          pageNumberInBook: '285'
        },
        {
          code: '7519 C',
          name: null,
          rgb: {
            r: 93,
            g: 75,
            b: 60
          },
          hex: '5D4B3C',
          positionInBook: 1992,
          pageNumberInBook: '285'
        },
        {
          code: '4755 C',
          name: null,
          rgb: {
            r: 215,
            g: 196,
            b: 183
          },
          hex: 'D7C4B7',
          positionInBook: 1993,
          pageNumberInBook: '286'
        },
        {
          code: '4745 C',
          name: null,
          rgb: {
            r: 205,
            g: 181,
            b: 167
          },
          hex: 'CDB5A7',
          positionInBook: 1994,
          pageNumberInBook: '286'
        },
        {
          code: '4735 C',
          name: null,
          rgb: {
            r: 192,
            g: 163,
            b: 146
          },
          hex: 'C0A392',
          positionInBook: 1995,
          pageNumberInBook: '286'
        },
        {
          code: '4725 C',
          name: null,
          rgb: {
            r: 174,
            g: 138,
            b: 121
          },
          hex: 'AE8A79',
          positionInBook: 1996,
          pageNumberInBook: '286'
        },
        {
          code: '4715 C',
          name: null,
          rgb: {
            r: 149,
            g: 108,
            b: 88
          },
          hex: '956C58',
          positionInBook: 1997,
          pageNumberInBook: '286'
        },
        {
          code: '4705 C',
          name: null,
          rgb: {
            r: 124,
            g: 77,
            b: 58
          },
          hex: '7C4D3A',
          positionInBook: 1998,
          pageNumberInBook: '286'
        },
        {
          code: '4695 C',
          name: null,
          rgb: {
            r: 91,
            g: 52,
            b: 39
          },
          hex: '5B3427',
          positionInBook: 1999,
          pageNumberInBook: '286'
        },
        {
          code: '482 C',
          name: null,
          rgb: {
            r: 219,
            g: 200,
            b: 182
          },
          hex: 'DBC8B6',
          positionInBook: 2000,
          pageNumberInBook: '287'
        },
        {
          code: '481 C',
          name: null,
          rgb: {
            r: 211,
            g: 187,
            b: 168
          },
          hex: 'D3BBA8',
          positionInBook: 2001,
          pageNumberInBook: '287'
        },
        {
          code: '480 C',
          name: null,
          rgb: {
            r: 198,
            g: 169,
            b: 146
          },
          hex: 'C6A992',
          positionInBook: 2002,
          pageNumberInBook: '287'
        },
        {
          code: '479 C',
          name: null,
          rgb: {
            r: 170,
            g: 128,
            b: 102
          },
          hex: 'AA8066',
          positionInBook: 2003,
          pageNumberInBook: '287'
        },
        {
          code: '478 C',
          name: null,
          rgb: {
            r: 113,
            g: 63,
            b: 42
          },
          hex: '713F2A',
          positionInBook: 2004,
          pageNumberInBook: '287'
        },
        {
          code: '477 C',
          name: null,
          rgb: {
            r: 98,
            g: 59,
            b: 42
          },
          hex: '623B2A',
          positionInBook: 2005,
          pageNumberInBook: '287'
        },
        {
          code: '476 C',
          name: null,
          rgb: {
            r: 78,
            g: 54,
            b: 41
          },
          hex: '4E3629',
          positionInBook: 2006,
          pageNumberInBook: '287'
        },
        {
          code: '4267 C',
          name: null,
          rgb: {
            r: 193,
            g: 178,
            b: 162
          },
          hex: 'C1B2A2',
          positionInBook: 2007,
          pageNumberInBook: '288'
        },
        {
          code: '4268 C',
          name: null,
          rgb: {
            r: 179,
            g: 160,
            b: 142
          },
          hex: 'B3A08E',
          positionInBook: 2008,
          pageNumberInBook: '288'
        },
        {
          code: '4269 C',
          name: null,
          rgb: {
            r: 171,
            g: 146,
            b: 120
          },
          hex: 'AB9278',
          positionInBook: 2009,
          pageNumberInBook: '288'
        },
        {
          code: '4270 C',
          name: null,
          rgb: {
            r: 149,
            g: 134,
            b: 111
          },
          hex: '95866F',
          positionInBook: 2010,
          pageNumberInBook: '288'
        },
        {
          code: '4271 C',
          name: null,
          rgb: {
            r: 142,
            g: 122,
            b: 107
          },
          hex: '8E7A6B',
          positionInBook: 2011,
          pageNumberInBook: '288'
        },
        {
          code: '4272 C',
          name: null,
          rgb: {
            r: 126,
            g: 106,
            b: 93
          },
          hex: '7E6A5D',
          positionInBook: 2012,
          pageNumberInBook: '288'
        },
        {
          code: '4273 C',
          name: null,
          rgb: {
            r: 78,
            g: 69,
            b: 68
          },
          hex: '4E4544',
          positionInBook: 2013,
          pageNumberInBook: '288'
        },
        {
          code: '7527 C',
          name: null,
          rgb: {
            r: 214,
            g: 210,
            b: 196
          },
          hex: 'D6D2C4',
          positionInBook: 2014,
          pageNumberInBook: '289'
        },
        {
          code: '7528 C',
          name: null,
          rgb: {
            r: 197,
            g: 185,
            b: 172
          },
          hex: 'C5B9AC',
          positionInBook: 2015,
          pageNumberInBook: '289'
        },
        {
          code: '7529 C',
          name: null,
          rgb: {
            r: 183,
            g: 169,
            b: 154
          },
          hex: 'B7A99A',
          positionInBook: 2016,
          pageNumberInBook: '289'
        },
        {
          code: '7530 C',
          name: null,
          rgb: {
            r: 163,
            g: 147,
            b: 130
          },
          hex: 'A39382',
          positionInBook: 2017,
          pageNumberInBook: '289'
        },
        {
          code: '7531 C',
          name: null,
          rgb: {
            r: 122,
            g: 104,
            b: 85
          },
          hex: '7A6855',
          positionInBook: 2018,
          pageNumberInBook: '289'
        },
        {
          code: '7532 C',
          name: null,
          rgb: {
            r: 99,
            g: 81,
            b: 61
          },
          hex: '63513D',
          positionInBook: 2019,
          pageNumberInBook: '289'
        },
        {
          code: '7533 C',
          name: null,
          rgb: {
            r: 71,
            g: 55,
            b: 41
          },
          hex: '473729',
          positionInBook: 2020,
          pageNumberInBook: '289'
        },
        {
          code: '7534 C',
          name: null,
          rgb: {
            r: 209,
            g: 204,
            b: 189
          },
          hex: 'D1CCBD',
          positionInBook: 2021,
          pageNumberInBook: '290'
        },
        {
          code: '7535 C',
          name: null,
          rgb: {
            r: 183,
            g: 176,
            b: 156
          },
          hex: 'B7B09C',
          positionInBook: 2022,
          pageNumberInBook: '290'
        },
        {
          code: '7536 C',
          name: null,
          rgb: {
            r: 166,
            g: 159,
            b: 136
          },
          hex: 'A69F88',
          positionInBook: 2023,
          pageNumberInBook: '290'
        },
        {
          code: '7537 C',
          name: null,
          rgb: {
            r: 167,
            g: 172,
            b: 162
          },
          hex: 'A7ACA2',
          positionInBook: 2024,
          pageNumberInBook: '290'
        },
        {
          code: '7538 C',
          name: null,
          rgb: {
            r: 148,
            g: 154,
            b: 144
          },
          hex: '949A90',
          positionInBook: 2025,
          pageNumberInBook: '290'
        },
        {
          code: '7539 C',
          name: null,
          rgb: {
            r: 142,
            g: 144,
            b: 137
          },
          hex: '8E9089',
          positionInBook: 2026,
          pageNumberInBook: '290'
        },
        {
          code: '7540 C',
          name: null,
          rgb: {
            r: 75,
            g: 79,
            b: 84
          },
          hex: '4B4F54',
          positionInBook: 2027,
          pageNumberInBook: '290'
        },
        {
          code: '427 C',
          name: null,
          rgb: {
            r: 208,
            g: 211,
            b: 212
          },
          hex: 'D0D3D4',
          positionInBook: 2028,
          pageNumberInBook: '291'
        },
        {
          code: '428 C',
          name: null,
          rgb: {
            r: 193,
            g: 198,
            b: 200
          },
          hex: 'C1C6C8',
          positionInBook: 2029,
          pageNumberInBook: '291'
        },
        {
          code: '429 C',
          name: null,
          rgb: {
            r: 162,
            g: 170,
            b: 173
          },
          hex: 'A2AAAD',
          positionInBook: 2030,
          pageNumberInBook: '291'
        },
        {
          code: '430 C',
          name: null,
          rgb: {
            r: 124,
            g: 135,
            b: 142
          },
          hex: '7C878E',
          positionInBook: 2031,
          pageNumberInBook: '291'
        },
        {
          code: '431 C',
          name: null,
          rgb: {
            r: 91,
            g: 103,
            b: 112
          },
          hex: '5B6770',
          positionInBook: 2032,
          pageNumberInBook: '291'
        },
        {
          code: '432 C',
          name: null,
          rgb: {
            r: 51,
            g: 63,
            b: 72
          },
          hex: '333F48',
          positionInBook: 2033,
          pageNumberInBook: '291'
        },
        {
          code: '433 C',
          name: null,
          rgb: {
            r: 29,
            g: 37,
            b: 45
          },
          hex: '1D252D',
          positionInBook: 2034,
          pageNumberInBook: '291'
        },
        {
          code: '4274 C',
          name: null,
          rgb: {
            r: 176,
            g: 183,
            b: 185
          },
          hex: 'B0B7B9',
          positionInBook: 2035,
          pageNumberInBook: '292'
        },
        {
          code: '4275 C',
          name: null,
          rgb: {
            r: 171,
            g: 174,
            b: 171
          },
          hex: 'ABAEAB',
          positionInBook: 2036,
          pageNumberInBook: '292'
        },
        {
          code: '4276 C',
          name: null,
          rgb: {
            r: 157,
            g: 156,
            b: 158
          },
          hex: '9D9C9E',
          positionInBook: 2037,
          pageNumberInBook: '292'
        },
        {
          code: '4277 C',
          name: null,
          rgb: {
            r: 143,
            g: 139,
            b: 144
          },
          hex: '8F8B90',
          positionInBook: 2038,
          pageNumberInBook: '292'
        },
        {
          code: '4278 C',
          name: null,
          rgb: {
            r: 126,
            g: 126,
            b: 130
          },
          hex: '7E7E82',
          positionInBook: 2039,
          pageNumberInBook: '292'
        },
        {
          code: '4279 C',
          name: null,
          rgb: {
            r: 90,
            g: 83,
            b: 87
          },
          hex: '5A5357',
          positionInBook: 2040,
          pageNumberInBook: '292'
        },
        {
          code: '4280 C',
          name: null,
          rgb: {
            r: 37,
            g: 42,
            b: 54
          },
          hex: '252A36',
          positionInBook: 2041,
          pageNumberInBook: '292'
        },
        {
          code: '420 C',
          name: null,
          rgb: {
            r: 199,
            g: 201,
            b: 199
          },
          hex: 'C7C9C7',
          positionInBook: 2042,
          pageNumberInBook: '293'
        },
        {
          code: '421 C',
          name: null,
          rgb: {
            r: 178,
            g: 180,
            b: 178
          },
          hex: 'B2B4B2',
          positionInBook: 2043,
          pageNumberInBook: '293'
        },
        {
          code: '422 C',
          name: null,
          rgb: {
            r: 158,
            g: 162,
            b: 162
          },
          hex: '9EA2A2',
          positionInBook: 2044,
          pageNumberInBook: '293'
        },
        {
          code: '423 C',
          name: null,
          rgb: {
            r: 137,
            g: 141,
            b: 141
          },
          hex: '898D8D',
          positionInBook: 2045,
          pageNumberInBook: '293'
        },
        {
          code: '424 C',
          name: null,
          rgb: {
            r: 112,
            g: 115,
            b: 114
          },
          hex: '707372',
          positionInBook: 2046,
          pageNumberInBook: '293'
        },
        {
          code: '425 C',
          name: null,
          rgb: {
            r: 84,
            g: 88,
            b: 89
          },
          hex: '545859',
          positionInBook: 2047,
          pageNumberInBook: '293'
        },
        {
          code: '426 C',
          name: null,
          rgb: {
            r: 37,
            g: 40,
            b: 42
          },
          hex: '25282A',
          positionInBook: 2048,
          pageNumberInBook: '293'
        },
        {
          code: '441 C',
          name: null,
          rgb: {
            r: 190,
            g: 198,
            b: 196
          },
          hex: 'BEC6C4',
          positionInBook: 2049,
          pageNumberInBook: '294'
        },
        {
          code: '442 C',
          name: null,
          rgb: {
            r: 162,
            g: 172,
            b: 171
          },
          hex: 'A2ACAB',
          positionInBook: 2050,
          pageNumberInBook: '294'
        },
        {
          code: '443 C',
          name: null,
          rgb: {
            r: 145,
            g: 157,
            b: 157
          },
          hex: '919D9D',
          positionInBook: 2051,
          pageNumberInBook: '294'
        },
        {
          code: '444 C',
          name: null,
          rgb: {
            r: 113,
            g: 124,
            b: 125
          },
          hex: '717C7D',
          positionInBook: 2052,
          pageNumberInBook: '294'
        },
        {
          code: '445 C',
          name: null,
          rgb: {
            r: 80,
            g: 87,
            b: 89
          },
          hex: '505759',
          positionInBook: 2053,
          pageNumberInBook: '294'
        },
        {
          code: '446 C',
          name: null,
          rgb: {
            r: 63,
            g: 68,
            b: 67
          },
          hex: '3F4443',
          positionInBook: 2054,
          pageNumberInBook: '294'
        },
        {
          code: '447 C',
          name: null,
          rgb: {
            r: 55,
            g: 58,
            b: 54
          },
          hex: '373A36',
          positionInBook: 2055,
          pageNumberInBook: '294'
        },
        {
          code: '413 C',
          name: null,
          rgb: {
            r: 186,
            g: 187,
            b: 177
          },
          hex: 'BABBB1',
          positionInBook: 2056,
          pageNumberInBook: '295'
        },
        {
          code: '414 C',
          name: null,
          rgb: {
            r: 168,
            g: 169,
            b: 158
          },
          hex: 'A8A99E',
          positionInBook: 2057,
          pageNumberInBook: '295'
        },
        {
          code: '415 C',
          name: null,
          rgb: {
            r: 145,
            g: 147,
            b: 136
          },
          hex: '919388',
          positionInBook: 2058,
          pageNumberInBook: '295'
        },
        {
          code: '416 C',
          name: null,
          rgb: {
            r: 126,
            g: 127,
            b: 116
          },
          hex: '7E7F74',
          positionInBook: 2059,
          pageNumberInBook: '295'
        },
        {
          code: '417 C',
          name: null,
          rgb: {
            r: 101,
            g: 102,
            b: 92
          },
          hex: '65665C',
          positionInBook: 2060,
          pageNumberInBook: '295'
        },
        {
          code: '418 C',
          name: null,
          rgb: {
            r: 81,
            g: 83,
            b: 74
          },
          hex: '51534A',
          positionInBook: 2061,
          pageNumberInBook: '295'
        },
        {
          code: '419 C',
          name: null,
          rgb: {
            r: 33,
            g: 35,
            b: 34
          },
          hex: '212322',
          positionInBook: 2062,
          pageNumberInBook: '295'
        },
        {
          code: '4281 C',
          name: null,
          rgb: {
            r: 178,
            g: 177,
            b: 178
          },
          hex: 'B2B1B2',
          positionInBook: 2063,
          pageNumberInBook: '296'
        },
        {
          code: '4282 C',
          name: null,
          rgb: {
            r: 176,
            g: 170,
            b: 171
          },
          hex: 'B0AAAB',
          positionInBook: 2064,
          pageNumberInBook: '296'
        },
        {
          code: '4283 C',
          name: null,
          rgb: {
            r: 169,
            g: 162,
            b: 161
          },
          hex: 'A9A2A1',
          positionInBook: 2065,
          pageNumberInBook: '296'
        },
        {
          code: '4284 C',
          name: null,
          rgb: {
            r: 115,
            g: 107,
            b: 116
          },
          hex: '736B74',
          positionInBook: 2066,
          pageNumberInBook: '296'
        },
        {
          code: '4285 C',
          name: null,
          rgb: {
            r: 105,
            g: 97,
            b: 108
          },
          hex: '69616C',
          positionInBook: 2067,
          pageNumberInBook: '296'
        },
        {
          code: '4286 C',
          name: null,
          rgb: {
            r: 95,
            g: 85,
            b: 93
          },
          hex: '5F555D',
          positionInBook: 2068,
          pageNumberInBook: '296'
        },
        {
          code: '4287 C',
          name: null,
          rgb: {
            r: 69,
            g: 65,
            b: 66
          },
          hex: '454142',
          positionInBook: 2069,
          pageNumberInBook: '296'
        },
        {
          code: '2330 C',
          name: null,
          rgb: {
            r: 207,
            g: 205,
            b: 201
          },
          hex: 'CFCDC9',
          positionInBook: 2070,
          pageNumberInBook: '297'
        },
        {
          code: '2331 C',
          name: null,
          rgb: {
            r: 174,
            g: 168,
            b: 165
          },
          hex: 'AEA8A5',
          positionInBook: 2071,
          pageNumberInBook: '297'
        },
        {
          code: '2332 C',
          name: null,
          rgb: {
            r: 140,
            g: 137,
            b: 133
          },
          hex: '8C8985',
          positionInBook: 2072,
          pageNumberInBook: '297'
        },
        {
          code: '2333 C',
          name: null,
          rgb: {
            r: 113,
            g: 110,
            b: 106
          },
          hex: '716E6A',
          positionInBook: 2073,
          pageNumberInBook: '297'
        },
        {
          code: '2334 C',
          name: null,
          rgb: {
            r: 108,
            g: 100,
            b: 99
          },
          hex: '6C6463',
          positionInBook: 2074,
          pageNumberInBook: '297'
        },
        {
          code: '2335 C',
          name: null,
          rgb: {
            r: 94,
            g: 80,
            b: 71
          },
          hex: '5E5047',
          positionInBook: 2075,
          pageNumberInBook: '297'
        },
        {
          code: '2336 C',
          name: null,
          rgb: {
            r: 78,
            g: 75,
            b: 72
          },
          hex: '4E4B48',
          positionInBook: 2076,
          pageNumberInBook: '297'
        },
        {
          code: '400 C',
          name: null,
          rgb: {
            r: 196,
            g: 191,
            b: 182
          },
          hex: 'C4BFB6',
          positionInBook: 2077,
          pageNumberInBook: '298'
        },
        {
          code: '401 C',
          name: null,
          rgb: {
            r: 175,
            g: 169,
            b: 160
          },
          hex: 'AFA9A0',
          positionInBook: 2078,
          pageNumberInBook: '298'
        },
        {
          code: '402 C',
          name: null,
          rgb: {
            r: 157,
            g: 150,
            b: 141
          },
          hex: '9D968D',
          positionInBook: 2079,
          pageNumberInBook: '298'
        },
        {
          code: '403 C',
          name: null,
          rgb: {
            r: 140,
            g: 133,
            b: 123
          },
          hex: '8C857B',
          positionInBook: 2080,
          pageNumberInBook: '298'
        },
        {
          code: '404 C',
          name: null,
          rgb: {
            r: 119,
            g: 110,
            b: 100
          },
          hex: '776E64',
          positionInBook: 2081,
          pageNumberInBook: '298'
        },
        {
          code: '405 C',
          name: null,
          rgb: {
            r: 105,
            g: 97,
            b: 88
          },
          hex: '696158',
          positionInBook: 2082,
          pageNumberInBook: '298'
        },
        {
          code: 'Black C',
          name: null,
          rgb: {
            r: 45,
            g: 41,
            b: 38
          },
          hex: '2D2926',
          positionInBook: 2083,
          pageNumberInBook: '298'
        },
        {
          code: '4288 C',
          name: null,
          rgb: {
            r: 183,
            g: 188,
            b: 180
          },
          hex: 'B7BCB4',
          positionInBook: 2084,
          pageNumberInBook: '299'
        },
        {
          code: '4289 C',
          name: null,
          rgb: {
            r: 153,
            g: 153,
            b: 152
          },
          hex: '999998',
          positionInBook: 2085,
          pageNumberInBook: '299'
        },
        {
          code: '4290 C',
          name: null,
          rgb: {
            r: 146,
            g: 139,
            b: 138
          },
          hex: '928B8A',
          positionInBook: 2086,
          pageNumberInBook: '299'
        },
        {
          code: '4291 C',
          name: null,
          rgb: {
            r: 116,
            g: 110,
            b: 110
          },
          hex: '746E6E',
          positionInBook: 2087,
          pageNumberInBook: '299'
        },
        {
          code: '4292 C',
          name: null,
          rgb: {
            r: 113,
            g: 109,
            b: 110
          },
          hex: '716D6E',
          positionInBook: 2088,
          pageNumberInBook: '299'
        },
        {
          code: '4293 C',
          name: null,
          rgb: {
            r: 100,
            g: 91,
            b: 100
          },
          hex: '645B64',
          positionInBook: 2089,
          pageNumberInBook: '299'
        },
        {
          code: '4294 C',
          name: null,
          rgb: {
            r: 87,
            g: 82,
            b: 87
          },
          hex: '575257',
          positionInBook: 2090,
          pageNumberInBook: '299'
        },
        {
          code: '406 C',
          name: null,
          rgb: {
            r: 196,
            g: 188,
            b: 183
          },
          hex: 'C4BCB7',
          positionInBook: 2091,
          pageNumberInBook: '300'
        },
        {
          code: '407 C',
          name: null,
          rgb: {
            r: 178,
            g: 168,
            b: 162
          },
          hex: 'B2A8A2',
          positionInBook: 2092,
          pageNumberInBook: '300'
        },
        {
          code: '408 C',
          name: null,
          rgb: {
            r: 151,
            g: 140,
            b: 135
          },
          hex: '978C87',
          positionInBook: 2093,
          pageNumberInBook: '300'
        },
        {
          code: '409 C',
          name: null,
          rgb: {
            r: 133,
            g: 120,
            b: 116
          },
          hex: '857874',
          positionInBook: 2094,
          pageNumberInBook: '300'
        },
        {
          code: '410 C',
          name: null,
          rgb: {
            r: 116,
            g: 102,
            b: 97
          },
          hex: '746661',
          positionInBook: 2095,
          pageNumberInBook: '300'
        },
        {
          code: '411 C',
          name: null,
          rgb: {
            r: 94,
            g: 81,
            b: 77
          },
          hex: '5E514D',
          positionInBook: 2096,
          pageNumberInBook: '300'
        },
        {
          code: '412 C',
          name: null,
          rgb: {
            r: 56,
            g: 47,
            b: 45
          },
          hex: '382F2D',
          positionInBook: 2097,
          pageNumberInBook: '300'
        },
        {
          code: '434 C',
          name: null,
          rgb: {
            r: 208,
            g: 196,
            b: 197
          },
          hex: 'D0C4C5',
          positionInBook: 2098,
          pageNumberInBook: '301'
        },
        {
          code: '435 C',
          name: null,
          rgb: {
            r: 193,
            g: 178,
            b: 182
          },
          hex: 'C1B2B6',
          positionInBook: 2099,
          pageNumberInBook: '301'
        },
        {
          code: '436 C',
          name: null,
          rgb: {
            r: 171,
            g: 152,
            b: 157
          },
          hex: 'AB989D',
          positionInBook: 2100,
          pageNumberInBook: '301'
        },
        {
          code: '437 C',
          name: null,
          rgb: {
            r: 123,
            g: 100,
            b: 105
          },
          hex: '7B6469',
          positionInBook: 2101,
          pageNumberInBook: '301'
        },
        {
          code: '438 C',
          name: null,
          rgb: {
            r: 88,
            g: 68,
            b: 70
          },
          hex: '584446',
          positionInBook: 2102,
          pageNumberInBook: '301'
        },
        {
          code: '439 C',
          name: null,
          rgb: {
            r: 69,
            g: 53,
            b: 54
          },
          hex: '453536',
          positionInBook: 2103,
          pageNumberInBook: '301'
        },
        {
          code: '440 C',
          name: null,
          rgb: {
            r: 56,
            g: 46,
            b: 44
          },
          hex: '382E2C',
          positionInBook: 2104,
          pageNumberInBook: '301'
        },
        {
          code: '2473 C',
          name: null,
          rgb: {
            r: 196,
            g: 184,
            b: 189
          },
          hex: 'C4B8BD',
          positionInBook: 2105,
          pageNumberInBook: '302'
        },
        {
          code: '2474 C',
          name: null,
          rgb: {
            r: 176,
            g: 161,
            b: 152
          },
          hex: 'B0A198',
          positionInBook: 2106,
          pageNumberInBook: '302'
        },
        {
          code: '2475 C',
          name: null,
          rgb: {
            r: 161,
            g: 135,
            b: 127
          },
          hex: 'A1877F',
          positionInBook: 2107,
          pageNumberInBook: '302'
        },
        {
          code: '2476 C',
          name: null,
          rgb: {
            r: 130,
            g: 107,
            b: 106
          },
          hex: '826B6A',
          positionInBook: 2108,
          pageNumberInBook: '302'
        },
        {
          code: '2477 C',
          name: null,
          rgb: {
            r: 112,
            g: 88,
            b: 84
          },
          hex: '705854',
          positionInBook: 2109,
          pageNumberInBook: '302'
        },
        {
          code: '2478 C',
          name: null,
          rgb: {
            r: 76,
            g: 54,
            b: 58
          },
          hex: '4C363A',
          positionInBook: 2110,
          pageNumberInBook: '302'
        },
        {
          code: '2479 C',
          name: null,
          rgb: {
            r: 62,
            g: 52,
            b: 47
          },
          hex: '3E342F',
          positionInBook: 2111,
          pageNumberInBook: '302'
        },
        {
          code: 'Warm Gray 1 C',
          name: null,
          rgb: {
            r: 215,
            g: 210,
            b: 203
          },
          hex: 'D7D2CB',
          positionInBook: 2112,
          pageNumberInBook: '303'
        },
        {
          code: 'Warm Gray 2 C',
          name: null,
          rgb: {
            r: 203,
            g: 196,
            b: 188
          },
          hex: 'CBC4BC',
          positionInBook: 2113,
          pageNumberInBook: '303'
        },
        {
          code: 'Warm Gray 3 C',
          name: null,
          rgb: {
            r: 191,
            g: 184,
            b: 175
          },
          hex: 'BFB8AF',
          positionInBook: 2114,
          pageNumberInBook: '303'
        },
        {
          code: 'Warm Gray 4 C',
          name: null,
          rgb: {
            r: 182,
            g: 173,
            b: 165
          },
          hex: 'B6ADA5',
          positionInBook: 2115,
          pageNumberInBook: '303'
        },
        {
          code: 'Warm Gray 5 C',
          name: null,
          rgb: {
            r: 172,
            g: 163,
            b: 154
          },
          hex: 'ACA39A',
          positionInBook: 2116,
          pageNumberInBook: '303'
        },
        {
          code: 'Warm Gray 6 C',
          name: null,
          rgb: {
            r: 165,
            g: 156,
            b: 148
          },
          hex: 'A59C94',
          positionInBook: 2117,
          pageNumberInBook: '304'
        },
        {
          code: 'Warm Gray 7 C',
          name: null,
          rgb: {
            r: 150,
            g: 140,
            b: 131
          },
          hex: '968C83',
          positionInBook: 2118,
          pageNumberInBook: '304'
        },
        {
          code: 'Warm Gray 8 C',
          name: null,
          rgb: {
            r: 140,
            g: 130,
            b: 121
          },
          hex: '8C8279',
          positionInBook: 2119,
          pageNumberInBook: '304'
        },
        {
          code: 'Warm Gray 9 C',
          name: null,
          rgb: {
            r: 131,
            g: 120,
            b: 111
          },
          hex: '83786F',
          positionInBook: 2120,
          pageNumberInBook: '304'
        },
        {
          code: 'Warm Gray 10 C',
          name: null,
          rgb: {
            r: 121,
            g: 110,
            b: 101
          },
          hex: '796E65',
          positionInBook: 2121,
          pageNumberInBook: '304'
        },
        {
          code: 'Warm Gray 11 C',
          name: null,
          rgb: {
            r: 110,
            g: 98,
            b: 89
          },
          hex: '6E6259',
          positionInBook: 2122,
          pageNumberInBook: '304'
        },
        {
          code: 'Cool Gray 1 C',
          name: null,
          rgb: {
            r: 217,
            g: 217,
            b: 214
          },
          hex: 'D9D9D6',
          positionInBook: 2123,
          pageNumberInBook: '305'
        },
        {
          code: 'Cool Gray 2 C',
          name: null,
          rgb: {
            r: 208,
            g: 208,
            b: 206
          },
          hex: 'D0D0CE',
          positionInBook: 2124,
          pageNumberInBook: '305'
        },
        {
          code: 'Cool Gray 3 C',
          name: null,
          rgb: {
            r: 200,
            g: 201,
            b: 199
          },
          hex: 'C8C9C7',
          positionInBook: 2125,
          pageNumberInBook: '305'
        },
        {
          code: 'Cool Gray 4 C',
          name: null,
          rgb: {
            r: 187,
            g: 188,
            b: 188
          },
          hex: 'BBBCBC',
          positionInBook: 2126,
          pageNumberInBook: '305'
        },
        {
          code: 'Cool Gray 5 C',
          name: null,
          rgb: {
            r: 177,
            g: 179,
            b: 179
          },
          hex: 'B1B3B3',
          positionInBook: 2127,
          pageNumberInBook: '305'
        },
        {
          code: 'Cool Gray 6 C',
          name: null,
          rgb: {
            r: 167,
            g: 168,
            b: 169
          },
          hex: 'A7A8A9',
          positionInBook: 2128,
          pageNumberInBook: '306'
        },
        {
          code: 'Cool Gray 7 C',
          name: null,
          rgb: {
            r: 151,
            g: 153,
            b: 155
          },
          hex: '97999B',
          positionInBook: 2129,
          pageNumberInBook: '306'
        },
        {
          code: 'Cool Gray 8 C',
          name: null,
          rgb: {
            r: 136,
            g: 139,
            b: 141
          },
          hex: '888B8D',
          positionInBook: 2130,
          pageNumberInBook: '306'
        },
        {
          code: 'Cool Gray 9 C',
          name: null,
          rgb: {
            r: 117,
            g: 120,
            b: 123
          },
          hex: '75787B',
          positionInBook: 2131,
          pageNumberInBook: '306'
        },
        {
          code: 'Cool Gray 10 C',
          name: null,
          rgb: {
            r: 99,
            g: 102,
            b: 106
          },
          hex: '63666A',
          positionInBook: 2132,
          pageNumberInBook: '306'
        },
        {
          code: 'Cool Gray 11 C',
          name: null,
          rgb: {
            r: 83,
            g: 86,
            b: 90
          },
          hex: '53565A',
          positionInBook: 2133,
          pageNumberInBook: '306'
        },
        {
          code: 'Black 2 C',
          name: null,
          rgb: {
            r: 51,
            g: 47,
            b: 33
          },
          hex: '332F21',
          positionInBook: 2134,
          pageNumberInBook: '307'
        },
        {
          code: 'Black 3 C',
          name: null,
          rgb: {
            r: 33,
            g: 39,
            b: 33
          },
          hex: '212721',
          positionInBook: 2135,
          pageNumberInBook: '307'
        },
        {
          code: 'Black 4 C',
          name: null,
          rgb: {
            r: 49,
            g: 38,
            b: 29
          },
          hex: '31261D',
          positionInBook: 2136,
          pageNumberInBook: '307'
        },
        {
          code: 'Black 5 C',
          name: null,
          rgb: {
            r: 62,
            g: 43,
            b: 46
          },
          hex: '3E2B2E',
          positionInBook: 2137,
          pageNumberInBook: '307'
        },
        {
          code: 'Black 6 C',
          name: null,
          rgb: {
            r: 16,
            g: 24,
            b: 32
          },
          hex: '101820',
          positionInBook: 2138,
          pageNumberInBook: '307'
        },
        {
          code: 'Black 7 C',
          name: null,
          rgb: {
            r: 61,
            g: 57,
            b: 53
          },
          hex: '3D3935',
          positionInBook: 2139,
          pageNumberInBook: '307'
        }
      ]
    }
  }
}
